// GENERADO por horizon/tools/gen-cotizador.cjs desde la maqueta congelada e5-cotizador-app.html.
// La IIFE del motor (rondas 6-21) VERBATIM, menos los datos (viven en mp-cotizador-datos.js), con los
// parches del contrato: P1 arranque (try/catch + html.mp-app + room.hidden + MP_QA_BOOT_FAIL),
// P3 calibrador sin enganche, P5 el Paseo apendido al cuarto, P6 la siembra del Oraculo (?m=<Nombre> pinta el pincel activo),
// P7 lectura adaptativa (la puerta 2-6; con 4+ el worker lee el acorde),
// P10 el centro de 12 mm fuera (sin el Abulon ni la Charoita; una forma sin minerales cae al icosaedro).
// Ver la constante de parches en el generador.
// datos.js corre antes (ambos scripts defer, en orden). NO editar a mano.
(function(){
"use strict";
  try {
  var QA = (window.MP_QA === true);
  var root = document.querySelector('[data-mp-cotizador]');
  if (!root) { return; }
  var room = root.querySelector('[data-room]');
  if (!room) { return; }
  document.documentElement.classList.add('mp-app');
  room.hidden = false;
  if (window.MP_QA_BOOT_FAIL) { throw new Error('qa-boot-fail'); }


const $ = function(id){ return document.getElementById(id); };
const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

/* ===== indices y respaldos ===== */
const byName = {};
DATOS.minerales.forEach(function(m,i){ byName[m.n] = i; });

// id de retrato por nombre (para minerales, separadores y centro)
const RTID = {}; let rtn = 0;
Object.keys(RETRATOS).forEach(function(name){ if(RETRATOS[name] && RETRATOS[name].uri){ RTID[name] = rtn++; } });

// color de respaldo por mineral (propio si esta fuera del canon, si no el del retrato, si no gris)
const COL = DATOS.minerales.map(function(m){
  if(m.color) return m.color;
  const r = RETRATOS[m.n];
  if(r) return { c:r.c, hi:r.hi, sh:r.sh };
  return { c:"#6b6258", hi:"#928a80", sh:"#4a423a" };
});
const HASRT = DATOS.minerales.map(function(m){ return RTID[m.n] != null; });

// listas reales del centro (indices de mineral)
const LISTS = {
  icosaedro: DATOS.icosaedro_minerales.map(function(x){ return byName[x.n]; }).filter(function(i){ return i != null; }),
  c10: DATOS.centro_10mm.map(function(n){ return byName[n]; }).filter(function(i){ return i != null && DATOS.minerales[i].cuenta10 != null; }),
  /* >>> parche gen (cotizador-c12-fuera) >>> */
  // P10 (2-nov-2026): el Abulon (es plana) y la Charoita de 12 mm salen del centro de 12 mm; con la lista vacia, la forma no se ofrece.
  c12: DATOS.centro_12mm.filter(function(n){ return n !== "Abulón" && n !== "Charoita"; }).map(function(n){ return byName[n]; }).filter(function(i){ return i != null && DATOS.minerales[i].cuenta12 != null; }),
  /* <<< parche gen (cotizador-c12-fuera) <<< */
  flanqueada: DATOS.minerales.map(function(_,i){ return i; }),
  guru: DATOS.guru_minerales.map(function(x){ return byName[x.n]; }).filter(function(i){ return i != null; })
};

const CFG = {
  cod:  { N:44,  half:22 },
  japa: { N:108, half:54 }
};
// topes de tamano de cuenta por pieza (px de diametro) · mp11: solo la gota
const SIZES = {
  cod:{ Dmax:50, Dmin:20 }, japa:{ Dmax:22, Dmin:11 }
};
// intenciones canonicas (orden de primera aparicion en DATOS)
const INTENCIONES = (function(){
  const seen = {}, out = [];
  DATOS.minerales.forEach(function(m){ if(m.intenciones) m.intenciones.forEach(function(x){ if(!seen[x]){ seen[x] = 1; out.push(x); } }); });
  return out;
})();

/* ===== estado ===== */
let cuarto = "charola";                    // charola | observatorio (los dos cuartos)
let pieza = "cod";
let brush = -1;
let espejo = true;
let vista = "gota";                        // mp11: la pieza vive SOLO en gota (la enrollada murio); se conserva por compat de codigos/guardado
let patronIdx = 0;
let sepMineralIdx = 0;
// R18 · F1: separadores personalizables por SLOT. sepPinta[k] = indice a DATOS.separadores u
// null (null = el separador base sepMineralIdx). Longitud = pat.sep del patron vigente (solo cod).
// sepBrush = pincel de separadores activo (indice a DATOS.separadores) o -1. Un solo pincel a la vez:
// activar sepBrush apaga brush (cuentas) y viceversa.
let sepPinta = [];
let sepBrush = -1;
let centroForma = "icosaedro";            // icosaedro | c10 | c12 | flanqueada
let centroManual = { icosaedro:null, c10:null, c12:null, flanqueada:null, guru:null };
let colchon = 6;
let recargoPct = 4;
let calibAncla = "A";
let beads = [];
let reemplazo = null;
let tocada = false;                        // ya se toco alguna cuenta (apaga la invitacion)
let degTono = false;                        // Ronda 15b: peticion de taller "degradado de tono" (por pieza; solo valida con 1 mineral multicolor)
let sheetTipo = null;
let sheetTimer = null;
let justPainted = [];
let LAYOUT = { centers:[], maxR:24, cw:0, ch:0 };
let rafLayout = 0;
let lastAppW = 0, lastAppH = 0;            // Ronda 8: ultima caja de la app (guarda re-renders espurios)
let mesa = [];                             // pinceles a la mano: [{mid, fija}], mas reciente primero, fijas arriba
let historial = [];                        // deshacer: hasta 20 pasos
let zoom = 1, panX = 0, panY = 0;          // el zoom de verdad
let expFiltro = "";
let expInt = {};                           // intenciones seleccionadas (set-como-objeto)
let expFam = "";                           // Ronda 13: familia de luz seleccionada (una sola) o ""
let expOrden = "nombre";
let expAbierto = false;
// ===== RONDA 23 · OLEADA 3 · estado de las cuatro ventanas nuevas =====
let mp23EneAbierta = false;      // la ventana centrada de la energia (sin autocierre)
let mp23MesaAbierta = false;     // el panel expandido de la mesa (todos los pinceles a la vista)
let mp23FichaAbierta = false;    // la ficha de inspeccion dentro del explorador
let mp23FichaMid = -1;           // el mineral que muestra la ficha (para el boton de accion)
// R5: sonido y tacto
let sonidoOn = true;
let audioCtx = null, lastTic = 0, wasComplete = false;
// R7: acomodos (galeria de permutaciones puras del cuerpo)
let acomodoBloqueN = 3;                    // tamano de bloque para el acomodo "Bloques"
const LUMEN = {};                          // claridad media por nombre de mineral (perezoso, cacheado)
// R6: estado por pieza (autoguardado) + persistencia
const PZ = {};                             // { cod:{...}, japa:{...} } estado de diseno de cada pieza
let espejoToastMostrado = false;           // el mensajito del espejo se muestra una vez por visita
let huecoObjetivo = -1;                     // Ronda 9: hueco a pintar tras elegir en el explorador (primer minuto guiado)
let mp9ToastTimer = 0;                      // Ronda 9: temporizador del avisito reutilizable (espejo-toast)
// ===== RONDA 21 · EL REGISTRO DE SUSURROS DE PRIMERA VEZ =====
const LS_SUSURROS = "mp_cotizador_susurros_v1";          // {id:true} aditivo · UNA vez en la vida por dispositivo
const LS_ESPEJO_LEGACY = "mp_cotizador_espejo_visto_v1"; // llave vieja del toast del espejo: su semilla de migracion
let mp21Vistos = {};                                     // se carga en el arranque desde LS_SUSURROS (+ migracion espejo)
let mp21Activo = false;                                  // hay UN susurro visible ahora mismo (garantiza uno-a-la-vez)
let mp21Timer = 0;                                       // temporizador de vida del susurro
// Ronda 9: identidad perpetua. v1 (por indices) queda como reliquia; v2 guarda por NOMBRE.
const LS_ESTADO_V1 = "mp_cotizador_v1";
const LS_ESTADO = "mp_cotizador_v2";
const LS_DISENOS_V1 = "mp_cotizador_disenos_v1";
// Ronda 15b: minerales multicolor (una misma tira trae tonos distintos cuenta por cuenta).
// La app no puede pintar ese degradado ni el codigo MP1 codificarlo: por eso es una peticion
// que viaja al taller y se afina a mano. La lista la cura el fundador y se extiende AQUI,
// con el NOMBRE CANONICO EXACTO de DATOS.minerales (acentos incluidos). "Berilos" = solo la
// mezcla que se llama asi; la Morganita/Aguamarina/Esmeralda por separado NO entran.
const MP15B_MULTICOLOR = ["Fluorita", "Fluorita Arcoíris", "Berilos", "Jaspe Oceánico", "Jaspe Mokaita"];
// (La "Turmalina Multicolor" que pidio el fundador no existe en DATOS: queda fuera hasta que se cargue.)

/* ===== Ronda 16 · el enlace a la pieza de la tienda =====
   Mapa GENERADO leyendo los CSV reales de catalogos-csv/ (Codificadores 45 26 abril.csv y
   Todos los productos activos 10 Junio.csv), title -> handle, solo empates seguros 1:1:
   codificador = "Codificador de [Mineral] (NN cm)" single-mineral, la pieza BASE (el cm menor);
   japa = "Japa Mala de [Mineral]". Los dudosos quedaron FUERA (cero enlaces rotos):
   cod sin producto single: Aguamarina, Jaspe Paisaje, Maifanita, Shoushan;
   japa: Fluorita (2 candidatos), Piedra Sol Naranja (ninguno). NO tocar a mano: se regenera. */
const MP16_URLS = {
  base: "https://mamapachita.com/products/",
  cod: {
    "Amatista": "codificador-elastico-de-amatista-8-mm-vision-espiritual",
    "Amatista Fantasma": "codificador-elastico-de-amatista-con-hematita-vision-enraizada",
    "Amazonita": "codificador-amazonita-8-mm-expresion-suave",
    "Amazonita Aqua": "codificador-el-camino-de-en-medio-amazonita-claridad-expresion",
    "Apatita Azul": "codificador-apatita-azul-codigos-agesta-expresion-clara",
    "Berilos": "codificador-de-morganita-8-mm-ternura-vision",
    "Citrino": "codificador-citrino-8-mm-voluntad-luminosa",
    "Cornalina": "codificador-agata-cornalina-8-mm-fuerza-deseo",
    "Cuarzo Ahumado": "codificador-cuarzo-ahumado-con-icosaedro-8-mm-anclaje-suave",
    "Cuarzo Rosa": "codificador-cuarzo-rosa-8-mm-amor-tierno",
    "Cuarzo Transparente": "codificador-cuarzo-transparente-8-mm-vision-clara",
    "Fluorita": "codificador-elastico-de-fluorita-8-mm-claridad-orden",
    "Granate Estrella": "codificador-elastico-de-granate-estrella-8-mm-fuerza-silenciosa",
    "Howlita": "codificador-howlita-8-mm-calma-mental",
    "Jaspe Dálmata": "codificador-sagrado-jaspe-dalmata-dualidad-ligera",
    "Jaspe Kambaba": "codificador-jaspe-kambaba-8-mm-raiz-profunda",
    "Jaspe Mapa": "codificador-sagrado-jaspe-mapa-direccion-claridad",
    "Jaspe Mokaita": "codificador-jaspe-mokaita-8-mm-estabilidad-suave",
    "Jaspe Picasso": "codificador-jaspe-picasso-8-mm-equilibrio-patron",
    "Jaspe Piel de Leopardo": "codificador-sagrado-jaspe-piel-de-leopardo-instinto-presencia",
    "Jaspe Rojo": "codificador-jaspe-rojo-8-mm-presencia-raiz",
    "Jaspe Sangre de Dragón": "codificador-jaspe-sangre-de-dragon-8-mm-fuerza-corazon",
    "Kunzita": "codificador-elastico-de-kunzita-8-mm-corazon-apertura",
    "Labradorita": "codificador-sagrado-labdradorita-intuicion-sutil",
    "Lapislázuli": "codificador-sagrado-lapislazuli-vision-palabra",
    "Malaquita": "codificador-elastico-de-malaquita-8-mm-poder-emocional",
    "Obsidiana Dorada": "codificador-elastico-obsidiana-dorada-8-mm-introspeccion",
    "Ojo de Tigre": "codificador-sagrado-ojo-de-tigre-proteccion-centro",
    "Piedra Luna": "codificador-claro-de-luna-corto-piedra-luna-intuicion-ciclica",
    "Piedra Sol Naranja": "codificador-piedra-sol-8-mm-gozo-expresion",
    "Pietersita Amarilla y Roja": "codificador-ojo-del-infinito-pietersita-vision-clara",
    "Pirita": "codificador-pirita-8-mm-claridad-voluntad",
    "Prehnita": "codificador-prehnita-8-mm-intuicion-corazon",
    "Rodonita Encaje Negro": "codificador-rodonita-encaje-negro-8-mm",
    "Rodonita Rosa": "codificador-rodonita-argentina-8-mm-amor-propio",
    "Saffordita": "codificador-elastico-de-saffordita-cintamani-8-mm-vacio-sagrado",
    "Shungita": "codificador-shungita-8-mm-proteccion-profunda",
    "Turmalina Negra": "codificador-turmalina-negra-8-mm-enraizamiento",
    "Turmalina Rosa": "codificador-turmalina-rosa-8-mm-rosa-amor-centrado",
    "Variscita": "codificador-elastico-de-variscita-8-mm-expresion-suave",
    "Ágata Musgosa": "codificador-sagrado-agata-musgosa-conexion-tierra",
    "Ámbar": "codificador-ambar-codigos-sagrados-agesta-raiz-contencion"
  },
  japa: {
    "Amatista": "japa-mala-amatista-vision-intuitiva",
    "Amazonita": "japa-mala-amazonita-voz-suave",
    "Apatita Azul": "japa-mala-apatita-azul-expresion-clara",
    "Citrino": "japa-mala-citrino-facetado-8-mm-proposito-luminoso",
    "Cornalina": "japa-mala-cornalina-8-mm-pasion-vitalidad",
    "Cuarzo Ahumado": "japa-mala-cuarzo-ahumado-8-mm-presencia-clara",
    "Cuarzo Rosa": "japa-mala-cuarzo-rosa-amor-incondicional",
    "Cuarzo Transparente": "japa-mala-cuarzo-transparente-claridad",
    "Esmeralda en Matriz de Biotita": "japa-mala-esmeralda-8-mm-corazon-nobleza",
    "Granate Estrella": "japa-mala-granate-estrella-8-mm-poder-radiante",
    "Howlita": "japa-mala-howlita-8-mm-calma-mental",
    "Obsidiana Dorada": "japa-mala-obsidiana-poder-interior",
    "Ojo de Tigre": "japa-mala-ojo-de-tigre-proteccion-clara",
    "Rubí": "japa-mala-de-rubi-8-mm",
    "Turmalina Negra": "japa-mala-turmalina-negra-anclaje",
    "Ámbar": "japa-mala-ambar-natural-contencion-enraizamiento"
  }
};
// href de la pieza de linea actual, o null si no hay empate seguro (entonces no aparece nada)
function mp16HrefDeLinea(r){
  if(!r || !r.exacta || !r.pura) return null;
  const h = MP16_URLS[pieza === "cod" ? "cod" : "japa"][DATOS.minerales[r.pura.mid].n];
  return h ? (MP16_URLS.base + h) : null;
}

/* ===== utilidades ===== */
function money(n){ return "$" + Math.round(n).toLocaleString("es-MX"); }
function cap(s){ return s.charAt(0).toUpperCase() + s.slice(1); }
function nombreArt(m, up){ let a = m.art; if(up) a = cap(a); return a + " " + m.n; }
function deMin(m){ return (m.art === "el" ? "del " : "de la ") + m.n; }
function razonPieza(){ return pieza === "cod" ? DATOS.razones.cod : DATOS.razones.japa; }
function twin(i){ const h = CFG[pieza].half; return i < h ? i + h : i - h; }
function redondea(v){ return Math.ceil((v - 49) / 50) * 50 + 49; }
function normaliza(s){ return s.normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase(); }
function esEstimado(m){ return m.confianza === "derivada" || m.confianza === "estimada"; }
function llevaNota(m){ return m.confianza !== "media" && m.confianza !== "alta"; }
// R23: precio que viene DIRECTO del fundador (dato exacto, p.ej. el Rubi $135); no lleva matiz de "aprox." por cuenta
function precioDirecto(m){ return !!(m && m.via === "fundador_directo"); }

// fondo (retrato o gradiente) por nombre + color de respaldo
function fillByName(name, col){
  const id = RTID[name];
  if(id != null) return { cls:"rt" + id, style:"" };
  return { cls:"grad", style:"--c:" + col.c + ";--hi:" + col.hi + ";--sh:" + col.sh + ";" };
}
function fillMin(mid){ return fillByName(DATOS.minerales[mid].n, COL[mid]); }
function sepColor(s){ const r = RETRATOS[s.n]; return r ? { c:r.c, hi:r.hi, sh:r.sh } : { c:"#8a8078", hi:"#b3aaa1", sh:"#5e564e" }; }
function fillSep(s){ return fillByName(s.n, sepColor(s)); }

function dominante(){
  const cnt = {};
  beads.forEach(function(x){ if(x != null) cnt[x] = (cnt[x] || 0) + 1; });
  let best = -1, bn = 0;
  Object.keys(cnt).forEach(function(k){ if(cnt[k] > bn){ bn = cnt[k]; best = +k; } });
  return best;
}
// Ronda 15b: el degradado de tono SOLO es valido cuando todas las cuentas puestas son de UN
// mismo mineral Y ese mineral esta en MP15B_MULTICOLOR. Decide si el apagador puede vivir/viajar.
function mp15bAplica(){
  const placed = beads.filter(function(x){ return x != null; });
  if(placed.length === 0) return false;
  const first = placed[0];
  for(let k = 1; k < placed.length; k++){ if(placed[k] !== first) return false; }
  const m = DATOS.minerales[first];
  return !!m && MP15B_MULTICOLOR.indexOf(m.n) >= 0;
}
// Si la composicion deja de cumplir, el flag se apaga solo (nunca viaja un degradado invalido).
function mp15bReevalua(){ if(degTono && !mp15bAplica()) degTono = false; }
// La tarjeta apagador (solo existe cuando la pieza cumple: 1 mineral multicolor). Con 2+ minerales, "".
function mp15bCardHTML(){
  if(!mp15bAplica()) return "";
  return '<div class="mp15b-card">'
    + '<div class="mp15b-tx"><div class="mp15b-tit">Degradado de tono</div>'
    + '<div class="mp15b-meta">de tono a tono; se afina a mano en el taller</div></div>'
    + '<button class="mp15b-tog" id="mp15b-tog" role="switch" aria-checked="' + (degTono ? "true" : "false")
    + '" aria-label="Degradado de tono ' + (degTono ? "encendido" : "apagado") + '"><span class="knob"></span></button>'
    + '</div>';
}
// la voz de la pieza: las intenciones dominantes de la mezcla, ponderadas por cuenta
// (por defecto hasta 3, para el desglose; el sellado la pide con 2)
// Ronda 15: los separadores tambien suman, con peso 0.125 por separador
// ((4/8)^3 = la razon real de volumen entre la cuenta de 4 mm y la de 8 mm)
function pesoSeparadores(w, patIdx, sepIdx, forma, pintaArr){
  const pat = DATOS.patrones[patIdx];
  const slots = [];
  // R18 · F1: cada slot pesa con SU mineral (override o base), 0.125 por separador
  if(pat && pat.sep > 0){
    const cad = cadenciaDe(patIdx, "cod");
    const n = 2 * cad.bs.length + (cad.guru ? 2 : 0) + (cad.cierre ? 1 : 0);
    const arr = Array.isArray(pintaArr) ? pintaArr : null;
    for(let k = 0; k < n; k++){ slots.push((arr && arr[k] != null) ? arr[k] : sepIdx); }
  }
  if(forma === "flanqueada"){ slots.push(sepIdx); slots.push(sepIdx); }   // 33 cm: sin slots, 2 flancos base
  if(!slots.length) return;
  slots.forEach(function(si){
    const sm = DATOS.separadores[si];
    const smi = sm ? byName[sm.n] : null;
    if(smi == null || !DATOS.minerales[smi].intenciones) return;
    DATOS.minerales[smi].intenciones.forEach(function(x){ w[x] = (w[x] || 0) + 0.125; });
  });
}
function vozDeLaPieza(max){
  const w = {};
  beads.forEach(function(mid){
    if(mid == null) return;
    const m = DATOS.minerales[mid];
    if(!m.intenciones) return;
    m.intenciones.forEach(function(x){ w[x] = (w[x] || 0) + 1; });
  });
  if(!Object.keys(w).length) return null;   // sin cuentas no hay voz (los separadores no hablan solos)
  if(pieza === "cod") pesoSeparadores(w, patronIdx, sepMineralIdx, formaActual(), sepPinta);
  const keys = Object.keys(w);
  if(!keys.length) return null;
  keys.sort(function(a, b){ return w[b] - w[a] || a.localeCompare(b, "es"); });
  const top = keys.slice(0, (max || 3)).map(function(x){ return x.toLowerCase(); });
  let frase;
  if(top.length === 1) frase = top[0];
  else if(top.length === 2) frase = top[0] + " y " + top[1];
  else frase = top[0] + ", " + top[1] + " y " + top[2];
  return "Tu pieza habla de " + frase + ".";
}
// Ronda 15: la linea que nombra al separador cuando la talla lleva separadores.
// R18 · F1: con separadores mixtos nombra los 2 (si son 2) o dice "Los separadores" (si son 3+).
function mp15SepVoz(patIdx, sepIdx, p, pintaArr){
  if((p || pieza) !== "cod") return null;
  const pi = (patIdx != null ? patIdx : patronIdx);
  const pat = DATOS.patrones[pi];
  if(!pat || !(pat.sep > 0)) return null;
  const si = (sepIdx != null ? sepIdx : sepMineralIdx);
  const cad = cadenciaDe(pi, "cod");
  const nslots = 2 * cad.bs.length + (cad.guru ? 2 : 0) + (cad.cierre ? 1 : 0);
  const arr = Array.isArray(pintaArr) ? pintaArr : sepPinta;
  const distintos = [];
  for(let k = 0; k < nslots; k++){ const v = (Array.isArray(arr) && arr[k] != null) ? arr[k] : si; if(distintos.indexOf(v) < 0) distintos.push(v); }
  if(distintos.length <= 1){ const sm = DATOS.separadores[si]; if(!sm) return null; return nombreArt(sm, true) + " acompaña entre cuenta y cuenta."; }
  if(distintos.length === 2){ const a = DATOS.separadores[distintos[0]], b = DATOS.separadores[distintos[1]]; return nombreArt(a, true) + " y " + nombreArt(b, false) + " acompañan entre cuenta y cuenta."; }
  return "Los separadores acompañan entre cuenta y cuenta.";
}
function formaActual(){ return pieza === "japa" ? "guru" : centroForma; }
function centroMinFor(forma){
  if(centroManual[forma] != null) return centroManual[forma];
  const list = LISTS[forma];
  const dom = dominante();
  if(dom >= 0 && list.indexOf(dom) >= 0) return dom;
  return list.length ? list[0] : -1;
}
function centroMinActual(){ return centroMinFor(formaActual()); }
// Trabajo 7d: el centro esta PROPUESTO (default sin elegir) mientras nadie fije su mineral manualmente
function centroEsPropuesto(){ return centroManual[formaActual()] == null; }

/* ===== anclas ===== */
function anclaInfo(mid){
  const m = DATOS.minerales[mid];
  const pub = pieza === "cod" ? m.ancla_cod : m.ancla_japa;
  const deriv = pieza === "cod" ? (m.ancla_cod_derivada != null ? m.ancla_cod_derivada : null) : (m.ancla_japa_derivada != null ? m.ancla_japa_derivada : null);
  const porRazon = m.pulsera8 != null ? m.pulsera8 * razonPieza() : null;
  let used, tipo;
  if(calibAncla === "A"){
    if(pub != null){ used = pub; tipo = "publicada"; }
    else if(porRazon != null){ used = porRazon; tipo = "razon"; }
    else if(deriv != null){ used = deriv; tipo = "derivada"; }
    else { used = m.cuenta8 * razonPieza(); tipo = "estimada"; }
  } else {
    if(porRazon != null){ used = porRazon; tipo = "razon"; }
    else if(deriv != null){ used = deriv; tipo = "derivada"; }
    else { used = m.cuenta8 * razonPieza(); tipo = "estimada"; }
  }
  return { used:used, pub:pub, porRazon:porRazon, deriv:deriv, tipo:tipo, m:m };
}

/* ===== la formula v2 ===== */
function centroDato(){
  // devuelve {cargo, detalle, mid} para la forma y el mineral actuales
  const forma = formaActual();
  const mid = centroMinActual();
  if(mid < 0) return { cargo:0, detalle:"elige el mineral del centro", mid:-1, forma:forma };
  const m = DATOS.minerales[mid];
  if(pieza === "japa"){ return { cargo:0, detalle:"cuenta gurú " + deMin(m) + " + borla de seda natural, incluidos", mid:mid, forma:"guru" }; }
  if(forma === "icosaedro"){ return { cargo:0, detalle:"icosaedro clásico " + deMin(m) + ", incluido en el precio", mid:mid, forma:forma }; }
  if(forma === "c10"){ return { cargo:m.cuenta10, detalle:"cuenta de 10 mm " + deMin(m), mid:mid, forma:forma }; }
  if(forma === "c12"){ return { cargo:m.cuenta12, detalle:"cuenta de 12 mm " + deMin(m), mid:mid, forma:forma }; }
  // flanqueada
  const sm = DATOS.separadores[sepMineralIdx];
  const cargo = 2 * (sm ? sm.por_sep : 0);
  return { cargo:cargo, detalle:"cuenta de 8 mm " + deMin(m) + " + 2 separadores de 4 mm " + deMin(sm), mid:mid, forma:forma };
}

function calcular(){
  coerceCentroForma();                       // R17 · F1: la flanqueada cae a icosaedro si la talla ya no la admite
  const N = CFG[pieza].N;
  const puestas = beads.filter(function(x){ return x != null; });
  const T = puestas.length;
  if(T === 0){ return { vacia:true, N:N, T:0 }; }

  const completa = (T === N);
  // Incompleta: cada cuenta colocada aporta ancla_i / N (suma desde cero).
  // Completa: ponderado clasico (n_i / T), identico a n_i / N cuando T = N.
  const denom = completa ? T : N;

  const cnt = {};
  puestas.forEach(function(x){ cnt[x] = (cnt[x] || 0) + 1; });
  const grupos = Object.keys(cnt).map(function(k){
    const mid = +k, n = cnt[k], a = anclaInfo(mid);
    return { mid:mid, n:n, ancla:a, contrib:(n / denom) * a.used };
  }).sort(function(x,y){ return y.n - x.n; });
  const M = grupos.length;

  let base = 0;
  grupos.forEach(function(g){ base += g.contrib; });

  // separadores (solo cod): dibujados = cobrados, entran ya en la suma incremental.
  // R18 · F1: el costo = suma del por_sep POR SLOT (base u override). El recargo por mezcla suma los
  // minerales de separador ADICIONALES al primero: el primer separador YA vive en la base de siempre y
  // no mueve los precios existentes; cada mineral de 4 mm DISTINTO adicional es otra busqueda en el taller.
  const pat = DATOS.patrones[patronIdx];
  const sepMin = DATOS.separadores[sepMineralIdx];      // el base (compat; el desglose/encargo uniforme lo usa)
  const sepCount = pieza === "cod" ? pat.sep : 0;
  let sepCost = 0, sepGrupos = [], sepDistintos = 0;
  if(sepCount > 0){
    sepPintaSane();
    const nslots = sepSlotCount();
    for(let k = 0; k < nslots; k++){ const s = sepDeSlot(k); sepCost += s ? s.por_sep : 0; }
    sepGrupos = sepGruposUsados();
    sepDistintos = sepGrupos.length;
  }
  const sepAdicionales = sepDistintos > 0 ? sepDistintos - 1 : 0;   // el primero no mueve el precio
  const sepMixto = sepDistintos > 1;
  const Mrec = M + sepAdicionales;                                  // los minerales que cuentan para el recargo

  // centro
  const cen = centroDato();
  const centroCargo = cen.cargo;

  const subtotal = base + sepCost + centroCargo;
  const recargo = subtotal * (Mrec - 1) * recargoPct / 100;
  const conRecargo = subtotal + recargo;

  if(!completa){
    // SUMA DESDE CERO: sin colchon, sin redondeo, sin piso, sin linea exacta.
    return {
      vacia:false, exacta:false, incompleta:true, N:N, T:T, grupos:grupos, M:M, base:base,
      sepCount:sepCount, sepMin:sepMin, sepCost:sepCost, sepGrupos:sepGrupos, sepMixto:sepMixto,
      centroCargo:centroCargo, centroDetalle:cen.detalle, centroMid:cen.mid, forma:cen.forma,
      subtotal:subtotal, recargo:recargo, conRecargo:conRecargo, final:conRecargo, pura:null
    };
  }

  // === PIEZA COMPLETA: la formula de siempre ===
  // PIEZA DE LINEA EXACTA (regla numero uno del fundador; solo en modo Recomendada)
  let pura = null;
  if(M === 1 && grupos[0].ancla.pub != null){ pura = { mid:grupos[0].mid, pub:grupos[0].ancla.pub }; }
  const claveCentro = pieza === "cod" ? (cen.forma === "icosaedro") : true;
  const centroMismo = cen.mid === grupos[0].mid;
  if(calibAncla === "A" && M === 1 && pura && sepCount === 0 && claveCentro && centroMismo){
    return {
      vacia:false, exacta:true, incompleta:false, N:N, T:T, grupos:grupos, M:1,
      centroDetalle:cen.detalle, centroMid:cen.mid, centroCargo:0, forma:cen.forma,
      sepCount:0, sepMin:sepMin, sepCost:0,
      final:pura.pub, pura:pura, subtotal:pura.pub
    };
  }

  // subtotal + recargo por mezcla + colchon + redondeo + piso
  const conColchon = conRecargo * (1 + colchon / 100);
  const redondeado = redondea(conColchon);

  let piso = null;
  grupos.forEach(function(g){ if(g.ancla.pub != null){ if(piso == null || g.ancla.pub < piso) piso = g.ancla.pub; } });
  let pisoAplicado = false, final = redondeado;
  if(piso != null && redondeado < piso){ final = piso; pisoAplicado = true; }

  return {
    vacia:false, exacta:false, incompleta:false, N:N, T:T, grupos:grupos, M:M, base:base,
    sepCount:sepCount, sepMin:sepMin, sepCost:sepCost, sepGrupos:sepGrupos, sepMixto:sepMixto,
    centroCargo:centroCargo, centroDetalle:cen.detalle, centroMid:cen.mid, forma:cen.forma,
    subtotal:subtotal, recargo:recargo, conRecargo:conRecargo, conColchon:conColchon, redondeado:redondeado,
    piso:piso, pisoAplicado:pisoAplicado, final:final, pura:pura
  };
}

/* ===== layout organico: la GOTA (mp11: unica vista) ===== */
// El lienzo ya no tiene carriles rectos: la pieza se lee como un circuito bello.
//  - GOTA: circuito CERRADO en gota/ovalo suave, espejo perfecto izquierda/derecha.
// Produce nodos por indice de cuenta, centros para el toque por cercania,
// separadores sobre el hilo (dibujados = cobrados) y el path del contorno.
function sizeCap(){ return SIZES[pieza]; }

function minGapArr(nodes){
  let m = Infinity;
  for(let i = 1; i < nodes.length; i++){
    const dx = nodes[i].x - nodes[i - 1].x, dy = nodes[i].y - nodes[i - 1].y;
    const d = Math.sqrt(dx * dx + dy * dy);
    if(d < m) m = d;
  }
  return m;
}

// separadores intercalados sobre el hilo (solo cod), a partir de los nodos de una hebra.
// Ronda 16 · LA LEY DEL CIRCULO (fotos de las piezas reales del taller): la pieza es un
// CIRCUITO CERRADO guru -> hebra izquierda -> fondo -> hebra derecha -> guru. Son 45 huecos
// (44 cuentas + guru en circulo). Un separador vive SIEMPRE en un hueco del circuito (entre
// dos cuentas, o pegado al guru, o en el cierre del fondo); JAMAS flota fuera del hilo.
// sepCadencia() es la fuente UNICA: la consumen el observatorio (computeSeps), la charola
// (pintaCharolaSeps), la hoja de armado (mp14ArmadoLista), la estampa y el tamano real.
//   bs     = indices b de la hebra izquierda con separador entre la cuenta b y la b+1 (0..half-2),
//            cada uno con su espejo en la hebra derecha (+2 al total)
//   guru   = separador pegado al guru (uno por hebra, en el hueco entre la principal y la 1a cuenta; +2)
//   cierre = separador en el hueco del cierre del fondo (en el eje, unico; +1)
// TOTAL dibujado = 2*bs.length + 2*guru + cierre == pat.sep EXACTO (el precio ya cobra pat.sep).
// Aritmetica por talla (cod, half=22, 45 huecos), verificada:
//   33 (sep 0):        bs [],                          guru 0, cierre 0  -> 0
//   37 (sep 8, cada6): 1 cuenta pegada al guru, luego bloques de 6; bs [0,6,12,18], guru 0, cierre 0 -> 4*2+0 = 8
//                      (R16b: el fondo es un bloque de 6 cruzando el cierre [3+3], SIN sep al centro; los dos ultimos seps lo flanquean)
//   41 (sep15, cada3): 1 cuenta pegada al guru, luego bloques de 3; bs [0,3,6,9,12,15,18], guru 0, cierre 1 -> 7*2+1 = 15
//   44 (sep23, cada2): separador pegado al guru, bloques de 2 en todo el circuito; bs [1,3,5,7,9,11,13,15,17,19], guru 1, cierre 1 -> 10*2+2+1 = 23
//   54 (sep45, cada1): separador en CADA hueco; bs [0..20], guru 1, cierre 1 -> 21*2+2+1 = 45
function sepCadencia(){
  const out = { bs:[], guru:false, cierre:false };
  if(pieza !== "cod") return out;
  const pat = DATOS.patrones[patronIdx];
  if(!(pat.sep > 0 && pat.cada)) return out;
  const half = CFG[pieza].half, cada = pat.cada;
  // guru/cierre por la ley del fundador: asignacion inicial por cada; el presupuesto EXACTO de
  // pat.sep (paridad de perHebra) realiza el cierre del fondo (R16b: 44 lo gana, 37 lo cede a su bloque de 6).
  //   cada 1  -> separador en cada hueco (guru y cierre)
  //   cada 2  -> separador pegado al guru, bloques de 2; cierre inicial off (44 lo recupera por paridad)
  //   cada 3+ -> 1 cuenta pegada al guru, luego bloques; cierre inicial on (37 lo cede por paridad, fondo = bloque completo)
  let guru, cierre;
  if(cada === 1){ guru = true; cierre = true; }
  else if(cada === 2){ guru = true; cierre = false; }
  else { guru = false; cierre = true; }
  // internos por hebra que caben en el presupuesto EXACTO de pat.sep
  let perHebra = (pat.sep - (guru ? 2 : 0) - (cierre ? 1 : 0)) / 2;
  if(perHebra !== Math.floor(perHebra)){        // si una talla nueva no cuadra la paridad:
    cierre = !cierre;                            // mueve el cierre (residuo al fondo) para cerrar exacto
    perHebra = (pat.sep - (guru ? 2 : 0) - (cierre ? 1 : 0)) / 2;
  }
  out.guru = guru; out.cierre = cierre;
  // huecos internos desde el guru hacia el fondo (cada2 arranca en I1: 1 bloque de 2 pegado al guru);
  // se toman SOLO los que caben en perHebra (el residuo engorda el bloque del fondo)
  const start = (cada === 2) ? 1 : 0;
  for(let b = start, c = 0; b <= half - 2 && c < perHebra; b += cada, c++){ out.bs.push(b); }
  return out;
}
// R17 · F1: "flanqueada" ya SOLO se ofrece en 33 cm (patron sin separadores), donde la cadencia
// jamas trae guru; por eso la fusion flanqueada+guru de R16 quedo como codigo muerto y se retiro.
// El separador pegado al guru se dibuja siempre que la cadencia lo pida.
function sepGuruVisible(cad){ return cad.guru; }
// R17 · F1 · F1b: la forma "flanqueada" es el UNICO centro redondo de 8 mm; el fundador solo la
// admite cuando el patron NO trae separadores (cod 33 cm), donde las 2 cuentas de 4 mm la separan
// y se distingue al llegar a la 45. En 37/41/44/54 el patron ya rodea el centro y la principal debe
// distinguirse por forma (icosaedro) o por tamano (10/12 mm): nada redondo liso de 8 mm.
function sepCadenciaVacia(cad){ cad = cad || sepCadencia(); return cad.bs.length === 0 && !cad.guru && !cad.cierre; }
function flanqueadaDisponible(){ return pieza === "cod" && sepCadenciaVacia(); }
// cae con gracia a icosaedro si la flanqueada dejo de estar disponible (cambio de talla, un MP1
// viejo, un diseno guardado o una semilla): sin error. El mineral en centroManual.flanqueada se
// conserva en memoria por si se vuelve a 33.
function coerceCentroForma(){ if(pieza === "cod" && centroForma === "flanqueada" && !flanqueadaDisponible()){ centroForma = "icosaedro"; }
  /* >>> parche gen (cotizador-c12-fuera) >>> */
  // P10: una forma de cuenta que se quedo sin minerales (la de 12 mm desde el 2-nov) cae al icosaedro clasico: un codigo MP1,
  // un diseno guardado o un deshacer que la traigan abren sin error. El mineral se queda en centroManual, como con la flanqueada.
  if(pieza === "cod" && mpFormaSinLista(centroForma)){ centroForma = "icosaedro"; }
  /* <<< parche gen (cotizador-c12-fuera) <<< */
}
function mpFormaSinLista(f){ return (f === "c10" || f === "c12") && !LISTS[f].length; }   // parche gen (cotizador-c12-fuera)

/* ===== Ronda 18 · F1 · SEPARADORES PERSONALIZABLES POR SLOT =====
   sepCadencia() ya da las posiciones. Aqui vive la maquinaria de SLOTS: un slot es cada
   separador dibujado, en el MISMO orden en que lo empujan computeSeps y pintaCharolaSeps:
     por cada b de cad.bs: [izquierda, derecha]  ·  luego [guruIzq, guruDer]  ·  luego [cierre]
   sepPinta[k] = indice a DATOS.separadores u null (null = el base sepMineralIdx). El gemelo de un
   slot comparte su valor (pintar uno pinta al otro cuando el espejo esta encendido); el cierre es
   gemelo de si mismo. La longitud de sepPinta = numero de slots = pat.sep EXACTO. */
function sepSlotCount(cad){ cad = cad || sepCadencia(); return 2 * cad.bs.length + (cad.guru ? 2 : 0) + (cad.cierre ? 1 : 0); }
// cadencia de un patron/pieza arbitrarios sin cambiar el estado (para el precio/voz de disenos ajenos)
function cadenciaDe(patIdx, pz){ const sp = patronIdx, sz = pieza; patronIdx = patIdx; if(pz) pieza = pz; const c = sepCadencia(); patronIdx = sp; pieza = sz; return c; }
function sepSlotCountFor(patIdx){ return sepSlotCount(cadenciaDe(patIdx, "cod")); }
// gemelo del slot k en la cadencia dada (el cierre y los fuera de rango se devuelven a si mismos)
function sepTwinIdx(k, cad){
  cad = cad || sepCadencia();
  const nb = 2 * cad.bs.length;
  if(k < nb){ return (k % 2 === 0) ? k + 1 : k - 1; }
  if(cad.guru && k < nb + 2){ return (k === nb) ? nb + 1 : nb; }
  return k;   // cierre (o fuera de rango)
}
// indice de separador efectivo del slot k (override propio o el base)
function sepIdxDeSlot(k){ return (Array.isArray(sepPinta) && sepPinta[k] != null) ? sepPinta[k] : sepMineralIdx; }
function sepDeSlot(k){ return DATOS.separadores[sepIdxDeSlot(k)]; }
// true si no hay NINGUN override (la pieza usa un solo separador uniforme: emite MP1 sch2 identico)
function sepPintaTodoNull(){ return !Array.isArray(sepPinta) || sepPinta.every(function(x){ return x == null; }); }
// deja sepPinta con la longitud EXACTA de la cadencia vigente (rellena con null; nunca inventa overrides)
function sepPintaSane(){
  if(pieza !== "cod"){ sepPinta = []; return sepPinta; }
  const need = sepSlotCount();
  if(!Array.isArray(sepPinta)) sepPinta = [];
  if(sepPinta.length !== need){
    const out = new Array(need).fill(null);
    for(let k = 0; k < Math.min(need, sepPinta.length); k++) out[k] = sepPinta[k];
    sepPinta = out;
  }
  return sepPinta;
}
// separadores DISTINTOS realmente usados (base + overrides), en orden por cantidad; para desglose/encargo.
// El primer separador (el mas usado) es "la base" del taller; cada mineral de 4 mm distinto ADICIONAL
// suma una busqueda mas (entra al recargo por mezcla).
function sepGruposUsados(){
  const cnt = {};
  const n = sepSlotCount();
  for(let k = 0; k < n; k++){ const si = sepIdxDeSlot(k); cnt[si] = (cnt[si] || 0) + 1; }
  return Object.keys(cnt).map(function(k){ return { si: +k, n: cnt[k] }; })
    .sort(function(a, b){ return b.n - a.n || DATOS.separadores[a.si].n.localeCompare(DATOS.separadores[b.si].n, "es"); });
}
// remapea los overrides al cambiar de talla: por rol (i-esimo interno -> i-esimo interno; guru->guru;
// cierre->cierre). Los slots nuevos quedan en null (base). Los gemelos comparten valor.
function sepPintaRemap(oldCad, oldPinta, newCad){
  const out = new Array(sepSlotCount(newCad)).fill(null);
  if(!Array.isArray(oldPinta) || !oldPinta.length) return out;
  const oldBs = [];
  for(let i = 0; i < oldCad.bs.length; i++){ oldBs.push(oldPinta[2 * i] != null ? oldPinta[2 * i] : null); }
  const nbOld = 2 * oldCad.bs.length;
  const oldGuru = oldCad.guru ? oldPinta[nbOld] : null;
  const oldCierre = oldCad.cierre ? oldPinta[nbOld + (oldCad.guru ? 2 : 0)] : null;
  for(let i = 0; i < newCad.bs.length; i++){ const v = (i < oldBs.length) ? oldBs[i] : null; if(v != null){ out[2 * i] = v; out[2 * i + 1] = v; } }
  const nbNew = 2 * newCad.bs.length;
  if(newCad.guru && oldGuru != null){ out[nbNew] = oldGuru; out[nbNew + 1] = oldGuru; }
  if(newCad.cierre && oldCierre != null){ out[nbNew + (newCad.guru ? 2 : 0)] = oldCierre; }
  return out;
}
// pinta un slot (y su gemelo si el espejo esta encendido) con el separador si (o null = base)
function sepPintaSlot(k, si){
  sepPintaSane();
  const cad = sepCadencia();
  const val = (si === sepMineralIdx) ? null : si;   // igual al base = sin override
  sepPinta[k] = val;
  if(espejo){ const t = sepTwinIdx(k, cad); if(t !== k) sepPinta[t] = val; }
}
function computeSeps(leftNodes, half, cx, apex){
  const seps = [];
  if(pieza !== "cod") return seps;
  const cad = sepCadencia();
  // internos: punto medio entre la cuenta b y la b+1, sobre el hilo (y su espejo en la otra hebra)
  cad.bs.forEach(function(b){
    const a = leftNodes[b], c = leftNodes[b + 1];
    const p = { x:(a.x + c.x) / 2, y:(a.y + c.y) / 2 };
    seps.push({ x:p.x, y:p.y });
    seps.push({ x:2 * cx - p.x, y:p.y });
  });
  // pegado al guru: en el hueco entre la principal (apice) y la primera cuenta, sobre el hilo (y espejo)
  if(sepGuruVisible(cad)){
    const a = leftNodes[0];
    const p = { x:(apex.x + a.x) / 2, y:(apex.y + a.y) / 2 };
    seps.push({ x:p.x, y:p.y });
    seps.push({ x:2 * cx - p.x, y:p.y });
  }
  // cierre del fondo: en el hueco del eje, punto medio de la ultima cuenta y su gemela (JAMAS fuera del hilo)
  if(cad.cierre){ seps.push({ x:cx, y:leftNodes[half - 1].y }); }
  return seps;
}

// VISTA GOTA: contorno cerrado en forma de gota. Las cuentas se reparten por
// longitud de arco UNIFORME sobre TODO el lazo (mismo paso entre centros), la
// principal vive en el apice como cuenta grande (~1.6x) y el hilo fluye continuo
// hasta el apice sin picos ni "V" (tangente vertical en apice y fondo).
function layoutGota(cw, ch, pad){
  const cfg = CFG[pieza], half = cfg.half, N = cfg.N;
  const cap = sizeCap();
  // region util dentro de las capas flotantes (barra, mesa, precio, ajustes)
  const x0 = pad.left, y0 = pad.top;
  const uw = Math.max(80, cw - pad.left - pad.right);
  const uh = Math.max(140, ch - pad.top - pad.bottom);
  const cx = x0 + uw / 2;

  // el apice vive justo bajo la principal; reservamos con el tope de cuenta para
  // no recortar arriba (la principal real se dimensiona luego con D)
  const guessD = cap.Dmax * 1.6;
  const apexY = y0 + guessD * 0.92 + 6;
  const botY = y0 + uh - 14;
  const spanH = Math.max(90, botY - apexY);
  const amp = Math.min(uw / 2 - 14, spanH * 0.46);
  const P = 0.72;                        // sesgo: la gota es mas ancha abajo

  // contorno de la media izquierda: apice en t=0 (arriba, sobre el eje) y fondo en
  // t=PI (abajo, sobre el eje). El ancho w(t) se anula en ambos extremos con
  // tangente vertical, asi la curva llega al apice y al fondo sin picos.
  const SAMP = 360;
  const px = new Array(SAMP + 1), py = new Array(SAMP + 1), cum = new Array(SAMP + 1);
  for(let s = 0; s <= SAMP; s++){
    const t = Math.PI * s / SAMP;
    const w = Math.sin(t) * Math.pow(Math.sin(t / 2), P);
    px[s] = cx - amp * w;
    py[s] = apexY + spanH * (1 - Math.cos(t)) / 2;
    cum[s] = s === 0 ? 0 : cum[s - 1] + Math.hypot(px[s] - px[s - 1], py[s] - py[s - 1]);
  }
  const Sleft = cum[SAMP], L = 2 * Sleft;

  // punto de la hebra izquierda a una distancia de arco dada (0..Sleft)
  function atArc(a){
    if(a <= 0) return { x:px[0], y:py[0] };
    if(a >= Sleft) return { x:px[SAMP], y:py[SAMP] };
    let lo = 0, hi = SAMP;
    while(lo + 1 < hi){ const m = (lo + hi) >> 1; if(cum[m] < a) lo = m; else hi = m; }
    const f = (a - cum[lo]) / ((cum[hi] - cum[lo]) || 1);
    return { x:px[lo] + (px[hi] - px[lo]) * f, y:py[lo] + (py[hi] - py[lo]) * f };
  }

  // reparto por arco: N cuentas de cuerpo con paso g uniforme + el hueco del apice
  // (2*cApex*g) donde se aloja la principal, mas grande. Con este denominador el
  // fondo tambien cierra a un paso g (la ultima cuenta queda a g/2 del fondo, y su
  // gemela a g/2 del otro lado => cruce del fondo = g, sin holgura doble).
  const cApex = 1.35;
  const g = L / (N - 1 + 2 * cApex);
  const nodes = new Array(N), Lnodes = [];
  for(let k = 0; k < half; k++){
    const p = atArc(g * cApex + k * g);
    const Lp = { x:p.x, y:p.y };
    nodes[k] = Lp;
    nodes[k + half] = { x:2 * cx - p.x, y:p.y };   // gemela espejada
    Lnodes.push(Lp);
  }

  // diametro: por debajo del menor hueco euclidiano real (cero traslapes garantizado)
  let gapMin = Infinity;
  for(let k = 1; k < half; k++){
    const d = Math.hypot(Lnodes[k].x - Lnodes[k - 1].x, Lnodes[k].y - Lnodes[k - 1].y);
    if(d < gapMin) gapMin = d;
  }
  const bgap = 2 * (cx - Lnodes[half - 1].x);   // fondo: ultima izquierda a su gemela
  if(bgap < gapMin) gapMin = bgap;
  let D = Math.min(cap.Dmax, gapMin * 0.88);
  const piso = Math.min(cap.Dmin, gapMin * 0.9);  // el piso nunca fuerza traslape
  if(D < piso) D = piso;

  const principalD = D * 1.6;
  const principalY = apexY - principalD * 0.42;

  const centers = [];
  for(let i = 0; i < N; i++) centers.push({ i:i, x:nodes[i].x, y:nodes[i].y });

  // hilo: el propio contorno cerrado (izquierda apice->fondo, derecha fondo->apice)
  let d = "M " + px[0].toFixed(1) + " " + py[0].toFixed(1);
  for(let s = 1; s <= SAMP; s++) d += " L " + px[s].toFixed(1) + " " + py[s].toFixed(1);
  for(let s = SAMP - 1; s >= 1; s--) d += " L " + (2 * cx - px[s]).toFixed(1) + " " + py[s].toFixed(1);
  d += " Z";

  const seps = computeSeps(Lnodes, half, cx, { x:cx, y:apexY });

  return {
    cw:cw, ch:ch, cx:cx, apexY:apexY, botY:botY, amp:amp, D:D, principalD:principalD, principalY:principalY,
    nodes:nodes, centers:centers, seps:seps, paths:[d],
    maxR: Math.max(20, D * 0.95)
  };
}

function buildLayout(cw, ch, pad){
  return layoutGota(cw, ch, pad);   // mp11: la gota es la unica forma
}

// mide las capas flotantes para que la pieza no quede tapada por ellas
function medirPads(refId){
  const lz = $(refId || "lienzo").getBoundingClientRect();
  // R23 · durante el Paseo el cromo normal esta oculto (visibility:hidden) pero CONSERVA su caja,
  // y estos pads seguian reservando sus huecos: la mesa cargaba la pieza a la izquierda y el
  // precio/contexto la encogian (la queja del fundador: amontonada y a la izquierda). En el Paseo
  // mandan sus capas reales: los carriles arriba y nada mas; la info vive DENTRO del hueco del lazo
  // y las flechas flotan pegadas al borde, sobre su propio velo.
  if(mp20Activo){
    let pTop = 64;
    const carr = $("mp20-carriles");
    if(carr){ const r = carr.getBoundingClientRect(); if(r.height > 0 && r.bottom > lz.top) pTop = Math.max(24, r.bottom - lz.top + 10); }
    return { top:pTop, bottom:18, left:12, right:12 };
  }
  let top = 16, bottom = 16, right = 16, left = 14;
  [".topbar", ".cuartos"].forEach(function(sel){
    const el = document.querySelector(sel);
    if(el && el.offsetParent !== null){ const r = el.getBoundingClientRect(); top = Math.max(top, r.bottom - lz.top + 8); }
  });
  let bottomY = lz.bottom;
  ["precio-wrap", "contexto"].forEach(function(id){
    const el = $(id);
    if(el && el.offsetParent !== null && el.getBoundingClientRect().height > 0){
      const r = el.getBoundingClientRect();
      if(r.top < bottomY) bottomY = r.top;
    }
  });
  bottom = Math.max(16, lz.bottom - bottomY + 8);
  const mz = $("mesa");
  if(mz && mz.offsetParent !== null && mz.getBoundingClientRect().width > 0){
    const r = mz.getBoundingClientRect();
    right = Math.max(right, lz.right - r.left + 8);
  }
  return { top:top, bottom:bottom, left:left, right:right };
}

// cuenta mas cercana a (x,y) dentro del radio; -1 si no hay ninguna en rango
function nearestBead(x, y){
  let best = -1, bd = Infinity;
  LAYOUT.centers.forEach(function(c){ const dx = c.x - x, dy = c.y - y, d = dx * dx + dy * dy; if(d < bd){ bd = d; best = c.i; } });
  return (best >= 0 && bd <= LAYOUT.maxR * LAYOUT.maxR) ? best : -1;
}

function smoothPath(pts){
  if(pts.length < 2) return "";
  let d = "M " + pts[0].x.toFixed(1) + " " + pts[0].y.toFixed(1);
  for(let i = 0; i < pts.length - 1; i++){
    const p0 = pts[i - 1] || pts[i], p1 = pts[i], p2 = pts[i + 1], p3 = pts[i + 2] || pts[i + 1];
    const c1x = p1.x + (p2.x - p0.x) / 6, c1y = p1.y + (p2.y - p0.y) / 6;
    const c2x = p2.x - (p3.x - p1.x) / 6, c2y = p2.y - (p3.y - p1.y) / 6;
    d += " C " + c1x.toFixed(1) + " " + c1y.toFixed(1) + " " + c2x.toFixed(1) + " " + c2y.toFixed(1) + " " + p2.x.toFixed(1) + " " + p2.y.toFixed(1);
  }
  return d;
}

// Trabajo 7c: polilinea con esquinas redondeadas (curva de Bezier en cada vuelta; los tramos rectos siguen rectos)
function roundedPath(pts, r){
  if(pts.length < 2) return "";
  if(pts.length === 2) return "M " + pts[0].x.toFixed(1) + " " + pts[0].y.toFixed(1) + " L " + pts[1].x.toFixed(1) + " " + pts[1].y.toFixed(1);
  let d = "M " + pts[0].x.toFixed(1) + " " + pts[0].y.toFixed(1);
  for(let i = 1; i < pts.length - 1; i++){
    const p0 = pts[i - 1], p1 = pts[i], p2 = pts[i + 1];
    const v1x = p1.x - p0.x, v1y = p1.y - p0.y, len1 = Math.hypot(v1x, v1y) || 1;
    const v2x = p2.x - p1.x, v2y = p2.y - p1.y, len2 = Math.hypot(v2x, v2y) || 1;
    const rr = Math.min(r, len1 / 2, len2 / 2);
    const ax = p1.x - v1x / len1 * rr, ay = p1.y - v1y / len1 * rr;
    const bx = p1.x + v2x / len2 * rr, by = p1.y + v2y / len2 * rr;
    d += " L " + ax.toFixed(1) + " " + ay.toFixed(1);
    d += " Q " + p1.x.toFixed(1) + " " + p1.y.toFixed(1) + " " + bx.toFixed(1) + " " + by.toFixed(1);
  }
  const last = pts[pts.length - 1];
  d += " L " + last.x.toFixed(1) + " " + last.y.toFixed(1);
  return d;
}

/* ===== los dos cuartos: orden serpentina y render de la charola ===== */
// El orden de lectura de la pieza (serpentina con el centro al medio):
//   cod  = 22 | C | 22  (45 espacios)   ·   japa = 54 | G | 54  (109 espacios)
// linea L (0..N): antes del centro va la mitad izquierda del fondo a la principal;
// el centro en L=half; despues la mitad derecha de la principal al fondo.
function linToBead(L){ const half = CFG[pieza].half; if(L < half) return half - 1 - L; if(L === half) return -1; return L - 1; }
function beadToLin(i){ const half = CFG[pieza].half; return i < half ? half - 1 - i : i + 1; }

// cuantas columnas por franja segun pieza y viewport (llenar la pantalla equilibrado)
function charolaColumns(p, W, H, S){
  const rng = p === "cod" ? [6, 9] : [8, 12];
  let bestC = rng[0], bestCell = 0;
  for(let C = rng[0]; C <= rng[1]; C++){
    const R = Math.ceil(S / C);
    const cell = Math.min(W / C, H / R);
    if(cell > bestCell){ bestCell = cell; bestC = C; }
  }
  return bestC;
}

// guarda la ultima geometria de la charola para el arrastre y el intercambio
let CHAROLA = { C:7, R:1, cellW:0, cellH:0, x0:0, y0:0, D:0 };

function renderCharola(){
  const host = $("charola");
  const cw = host.clientWidth, ch = host.clientHeight;
  if(cw < 8 || ch < 8) return;
  const pad = medirPads("charola");
  const x0 = pad.left, y0 = pad.top;
  const W = Math.max(80, cw - pad.left - pad.right);
  // Trabajo 7b: reserva el alto REAL del texto guia + respiro para que ninguna cuenta quede cortada ni lo toque
  let guiaReserva = 160;   // respaldo generoso para el primer pintado (aun no existe el texto para medirlo)
  const oldGuia = host.querySelector(".charola-invita");
  if(oldGuia){ const gr = oldGuia.getBoundingClientRect(); if(gr.height > 0) guiaReserva = (ch - (gr.top - host.getBoundingClientRect().top)) + 12; }
  const H = Math.max(120, ch - pad.top - Math.max(pad.bottom, guiaReserva));
  const N = CFG[pieza].N, half = CFG[pieza].half, S = N + 1;
  const C = charolaColumns(pieza, W, H, S);
  const R = Math.ceil(S / C);
  const cellW = W / C, cellH = H / R;
  // diametro de cuenta: llena el hueco
  let D = Math.min(cellW, cellH) * 0.82;
  const cD = D * 1.32;                       // el centro, un poco mas grande
  CHAROLA = { C:C, R:R, cellW:cellW, cellH:cellH, x0:x0, y0:y0, D:D };

  function cellCenter(L){
    const row = Math.floor(L / C), pos = L % C;
    const col = (row % 2 === 0) ? pos : (C - 1 - pos);
    return { x: x0 + col * cellW + cellW / 2, y: y0 + row * cellH + cellH / 2 };
  }
  // Trabajo 7c: el hilo/cordon que enhebra los espacios en su orden, con esquinas redondeadas en las vueltas
  const hiloPts = [];
  for(let L = 0; L < S; L++){ hiloPts.push(cellCenter(L)); }
  const rEsquina = Math.min(cellW, cellH) * 0.44;
  const dpath = roundedPath(hiloPts, rEsquina);
  let html = '<svg class="charola-hilos" viewBox="0 0 ' + cw + ' ' + ch + '" preserveAspectRatio="none" aria-hidden="true"><path d="' + dpath + '"></path></svg>';
  for(let L = 0; L < S; L++){
    const c = cellCenter(L);
    if(L === half){ html += centroSlotHTML(c, cD); }
    else { html += huecoHTML(linToBead(L), c, D); }
  }
  html += '<p class="charola-invita" id="charola-invita">' + charolaInvita() + '</p>';
  host.className = "charola" + (tocada ? " tocada" : "");
  host.innerHTML = html;
  pintaCharolaSeps(host);                    // Ronda 15 · separadores en su lugar real entre cuentas
  if(!reduce && justPainted.length){
    justPainted.forEach(function(i){ const el = host.querySelector('[data-i="' + i + '"]'); if(el) el.classList.add("nueva"); });
  }
  justPainted = [];
  if(respiroPend && !reduce && cuarto === "charola"){ requestAnimationFrame(iniciaRespiro); }  // Ronda 8 · T5
}

/* ===== Ronda 15 · separadores de la charola EN SU LUGAR REAL =====
   Solo codificador con separadores. Consume sepCadencia(), LA MISMA fuente que
   computeSeps del observatorio y la hoja de armado: cada separador cae en el punto
   medio entre los centros de las dos celdas que separa, como cuenta redonda chica
   con el retrato real del mineral separador (fallback al gradiente). Sin interaccion. */
function pintaCharolaSeps(host){
  if(pieza !== "cod") return;
  const pat = DATOS.patrones[patronIdx];
  if(!pat || !(pat.sep > 0)) return;
  const cad = sepCadencia();
  const half = CFG[pieza].half, S = CFG[pieza].N + 1;
  const C = CHAROLA.C, cw = CHAROLA.cellW, chh = CHAROLA.cellH;
  if(!(cw > 0 && chh > 0)) return;
  function cellCenter(L){
    const row = Math.floor(L / C), pos = L % C;
    const col = (row % 2 === 0) ? pos : (C - 1 - pos);
    return { x: CHAROLA.x0 + col * cw + cw / 2, y: CHAROLA.y0 + row * chh + chh / 2 };
  }
  function mid(La, Lb){ const a = cellCenter(La), b = cellCenter(Lb); return { x:(a.x + b.x) / 2, y:(a.y + b.y) / 2 }; }
  const pts = [];
  cad.bs.forEach(function(b){
    pts.push(mid(half - 1 - b, half - 2 - b));   // hebra izquierda: entre la cuenta b y la b+1
    pts.push(mid(b + half + 1, b + half + 2));   // su espejo en la hebra derecha
  });
  if(sepGuruVisible(cad)){                        // Ronda 16 · pegado al guru (el centro esta en L=half)
    pts.push(mid(half - 1, half));                // hueco entre la 1a cuenta y el centro
    pts.push(mid(half, half + 1));                // su espejo, entre el centro y la 1a cuenta de la otra hebra
  }
  if(cad.cierre){                                 // Ronda 16 · el separador del cierre del fondo (uno solo)
    const a0 = cellCenter(0), a1 = cellCenter(1); // donde el hilo cierra, mas alla de la 1a celda (fondo)
    pts.push({ x:a0.x + (a0.x - a1.x) * 0.5, y:a0.y + (a0.y - a1.y) * 0.5 });
  }
  // R18 · F1: cada slot lee su propio mineral (override o base); tocables con el pincel de separadores activo
  sepPintaSane();
  const sd = CHAROLA.D * 0.44;
  const op = respiroPend ? "0" : "1";
  const sepPintaOn = sepBrush >= 0;
  let frag = "";
  pts.forEach(function(p, k){
    const s = sepDeSlot(k), f = fillSep(s);
    const lbl = "separador de 4 mm " + deMin(s);
    const dataAttr = sepPintaOn ? (' data-sepslot="' + k + '"') : '';
    const tapCls = sepPintaOn ? ' mp18-tap' : '';
    frag += '<span class="mp15-charola-sep ' + f.cls + tapCls + '"' + dataAttr + ' title="' + lbl + '" aria-label="' + lbl + '" role="img" style="' + f.style + 'left:'
      + p.x.toFixed(1) + 'px;top:' + p.y.toFixed(1) + 'px;width:' + sd.toFixed(1) + 'px;height:' + sd.toFixed(1) + 'px;opacity:' + op + '"></span>';
  });
  host.insertAdjacentHTML("beforeend", frag);
}

/* ===== Ronda 8 · T5 · la respiracion de entrada (solo la primera carga de la sesion) ===== */
let respiroPend = !reduce;
function iniciaRespiro(){
  if(!respiroPend) return;
  respiroPend = false;
  if(reduce) return;
  const host = $("charola"); if(!host) return;
  // el hilo se dibuja solo (stroke-dashoffset del path existente)
  const path = host.querySelector("svg.charola-hilos path");
  if(path){
    let len = 0; try{ len = path.getTotalLength(); }catch(_){ len = 0; }
    if(len > 0){
      path.style.transition = "none";
      path.style.strokeDasharray = len + " " + len;
      path.style.strokeDashoffset = String(len);
      path.getBoundingClientRect();          // fuerza el reflow antes de animar
      path.style.transition = "stroke-dashoffset 1.6s ease-out";
      path.style.strokeDashoffset = "0";
    }
  }
  // los huecos aparecen en cascada siguiendo el orden serpentina (delays escalonados)
  const huecos = host.querySelectorAll(".hueco");
  const n = huecos.length, stag = Math.min(20, 900 / Math.max(1, n));
  huecos.forEach(function(el, k){ el.style.animationDelay = Math.round(k * stag) + "ms"; el.classList.add("mp8-entra"); });
  // los separadores aparecen una vez dibujado el hilo
  const seps = host.querySelectorAll(".mp15-charola-sep");
  seps.forEach(function(el){ el.style.transition = "opacity .5s ease"; });
  setTimeout(function(){ host.querySelectorAll(".mp15-charola-sep").forEach(function(el){ el.style.opacity = "1"; }); }, 1100);
}

function charolaInvita(){
  return "Toca un mineral de la mesa y llena los espacios de la charola. El orden no cambia el precio.";
}

function huecoHTML(i, c, D){
  const mid = beads[i];
  const lin = beadToLin(i), total = CFG[pieza].N + 1;
  const rep = (reemplazo != null && (reemplazo.index === i || (espejo && twin(reemplazo.index) === i))) ? " reemplazando" : "";
  const base = 'style="left:' + c.x.toFixed(1) + 'px;top:' + c.y.toFixed(1) + 'px;width:' + D.toFixed(1) + 'px;height:' + D.toFixed(1) + 'px;';
  const lugar = "espacio " + (lin + 1) + " de " + total;
  if(mid == null){
    return '<button class="hueco vacia' + rep + '" ' + base + '" data-i="' + i + '" aria-label="' + lugar + ': por nombrar"></button>';
  }
  const f = fillMin(mid);
  return '<button class="hueco fill ' + f.cls + rep + '" ' + base + f.style + '" data-i="' + i + '" aria-label="' + lugar + ': ' + nombreArt(DATOS.minerales[mid], false) + '"></button>';
}

function centroSlotHTML(c, D){
  const cm = centroMinActual();
  const base = 'style="left:' + c.x.toFixed(1) + 'px;top:' + c.y.toFixed(1) + 'px;width:' + D.toFixed(1) + 'px;height:' + D.toFixed(1) + 'px;';
  const cabeza = pieza === "cod" ? "el centro, el icosaedro" : "la cuenta gurú";
  if(cm < 0){
    return '<button class="hueco centro vacia" ' + base + '" data-centro-slot="1" aria-label="' + cabeza + ': por nombrar. Tócalo para elegir su mineral"></button>';
  }
  const f = fillMin(cm);
  const prop = centroEsPropuesto() ? " propuesto" : "";   // Trabajo 7d: tenue mientras sea el default
  const aria = 'data-centro-slot="1" aria-label="' + cabeza + ' ' + deMin(DATOS.minerales[cm]) + (prop ? " (propuesto)" : "") + '. Tócalo para elegir su mineral"';
  // R17 · F4: la celda del centro de la charola cuenta la MISMA verdad de forma que el observatorio
  //   icosaedro -> silueta facetada (mismo clip-path que la gema del observatorio)
  //   flanqueada (solo 33) -> redonda de 8 mm entre 2 flancos
  //   10/12 mm (cod) o guru (japa) -> redonda, como hoy
  const forma = formaActual();
  if(pieza === "cod" && forma === "icosaedro"){
    return '<button class="hueco centro mp17-ico' + prop + '" ' + base + '" ' + aria + '><span class="mp17-gema fill ' + f.cls + '" style="' + f.style + '"></span></button>';
  }
  if(pieza === "cod" && forma === "flanqueada"){
    const sm = DATOS.separadores[sepMineralIdx], sf = fillSep(sm), fd = D * 0.42;
    return '<button class="hueco centro mp17-flanq' + prop + '" ' + base + '" ' + aria + '>'
      + '<span class="mp17-flanco fill ' + sf.cls + '" style="left:' + (-fd * 0.62).toFixed(1) + 'px;width:' + fd.toFixed(1) + 'px;height:' + fd.toFixed(1) + 'px;' + sf.style + '"></span>'
      + '<span class="mp17-flanco fill ' + sf.cls + '" style="right:' + (-fd * 0.62).toFixed(1) + 'px;width:' + fd.toFixed(1) + 'px;height:' + fd.toFixed(1) + 'px;' + sf.style + '"></span>'
      + '<span class="mp17-redonda fill ' + f.cls + '" style="' + f.style + '"></span></button>';
  }
  return '<button class="hueco centro fill ' + f.cls + prop + '" ' + base + f.style + '" ' + aria + '></button>';
}

// renderiza el cuarto activo (la charola o el observatorio)
function renderCuarto(){ coerceCentroForma(); if(cuarto === "observatorio") renderLienzo(); else renderCharola(); }

// cambia de cuarto (Ronda 8: la transicion viva · las cuentas viajan de una forma a la otra)
function setCuarto(c){
  if(c === cuarto) return;
  ocultaVoz();
  const anim = !reduce;
  const src = anim ? mp8Rects(cuarto) : null;   // posiciones de origen (cuarto actual, aun visible)
  cuarto = c;
  zoom = 1; panX = 0; panY = 0;
  $("app").dataset.cuarto = c;
  actualizaTabs();
  renderContexto();
  renderCuarto();
  updateCotizacion();
  if(anim && src){
    const dst = mp8Rects(c);                     // posiciones de destino (cuarto nuevo, ya renderizado)
    mp8Transicion(src, dst);
  }
}

/* ===== Ronda 8 · T1 · la transicion viva entre cuartos ===== */
// lee el centro (x,y) y el diametro de cada cuenta y del centro en el cuarto dado
function mp8Rects(room){
  const host = room === "observatorio" ? $("escena") : $("charola");
  const res = { beads:{}, centro:null };
  if(!host) return res;
  const N = CFG[pieza].N;
  for(let i = 0; i < N; i++){
    const el = host.querySelector('[data-i="' + i + '"]');
    if(el){ const r = el.getBoundingClientRect(); if(r.width > 0) res.beads[i] = { x:r.left + r.width / 2, y:r.top + r.height / 2, d:r.width }; }
  }
  const cs = room === "observatorio" ? host.querySelector("[data-principal]") : host.querySelector("[data-centro-slot]");
  if(cs){ const r = cs.getBoundingClientRect(); if(r.width > 0) res.centro = { x:r.left + r.width / 2, y:r.top + r.height / 2, d:r.width }; }
  return res;
}
// clones absolutos en una capa de transicion: transform + opacity solamente, escalonado sutil
function mp8Transicion(src, dst){
  const capa = document.createElement("div"); capa.className = "mp8-trans-capa";
  const block = document.createElement("div"); block.className = "mp8-trans-block";
  room.appendChild(block); room.appendChild(capa);
  $("app").setAttribute("data-mp8trans", "1");
  const DUR = 600, STAG = 120;
  const clones = [];
  function addClon(s, d, color, extra){
    if(!s || !d || !(s.d > 0)) return;
    const el = document.createElement("div");
    el.className = "mp8-trans-clon" + (extra ? (" " + extra) : "");
    el.style.left = (s.x - s.d / 2).toFixed(1) + "px";
    el.style.top = (s.y - s.d / 2).toFixed(1) + "px";
    el.style.width = s.d.toFixed(1) + "px";
    el.style.height = s.d.toFixed(1) + "px";
    if(color) el.style.background = color;
    capa.appendChild(el);
    clones.push({ el:el, dx:(d.x - s.x), dy:(d.y - s.y), sc:(d.d / s.d) });
  }
  const N = CFG[pieza].N;
  for(let i = 0; i < N; i++){
    const mid = beads[i];
    if(mid == null) continue;                    // pieza vacia: transicion minima (solo el hilo/centro)
    addClon(src.beads[i], dst.beads[i], COL[mid].c);
  }
  const cm = centroMinActual();
  if(cm >= 0) addClon(src.centro, dst.centro, COL[cm].c, "mp8-clon-centro");
  const total = clones.length;
  requestAnimationFrame(function(){
    requestAnimationFrame(function(){
      clones.forEach(function(c, k){
        const delay = total > 1 ? Math.round(k / (total - 1) * STAG) : 0;
        c.el.style.transition = "transform " + DUR + "ms cubic-bezier(.4,0,.2,1) " + delay + "ms";
        c.el.style.transform = "translate(" + c.dx.toFixed(1) + "px," + c.dy.toFixed(1) + "px) scale(" + c.sc.toFixed(3) + ")";
      });
    });
  });
  setTimeout(function(){
    $("app").removeAttribute("data-mp8trans");
    if(capa.parentNode) capa.parentNode.removeChild(capa);
    if(block.parentNode) block.parentNode.removeChild(block);
  }, DUR + STAG + 60);
}
function actualizaTabs(){
  const a = $("tab-charola"), b = $("tab-observatorio");
  if(a) a.setAttribute("aria-selected", cuarto === "charola");
  if(b) b.setAttribute("aria-selected", cuarto === "observatorio");
}

/* ===== render del lienzo ===== */
function renderLienzo(){
  const lz = $("lienzo");
  const cw = lz.clientWidth, ch = lz.clientHeight;
  if(cw < 8 || ch < 8) return;
  const pad = medirPads();
  const L = buildLayout(cw, ch, pad);
  LAYOUT = { centers:L.centers, maxR:L.maxR, cw:cw, ch:ch, cx:L.cx, apexY:L.apexY, botY:L.botY, amp:L.amp, D:L.D };

  const N = CFG[pieza].N;
  let svg = '<svg class="hilos" viewBox="0 0 ' + cw + ' ' + ch + '" preserveAspectRatio="none" aria-hidden="true">';
  L.paths.forEach(function(d){ svg += '<path d="' + d + '"></path>'; });
  svg += '</svg>';
  let html = svg;

  // separadores primero (debajo de las cuentas) · R18 · F1: cada slot lee su propio mineral (override o base)
  sepPintaSane();
  const sd = Math.max(6, L.D * 0.42);
  const sepPintaOn = sepBrush >= 0;              // con el pincel de separadores activo, los sepdots se tocan
  L.seps.forEach(function(p, k){
    const s = sepDeSlot(k), f = fillSep(s);
    const extra = sepPintaOn ? (' mp18-tap" data-sepslot="' + k + '" aria-label="separador de 4 mm ' + deMin(s) + '"') : '"';
    html += '<span class="sepdot fill ' + f.cls + extra + ' style="left:' + p.x.toFixed(1) + 'px;top:' + p.y.toFixed(1) + 'px;width:' + sd.toFixed(1) + 'px;height:' + sd.toFixed(1) + 'px;' + f.style + '"></span>';
  });

  // cuentas del cuerpo (por indice: la gemela ya vive en su posicion espejada)
  for(let i = 0; i < N; i++){ html += beadHTML(i, L.nodes[i], L.D); }

  // principal
  html += principalHTML(L);

  lz.className = "lienzo " + pieza + " gota" + (tocada ? " tocada" : "");   // mp11: la gota es la unica forma
  const esc = $("escena");
  esc.innerHTML = html;

  // pulso de recien pintadas
  if(!reduce && justPainted.length){
    justPainted.forEach(function(i){
      const el = esc.querySelector('[data-i="' + i + '"]');
      if(el) el.classList.add("nueva");
    });
  }
  justPainted = [];
  clampPan();
  applyZoom();
}

/* ===== el zoom de verdad ===== */
function clampZoom(z){ return Math.max(1, Math.min(3, z)); }
function clampPan(){
  const cw = LAYOUT.cw || $("lienzo").clientWidth, ch = LAYOUT.ch || $("lienzo").clientHeight;
  panX = Math.min(0, Math.max(cw * (1 - zoom), panX));
  panY = Math.min(0, Math.max(ch * (1 - zoom), panY));
}
function applyZoom(){
  const e = $("escena");
  if(e) e.style.transform = "translate(" + panX.toFixed(2) + "px," + panY.toFixed(2) + "px) scale(" + zoom.toFixed(4) + ")";
  $("zoom-pill").hidden = !(zoom > 1.001);
}
function suaveZoom(on){ const e = $("escena"); if(!e) return; e.classList.toggle("suave", !reduce && !!on); }
// pantalla -> coordenadas del layout (invierte la transformacion del zoom)
function screenToLayout(clientX, clientY){
  const r = $("lienzo").getBoundingClientRect();
  return { x:(clientX - r.left - panX) / zoom, y:(clientY - r.top - panY) / zoom };
}
function zoomAPunto(clientX, clientY, z, suave){
  const r = $("lienzo").getBoundingClientRect();
  const lx = (clientX - r.left - panX) / zoom, ly = (clientY - r.top - panY) / zoom;
  zoom = clampZoom(z);
  panX = (clientX - r.left) - lx * zoom;
  panY = (clientY - r.top) - ly * zoom;
  clampPan(); suaveZoom(suave); applyZoom();
}
function resetZoom(suave){ zoom = 1; panX = 0; panY = 0; suaveZoom(suave); applyZoom(); }

function beadHTML(i, c, D){
  const mid = beads[i];
  const half = CFG[pieza].half;
  const lado = i < half ? "izquierda" : "derecha";
  const fila = (i % half) + 1;
  const lugar = "cuenta " + fila + " de la hebra " + lado;
  const rep = (reemplazo != null && (reemplazo.index === i || (espejo && twin(reemplazo.index) === i))) ? " reemplazando" : "";
  const base = 'style="left:' + c.x.toFixed(1) + 'px;top:' + c.y.toFixed(1) + 'px;width:' + D.toFixed(1) + 'px;height:' + D.toFixed(1) + 'px;';
  if(mid == null){
    return '<button class="cuenta vacia' + rep + '" ' + base + '" data-i="' + i + '" aria-label="' + lugar + ': por nombrar"></button>';
  }
  const f = fillMin(mid);
  return '<button class="cuenta fill ' + f.cls + rep + '" ' + base + f.style + '" data-i="' + i + '" aria-label="' + lugar + ': ' + nombreArt(DATOS.minerales[mid], false) + '"></button>';
}

function principalHTML(L){
  const cm = centroMinActual();
  const esCod = pieza === "cod";
  const base = 'style="left:' + L.cx.toFixed(1) + 'px;top:' + L.principalY.toFixed(1) + 'px;width:' + L.principalD.toFixed(1) + 'px;height:' + L.principalD.toFixed(1) + 'px;';
  let out = "";
  if(cm < 0){
    const cls = esCod ? "principal vacia" : "principal vacia redondo";
    const lbl = esCod ? "cuenta principal, el icosaedro: por nombrar" : "cuenta gurú: por nombrar";
    out = '<button class="' + cls + '" ' + base + '" data-principal="1" aria-label="' + lbl + '"></button>';
  } else {
    const m = DATOS.minerales[cm];
    const f = fillMin(cm);
    const forma = formaActual();
    // Trabajo 7d: si el centro sigue en su mineral por defecto (nadie lo eligio), se ve PROPUESTO (tenue, con su aro)
    const prop = centroEsPropuesto() ? " propuesto" : "";
    const sufAria = prop ? " (propuesto, elígelo o cámbialo)" : "";
    if(esCod && forma === "icosaedro"){
      out = '<button class="principal anima' + prop + '" ' + base + '" data-principal="1" aria-label="cuenta principal, el icosaedro ' + deMin(m) + sufAria + '">'
        + '<span class="halo"></span><span class="gema fill ' + f.cls + '" style="' + f.style + '"></span></button>';
    } else if(esCod && forma === "flanqueada"){
      const sm = DATOS.separadores[sepMineralIdx];
      const sf = fillSep(sm);
      const fd = L.principalD * 0.42;
      out = '<button class="principal' + prop + '" ' + base + '" data-principal="1" aria-label="centro flanqueado: cuenta de 8 mm ' + deMin(m) + ' entre 2 separadores ' + deMin(sm) + sufAria + '">'
        + '<span class="flanco fill ' + sf.cls + '" style="left:' + (-fd * 0.72) + 'px;width:' + fd + 'px;height:' + fd + 'px;' + sf.style + '"></span>'
        + '<span class="flanco fill ' + sf.cls + '" style="right:' + (-fd * 0.72) + 'px;width:' + fd + 'px;height:' + fd + 'px;' + sf.style + '"></span>'
        + '<span class="redonda fill ' + f.cls + '" style="' + f.style + '"></span></button>';
    } else {
      // c10 / c12 (cod) o guru (japa): bola grande con retrato
      const lbl = esCod ? ("cuenta grande del centro " + deMin(m)) : ("cuenta gurú " + deMin(m));
      out = '<button class="principal' + (esCod ? "" : " anima") + prop + '" ' + base + '" data-principal="1" aria-label="' + lbl + sufAria + '">'
        + '<span class="redonda fill ' + f.cls + '" style="' + f.style + '"></span></button>';
    }
  }
  // borla del japa
  if(!esCod && cm >= 0){
    const bw = L.principalD * 0.5;
    const bh = L.principalD * 0.9;
    out += '<span class="borla" style="left:' + L.cx.toFixed(1) + 'px;top:' + (L.principalY + L.principalD * 0.42).toFixed(1) + 'px;width:' + bw.toFixed(1) + 'px">'
      + '<i style="height:' + (bh * 0.78).toFixed(1) + 'px"></i><i style="height:' + bh.toFixed(1) + 'px"></i><i style="height:' + (bh * 0.88).toFixed(1) + 'px"></i><i style="height:' + (bh * 0.7).toFixed(1) + 'px"></i></span>';
  }
  return out;
}

/* ===== LA MESA: los 5 pinceles a la mano ===== */
function conteoMineral(mid){ let n = 0; for(let i = 0; i < beads.length; i++){ if(beads[i] === mid) n++; } return n; }

function renderMesa(){
  const el = $("mesa");
  let h = "";
  // R23 O3 · F2 · boton discreto que expande la mesa (todos los pinceles a la vista); oculto en desktop por CSS
  h += '<button class="mp23-mesa-exp" id="mp23-mesa-exp" aria-label="Ver todos tus pinceles a la vez" aria-expanded="' + (mp23MesaAbierta ? "true" : "false") + '">'
    + '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8 10l4-4 4 4M8 14l4 4 4-4"/></svg></button>';
  mesa.forEach(function(s){
    const m = DATOS.minerales[s.mid];
    const f = fillMin(s.mid);
    const cnt = conteoMineral(s.mid);
    const lbl = "Pincel " + nombreArt(m, false) + (cnt > 0 ? (", " + cnt + " en la pieza") : "") + (s.fija ? ", fijado" : "");
    h += '<button class="slot" aria-pressed="' + (brush === s.mid) + '" data-slot-mid="' + s.mid + '" aria-label="' + lbl + '">';
    h += '<span class="slot-r fill ' + f.cls + '" style="' + f.style + '"></span>';
    if(cnt > 0) h += '<span class="slot-badge">' + cnt + '</span>';
    if(s.fija) h += '<span class="slot-pin" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M12 3l0 8M8 11h8l-2 4h-4l-2-4zM12 15l0 6"/></svg></span>';
    h += '<span class="slot-n">' + m.n + '</span>';
    h += '</button>';
  });
  const T = beads.filter(function(x){ return x != null; }).length;
  if(mesa.length) h += '<span class="mesa-sep"></span>';
  if(brush >= 0 || T > 0){
    h += '<button class="mesa-varita" id="mesa-varita" aria-label="Acciones del pincel: llenar o vaciar">'
      + '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2l1.5 3.6L17 7l-3.5 1.4L12 12l-1.5-3.6L7 7l3.5-1.4zM5 14l2 .8L8 17l1-2.2 2-.8-2-.8L8 11l-1 2.2zM17 14l1.2 .6.6 1.4.6-1.4 1.2-.6-1.2-.6-.6-1.4-.6 1.4z"/></svg></button>';
  }
  h += '<button class="mesa-mas" id="mesa-mas" aria-label="Agregar minerales: abre el explorador">'
    + '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg></button>';
  // R18 · F1 · seccion de separadores (solo cod con separadores: 37/41/44/54). Cada chip es un pincel
  // de separador; tocarlo lo activa y apaga el pincel de cuentas. El "+" abre el selector completo.
  if(pieza === "cod" && DATOS.patrones[patronIdx] && DATOS.patrones[patronIdx].sep > 0){
    h += '<span class="mesa-sep"></span>';
    h += '<span class="mesa-seplbl">sep</span>';
    sepMesaChips().forEach(function(si){
      const s = DATOS.separadores[si], f = fillSep(s);
      const on = (sepBrush === si);
      const lbl = "Pincel de separador " + nombreArt(s, false) + ", " + money(s.por_sep) + " cada uno" + (on ? ", activo" : "");
      h += '<button class="slot sepslot" aria-pressed="' + on + '" data-sep-pincel="' + si + '" aria-label="' + lbl + '">'
        + '<span class="slot-r fill ' + f.cls + '" style="' + f.style + '"></span>'
        + '<span class="slot-n">' + s.n + '</span></button>';
    });
    h += '<button class="mesa-mas mesa-sep-mas" id="mesa-sep-mas" aria-label="Elegir otro mineral para pintar separadores">'
      + '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="7.5" cy="9" r="2.2"/><circle cx="16.5" cy="9" r="2.2"/><circle cx="12" cy="15" r="2.2"/></svg></button>';
  }
  el.innerHTML = h;
  if(mp23MesaAbierta) mp23RenderMesaPanel();   // R23 O3 · F2: el panel expandido se mantiene en sync con la mesa
}
// R18 · F1 · los separadores que la mesa ofrece como pincel: el base, los ya pintados y el activo
function sepMesaChips(){
  const out = [];
  function add(si){ if(si != null && si >= 0 && DATOS.separadores[si] && out.indexOf(si) < 0) out.push(si); }
  add(sepMineralIdx);
  if(Array.isArray(sepPinta)) sepPinta.forEach(function(si){ add(si); });
  add(sepBrush);
  return out.slice(0, 6);
}

// Ronda 9: la mesa arranca sembrada con 4 pinceles curados de colores bien distintos y presencia clasica de la casa.
// Solo siembra si la mesa esta vacia de verdad (no pisa recientes reales); brush queda sin elegir.
function mesaSembrar(){
  if(mesa.length) return;
  const idx = mineralIdxPorNombre();
  const curados = ["Amatista", "Ojo de Tigre", "Howlita", "Lapislázuli"];   // morado, ambar, blanco, azul
  curados.forEach(function(n){ const i = idx[n]; if(i != null && !mesa.some(function(s){ return s.mid === i; })) mesa.push({ mid:i, fija:false }); });
}
// usa un mineral: entra a la mesa (recientes) y queda como pincel
function mesaUsar(mid){
  const hadSep = sepBrush >= 0;
  if(hadSep) sepBrush = -1;                   // R18 · F1: usar un pincel de cuenta apaga el de separadores
  const ex = mesa.find(function(s){ return s.mid === mid; });
  if(ex && ex.fija){ brush = mid; renderMesa(); if(hadSep) renderCuarto(); return; }
  mesa = mesa.filter(function(s){ return s.mid !== mid; });
  mesa.unshift({ mid:mid, fija:false });
  ordenaMesa();
  while(mesa.length > 5){
    let quitada = false;
    for(let i = mesa.length - 1; i >= 0; i--){ if(!mesa[i].fija){ mesa.splice(i, 1); quitada = true; break; } }
    if(!quitada) break;
  }
  brush = mid; renderMesa();
  if(hadSep) renderCuarto();
  persistePZ();                              // la mesa se recuerda al momento (no solo al pintar)
}
// fijas arriba (en su orden), recientes abajo (en su orden)
function ordenaMesa(){ mesa = mesa.filter(function(s){ return s.fija; }).concat(mesa.filter(function(s){ return !s.fija; })); }
function mesaFijar(mid){
  const s = mesa.find(function(x){ return x.mid === mid; });
  if(!s) return;
  s.fija = !s.fija; ordenaMesa(); renderMesa();
  persistePZ();                              // el fijado tambien se recuerda
  if(s.fija){ const m = DATOS.minerales[mid]; if(m) mp21Susurro("fijar", "Fijada: " + nombreArt(m, false) + " se queda en tu mesa aunque explores."); }
}
function toggleBrush(mid){
  if(reemplazo != null){
    pushUndo();
    pintar(reemplazo.index, mid);
    reemplazo = null; $("reemplazo").classList.remove("on");
    tocada = true; mesaUsar(mid); tras(); return;
  }
  brush = (brush === mid) ? -1 : mid;
  const hadSep = sepBrush >= 0;
  if(brush >= 0 && hadSep) sepBrush = -1;   // R18 · F1: un solo pincel activo a la vez
  renderMesa();
  if(hadSep && sepBrush < 0) renderCuarto();  // los separadores dejan de ser tocables
}
// R18 · F1 · activa/desactiva el pincel de separadores (apaga el pincel de cuentas)
function toggleSepBrush(si){
  if(si == null || si < 0 || !DATOS.separadores[si]) return;
  if(sepBrush === si){ sepBrush = -1; }
  else { sepBrush = si; brush = -1; cancelarReemplazoSilencio(); mp21Susurro("sep-pincel", "Pincel de separadores: toca cualquier separador de la pieza y se pinta."); }
  renderMesa(); renderCuarto();
}
// R18 · F1 · pinta el slot de separador tocado (y su gemelo si el espejo esta encendido)
function sepPaintTap(slot){
  if(sepBrush < 0) return;
  ocultaVoz();
  pushUndo();
  sepPintaSlot(slot, sepBrush);
  vibra(8);
  renderMesa(); renderCuarto(); updateCotizacion(); marcaCambio();
}

/* ===== la pastilla de la pieza (arriba) ===== */
function actualizaPiezaChip(){
  const b = $("pieza-chip");
  const nombre = pieza === "cod" ? "Codificador 45" : "Japa Mala 108";
  const otro = pieza === "cod" ? "Japa Mala 108" : "Codificador 45";
  b.innerHTML = '<span class="n">' + nombre + '</span>'
    + '<span class="sub"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M17 4l3 3-3 3M20 7H8M7 20l-3-3 3-3M4 17h12"/></svg>cambiar a ' + otro + '</span>';
  b.setAttribute("aria-label", "Pieza actual " + nombre + ". Tocar para cambiar a " + otro);
}

/* ===== deshacer: hasta 20 pasos ===== */
function snapshot(){ return { beads:beads.slice(), centroForma:centroForma, centroManual:Object.assign({}, centroManual), tocada:tocada,
  pieza:pieza, vista:vista, patronIdx:patronIdx, sepMineralIdx:sepMineralIdx,
  sepPinta:(Array.isArray(sepPinta) ? sepPinta.slice() : []) }; }
function pushUndo(){ historial.push(snapshot()); if(historial.length > 20) historial.shift(); actualizaUndo(); }
function actualizaUndo(){ $("undo-pill").hidden = historial.length === 0; }
// R20: restaura un snapshot completo (lo comparte deshacer y el "Volver a como estaba" del Paseo)
function aplicaSnapshot(s){
  // R23 · solo la foto de "Hacerla mia" trae s.cuarto: ese deshacer regresa tambien al cuarto de entrada (restauracion completa)
  if(s.cuarto && s.cuarto !== cuarto){ cuarto = s.cuarto; $("app").dataset.cuarto = cuarto; actualizaTabs(); }
  pieza = s.pieza; vista = s.vista; patronIdx = s.patronIdx; sepMineralIdx = s.sepMineralIdx;
  sepPinta = Array.isArray(s.sepPinta) ? s.sepPinta.slice() : [];   // R18 · F1
  beads = s.beads.slice();
  centroForma = s.centroForma;
  centroManual = Object.assign({}, s.centroManual);
  tocada = s.tocada;
  zoom = 1; panX = 0; panY = 0;
  mp13SyncFill(); syncComplete();            // Ronda 13: baseline de hitos; volver a cruzar puede repetir el aliento (documentado)
  actualizaUndo();
  actualizaPiezaChip(); renderContexto();
  renderCuarto(); renderMesa(); updateCotizacion();
  marcaCambio();
}
function deshacer(){
  if(!historial.length) return;
  aplicaSnapshot(historial.pop());
}

/* ===== acciones del pincel ===== */
function llenarVacias(){ if(brush < 0) return; ocultaVoz(); pushUndo(); for(let i = 0; i < beads.length; i++){ if(beads[i] == null){ beads[i] = brush; justPainted.push(i); } } tocada = true; tras(); }
function llenarTodo(){ if(brush < 0) return; ocultaVoz(); pushUndo(); for(let i = 0; i < beads.length; i++){ beads[i] = brush; } justPainted = []; tocada = true; tras(); }
function vaciarTodo(){
  ocultaVoz();
  pushUndo();
  beads = new Array(CFG[pieza].N).fill(null);
  centroManual = { icosaedro:null, c10:null, c12:null, flanqueada:null, guru:null };
  centroForma = "icosaedro"; tocada = false; justPainted = []; tras();
}
function abrirAcciones(){
  const T = beads.filter(function(x){ return x != null; }).length;
  const nn = brush >= 0 ? nombreArt(DATOS.minerales[brush], false) : null;
  let h = '<div class="grabber"></div>';
  h += '<div class="sheet-head"><div><div class="sheet-nombre">El pincel</div><div class="sheet-lugar">'
    + (nn ? ("activo: " + nn) : "elige un pincel en la mesa") + '</div></div></div>';
  h += '<div class="acc-list">';
  h += '<button data-act="acomodos">Acomodos<small>cambia solo el orden de tus cuentas: alternado, bloques, degradados y más</small></button>';
  h += '<button data-act="llenar-vacias"' + (brush < 0 ? " disabled" : "") + '>Llenar las vacías'
    + (nn ? ('<small>pinta con ' + nn + ' solo las cuentas por nombrar</small>') : '<small>elige primero un pincel en la mesa</small>') + '</button>';
  h += '<button data-act="llenar-todo"' + (brush < 0 ? " disabled" : "") + '>Llenar todo'
    + (nn ? ('<small>toda la pieza con ' + nn + '</small>') : '<small>elige primero un pincel en la mesa</small>') + '</button>';
  h += '<button class="quitar" data-act="vaciar"' + (T === 0 ? " disabled" : "") + '>Vaciar la pieza<small>quita todas las cuentas nombradas</small></button>';
  h += '</div>';
  h += '<div class="sheet-acciones"><button class="prim" data-act="cerrar">Listo</button></div>';
  $("sheet-in").innerHTML = h;
  abrirSheet("acciones", "Acciones del pincel");
}

/* ===== el explorador (cara a pantalla completa) ===== */
function renderExpChips(){
  let h = "";
  INTENCIONES.forEach(function(x){
    h += '<button class="exp-int" aria-pressed="' + (expInt[x] ? "true" : "false") + '" data-int="' + x + '">' + x + '</button>';
  });
  $("exp-intenciones").innerHTML = h;
}

function renderExpGrid(){
  const q = normaliza(expFiltro.trim());
  const selInt = Object.keys(expInt).filter(function(k){ return expInt[k]; });
  let list = DATOS.minerales.map(function(m, i){ return { m:m, i:i }; });
  if(q) list = list.filter(function(o){ return normaliza(o.m.n).indexOf(q) >= 0; });
  if(selInt.length){
    list = list.filter(function(o){
      return o.m.intenciones && o.m.intenciones.some(function(x){ return expInt[x]; });
    });
  }
  if(expFam) list = list.filter(function(o){ return familiaMineral(o.i) === expFam; });   // Ronda 13: se compone con busqueda e intencion
  if(expOrden === "precio-asc") list.sort(function(a, b){ return a.m.cuenta8 - b.m.cuenta8; });
  else if(expOrden === "precio-desc") list.sort(function(a, b){ return b.m.cuenta8 - a.m.cuenta8; });
  else list.sort(function(a, b){ return a.m.n.localeCompare(b.m.n, "es"); });

  if(!list.length){
    $("exp-grid").innerHTML = '<p class="exp-vacio">Ningún mineral coincide con lo que buscas.<br>Prueba con otra intención o pídelo en el chat.</p>';
    return;
  }
  let h = "";
  list.forEach(function(o){
    const m = o.m, f = fillMin(o.i);
    const aprox = (esEstimado(m) && !precioDirecto(m)) ? ' <em>aprox.</em>' : "";   // R23: el precio directo del fundador no dice "aprox."
    h += '<button class="exp-card" role="option" aria-pressed="' + (brush === o.i) + '" data-exp-brush="' + o.i + '">'
      + '<span class="ec-r fill ' + f.cls + '" style="' + f.style + '"></span>'
      + '<span class="ec-t"><span class="ec-n">' + nombreArt(m, true) + '</span>'
      + '<span class="ec-p">' + money(m.cuenta8) + ' la cuenta' + aprox + '</span></span></button>';
  });
  $("exp-grid").innerHTML = h;
}

function abrirExplorador(){
  expAbierto = true;
  const ex = $("explorador");
  const hint = $("exp-hint");
  if(hint){
    if(huecoObjetivo >= 0){ hint.textContent = "Elige un mineral para esa cuenta."; hint.hidden = false; }
    else hint.hidden = true;
  }
  renderExpFamilias();
  precargaFamilias(DATOS.minerales.map(function(_, i){ return i; }));   // Ronda 13: familias por color, perezoso + cacheado
  renderExpChips();
  renderExpGrid();
  ex.hidden = false;
  ex.setAttribute("aria-hidden", "false");
  requestAnimationFrame(function(){ ex.classList.add("on"); });
  // Trabajo 4: NO auto-enfocar el buscador (iOS abriria el teclado y haria zoom sin que la persona lo pida).
  // El teclado aparece solo cuando se toca el buscador.
}
function cerrarExplorador(){
  expAbierto = false;
  huecoObjetivo = -1;                       // Ronda 9: si se cierra sin elegir, se olvida el hueco objetivo
  const ex = $("explorador");
  ex.classList.remove("on");
  ex.setAttribute("aria-hidden", "true");
  const fin = function(){ ex.hidden = true; };
  if(reduce) fin(); else setTimeout(fin, 280);
  const t = $("mesa-mas"); if(t) t.focus();
}
function elegirDesdeExplorador(i){
  if(huecoObjetivo >= 0){
    // Ronda 9: se eligio para un hueco concreto (primer minuto guiado): pinta ESE hueco y queda de pincel
    const idx = huecoObjetivo; huecoObjetivo = -1;
    pushUndo();
    pintar(idx, i);
    tocada = true;
    mesaUsar(i);   // entra a la mesa y queda como pincel activo
    tras();
  } else if(reemplazo != null){
    pushUndo();
    pintar(reemplazo.index, i);
    reemplazo = null; $("reemplazo").classList.remove("on");
    tocada = true; mesaUsar(i); tras();
  } else {
    mesaUsar(i);   // entra a la mesa (recientes) y queda como pincel
  }
  cerrarExplorador();
}

/* ===== contexto + acciones del pincel ===== */
function chipEspejoHTML(){
  // Trabajo 5: pastilla con PALABRA y estado visible (encendido dorado / apagado tenue)
  return '<button class="chip espejo" id="chip-espejo" role="switch" aria-checked="' + espejo + '" aria-label="Espejo ' + (espejo ? "encendido" : "apagado") + ': al colocar una cuenta se pinta también su gemela"><span class="dot"></span><span class="et">Espejo</span></button>';
}
// Trabajo 5: mensajito sereno la primera vez que se toca el espejo en la visita (se va solo a los ~4s)
function mostrarEspejoToast(){
  if(espejoToastMostrado) return;   // guarda rapido por sesion; el registro R21 lleva la memoria de por-vida
  // Ronda 21: el espejo migra AL registro (mismo texto, ahora una vez en la vida y uno-a-la-vez)
  if(mp21Susurro("espejo", "Colocar una cuenta pinta también a su gemela, del otro lado del centro.")){ espejoToastMostrado = true; }
}
// Ronda 9: avisito sereno reutilizable (usa el mismo toast del espejo; no toca el flag de una-vez del espejo)
function mp9Toast(msg, ms){
  const t = $("espejo-toast"); if(!t) return;
  t.textContent = msg; t.hidden = false;
  requestAnimationFrame(function(){ t.classList.add("on"); });
  clearTimeout(mp9ToastTimer);
  mp9ToastTimer = setTimeout(function(){ t.classList.remove("on"); setTimeout(function(){ t.hidden = true; }, 320); }, ms || 4600);
}
function mp9AvisoFantasma(){ mp9Toast("Una cuenta de ese diseño ya no vive en el catálogo y quedó vacía.", 5400); }
/* ===== RONDA 21 · el registro de susurros de primera vez =====
   (a) uno a la vez (mp21Activo): si hay uno visible, el segundo se pierde (jamas encolar ni encimar).
   (b) una vez en la vida por dispositivo (mp21Vistos + localStorage aditivo).
   (c) muere solo (mismo respiro que los toasts) y tambien al primer toque.
   (d) JAMAS al cargar: solo como reaccion a un acto de la persona. */
function mp21GuardaVistos(){ try{ localStorage.setItem(LS_SUSURROS, JSON.stringify(mp21Vistos)); }catch(_){} }
function mp21CargaVistos(){
  try{ mp21Vistos = JSON.parse(localStorage.getItem(LS_SUSURROS)) || {}; }catch(_){ mp21Vistos = {}; }
  // migracion: quien ya vio el toast del espejo (llave vieja) no lo vuelve a ver
  try{
    const leg = localStorage.getItem(LS_ESPEJO_LEGACY);
    if((leg === "1" || leg === "true") && !mp21Vistos.espejo){ mp21Vistos.espejo = true; mp21GuardaVistos(); }
  }catch(_){}
}
// muestra un susurro; paseo=true lo pinta DENTRO del Paseo (su propia capa), sin tapar la gota ni los botones
function mp21Susurro(id, texto, paseo){
  if(mp21Vistos[id]) return false;              // (b) una vez en la vida
  if(mp21Activo) return false;                  // (a) uno a la vez: el segundo se pierde
  const t = paseo ? $("mp21-paseo-susurro") : $("espejo-toast");
  if(!t) return false;
  mp21Vistos[id] = true; mp21GuardaVistos();    // se sella al mostrarse (si se perdio arriba, puede reintentar despues)
  mp21Activo = true;
  clearTimeout(mp9ToastTimer);                  // no compartir el instante con un aviso contextual
  t.textContent = texto; t.hidden = false;
  requestAnimationFrame(function(){ t.classList.add("on"); });
  const cierra = function(){
    clearTimeout(mp21Timer);
    t.classList.remove("on");
    setTimeout(function(){ t.hidden = true; }, 320);
    document.removeEventListener("pointerdown", alToque, true);
    mp21Activo = false;
  };
  function alToque(){ cierra(); }               // (c) muere tambien al primer toque
  setTimeout(function(){ document.addEventListener("pointerdown", alToque, true); }, 0);
  mp21Timer = setTimeout(cierra, 4600);         // (c) muere solo
  return true;
}
// R21 · F2 · la pastilla discreta "Cómo funciona" (siempre, ambos cuartos, sin protagonismo)
function mp21ComoChipHTML(){
  return '<button class="chip mp21-como" id="mp21-como-btn" aria-label="Cómo funciona: un mapa breve de la app, para leer">'
    + '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M9.6 9.2a2.5 2.5 0 014.7 1.1c0 1.7-2.3 2-2.3 3.4"/><circle cx="12" cy="17" r=".6" fill="currentColor" stroke="none"/></svg>'
    + '<span class="et">Cómo funciona</span></button>';
}
// R21 · F2 · la hoja serena: EL MAPA EN 5 LINEAS (sin pasos, sin flechas, sin overlay sobre la UI)
function mp21AbreComo(){
  const lineas = [
    ["La charola", "toca un mineral de la mesa y llena los espacios; el orden no cambia el precio."],
    ["La pieza", "mírala en su forma real, con su centro y sus separadores."],
    ["El patrón", "la talla elige cuántos separadores lleva; tú eliges de qué mineral."],
    ["Los diseños", "pasea por intenciones, familias de luz y piezas de la casa; tu pieza queda a salvo."],
    ["Cotizar", "se cotiza y se confirma en el chat."]
  ];
  let h = '<div class="grabber"></div>';
  h += '<div class="sheet-head"><div><div class="sheet-nombre">Cómo funciona</div><div class="sheet-lugar">un mapa breve, para leer</div></div></div>';
  h += '<div class="mp21-mapa">';
  lineas.forEach(function(l){
    h += '<div class="mp21-mapa-linea"><div class="mp21-mapa-t">' + l[0] + '</div><div class="mp21-mapa-d">' + l[1] + '</div></div>';
  });
  h += '</div>';
  h += '<div class="sheet-acciones"><button class="prim" data-act="cerrar">Listo</button></div>';
  $("sheet-in").innerHTML = h;
  abrirSheet("mp21como", "Cómo funciona");
}
function chipSonidoHTML(){
  return '<button class="chip icon solo sonido" id="chip-sonido" role="switch" aria-checked="' + sonidoOn + '" aria-label="Sonido y tacto ' + (sonidoOn ? "encendidos, tócalo para silenciar" : "apagados, tócalo para encender") + '">'
    + (sonidoOn
        ? '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 9v6h4l5 4V5L8 9H4z"/><path d="M16 8.5a4 4 0 010 7"/></svg>'
        : '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 9v6h4l5 4V5L8 9H4z"/><path d="M17 9.5l4 5M21 9.5l-4 5"/></svg>')
    + '</button>';
}
function renderContexto(){
  const cont = $("contexto");
  const vacia = beads.every(function(x){ return x == null; });
  let html = "";
  // Ronda 12: la puerta de la intencion vive junto a la invitacion, solo con la pieza vacia
  // Ronda 13: junto a ella, la puerta de las semillas de la casa
  html += mp20DisenosChipHTML();                 // R20 · F1: la pastilla unica "Los diseños" (siempre, ambos cuartos; protagonica con la pieza vacia)
  if(!vacia){ html += mp18EnergiaChipHTML(); }   // R18 · F2: la pastilla de la energia (ambos cuartos, con 1+ cuentas)
  if(cuarto === "charola"){
    // la charola: la talla (cod), el espejo y el sonido; el orden y la forma se afinan en el observatorio
    if(pieza === "cod"){
      const pat = DATOS.patrones[patronIdx];
      html += '<button class="chip" data-abre="patron" aria-label="La talla y los separadores: ' + pat.cm + ' cm, ' + pat.desc + '">Patrón · ' + pat.cm + ' cm</button>';
    }
    // R22 · los acomodos tambien a la mano en el riel de la charola (igual que el observatorio; la hoja abrirAcomodos ya gatea por composicion, y el contexto de la charola no se re-renderiza en cada pincelada)
    html += '<button class="chip acomodos" id="chip-acomodos" data-abre-acomodos="1" aria-label="Acomodos: cambia solo el orden de tus cuentas, nunca su mineral">'
      + '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="6" cy="7" r="2.4"/><circle cx="12" cy="7" r="2.4"/><circle cx="18" cy="7" r="2.4"/><circle cx="9" cy="15" r="2.4"/><circle cx="15" cy="15" r="2.4"/></svg>Acomodos</button>';
    html += chipEspejoHTML();
    html += chipSonidoHTML();
  } else {
    // el observatorio: los acomodos automaticos, el espejo y el sonido (mp11: el toggle de vista se retiro, la gota es la unica forma)
    // Ronda 15: el patron tambien vive aqui (mismo control, misma hoja, mismo estado)
    if(pieza === "cod"){
      const patO = DATOS.patrones[patronIdx];
      html += '<button class="chip" data-abre="patron" aria-label="La talla y los separadores: ' + patO.cm + ' cm, ' + patO.desc + '">Patrón · ' + patO.cm + ' cm</button>';
    }
    html += '<button class="chip acomodos" id="chip-acomodos" data-abre-acomodos="1" aria-label="Acomodos: cambia solo el orden de tus cuentas, nunca su mineral">'
      + '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="6" cy="7" r="2.4"/><circle cx="12" cy="7" r="2.4"/><circle cx="18" cy="7" r="2.4"/><circle cx="9" cy="15" r="2.4"/><circle cx="15" cy="15" r="2.4"/></svg>Acomodos</button>';
    // Ronda 12: la estampa (atenuada hasta completar) y el tamaño real, solo con pieza en curso
    // R23 · la estampa NO se ofrece durante el Paseo (el diseño aun no es tuyo, y el #contexto va oculto
    //   en el Paseo, asi que inyectarla ahi solo creaba un chip presente pero intocable). Vive en La pieza;
    //   reaparece al hacerla tuya (mp20HacerlaMia aterriza en el observatorio).
    if(!vacia && !mp20Activo){ html += mp12EstampaChipHTML(); html += mp12RealChipHTML(); }
    html += chipEspejoHTML();
    html += chipSonidoHTML();
  }
  html += mp21ComoChipHTML();                     // R21 · F2: la puerta "Cómo funciona" al final del riel (ambos cuartos)
  cont.innerHTML = html;
}


/* ===== reemplazo ===== */
function armarReemplazo(index){
  reemplazo = { index:index };
  $("reemplazo").classList.add("on");
  const lado = index < CFG[pieza].half ? "izquierda" : "derecha";
  $("reemplazo-txt").textContent = "Cambiando una cuenta de la hebra " + lado + (espejo ? " y su gemela" : "") + ": toca un mineral en la mesa o abre el explorador.";
  renderCuarto();
}
function cancelarReemplazo(){ reemplazo = null; $("reemplazo").classList.remove("on"); renderCuarto(); }

/* ===== pintar ===== */
function pintar(i, mid){
  ocultaVoz();
  beads[i] = mid;
  justPainted.push(i);
  if(espejo && twin(i) !== i){
    beads[twin(i)] = mid; justPainted.push(twin(i));
    if(!espejoToastMostrado) mostrarEspejoToast();   // Ronda 9: tambien en la PRIMERA pintada espejada de la visita
  }
  const filled = beads.filter(function(x){ return x != null; }).length;
  ticBead(filled / CFG[pieza].N);
}
function onBeadTap(i){
  ocultaVoz();
  if(reemplazo != null){
    pushUndo();
    pintar(reemplazo.index, brush >= 0 ? brush : beads[i]);
    reemplazo = null; $("reemplazo").classList.remove("on");
    tocada = true; tras(); return;
  }
  const mid = beads[i];
  if(brush >= 0){
    if(mid === brush){ abrirMirilla(i); }
    else { pushUndo(); pintar(i, brush); tocada = true; tras(); }
  } else {
    if(mid != null){ abrirMirilla(i); }
    else { huecoObjetivo = i; abrirExplorador(); }   // Ronda 9: tocar un hueco vacio sin pincel siempre responde
  }
}
function tras(){
  mp15bReevalua();                           // Ronda 15b: apaga el degradado si la composicion dejo de cumplir (antes de persistir)
  renderMesa(); renderCuarto();
  // Ronda 14 · T2: detecta el sello ANTES de updateCotizacion (wasComplete aun refleja el estado previo);
  //   asi mp13MuestraAcuse difiere el acuse hasta el latido de la cristalizacion.
  mp14Ceremonia = !reduce && mp14Completa() && !wasComplete;
  updateCotizacion(); maybeChord(); mp13ChecaHitos(); marcaCambio();
  mp14Ceremonia = false;
  if(mp13FilledCount() > 0) mp14Embudo("primera_cuenta");   // Ronda 14 · T4: primer pintado real de la sesion
}  // Ronda 10: la mesa primero (la charola mide el riel ya rendido) · Ronda 13: los hitos del llenado (japa)

/* ===== cotizacion ===== */
function pieceLabel(){
  const T = beads.filter(function(x){ return x != null; }).length;
  const cabeza = pieza === "cod" ? "Codificador" : "Japa Mala";
  if(T === 0) return cabeza + (pieza === "cod" ? " 45" : " 108");
  const unicos = {}; beads.forEach(function(x){ if(x != null) unicos[x] = 1; });
  const ks = Object.keys(unicos);
  if(ks.length === 1) return cabeza + " " + deMin(DATOS.minerales[+ks[0]]);
  return cabeza + " · mezcla de " + ks.length + " minerales";
}

function setPrecio(txt, invita){
  const el = $("pc-precio");
  const cambio = el.textContent !== txt;
  el.textContent = txt;
  el.classList.toggle("invita", !!invita);
  if(cambio && !invita && !reduce){ el.classList.remove("late"); void el.offsetWidth; el.classList.add("late"); }
}

// Ronda 9 · 4d: el susurro de MSI vive solo en el desglose (Ronda 10: fuera del chip, que crecia y tapaba las pastillas)
const MSI_MINIMO = 1500;
// Ronda 10: las pastillas de contexto se anclan SOBRE el recuadro del precio, midiendo su alto real.
// (En el telefono el recuadro crecia y las tapaba; ahora el traslape es imposible por construccion.)
function anclaContexto(){
  const w = $("precio-wrap"), c = $("contexto");
  if(!w || !c) return;
  const h = Math.ceil(w.getBoundingClientRect().height);
  c.style.bottom = "calc(env(safe-area-inset-bottom) + " + (h + 22) + "px)";
}
// Ronda 12: las pastillas nuevas (intencion / estampa) dependen de si la pieza esta vacia o completa;
// tras() no re-renderiza el contexto, asi que lo sincronizamos aqui solo cuando ese estado cambia.
let _mp12CtxKey = null;
function mp12SyncContexto(r){
  const completa = !r.vacia && !r.incompleta;
  const key = (r.vacia ? "1" : "0") + (completa ? "1" : "0");
  if(key !== _mp12CtxKey){ _mp12CtxKey = key; renderContexto(); }
}
function updateCotizacion(){
  const r = calcular();
  mp12SyncContexto(r);
  mp13SyncAcuse(!r.vacia && !r.incompleta);   // Ronda 13: el acuse del taller respira al sellar
  const sub = $("pc-sub"), cta = $("cot-cta"), ver = $("ver-cta");
  function ocultaCtas(){ cta.hidden = true; cta.setAttribute("aria-disabled", "true"); cta.removeAttribute("href"); ver.hidden = true; }
  if(r.vacia){
    setPrecio("Nombra la primera cuenta", true);
    sub.textContent = "se cotiza y se confirma en el chat";
    ocultaCtas();
    if(sheetTipo === "desglose") renderDesglose(r, 0);
    anclaContexto();
    return;
  }
  setPrecio(money(r.final), false);
  const porNombrar = r.N - r.T;
  if(r.incompleta){
    // suma desde cero: solo lo colocado. El precio se sella al completar la pieza. (4c: mas honesto, sin urgencia)
    const compacta = window.innerWidth <= 430;
    sub.textContent = compacta
      ? ("van " + money(r.final) + " · " + r.T + "/" + r.N + " · se sella al llenar")
      : ("van " + money(r.final) + " · " + r.T + " de " + r.N + " · al llenarla se sella el precio");
    ocultaCtas();
  } else {
    // pieza completa: el precio queda sellado (formula v2)
    sub.textContent = r.exacta ? "ya vive en la tienda" : "se cotiza y se confirma en el chat";
    if(cuarto === "charola"){
      // en la charola el paso siguiente es ver la pieza en su forma
      cta.hidden = true; cta.setAttribute("aria-disabled", "true"); cta.removeAttribute("href");
      ver.hidden = false;
    } else {
      // en el observatorio se confirma en el chat
      ver.hidden = true;
      cta.hidden = false; cta.removeAttribute("aria-disabled");
      cta.href = "https://wa.me/" + DATOS.wa + "?text=" + encodeURIComponent(mensajeWA(r));
    }
  }
  if(sheetTipo === "desglose") renderDesglose(r, porNombrar);
  anclaContexto();
}

// Ronda 10: viaTxt (anclas y razones a la vista) se retiro del desglose del cliente; esa cocina vive en el Calibrador.

// Ronda 9 · 4e: la fecha del catalogo, en espanol, desde DATOS.generado (no escrita fija)
function fechaLarga(iso){
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(iso || ""));
  if(!m) return null;
  const meses = ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"];
  const mes = meses[parseInt(m[2], 10) - 1];
  if(!mes) return null;
  return parseInt(m[3], 10) + " de " + mes + " de " + m[1];
}
// Ronda 9 · lineas tenues del desglose: susurro de MSI (solo sellado y >= minimo) + vigencia del catalogo
function desgloseExtras(r, sellado){
  let h = "";
  if(sellado && !r.incompleta && r.final >= MSI_MINIMO){
    h += '<p class="dl mp9-msi">Con meses sin intereses; se eligen al pagar.</p>';
  }
  const f = fechaLarga(DATOS.generado);
  if(f) h += '<p class="dl mp9-vig">Precios del catálogo del ' + f + '.</p>';
  return h;
}
function renderDesglose(r, porNombrar){
  const cajaVacia = $("desglose-lineas");
  if(!cajaVacia) return;
  let h = "";
  const voz = vozDeLaPieza();
  // Ronda 15: si la talla lleva separadores, una linea los nombra bajo la voz
  const sepVoz = voz ? mp15SepVoz() : null;
  const vozHtml = (voz ? ('<p class="dl voz">' + voz + '</p>') : "")
    + (sepVoz ? ('<p class="dl voz mp15-sep-voz">' + sepVoz + '</p>') : "");
  if(r.vacia){
    cajaVacia.innerHTML = '<p class="dl cierre">Toca una cuenta y elige su mineral para ver el desglose. <b>Se cotiza y se confirma en el chat.</b></p>';
    return;
  }
  if(r.exacta){
    const m = DATOS.minerales[r.pura.mid];
    h += '<div class="dl linea"><span class="k">Esta pieza ya vive en la tienda<small>mismo precio de línea ' + deMin(m) + '</small></span><span class="v">' + money(r.pura.pub) + '</span></div>';
    h += '<div class="dl"><span class="k">' + r.T + (r.T === 1 ? ' cuenta ' : ' cuentas ') + deMin(m) + '<small>' + (r.forma === "icosaedro" ? "icosaedro clásico" : "gurú") + ' del mismo mineral · sin separadores</small></span><span class="v suave">completa</span></div>';
    h += '<div class="dl total"><span class="k">Precio de línea</span><span class="v">' + money(r.pura.pub) + '</span></div>';
    h += vozHtml;
    h += desgloseExtras(r, true);
    h += '<p class="dl nota">Se arma a mano y se anuda en el taller.</p>';
    h += '<p class="dl cierre">Armar en el cotizador una pieza que ya existe da el precio de la tienda, idéntico. <b>Se cotiza y se confirma en el chat.</b></p>';
    // Ronda 16: si el mineral tiene su pagina en la tienda, una linea tocable discreta (solo con empate seguro)
    const mp16Href = mp16HrefDeLinea(r);
    if(mp16Href){ h += '<p class="dl mp16-tienda"><a href="' + mp16Href + '" target="_blank" rel="noopener">Ver esta pieza en la tienda</a></p>'; }
    $("desglose-lineas").innerHTML = h;
    return;
  }
  // Desglose para el cliente. El precio por cuenta se muestra tal cual;
  // de donde sale (anclas, razones, censo) es cocina interna y vive en el Calibrador.
  // mp11: llevamos la suma de los renglones YA REDONDEADOS para cerrar exacto contra el total.
  let sumaLineas = 0;
  r.grupos.forEach(function(g){
    const m = DATOS.minerales[g.mid];
    const porCuenta = money(g.contrib / g.n) + ' por cuenta' + ((g.ancla.tipo === "estimada" && !precioDirecto(m)) ? ' aprox.' : '');   // R23: el precio directo del fundador no dice "aprox." por cuenta
    sumaLineas += Math.round(g.contrib);
    h += '<div class="dl"><span class="k"><i style="background:' + COL[g.mid].c + '"></i>' + g.n + (g.n === 1 ? ' cuenta ' : ' cuentas ') + deMin(m)
      + '<small>' + porCuenta + '</small></span><span class="v">' + money(g.contrib) + '</span></div>';
  });
  if(pieza === "cod" && r.sepCount > 0){
    sumaLineas += Math.round(r.sepCost);
    if(!r.sepMixto){
      // uniforme: como siempre ("8 separadores de 4 mm de la Howlita")
      h += '<div class="dl"><span class="k"><i style="background:' + sepColor(r.sepMin).c + '"></i>' + r.sepCount + ' separadores de 4 mm ' + deMin(r.sepMin)
        + '<small>' + r.sepCount + ' x ' + money(r.sepMin.por_sep) + ' · talla ' + DATOS.patrones[patronIdx].cm + ' cm</small></span><span class="v">' + money(r.sepCost) + '</span></div>';
    } else {
      // R18 · F1: mixtos, agrupados por mineral ("8 separadores de 4 mm: 6 de la Howlita, 2 del Jade Verde")
      const partes = r.sepGrupos.map(function(g){ return g.n + ' ' + deMin(DATOS.separadores[g.si]); }).join(', ');
      const detalle = r.sepGrupos.map(function(g){ return g.n + ' x ' + money(DATOS.separadores[g.si].por_sep); }).join(' + ');
      const dot = sepColor(DATOS.separadores[r.sepGrupos[0].si]).c;
      h += '<div class="dl"><span class="k"><i style="background:' + dot + '"></i>' + r.sepCount + ' separadores de 4 mm: ' + partes
        + '<small>' + detalle + ' · talla ' + DATOS.patrones[patronIdx].cm + ' cm</small></span><span class="v">' + money(r.sepCost) + '</span></div>';
    }
  }
  if(r.centroMid >= 0){
    const val = r.centroCargo > 0 ? ("+" + money(r.centroCargo)) : "incluido";
    if(r.centroCargo > 0) sumaLineas += Math.round(r.centroCargo);
    h += '<div class="dl"><span class="k">Centro<small>' + r.centroDetalle + '</small></span><span class="v' + (r.centroCargo > 0 ? "" : " suave") + '">' + val + '</span></div>';
  }
  // mp11: EL ARMADO A MANO EN EL TALLER. Una sola linea con voz de cliente que funde
  //  el recargo por mezcla, el colchon, el redondeo y el piso (todo lo que hay entre el
  //  subtotal de cuentas y el total). Se calcula como el residuo contra el total mostrado,
  //  asi los renglones SUMAN EXACTO al total (ni un peso de diferencia). La cocina interna
  //  (subtotal ponderado, recargo, colchon, redondeo, piso) vive en el Calibrador.
  const totalMostrado = Math.round(r.final);
  const armado = totalMostrado - sumaLineas;
  if(armado !== 0){
    const signo = armado < 0 ? "-" : "+";
    h += '<div class="dl"><span class="k">El armado a mano en el taller<small>separar, acomodar y anudar tu diseño</small></span><span class="v">' + signo + money(Math.abs(armado)) + '</span></div>';
  }
  if(r.incompleta){
    h += '<div class="dl total"><span class="k">Van</span><span class="v">' + money(r.final) + '</span></div>';
    h += '<p class="dl nota">' + (r.T === 1 ? 'Suma de la cuenta nombrada' : 'Suma de las ' + r.T + ' cuentas nombradas') + ' de ' + r.N + '. El precio se sella al completar la pieza.</p>';
    h += vozHtml;
    h += desgloseExtras(r, false);
    h += '<p class="dl cierre">La cotización es una propuesta honesta. <b>Se cotiza y se confirma en el chat.</b></p>';
    $("desglose-lineas").innerHTML = h;
    return;
  }
  h += '<div class="dl total"><span class="k">Total estimado</span><span class="v">' + money(r.final) + '</span></div>';
  h += vozHtml;
  h += desgloseExtras(r, true);
  h += '<p class="dl nota">Se arma a mano y se anuda en el taller.</p>';
  h += '<p class="dl cierre">La cotización es una propuesta honesta. <b>Se cotiza y se confirma en el chat.</b></p>';
  $("desglose-lineas").innerHTML = h;
}

function mensajeWA(r){
  const L = [];
  L.push("Hola, quiero cotizar mi diseño:");
  L.push("");
  if(pieza === "cod"){
    L.push("Pieza: Codificador 45 (44 cuentas de 8 mm + icosaedro, elástico)");
    const p = DATOS.patrones[patronIdx];
    if(p.sep === 0){ L.push("Talla: 33 cm, sin separadores"); }
    else if(!r.sepMixto){ L.push("Talla: " + p.cm + " cm, " + p.sep + " separadores de 4 mm " + deMin(r.sepMin)); }
    else {
      L.push("Talla: " + p.cm + " cm, " + p.sep + " separadores de 4 mm");
      L.push("Separadores: " + r.sepGrupos.map(function(g){ return g.n + " " + deMin(DATOS.separadores[g.si]); }).join(", "));   // R18 · F1: mixtos, agrupados
    }
  } else {
    L.push("Pieza: Japa Mala 108 (108 cuentas de 8 mm + gurú, anudado en nailon, borla de seda natural)");
  }
  L.push("");
  L.push("Cuentas:");
  r.grupos.forEach(function(g){ L.push("- " + g.n + " " + deMin(DATOS.minerales[g.mid])); });
  if(r.centroMid >= 0){
    if(pieza === "cod"){
      const nom = { icosaedro:"icosaedro clásico", c10:"cuenta de 10 mm", c12:"cuenta de 12 mm", flanqueada:"flanqueada por 2 separadores" }[r.forma] || "icosaedro clásico";
      L.push("Centro: " + nombreArt(DATOS.minerales[r.centroMid], false) + " · " + nom);
    } else {
      L.push("Gurú: " + nombreArt(DATOS.minerales[r.centroMid], false));
    }
  }
  if(degTono && mp15bAplica()){ L.push("Degradado de tono: se afina a mano en el taller, de tono a tono."); }
  L.push("");
  L.push("Lo armamos a mano, cuenta por cuenta, tal como lo diseñaste.");
  L.push("Total estimado: " + money(r.final) + " · lo confirmamos juntos en el chat");
  L.push("");
  L.push("Código del diseño (para que lo armemos tal cual): " + codificaDiseno());
  return L.join("\n");
}

/* ===== hojas ===== */
function abrirSheet(tipo, label){
  clearTimeout(sheetTimer);
  sheetTipo = tipo;
  const bd = $("backdrop"), sh = $("sheet");
  $("sheet").setAttribute("aria-label", label || "Hoja");
  bd.hidden = false; sh.hidden = false;
  requestAnimationFrame(function(){ bd.classList.add("on"); sh.classList.add("on"); });
  mpMontaFocoVelo(sh);   // cura de foco: la Hoja hereda la MISMA trampa de Tab de la estampa y la antesala (regreso al cerrar)
}
function cerrarSheet(){
  const bd = $("backdrop"), sh = $("sheet");
  bd.classList.remove("on"); sh.classList.remove("on"); mpRegresaFocoVelo();
  sheetTipo = null;
  clearTimeout(sheetTimer);
  const fin = function(){ bd.hidden = true; sh.hidden = true; };
  if(reduce) fin(); else sheetTimer = setTimeout(fin, 240);
}

/* ===== Cura C2 · foco de los velos modales (accesibilidad) =====
   Patron canonico del contador (montaFocoModal + regreso), aqui local y propio: al abrir un velo
   se recuerda el disparador, el foco entra al velo, el Tab queda atrapado adentro mientras viva, y
   al cerrar el foco vuelve al disparador. Lo montan la estampa (mp12-est) y la antesala (mp14-antesala):
   los 2 velos que nacian sin foco al abrir, sin trampa de Tab y sin regreso de foco. No roba el foco
   de ningun campo: enfoca el velo (tabindex -1, sin anillo) y sus tocables conservan el suyo con Tab. */
let mpVeloDisparador = null;
function mpTocablesVelo(velo){
  const t = velo.querySelectorAll('button:not([disabled]), a[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])');
  return Array.prototype.filter.call(t, function(el){ return el.offsetParent !== null; });
}
function mpMontaFocoVelo(velo){
  if(!velo) return;
  mpVeloDisparador = document.activeElement;
  if(!velo.hasAttribute("tabindex")) velo.setAttribute("tabindex", "-1");
  velo.style.outline = "none";
  if(!velo.dataset.mpFocoTrampa){
    velo.dataset.mpFocoTrampa = "1";
    velo.addEventListener("keydown", function(e){
      if(e.key !== "Tab") return;
      const f = mpTocablesVelo(velo);
      if(!f.length){ e.preventDefault(); try{ velo.focus(); }catch(_){} return; }
      const primero = f[0], ultimo = f[f.length - 1], act = document.activeElement;
      if(act === velo){ e.preventDefault(); (e.shiftKey ? ultimo : primero).focus(); }
      else if(e.shiftKey && act === primero){ e.preventDefault(); ultimo.focus(); }
      else if(!e.shiftKey && act === ultimo){ e.preventDefault(); primero.focus(); }
    });
  }
  try{ velo.focus(); }catch(_){}
}
function mpRegresaFocoVelo(){
  const d = mpVeloDisparador; mpVeloDisparador = null;
  if(d && d.focus){ try{ d.focus(); }catch(_){} }
}

function abrirMirilla(i){
  const m = DATOS.minerales[beads[i]];
  const half = CFG[pieza].half;
  const lado = i < half ? "izquierda" : "derecha";
  const fila = (i % half) + 1;
  const f = fillMin(beads[i]);
  let h = '<div class="grabber"></div>';
  h += '<div class="sheet-head"><span class="sheet-esfera fill ' + f.cls + '" style="' + f.style + '"></span>'
    + '<div><div class="sheet-nombre">' + nombreArt(m, true) + '</div>'
    + '<div class="sheet-lugar">cuenta ' + fila + ' de la hebra ' + lado + '</div></div></div>';
  if(m.intenciones && m.intenciones.length){
    h += '<div class="sheet-chips">' + m.intenciones.slice(0, 3).map(function(x){ return '<span class="int-chip">' + x + '</span>'; }).join("") + '</div>';
  }
  if(m.hook){ h += '<p class="sheet-esencia">' + m.hook + '</p>'; }
  h += '<div class="sheet-precio"><b>' + money(m.cuenta8) + '</b> por cuenta de 8 mm';
  if(llevaNota(m) && !precioDirecto(m)){ h += '<span class="aviso">precio estimado, se confirma en el chat</span>'; }   // R23: el precio directo del fundador no lleva el aviso de estimado por cuenta
  h += '</div>';
  // Ronda 13: la hermana accesible (una puerta serena, jamas un empujon)
  const herm = mp13Hermana(beads[i]);
  if(herm){
    const hm = DATOS.minerales[herm.mid];
    h += '<div class="mp13-hermana">La misma ' + escHtml(herm.intp.toLowerCase()) + ' vive en <b>' + escHtml(nombreArt(hm, false)) + '</b>, a ' + money(hm.cuenta8) + ' la cuenta.'
      + '<br><button class="mp13-conocer" data-mp13-hermana="' + herm.mid + '">Conocerla</button></div>';
  }
  h += '<div class="sheet-acciones"><button class="prim" data-act="cambiar">Cambiar</button>'
    + '<button class="quitar" data-act="quitar">Quitar</button>'
    + '<button data-act="cerrar">Cerrar</button></div>';
  h = wrapCtx(h, i);
  $("sheet-in").innerHTML = h;
  abrirSheet("mirilla", "Detalle " + deMin(m));
}
function wrapCtx(h, i){ $("sheet").dataset.beadIndex = i; return h; }

function miniFila(list, sel, attr){
  let h = '<div class="mini-fila">';
  list.forEach(function(mid){
    const m = DATOS.minerales[mid];
    const f = fillMin(mid);
    h += '<button class="mini-chip" aria-pressed="' + (sel === mid) + '" ' + attr + '="' + mid + '">'
      + '<span class="mr fill ' + f.cls + '" style="' + f.style + '"></span>'
      + '<span class="mn">' + m.n + '</span></button>';
  });
  h += '</div>';
  return h;
}

// Ronda 15: resumen VIVO del centro resuelto (nombre + cargo real; se re-pinta al cambiar forma o mineral)
function mp15CentroResumen(forma, cm){
  const m = DATOS.minerales[cm];
  if(forma === "guru") return "Hoy tu gurú: la cuenta " + deMin(m) + ", incluida.";
  if(forma === "icosaedro") return "Hoy tu centro: el icosaedro " + deMin(m) + ", incluido.";
  if(forma === "c10" || forma === "c12"){
    const mm = forma === "c10" ? "10" : "12";
    const c = (forma === "c10" ? m.cuenta10 : m.cuenta12) || 0;
    return "Hoy tu centro: la cuenta de " + mm + " mm " + deMin(m) + (c > 0 ? ", +" + money(c) + "." : ", incluida.");
  }
  const sm = DATOS.separadores[sepMineralIdx];
  const c = 2 * (sm ? sm.por_sep : 0);
  return "Hoy tu centro: la cuenta de 8 mm " + deMin(m) + ", entre 2 separadores" + (sm ? " " + deMin(sm) : "") + (c > 0 ? ", +" + money(c) + "." : ", incluida.");
}
// Ronda 15: lo que la forma elegida no tiene del mineral vigente, dicho sereno
function mp15CentroFaltante(forma){
  const dom = dominante();
  if(dom < 0) return "";
  const list = LISTS[forma];
  if(!list || list.indexOf(dom) >= 0) return "";
  const m = DATOS.minerales[dom];
  let que;
  if(forma === "c10") que = "cuenta de 10 mm";
  else if(forma === "c12") que = "cuenta de 12 mm";
  else if(forma === "icosaedro") que = "icosaedro";
  else if(forma === "guru") que = "cuenta gurú";
  else return "";
  return '<div class="sheet-centro-propone">' + nombreArt(m, true) + ' no tiene ' + que + '; estos minerales sí.</div>';
}
function abrirCentro(){
  coerceCentroForma();                       // R17 · F1: nunca abrir la hoja con flanqueada activa en una talla con patron
  const esCod = pieza === "cod";
  const forma = formaActual();
  const cm = centroMinActual();
  let h = '<div class="grabber"></div>';
  const titulo = esCod ? "El centro de la pieza" : "La cuenta gurú";
  const sub = esCod ? "el icosaedro que cierra el circuito de 45" : "cierra las 108 antes de la borla";
  const esf = cm < 0 ? '<span class="sheet-esfera vacia"></span>' : ('<span class="sheet-esfera fill ' + fillMin(cm).cls + '" style="' + fillMin(cm).style + '"></span>');
  h += '<div class="sheet-head">' + esf + '<div><div class="sheet-nombre">' + titulo + '</div><div class="sheet-lugar">' + sub + '</div></div></div>';

  // Ronda 15: el aviso es un resumen VIVO del centro resuelto (forma + mineral + cargo real)
  if(cm >= 0){
    h += '<div class="sheet-centro-propone">' + mp15CentroResumen(forma, cm) + '</div>';
  }

  if(esCod){
    h += '<div class="sheet-label">La forma del centro</div>';
    h += '<div class="formas" id="centro-formas">';
    const sm = DATOS.separadores[sepMineralIdx];
    h += formaHTML("icosaedro", "Icosaedro clásico", "incluido en el precio de la pieza", 0);
    // Ronda 15: los meta hablan en generico honesto; el cargo exacto del mineral resuelto vive en el aviso vivo
    if(LISTS.c10.length){
      const min10 = Math.min.apply(null, LISTS.c10.map(function(i){ return DATOS.minerales[i].cuenta10; }));
      h += formaHTML("c10", "Cuenta de 10 mm", "una cuenta mayor, del mineral que elijas abajo · desde +" + money(min10), min10, true);
    }
    if(LISTS.c12.length){
      const min12 = Math.min.apply(null, LISTS.c12.map(function(i){ return DATOS.minerales[i].cuenta12; }));
      h += formaHTML("c12", "Cuenta de 12 mm", "una cuenta mayor, del mineral que elijas abajo · desde +" + money(min12), min12, true);
    }
    // R17 · F1: la flanqueada (unico centro redondo de 8 mm) solo se ofrece en 33 cm, sin patron
    if(flanqueadaDisponible()){
      h += formaHTML("flanqueada", "Flanqueada por 2 separadores", "una cuenta de 8 mm del mineral que elijas abajo, entre 2 separadores de 4 mm " + deMin(sm), 2 * (sm ? sm.por_sep : 0));
    }
    h += '</div>';
    h += '<div class="sheet-label">El mineral del centro</div>';
    h += mp15CentroFaltante(forma);
    h += miniFila(LISTS[forma], cm, "data-centro");
  } else {
    h += '<p class="sheet-nota">La gurú y su <b>borla de seda natural</b> van <b>anudadas en nailon</b> e incluidas en el precio del japa. Aquí eliges su mineral.</p>';
    h += '<div class="sheet-label">El mineral del gurú</div>';
    h += mp15CentroFaltante(forma);
    h += miniFila(LISTS.guru, cm, "data-centro");
  }
  h += '<p class="sheet-nota">¿Otro mineral para el centro? Se consigue y se cotiza en el chat.</p>';
  h += '<div class="sheet-acciones"><button class="prim" data-act="cerrar">Listo</button></div>';
  $("sheet-in").innerHTML = h;
  abrirSheet("centro", titulo);
  // Ronda 15: el mineral resuelto del centro se lleva a la vista al abrir la hoja
  const selChip = $("sheet-in").querySelector('.mini-chip[aria-pressed="true"]');
  if(selChip && selChip.scrollIntoView){ try{ selChip.scrollIntoView({ block:"nearest", inline:"nearest" }); }catch(_){} }
}

function formaHTML(val, titulo, meta, cargo, desde){
  const activo = centroForma === val;
  const cargoTxt = cargo > 0 ? ((desde ? "desde +" : "+") + money(cargo)) : "incluida";
  return '<button class="forma" aria-pressed="' + activo + '" data-forma="' + val + '">'
    + '<span class="radio"></span>'
    + '<span class="body"><span class="t">' + titulo + '</span><span class="m">' + meta + '</span></span>'
    + '<span class="cargo' + (cargo > 0 ? "" : " cero") + '">' + cargoTxt + '</span></button>';
}

function abrirPatron(){
  let h = '<div class="grabber"></div>';
  h += '<div class="sheet-head"><div><div class="sheet-nombre">La talla y los separadores</div><div class="sheet-lugar">separadores de 4 mm intercalados en el codificador</div></div></div>';
  h += '<div class="sheet-label">La talla</div><div class="patrones" id="patrones">';
  DATOS.patrones.forEach(function(p, i){
    const sepTxt = p.sep > 0 ? (p.sep + " separadores") : "sin separadores";
    h += '<button class="pat" aria-pressed="' + (patronIdx === i) + '" data-pat="' + i + '"><span class="cm">' + p.cm + ' cm</span><span class="d">' + sepTxt + '<br>' + p.desc + '</span></button>';
  });
  h += '</div>';
  h += '<p class="sheet-nota">Conteos derivados de la guía de tallas; el largo final se confirma al armar.</p>';
  h += '<div class="sheet-label">El mineral del separador</div>';
  h += miniFila(DATOS.separadores.map(function(s){ return byName[s.n]; }).filter(function(i){ return i != null; }), sepMineralIdx >= 0 ? byName[DATOS.separadores[sepMineralIdx].n] : -1, "data-sepbyname");
  // R18 · F1 · F4: este selector es la BROCHA GORDA (pinta todos); los detalles se afinan en la mesa
  h += '<p class="sheet-nota">Pinta todos los separadores; luego puedes personalizarlos uno a uno en la mesa.</p>';
  h += '<div class="sheet-acciones"><button class="prim" data-act="cerrar">Listo</button></div>';
  $("sheet-in").innerHTML = h;
  abrirSheet("patron", "La talla y los separadores");
}
// R18 · F1 · el selector completo del pincel de separadores (el "+" de la seccion de sep en la mesa)
function abrirSepSelector(){
  let h = '<div class="grabber"></div>';
  h += '<div class="sheet-head"><div><div class="sheet-nombre">El separador que pintas</div><div class="sheet-lugar">elige un mineral de 4 mm y toca los separadores de tu pieza</div></div></div>';
  h += '<div class="mini-fila mp18-seppick">';
  DATOS.separadores.forEach(function(s, i){
    if(byName[s.n] == null) return;   // la UI ya filtra los que no tienen retrato (Tanzanita, Topacio Azul)
    const f = fillSep(s);
    h += '<button class="mini-chip mp18-sepchip" aria-pressed="' + (sepBrush === i) + '" data-sep-pincel-pick="' + i + '" aria-label="Pintar separadores ' + nombreArt(s, false) + ', ' + money(s.por_sep) + ' cada uno">'
      + '<span class="mr fill ' + f.cls + '" style="' + f.style + '"></span>'
      + '<span class="mn">' + s.n + '</span>'
      + '<span class="mp18-sepp">' + money(s.por_sep) + '</span></button>';
  });
  h += '</div>';
  h += '<p class="sheet-nota">Toca un separador en tu pieza para pintarlo con este mineral (su gemelo también, si el espejo está encendido). Para pintarlos todos de un solo mineral, usa "El mineral del separador" en la talla.</p>';
  h += '<div class="sheet-acciones"><button class="prim" data-act="cerrar">Listo</button></div>';
  $("sheet-in").innerHTML = h;
  abrirSheet("sepselector", "El separador que pintas");
}

function abrirDesglose(){
  let h = '<div class="grabber"></div>';
  h += '<div class="sheet-head"><div><div class="sheet-nombre">El desglose honesto</div><div class="sheet-lugar">de dónde sale cada peso</div></div></div>';
  h += '<div id="desglose-lineas" style="margin-top:14px"></div>';
  // compartir / pegar un diseno (codigo copiable, sin red)
  h += '<div class="comp"><div class="sheet-label">Comparte o recupera un diseño</div>';
  h += '<div class="comp-row"><button class="comp-btn ghost" id="btn-compartir">Compartir mi diseño</button></div>';
  h += '<input class="comp-out" id="share-out" readonly hidden aria-label="Tu código de diseño">';
  h += '<p class="comp-msg" id="share-msg" hidden></p>';
  h += '<div class="comp-row"><input class="comp-in" id="paste-in" placeholder="Pega aquí un código MP1." aria-label="Pega un código de diseño" autocomplete="off">'
    + '<button class="comp-btn" id="btn-pegar">Pegar un diseño</button></div>';
  h += '<p class="comp-msg" id="paste-msg" hidden></p>';
  // Ronda 14 · T3: entrada discreta a la vista de armado (para la mesa del taller, no para la clienta)
  h += '<div class="comp-row"><button class="comp-btn ghost" id="mp14-armado-abrir">Vista de armado</button></div></div>';
  h += '<div class="sheet-acciones"><button class="prim" data-act="cerrar">Listo</button></div>';
  $("sheet-in").innerHTML = h;
  const r = calcular();
  const porNombrar = r.vacia ? 0 : r.N - r.T;
  renderDesglose(r, porNombrar);
  abrirSheet("desglose", "El desglose honesto");
}

// mp11: LA COCINA DEL PRECIO. Bloque de solo lectura con el detalle interno de la pieza
//  actual, separado y con los nombres de cocina. Es el reverso del desglose del cliente,
//  donde todo esto se funde en "El armado a mano en el taller".
function cocinaHTML(){
  const r = calcular();
  let inner = '<div class="ck-lbl">La cocina del precio</div>';
  inner += '<div class="ck-sub">Uso interno, de la pieza actual: de dónde sale el armado. Subtotal ponderado, recargo por mezcla (más tiempo en el taller), colchón, redondeo a 49 o 99 y piso de línea. En el desglose del cliente todo esto es una sola línea.</div>';
  if(r.vacia){
    inner += '<div class="ck-row"><span class="ck-k">Aún no hay cuentas nombradas</span><span class="ck-v">·</span></div>';
    return '<div class="mp11-cocina">' + inner + '</div>';
  }
  if(r.exacta){
    inner += '<div class="ck-row"><span class="ck-k">Pieza de línea exacta<small>precio publicado de la tienda, sin recargo ni colchón</small></span><span class="ck-v">' + money(r.final) + '</span></div>';
    inner += '<div class="ck-row tot"><span class="ck-k">Total</span><span class="ck-v">' + money(r.final) + '</span></div>';
    return '<div class="mp11-cocina">' + inner + '</div>';
  }
  inner += '<div class="ck-row"><span class="ck-k">Subtotal ponderado<small>cuentas' + (r.sepCost > 0 ? ' + separadores' : '') + (r.centroCargo > 0 ? ' + centro' : '') + '</small></span><span class="ck-v">' + money(r.subtotal) + '</span></div>';
  inner += '<div class="ck-row"><span class="ck-k">Recargo por mezcla<small>(M - 1) x ' + recargoPct + '% · M = ' + r.M + ' · más tiempo en localizar y acomodar</small></span><span class="ck-v">+' + money(r.recargo) + '</span></div>';
  if(r.incompleta){
    inner += '<div class="ck-row"><span class="ck-k">Subtotal con recargo<small>colchón, redondeo y piso se aplican al sellar la pieza</small></span><span class="ck-v">' + money(r.conRecargo) + '</span></div>';
    inner += '<div class="ck-row tot"><span class="ck-k">Van (provisional)</span><span class="ck-v">' + money(r.final) + '</span></div>';
    return '<div class="mp11-cocina">' + inner + '</div>';
  }
  const colchonMonto = r.conColchon - r.conRecargo;
  inner += '<div class="ck-row"><span class="ck-k">Colchón de seguridad<small>' + colchon + '% sobre el subtotal con recargo</small></span><span class="ck-v">+' + money(colchonMonto) + '</span></div>';
  const redondeoMonto = r.redondeado - r.conColchon;
  const rSigno = redondeoMonto < 0 ? "-" : "+";
  inner += '<div class="ck-row"><span class="ck-k">Redondeo de la casa<small>' + money(r.conColchon) + ' → ' + money(r.redondeado) + ' (termina en 49 o 99)</small></span><span class="ck-v">' + rSigno + money(Math.abs(redondeoMonto)) + '</span></div>';
  if(r.pisoAplicado){
    inner += '<div class="ck-row"><span class="ck-k">Piso de pieza de línea<small>el redondeado ' + money(r.redondeado) + ' quedaba bajo el piso ' + money(r.piso) + '</small></span><span class="ck-v">' + money(r.final) + '</span></div>';
  } else if(r.piso != null){
    inner += '<div class="ck-row"><span class="ck-k">Piso de pieza de línea<small>no actuó · piso ' + money(r.piso) + ', el total quedó por encima</small></span><span class="ck-v suave">·</span></div>';
  }
  inner += '<div class="ck-row tot"><span class="ck-k">Total sellado</span><span class="ck-v">' + money(r.final) + '</span></div>';
  return '<div class="mp11-cocina">' + inner + '</div>';
}

function abrirCalibrador(){
  let h = '<div class="grabber"></div>';
  h += '<div class="sheet-head"><div><div class="sheet-nombre">Calibrador de la casa</div><div class="sheet-lugar">las perillas del ojo del fundador · todo late en vivo</div></div></div>';
  h += '<div style="margin-top:16px">';
  h += '<div class="calib-fila"><span class="lbl">Lectura del ancla por mineral</span><div class="calib-ab">'
    + '<button id="ancla-a" aria-pressed="' + (calibAncla === "A") + '">Recomendada<small>pieza publicada si existe; si no, pulsera por su razón</small></button>'
    + '<button id="ancla-b" aria-pressed="' + (calibAncla === "B") + '">B: pulsera por razón<small>siempre pulsera por su razón, para comparar con tu ojo</small></button></div></div>';
  h += '<div class="calib-fila"><div class="calib-slider"><span>Colchón de seguridad</span><b id="colchon-val">' + colchon + '%</b></div>'
    + '<input type="range" id="colchon" min="0" max="12" step="1" value="' + colchon + '" aria-label="Colchón de seguridad en por ciento">'
    + '<small class="hint">Recomendado 5 a 8 por ciento. Cubre mano de obra y variación de la materia.</small></div>';
  h += '<div class="calib-fila"><div class="calib-slider"><span>Recargo por mineral adicional</span><b id="recargo-val">' + recargoPct + '%</b></div>'
    + '<input type="range" id="recargo" min="0" max="10" step="1" value="' + recargoPct + '" aria-label="Recargo por cada mineral adicional en por ciento">'
    + '<small class="hint">Entre más minerales lleve la pieza, más tiempo toma localizarlos en el taller y acomodarlos igual al diseño.</small></div>';
  h += cocinaHTML();
  h += mp14EmbudoHTML();                        // Ronda 14 · T4: el embudo (solo lectura), en el cuarto del fundador
  h += '</div><div class="sheet-acciones"><button class="prim" data-act="cerrar">Listo</button></div>';
  $("sheet-in").innerHTML = h;
  abrirSheet("calibrador", "Calibrador de la casa");
}

/* ===== R5 · sonido y tacto (herencia del contador de la casa: marimba honda) ===== */
function ensureAudio(){
  if(!sonidoOn) return null;
  if(!audioCtx){
    const AC = window.AudioContext || window.webkitAudioContext;
    if(!AC) return null;
    // parche gen (audio-sesion-ios): la sesion de Safari en playback suena con el switch en silencio sin el <audio> que se atoraba
    try{ if(navigator.audioSession){ navigator.audioSession.type = "playback"; sesionAudio = navigator.audioSession.type === "playback"; } }catch(_){ sesionAudio = false; }
    try{ audioCtx = new AC(); }catch(_){ audioCtx = null; return null; }
  }
  if(audioCtx.state === "suspended"){ try{ audioCtx.resume(); }catch(_){} }
  return audioCtx;
}

// ===== iOS: el switch fisico de silencio MUTEA el WebAudio puro. La cura (espejo del Oraculo, funcion
// salidaDe): enrutar por un MediaStreamAudioDestinationNode a un <audio playsinline> oculto (iOS lo trata
// como medio y suena en silencio, como un video). salidaDe(ctx) devuelve ese destino SOLO en iOS; si algo
// falla (mediaRota) cae a ctx.destination (red que jamas empeora lo de hoy). El singleton nace DENTRO del
// primer gesto que enciende el sonido (marimbaNota corre en el toque). Desktop y Android: 0 elementos audio. =====
const esIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
let mediaSalida = null, mediaRota = false;
let sesionAudio = false; // parche gen (audio-sesion-ios): con la sesion de audio de Safari en playback, salida directa
function salidaDe(ctx){
  if(!esIOS || mediaRota || sesionAudio) return ctx.destination;
  try{
    if(!mediaSalida){
      const dest = ctx.createMediaStreamDestination();
      const el = document.createElement("audio");
      el.setAttribute("playsinline", "");
      el.setAttribute("aria-hidden", "true");
      el.style.position = "absolute"; el.style.width = "0"; el.style.height = "0"; el.style.opacity = "0";
      el.srcObject = dest.stream;
      document.body.appendChild(el);
      mediaSalida = { dest: dest, el: el };
    }
    if(mediaSalida.el.paused){
      const p = mediaSalida.el.play();
      if(p && p.catch) p.catch(function(){ mediaRota = true; });
    }
    return mediaSalida.dest;
  }catch(_){ mediaRota = true; return ctx.destination; }
}
// iOS interrumpe el audio en llamadas/Siri: al volver, reanuda el contexto y el elemento de medios.
document.addEventListener("visibilitychange", function(){
  if(!document.hidden && sonidoOn && audioCtx){
    try{ if(audioCtx.state !== "running" && audioCtx.resume) audioCtx.resume().catch(function(){}); }catch(_){}
    if(mediaSalida && mediaSalida.el && mediaSalida.el.paused && !mediaRota){
      try{ const pp = mediaSalida.el.play(); if(pp && pp.catch) pp.catch(function(){}); }catch(_){}
    }
  }
});
// una nota de marimba honda (base grave + parcial FM, envolvente de pulsacion corta)
function marimbaNota(ctx, f, t, vol, dur){
  const o = ctx.createOscillator(), g = ctx.createGain();
  const m = ctx.createOscillator(), mg = ctx.createGain();
  m.frequency.value = f * 3.8;
  mg.gain.setValueAtTime(f * 2.0, t);
  mg.gain.exponentialRampToValueAtTime(1, t + 0.08);
  m.connect(mg).connect(o.frequency);
  o.type = "sine"; o.frequency.value = f;
  g.gain.setValueAtTime(0.0001, t);
  g.gain.exponentialRampToValueAtTime(vol, t + 0.006);
  g.gain.exponentialRampToValueAtTime(0.0001, t + dur);
  o.connect(g).connect(salidaDe(ctx));
  o.start(t); o.stop(t + dur + 0.02);
  m.start(t); m.stop(t + dur + 0.02);
}
function vibra(p){
  if(!sonidoOn || reduce) return;
  if(navigator.vibrate){ try{ navigator.vibrate(p); }catch(_){} }
}
// tic al pintar una cuenta: tono que sube apenas con el avance de la pieza (max un tic por 40ms)
function ticBead(progress){
  if(!sonidoOn) return;
  const now = (window.performance && performance.now) ? performance.now() : Date.now();
  if(now - lastTic < 40) return;
  lastTic = now;
  const ctx = ensureAudio();
  if(ctx){
    const semis = Math.round((progress || 0) * 12);            // sube hasta una octava al llenar
    const f = 175 * Math.pow(2, semis / 12);                   // marimba honda
    marimbaNota(ctx, f, ctx.currentTime, 0.15, 0.18);
  }
  vibra(8);
}
// acorde breve y calido al completar la pieza (no fanfarria)
function acorde(){
  if(!sonidoOn) return;
  const ctx = ensureAudio();
  if(!ctx) return;
  const t = ctx.currentTime;
  const notas = [261.63, 329.63, 392.00];                      // do mayor calido
  notas.forEach(function(f, i){ marimbaNota(ctx, f, t + i * 0.05, 0.12, 0.6); });
}
// vigila el paso de incompleta -> completa para el acorde (silencioso si no aplica)
function maybeChord(){
  const c = beads.filter(function(x){ return x != null; }).length === CFG[pieza].N;
  if(c && !wasComplete){ mp14Embudo("precio_sellado"); mp14Cristaliza(); }   // Ronda 14 · T2 + T4
  wasComplete = c;
}

/* ===== Ronda 8 · T2 · la voz de la pieza al sellar (2 intenciones dominantes, del corpus) ===== */
let vozTimer = 0;
function mostrarVozSellado(manifiesto){
  const voz = vozDeLaPieza(2);                   // reutiliza la logica del desglose, con 2 dominantes
  if(!voz && !manifiesto) return;
  const el = $("mp8-voz"); if(!el) return;
  let html = "";
  // Ronda 14 · T2: en reduced-motion la frase del manifiesto se apila sobre la voz (aparecen juntas, sin traslape)
  if(manifiesto) html += '<span class="mp14-voz-cristal">' + escHtml(manifiesto) + '</span>';
  if(voz){
    html += '<span class="mp9-voz-l1">' + escHtml(voz) + '</span>';
    // MUDANZA (9-jul): el sello de coincidencias de la Mesa, a la voz de la pieza (2+ minerales que comparten una intencion)
    html += cotSelloVozHTML();
    // Ronda 15: si la talla lleva separadores, la linea que los nombra
    const sepVoz = mp15SepVoz();
    if(sepVoz) html += '<span class="mp15-voz-sep">' + escHtml(sepVoz) + '</span>';
    // Ronda 9 · 5: segunda linea = el HOOK VERBATIM del mineral dominante (cero palabras inventadas)
    const dom = dominante();
    if(dom >= 0){ const m = DATOS.minerales[dom]; if(m && m.hook) html += '<span class="mp9-voz-hook">' + escHtml(m.hook) + '</span>'; }
  }
  el.innerHTML = html; el.hidden = false;
  requestAnimationFrame(function(){ el.classList.add("on"); });
  clearTimeout(vozTimer); vozTimer = setTimeout(ocultaVoz, 11000);   // respira 11s (antes 6); muere al siguiente toque
}
function ocultaVoz(){
  const el = $("mp8-voz"); if(!el || el.hidden) return;
  el.classList.remove("on"); clearTimeout(vozTimer);
  if(reduce){ el.hidden = true; return; }
  vozTimer = setTimeout(function(){ el.hidden = true; }, 420);
}
function syncComplete(){ wasComplete = beads.filter(function(x){ return x != null; }).length === CFG[pieza].N; }

/* ===== Ronda 18 · F2 · LA PASTILLA DE LA ENERGIA =====
   La voz aparece al sellar y se va sola; esta pastilla es la puerta de regreso (sin re-ceremonia).
   Con la pieza sellada muestra la voz completa (frase del manifiesto + voz + hook); a medias, la
   voz normal de 3 intenciones + la linea de separadores. Solo existe con 1+ cuentas. */
function mp18EnergiaChipHTML(){
  return '<button class="chip mp18-energia" id="mp18-energia-btn" aria-label="La energía de tu pieza: escucha su voz">'
    + '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3l1.7 4.3L18 9l-4.3 1.7L12 15l-1.7-4.3L6 9l4.3-1.7z"/></svg>La energía</button>';
}
function mp18AbreEnergia(){
  if(mp14Completa()){ mostrarVozSellado(mp14FraseManifiesto()); return; }   // sellada: la voz completa, sin re-disparar la ceremonia ni el precio
  // a medias: la voz normal (3 intenciones) + la linea de separadores, en el mismo recuadro
  const voz = vozDeLaPieza(3);
  if(!voz) return;
  const el = $("mp8-voz"); if(!el) return;
  let html = '<span class="mp9-voz-l1">' + escHtml(voz) + '</span>';
  const sepVoz = mp15SepVoz();
  if(sepVoz) html += '<span class="mp15-voz-sep">' + escHtml(sepVoz) + '</span>';
  el.innerHTML = html; el.hidden = false;
  requestAnimationFrame(function(){ el.classList.add("on"); });
  clearTimeout(vozTimer); vozTimer = setTimeout(ocultaVoz, 11000);   // mismo respiro de 11s
}

/* ======================= RONDA 23 · OLEADA 3 =======================
   F1 la energia completa en ventana · F2 la mesa expandida · F3 el QR de compartir · F4 la ficha del explorador */

/* --- F3 · encoder QR propio: byte mode, EC nivel M, versiones 1..10. Sin servicios
   externos ni fetch; determinista. Verificado contra un decodificador real (opencv).
   Nota del taller: cuando la URL portadora #d= lleve el GO del fundador, el QR cargara
   el diseno exacto de la pieza; HOY lleva al Taller de la casa. */
const MP23_QR_URL = "https://mamapachita.com/pages/taller";
/* dormido 9-jul por decision del fundador: la estampa lleva firma legible; revivira si algun dia hay estampas impresas */
var MP23QR = (function(){
  const ECCPB = { L:[0,7,10,15,20,26,18,20,24,30,18], M:[0,10,16,26,18,24,16,18,22,22,26],
                  Q:[0,13,22,18,26,18,24,18,22,20,24], H:[0,17,28,22,16,22,28,26,26,24,28] };
  const NBLK = { L:[0,1,1,1,1,1,2,2,2,2,4], M:[0,1,1,1,2,2,4,4,4,5,5],
                 Q:[0,1,1,2,2,4,4,6,6,8,8], H:[0,1,1,2,4,4,4,5,5,8,8] };
  const FMT = { L:1, M:0, Q:3, H:2 };
  function rsMul(x,y){ let z=0; for(let i=7;i>=0;i--){ z=(z<<1)^((z>>>7)*0x11d); z^=((y>>>i)&1)*x; } return z & 0xFF; }
  function rsDivisor(deg){ const r=[]; for(let i=0;i<deg-1;i++) r.push(0); r.push(1); let root=1;
    for(let i=0;i<deg;i++){ for(let j=0;j<r.length;j++){ r[j]=rsMul(r[j],root); if(j+1<r.length) r[j]^=r[j+1]; } root=rsMul(root,0x02); } return r; }
  function rsRemainder(data,div){ const r=div.map(function(){return 0;});
    for(let k=0;k<data.length;k++){ const f=data[k]^r.shift(); r.push(0); for(let i=0;i<div.length;i++) r[i]^=rsMul(div[i],f); } return r; }
  function numRaw(v){ let r=(16*v+128)*v+64; if(v>=2){ const na=Math.floor(v/7)+2; r-=(25*na-10)*na-55; if(v>=7) r-=36; } return r; }
  function numData(v,e){ return Math.floor(numRaw(v)/8) - ECCPB[e][v]*NBLK[e][v]; }
  function bytesOf(s){ const o=[]; for(let i=0;i<s.length;i++){ let c=s.charCodeAt(i);
    if(c<0x80) o.push(c); else if(c<0x800){ o.push(0xC0|(c>>6)); o.push(0x80|(c&0x3F)); }
    else { o.push(0xE0|(c>>12)); o.push(0x80|((c>>6)&0x3F)); o.push(0x80|(c&0x3F)); } } return o; }
  function bitData(bytes,v,e){ const cap=numData(v,e)*8, bits=[];
    function push(val,len){ for(let i=len-1;i>=0;i--) bits.push((val>>>i)&1); }
    push(0x4,4); const cc=v<10?8:16; push(bytes.length,cc);
    for(let i=0;i<bytes.length;i++) push(bytes[i],8);
    for(let t=0;t<4 && bits.length<cap;t++) bits.push(0);
    while(bits.length%8!==0) bits.push(0);
    const pad=[0xEC,0x11]; let pi=0; while(bits.length<cap){ push(pad[pi],8); pi^=1; }
    const cw=[]; for(let b=0;b<bits.length;b+=8){ let x=0; for(let k=0;k<8;k++) x=(x<<1)|bits[b+k]; cw.push(x); } return cw; }
  function addEcc(cw,v,e){ const nb=NBLK[e][v], el=ECCPB[e][v], raw=Math.floor(numRaw(v)/8);
    const nShort=nb-(raw%nb), sLen=Math.floor(raw/nb), blocks=[], div=rsDivisor(el); let off=0;
    for(let i=0;i<nb;i++){ const dl=sLen-el+(i<nShort?0:1); const dat=cw.slice(off,off+dl); off+=dl; blocks.push({dat:dat,ecc:rsRemainder(dat,div)}); }
    const out=[]; let maxD=0; blocks.forEach(function(b){ if(b.dat.length>maxD) maxD=b.dat.length; });
    for(let j=0;j<maxD;j++) for(let i=0;i<blocks.length;i++){ if(j<blocks[i].dat.length) out.push(blocks[i].dat[j]); }
    for(let j=0;j<el;j++) for(let i=0;i<blocks.length;i++) out.push(blocks[i].ecc[j]); return out; }
  function aligns(v){ if(v===1) return []; const na=Math.floor(v/7)+2;
    const step=Math.ceil((v*4+4)/(na*2-2))*2; const r=[6];
    for(let pos=v*4+10; r.length<na; pos-=step) r.splice(1,0,pos); return r; }
  function build(cw,v,e,forced){ const size=v*4+17, mod=[], fn=[];
    for(let i=0;i<size;i++){ mod.push(new Array(size).fill(false)); fn.push(new Array(size).fill(false)); }
    function setF(x,y,val){ if(x<0||x>=size||y<0||y>=size) return; mod[y][x]=val; fn[y][x]=true; }
    function finder(x,y){ for(let dy=-4;dy<=4;dy++) for(let dx=-4;dx<=4;dx++){ const d=Math.max(Math.abs(dx),Math.abs(dy)); setF(x+dx,y+dy,d!==2 && d!==4); } }
    for(let i=0;i<size;i++){ setF(6,i,i%2===0); setF(i,6,i%2===0); }
    finder(3,3); finder(size-4,3); finder(3,size-4);
    const ap=aligns(v);
    for(let a=0;a<ap.length;a++) for(let b=0;b<ap.length;b++){
      if((a===0&&b===0)||(a===0&&b===ap.length-1)||(a===ap.length-1&&b===0)) continue;
      const cx=ap[a], cy=ap[b];
      for(let dy=-2;dy<=2;dy++) for(let dx=-2;dx<=2;dx++) setF(cx+dx,cy+dy,Math.max(Math.abs(dx),Math.abs(dy))!==1);
    }
    for(let i=0;i<9;i++){ if(i!==6){ fn[i][8]=true; fn[8][i]=true; } }
    for(let i=0;i<8;i++){ fn[size-1-i][8]=true; fn[8][size-1-i]=true; }
    fn[8][8]=true; fn[8][6]=true; fn[6][8]=true; setF(8,size-8,true);
    const bits=[]; for(let k=0;k<cw.length;k++) for(let i=7;i>=0;i--) bits.push((cw[k]>>>i)&1);
    let idx=0;
    for(let right=size-1; right>=1; right-=2){ if(right===6) right=5;
      for(let vert=0; vert<size; vert++){ for(let jj=0;jj<2;jj++){ const x=right-jj; const up=((right+1)&2)===0; const y=up?(size-1-vert):vert;
        if(!fn[y][x] && idx<bits.length){ mod[y][x]=(bits[idx]!==0); idx++; } } } }
    function maskFn(m,x,y){ switch(m){ case 0:return (x+y)%2===0; case 1:return y%2===0; case 2:return x%3===0; case 3:return (x+y)%3===0;
      case 4:return (Math.floor(x/3)+Math.floor(y/2))%2===0; case 5:return (x*y)%2+(x*y)%3===0; case 6:return ((x*y)%2+(x*y)%3)%2===0; case 7:return ((x+y)%2+(x*y)%3)%2===0; } return false; }
    function applyMask(m){ for(let y=0;y<size;y++) for(let x=0;x<size;x++) if(!fn[y][x] && maskFn(m,x,y)) mod[y][x]=!mod[y][x]; }
    function drawFmt(m){ const data=(FMT[e]<<3)|m; let rem=data; for(let i=0;i<10;i++) rem=(rem<<1)^((rem>>>9)*0x537);
      const bf=((data<<10)|rem)^0x5412;
      for(let i=0;i<=5;i++) mod[i][8]=((bf>>>i)&1)!==0;
      mod[7][8]=((bf>>>6)&1)!==0; mod[8][8]=((bf>>>7)&1)!==0; mod[8][7]=((bf>>>8)&1)!==0;
      for(let i=9;i<15;i++) mod[8][14-i]=((bf>>>i)&1)!==0;
      for(let i=0;i<8;i++) mod[8][size-1-i]=((bf>>>i)&1)!==0;
      for(let i=8;i<15;i++) mod[size-15+i][8]=((bf>>>i)&1)!==0;
      mod[size-8][8]=true; }
    function penalty(){ let p=0; const N1=3,N2=3,N3=40,N4=10;
      for(let y=0;y<size;y++){ let run=1; for(let x=1;x<size;x++){ if(mod[y][x]===mod[y][x-1]){ run++; if(run===5) p+=N1; else if(run>5) p++; } else run=1; } }
      for(let x=0;x<size;x++){ let run=1; for(let y=1;y<size;y++){ if(mod[y][x]===mod[y-1][x]){ run++; if(run===5) p+=N1; else if(run>5) p++; } else run=1; } }
      for(let y=0;y<size-1;y++) for(let x=0;x<size-1;x++){ const c=mod[y][x]; if(c===mod[y][x+1]&&c===mod[y+1][x]&&c===mod[y+1][x+1]) p+=N2; }
      const pA=[true,false,true,true,true,false,true,false,false,false,false], pB=[false,false,false,false,true,false,true,true,true,false,true];
      function lm(get){ for(let i=0;i<=size-11;i++){ let o1=true,o2=true; for(let k=0;k<11;k++){ const val=get(i+k); if(val!==pA[k]) o1=false; if(val!==pB[k]) o2=false; } if(o1) p+=N3; if(o2) p+=N3; } }
      for(let y=0;y<size;y++){ (function(yy){ lm(function(i){ return mod[yy][i]; }); })(y); }
      for(let x=0;x<size;x++){ (function(xx){ lm(function(i){ return mod[i][xx]; }); })(x); }
      let dark=0; for(let y=0;y<size;y++) for(let x=0;x<size;x++) if(mod[y][x]) dark++;
      const total=size*size; let kk=0; while(Math.abs(dark*20 - total*10) > (kk+1)*total){ kk++; } p+=kk*N4; return p; }
    let chosen=forced;
    if(chosen==null){ let best=-1, bp=Infinity;
      for(let m=0;m<8;m++){ applyMask(m); drawFmt(m); const pen=penalty(); applyMask(m); if(pen<bp){ bp=pen; best=m; } } chosen=best; }
    applyMask(chosen); drawFmt(chosen);
    return { size:size, version:v, mask:chosen, modules:mod }; }
  function make(text, ecl, forced){ ecl=ecl||"M"; const data=bytesOf(text); let v=1;
    for(; v<=10; v++){ const cc=v<10?8:16; if(4+cc+data.length*8 <= numData(v,ecl)*8) break; }
    if(v>10) v=10; const cw=bitData(data,v,ecl); return build(addEcc(cw,v,ecl),v,ecl,(forced==null?null:forced)); }
  return { make:make };
})();
// rectangulo con esquinas suaves para la zona de silencio del QR en la estampa
function mp23RoundRect(ctx,x,y,w,h,r){ ctx.beginPath(); ctx.moveTo(x+r,y);
  ctx.arcTo(x+w,y,x+w,y+h,r); ctx.arcTo(x+w,y+h,x,y+h,r); ctx.arcTo(x,y+h,x,y,r); ctx.arcTo(x,y,x+w,y,r); ctx.closePath(); }
// dibuja el QR discreto (modulos oscuros sobre zona clara, 4 modulos de silencio: escanea de verdad)
function mp23QRDibuja(ctx, x, y, sizePx, text){
  let qr; try{ qr = MP23QR.make(text, "M"); }catch(_){ return; }
  const n = qr.size, quiet = 4, units = n + quiet * 2;
  const mpx = Math.max(1, Math.floor(sizePx / units)), draw = mpx * units;
  const ox = x + Math.round((sizePx - draw) / 2), oy = y + Math.round((sizePx - draw) / 2);
  ctx.fillStyle = "#F3EFE9"; mp23RoundRect(ctx, ox, oy, draw, draw, 12); ctx.fill();
  ctx.fillStyle = "#141110";
  for(let r = 0; r < n; r++) for(let c = 0; c < n; c++){
    if(qr.modules[r][c]) ctx.fillRect(ox + (c + quiet) * mpx, oy + (r + quiet) * mpx, mpx, mpx);
  }
}

/* --- monta el CSS y el HTML de la Oleada 3 en tiempo de ejecucion (DESPUES de DATOS,
   para que las lineas sagradas 1297/1298 no se muevan ni un renglon) --- */
let mp23Montado = false;
function mp23Monta(){
  if(mp23Montado) return; mp23Montado = true;
  const css = ''
    + '.mp23-ene-ov{--hueso:#F3EFE9;--hueso-tenue:rgba(243,239,233,.66);--oro-claro:#DCC188;--oro:#C9A961;--linea:rgba(201,169,97,.20);--obsidiana-2:#221E1A;position:fixed;inset:0;z-index:78;display:none;align-items:center;justify-content:center;padding:20px}'
    + '.mp23-ene-ov.on{display:flex}'
    + '.mp23-ene-scrim{position:absolute;inset:0;background:rgba(12,10,9,.66);backdrop-filter:blur(4px);-webkit-backdrop-filter:blur(4px)}'
    + '.mp23-ene-card{position:relative;z-index:1;width:min(94vw,420px);max-height:82dvh;display:flex;flex-direction:column;background:radial-gradient(120% 90% at 50% 0%,#241F1B 0%,#181513 82%);border:1px solid var(--linea);border-radius:22px;box-shadow:0 22px 60px rgba(0,0,0,.62);opacity:0;transform:translateY(10px) scale(.98);transition:opacity .26s ease,transform .26s ease}'
    + '.mp23-ene-ov.on .mp23-ene-card{opacity:1;transform:none}'
    + '.mp23-ene-x{position:absolute;top:10px;right:10px;z-index:2;width:36px;height:36px;border-radius:50%;background:var(--obsidiana-2);border:1px solid var(--linea);display:flex;align-items:center;justify-content:center}'
    + '.mp23-ene-x svg{width:16px;height:16px;stroke:var(--oro-claro);fill:none;stroke-width:2;stroke-linecap:round;stroke-linejoin:round}'
    + '.mp23-ene-x:hover{border-color:var(--oro)}'
    + '.mp23-ene-scroll{overflow-y:auto;padding:30px 22px 24px;-webkit-overflow-scrolling:touch}'
    + '.mp23-ene-scroll::-webkit-scrollbar{width:6px}.mp23-ene-scroll::-webkit-scrollbar-thumb{background:var(--linea);border-radius:9px}'
    + '.mp23-ene-tit{font-family:var(--display);font-style:italic;font-weight:500;font-size:1.24rem;color:var(--hueso);text-align:center;line-height:1.14}'
    + '.mp23-ene-man{margin-top:13px;font-family:var(--display);font-style:italic;font-size:.98rem;line-height:1.42;color:var(--oro-claro);text-align:center}'
    + '.mp23-ene-dom{margin-top:13px;font-family:var(--display);font-style:italic;font-size:1.02rem;line-height:1.42;color:var(--hueso);text-align:center}'
    + '.mp23-ene-lista{margin-top:16px;border-top:1px solid var(--linea);padding-top:4px}'
    + '.mp23-ene-row{display:flex;align-items:center;gap:12px;padding:11px 2px;border-bottom:1px solid rgba(201,169,97,.09)}'
    + '.mp23-ene-row:last-child{border-bottom:0}'
    + '.mp23-ene-r{flex:0 0 34px;width:34px;height:34px;border-radius:50%;border:1px solid rgba(0,0,0,.4);box-shadow:inset 0 -1px 3px rgba(0,0,0,.35),inset 0 1px 2px rgba(255,255,255,.14),0 1px 3px rgba(0,0,0,.4)}'
    + '.mp23-ene-tx{min-width:0}'
    + '.mp23-ene-n{display:block;font-size:.9rem;font-weight:600;color:var(--oro-claro);line-height:1.2}'
    + '.mp23-ene-e{display:block;font-size:.8rem;color:var(--hueso-tenue);line-height:1.35;margin-top:2px}'
    + '.mp23-ene-sep{margin-top:14px;font-size:.84rem;line-height:1.42;color:var(--hueso-tenue);text-align:center;font-style:italic;font-family:var(--display)}'
    + '.mp23-mesa-exp{flex:0 0 auto;width:34px;height:34px;border-radius:50%;background:var(--obsidiana-2);border:1px solid var(--linea);display:flex;align-items:center;justify-content:center;transition:.14s}'
    + '.mp23-mesa-exp svg{width:16px;height:16px;stroke:var(--oro);fill:none;stroke-width:2;stroke-linecap:round;stroke-linejoin:round}'
    + '.mp23-mesa-exp:hover{border-color:var(--oro)}'
    + '.mp23-mesa-scrim{position:fixed;inset:0;z-index:48;background:rgba(12,10,9,.42);backdrop-filter:blur(2px);-webkit-backdrop-filter:blur(2px)}'
    + '.mp23-mesa-scrim[hidden]{display:none}'
    + '.mp23-mesa-panel{position:fixed;z-index:49;right:calc(env(safe-area-inset-right) + 8px);bottom:calc(env(safe-area-inset-bottom) + 150px);width:min(90vw,330px);max-height:calc(100dvh - 220px);overflow-y:auto;-webkit-overflow-scrolling:touch;padding:14px 14px 16px;background:rgba(24,21,18,.97);backdrop-filter:blur(14px);-webkit-backdrop-filter:blur(14px);border:1px solid var(--linea-2);border-radius:22px;box-shadow:0 20px 54px rgba(0,0,0,.6);opacity:0;transform:translateY(10px);transition:opacity .22s ease,transform .22s ease}'
    + '.mp23-mesa-panel.on{opacity:1;transform:none}.mp23-mesa-panel[hidden]{display:none}'
    + '.mp23-mesa-panel::-webkit-scrollbar{width:6px}.mp23-mesa-panel::-webkit-scrollbar-thumb{background:var(--linea);border-radius:9px}'
    + '.mp23-mp-tit{font-size:.66rem;letter-spacing:.11em;text-transform:uppercase;color:var(--hueso-tenue);opacity:.82;margin-bottom:10px}'
    + '.mp23-mp-grid{display:flex;flex-wrap:wrap;gap:12px 4px;align-items:flex-start}'
    + '.mp23-mp-grid .slot{width:62px}'
    + '.mp23-mp-lbl{width:100%;font-size:.58rem;letter-spacing:.09em;text-transform:uppercase;color:var(--hueso-tenue);opacity:.72;margin:10px 0 0;border-top:1px solid rgba(201,169,97,.1);padding-top:11px}'
    + '.mp23-mp-act{display:flex;gap:8px;flex-wrap:wrap;margin-top:14px;border-top:1px solid rgba(201,169,97,.1);padding-top:13px}'
    + '.mp23-mp-btn{flex:0 0 auto;display:inline-flex;align-items:center;gap:7px;padding:9px 13px;border-radius:999px;background:var(--obsidiana-2);border:1px solid var(--linea);color:var(--hueso-tenue);font-size:.78rem;font-weight:600}'
    + '.mp23-mp-btn svg{width:15px;height:15px;stroke:var(--oro);fill:none;stroke-width:2;stroke-linecap:round;stroke-linejoin:round}'
    + '.mp23-mp-btn:hover{border-color:var(--oro);color:var(--oro-claro)}'
    + '.mp23-fic{position:absolute;inset:0;z-index:5;display:none}.mp23-fic.on{display:block}'
    + '.mp23-fic-scrim{position:absolute;inset:0;background:rgba(12,10,9,.6);backdrop-filter:blur(3px);-webkit-backdrop-filter:blur(3px)}'
    + '.mp23-fic-card{position:absolute;left:0;right:0;bottom:0;max-height:92%;display:flex;flex-direction:column;background:radial-gradient(120% 80% at 50% 0%,#241F1B 0%,#181513 88%);border-top:1px solid var(--linea);border-radius:24px 24px 0 0;box-shadow:0 -14px 44px rgba(0,0,0,.55);transform:translateY(100%);transition:transform .28s cubic-bezier(.22,.61,.36,1)}'
    + '.mp23-fic.on .mp23-fic-card{transform:none}'
    + '.mp23-fic-in{width:100%;max-width:520px;margin:0 auto;display:flex;flex-direction:column;min-height:0}'
    + '.mp23-fic-x{position:absolute;top:12px;right:12px;z-index:2;width:36px;height:36px;border-radius:50%;background:var(--obsidiana-2);border:1px solid var(--linea);display:flex;align-items:center;justify-content:center}'
    + '.mp23-fic-x svg{width:16px;height:16px;stroke:var(--oro-claro);fill:none;stroke-width:2;stroke-linecap:round;stroke-linejoin:round}'
    + '.mp23-fic-x:hover{border-color:var(--oro)}'
    + '.mp23-fic-scroll{overflow-y:auto;padding:26px 22px calc(env(safe-area-inset-bottom) + 20px);-webkit-overflow-scrolling:touch}'
    + '.mp23-fic-top{display:flex;flex-direction:column;align-items:center;text-align:center;gap:14px}'
    + '.mp23-fic-esfera{width:116px;height:116px;border-radius:50%;border:1px solid rgba(0,0,0,.42);box-shadow:inset 0 -7px 15px rgba(0,0,0,.42),inset 0 6px 13px rgba(255,255,255,.13),0 9px 24px rgba(0,0,0,.5)}'
    + '.mp23-fic-nombre{font-family:var(--display);font-style:italic;font-weight:500;font-size:1.5rem;color:var(--hueso);line-height:1.1}'
    + '.mp23-fic-chips{display:flex;flex-wrap:wrap;gap:6px;justify-content:center}'
    + '.mp23-fic-esencia{margin-top:16px;color:var(--hueso-tenue);font-size:.92rem;line-height:1.62}'
    + '.mp23-fic-precio{margin-top:16px;padding-top:12px;border-top:1px dashed var(--linea-2);font-size:.84rem;color:var(--hueso-tenue)}'
    + '.mp23-fic-precio b{color:var(--hueso);font-weight:600}'
    + '.mp23-fic-precio .aviso{display:block;margin-top:4px;font-size:.75rem;color:var(--oro-claro)}'
    + '.mp23-fic-cta{margin-top:18px;width:100%;padding:14px;border-radius:14px;background:var(--oro);color:var(--obsidiana);font-size:.94rem;font-weight:700;border:1px solid var(--oro)}'
    + '.mp23-fic-cta:hover{filter:brightness(1.06)}'
    + '.mp23-ene-mezcla{margin-top:15px;font-family:var(--display);font-style:italic;font-size:.94rem;line-height:1.5;color:var(--hueso);text-align:center}'
    + '.mp23-ene-mezcla .mp23-ene-casa{color:var(--oro-claro);font-style:italic}'
    + '.mp23-ene-lectura{margin-top:15px;font-family:var(--display);font-style:italic;font-size:.92rem;line-height:1.55;color:var(--oro-claro);text-align:center}'
    + '.mp23-ene-pide{display:block;margin:16px auto 2px;font-family:inherit;font-size:.82rem;color:var(--oro-claro);background:var(--obsidiana-2);border:1px solid var(--linea);border-radius:999px;padding:9px 16px;cursor:pointer;transition:border-color .2s ease}'
    + '.mp23-ene-pide:hover{border-color:var(--oro)}'
    + '.mp23-ene-pide[disabled]{opacity:.6;cursor:default}'
    + '@media (min-width:1024px){.mp23-mesa-exp{display:none}}'
    + '@media (prefers-reduced-motion:reduce){.mp23-ene-card,.mp23-mesa-panel,.mp23-fic-card{transition:none}}';
  const st = document.createElement("style"); st.id = "mp23-css"; st.textContent = css; document.head.appendChild(st);
  // F1 · la ventana de la energia + F2 · el panel de la mesa (al final del body)
  document.body.insertAdjacentHTML("beforeend", ''
    + '<div class="mp23-ene-ov" id="mp23-ene-ov" aria-hidden="true" role="dialog" aria-modal="true" aria-label="La energía de tu pieza">'
    +   '<div class="mp23-ene-scrim" id="mp23-ene-scrim"></div>'
    +   '<div class="mp23-ene-card"><button class="mp23-ene-x" id="mp23-ene-x" aria-label="Cerrar la ventana de la energía">'
    +     '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6l-12 12"/></svg></button>'
    +     '<div class="mp23-ene-scroll" id="mp23-ene-scroll"></div></div>'
    + '</div>'
    + '<div class="mp23-mesa-scrim" id="mp23-mesa-scrim" hidden></div>'
    + '<div class="mp23-mesa-panel" id="mp23-mesa-panel" hidden role="group" aria-label="Todos tus pinceles a la vista"></div>');
  // F4 · la ficha DENTRO del explorador
  const exp = $("explorador");
  if(exp) exp.insertAdjacentHTML("beforeend", ''
    + '<div class="mp23-fic" id="mp23-fic" aria-hidden="true">'
    +   '<div class="mp23-fic-scrim" id="mp23-fic-scrim"></div>'
    +   '<div class="mp23-fic-card" role="dialog" aria-modal="true" aria-label="Ficha del mineral">'
    +     '<button class="mp23-fic-x" id="mp23-fic-x" aria-label="Cerrar la ficha y volver a las cuentas"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6l-12 12"/></svg></button>'
    +     '<div class="mp23-fic-scroll"><div class="mp23-fic-in" id="mp23-fic-in"></div></div>'
    +   '</div>'
    + '</div>');
}

/* --- F1 · la energia completa en una ventana centrada, sin autocierre (scroll interno) --- */
function mp23EsenciaMineral(m){
  if(m && m.intenciones && m.intenciones.length){
    const t = m.intenciones.slice(0, 3).map(function(x){ return x.toLowerCase(); });
    if(t.length === 1) return t[0];
    if(t.length === 2) return t[0] + " y " + t[1];
    return t[0] + ", " + t[1] + " y " + t[2];
  }
  if(m && m.hook){ const f = m.hook.split(". ")[0]; return f.charAt(0).toLowerCase() + f.slice(1); }
  return "";
}
// los minerales distintos del cuerpo, ordenados por presencia (mas cuentas primero, luego nombre)
function mp23MineralesCuerpo(){
  const cnt = {};
  beads.forEach(function(x){ if(x != null) cnt[x] = (cnt[x] || 0) + 1; });
  const ids = Object.keys(cnt).map(Number);
  ids.sort(function(a, b){ return cnt[b] - cnt[a] || DATOS.minerales[a].n.localeCompare(DATOS.minerales[b].n, "es"); });
  return ids;
}
function mp23EnergiaContenidoHTML(){
  let h = '<div class="mp23-ene-tit">La energía de tu pieza</div>';
  if(mp14Completa()){ const man = mp14FraseManifiesto(); if(man) h += '<div class="mp23-ene-man">' + escHtml(man) + '</div>'; }
  const dom = vozDeLaPieza(3);
  if(dom) h += '<div class="mp23-ene-dom">' + escHtml(dom) + '</div>';
  const ids = mp23MineralesCuerpo();
  // MUDANZA (9-jul): la lectura de la mezcla de la Mesa (verbatim si la union vive en la casa; si no, composicion canonica)
  const cotLect = cotLeeMezcla(ids);
  if(cotLect) h += '<div class="mp23-ene-mezcla">' + cotLect + '</div>';
  if(ids.length){
    h += '<div class="mp23-ene-lista">';
    ids.forEach(function(mid){
      const m = DATOS.minerales[mid], f = fillMin(mid);
      h += '<div class="mp23-ene-row"><span class="mp23-ene-r fill ' + f.cls + '" style="' + f.style + '"></span>'
        + '<span class="mp23-ene-tx"><span class="mp23-ene-n">' + escHtml(nombreArt(m, true)) + '</span>'
        + '<span class="mp23-ene-e">' + escHtml(mp23EsenciaMineral(m)) + '</span></span></div>';
    });
    h += '</div>';
  }
  const sepVoz = mp15SepVoz();
  if(sepVoz) h += '<div class="mp23-ene-sep">' + escHtml(sepVoz) + '</div>';
  // MUDANZA · T4 + P7: la lectura del Oraculo a peticion (una llamada por mezcla; el worker atiende 2-6; con 4+ lee el acorde)
  if(ids.length >= 2 && ids.length <= 6){
    const cl = cotClaveLectura(ids), gu = cotLecturasCache()[cl];
    if(gu) h += '<div class="mp23-ene-lectura">' + escHtml(gu) + '</div>';
    else h += '<button type="button" class="mp23-ene-pide" data-cot-lectura data-espera="El Oráculo escucha tu mezcla…">Pídele su lectura al Oráculo</button>';
  }
  return h;
}
function mp23AbreEnergia(){
  const box = $("mp23-ene-scroll"); if(!box) return;
  box.innerHTML = mp23EnergiaContenidoHTML();   // solo lee el estado: JAMAS re-dispara la ceremonia ni mueve el precio
  box.scrollTop = 0;
  const ov = $("mp23-ene-ov");
  ov.classList.add("on"); ov.setAttribute("aria-hidden", "false");
  mp23EneAbierta = true;
}
function mp23CierraEnergia(){
  const ov = $("mp23-ene-ov"); if(!ov) return;
  ov.classList.remove("on"); ov.setAttribute("aria-hidden", "true");
  mp23EneAbierta = false;
}

/* ===== MUDANZA DEL ALMA DE LA MESA (9-jul-2026, decision del fundador; construida en la ronda de los frutos maduros) =====
   Dos tesoros de la Mesa (sections/mp-taller.liquid, cuarto retirado) viajan al Taller:
   (1) LA LECTURA DE LA MEZCLA -> a la ventana "La energia" (mp23): si la union de minerales ya vive
       en una pieza intima de la casa, se dice VERBATIM (COT_COMBOS, horneado); si no, composicion
       serena desde las intenciones canonicas. Ademas ofrece la lectura del Oraculo a peticion (T4).
   (2) EL SELLO DE COINCIDENCIAS -> a la voz de la pieza (mostrarVozSellado): cuando 2+ minerales
       comparten una intencion canonica, la voz lo nombra ("Tu mezcla coincide en ...").
   COT_COMBOS: uniones intimas de la casa, derivadas de snippets/mp-taller-datos.liquid (que las
   genera gen-taller-datos.cjs desde oraculo-worker/src/corpus-mezclas.json), filtradas a los 113
   minerales del Taller. Copia horneada (como DATOS): si el corpus de mezclas cambia, re-hornear. */
const COT_COMBOS = {"Aguamarina|Apatita Azul":"expresión alineada (azules)","Aguamarina|Apatita Azul|Lapislázuli":"expresión alineada (azules)","Aguamarina|Apatita Azul|Larimar":"verbo y visión (azules)","Aguamarina|Apatita Azul|Ojo de Halcón":"expresión alineada (azules)","Aguamarina|Apatita Azul|Perla Negra":"verbo y visión (azules)","Aguamarina|Apatita Azul|Piedra Luna":"verbo y visión (azules)","Aguamarina|Berilos":"amor y comunicación","Aguamarina|Berilos|Esmeralda en Matriz de Biotita":"alineación sentir-decir-hacer, los tres berilos","Aguamarina|Berilos|Turmalina Negra":"visión trifocal anclada","Aguamarina|Esmeralda en Matriz de Biotita":"alineación sentir-decir-hacer, los tres berilos","Aguamarina|Esmeralda en Matriz de Biotita|Turmalina Negra":"visión trifocal anclada","Aguamarina|Lapislázuli":"expresión alineada (azules)","Aguamarina|Lapislázuli|Larimar":"verbo y visión (azules)","Aguamarina|Lapislázuli|Ojo de Halcón":"expresión alineada (azules)","Aguamarina|Lapislázuli|Perla Negra":"verbo y visión (azules)","Aguamarina|Lapislázuli|Piedra Luna":"verbo y visión (azules)","Aguamarina|Larimar":"verbo y visión (azules)","Aguamarina|Larimar|Perla Negra":"verbo y visión (azules)","Aguamarina|Larimar|Piedra Luna":"verbo y visión (azules)","Aguamarina|Ojo de Halcón":"expresión alineada (azules)","Aguamarina|Perla Negra":"verbo y visión (azules)","Aguamarina|Perla Negra|Piedra Luna":"verbo y visión (azules)","Aguamarina|Piedra Luna":"verbo y visión (azules)","Aguamarina|Turmalina Negra":"verdad serena y protección energética","Amatista Fantasma|Esmeralda en Matriz de Biotita":"zodiaco: Escorpio, agua fija","Amatista Fantasma|Esmeralda en Matriz de Biotita|Prehnita":"zodiaco: Escorpio, agua fija","Amatista Fantasma|Labradorita":"sol, dios: Mithra, dios persa de la luz y los pactos, intuición anclada","Amatista Fantasma|Labradorita|Super 7":"alma integrada, multi-chakra","Amatista Fantasma|Labradorita|Turmalina Rosa":"alma integrada, multi-chakra","Amatista Fantasma|Labradorita|Ámbar":"sol, dios: Mithra, dios persa de la luz y los pactos, intuición anclada","Amatista Fantasma|Prehnita":"zodiaco: Escorpio, agua fija","Amatista Fantasma|Super 7":"alma integrada, multi-chakra","Amatista Fantasma|Super 7|Turmalina Rosa":"alma integrada, multi-chakra","Amatista Fantasma|Turmalina Negra":"guerrero espiritual, ascensión anclada","Amatista Fantasma|Turmalina Rosa":"alma integrada, multi-chakra","Amatista Fantasma|Ámbar":"sol, dios: Mithra, dios persa de la luz y los pactos, intuición anclada","Amatista|Amatista Fantasma":"alma integrada, multi-chakra, collar","Amatista|Amatista Fantasma|Labradorita":"alma integrada, multi-chakra, collar","Amatista|Amatista Fantasma|Super 7":"alma integrada, multi-chakra, collar","Amatista|Amatista Fantasma|Turmalina Rosa":"alma integrada, multi-chakra, collar","Amatista|Charoita":"visión y ternura (violeta)","Amatista|Charoita|Perla Negra":"visión y ternura (violeta)","Amatista|Charoita|Turmalina Rosa":"visión y ternura (violeta)","Amatista|Citrino":"transmutación lúcida y voluntad proyectiva","Amatista|Cuarzo Rosa":"corazón y visión","Amatista|Cuarzo Rutilado":"orisha: Babaluallé, enfermedad y sanación","Amatista|Granate Estrella":"intuición, dirección en la oscuridad","Amatista|Hematita":"mente aquietada, eje mental-corporal","Amatista|Labradorita":"alma integrada, multi-chakra","Amatista|Labradorita|Super 7":"alma integrada, multi-chakra, collar","Amatista|Labradorita|Turmalina Rosa":"alma integrada, multi-chakra, collar","Amatista|Perla Negra":"visión y ternura (violeta)","Amatista|Perla Negra|Turmalina Rosa":"visión y ternura (violeta)","Amatista|Shungita":"protección triple, escudo integral","Amatista|Shungita|Turmalina Negra":"protección triple, escudo integral","Amatista|Super 7":"alma integrada, multi-chakra, collar","Amatista|Super 7|Turmalina Rosa":"alma integrada, multi-chakra, collar","Amatista|Turmalina Negra":"protección triple, escudo integral","Amatista|Turmalina Rosa":"visión y ternura (violeta)","Amatista|Ámbar":"sol, dios: Apolo, dios griego de la luz, sanación, música, calma mental","Amazonita Aqua|Piedra Luna":"comunicación cíclica, verdad con ciclo","Amazonita|Crisoprasa":"zodiaco: Cáncer, agua cardinal","Amazonita|Crisoprasa|Piedra Luna":"zodiaco: Cáncer, agua cardinal","Amazonita|Piedra Luna":"zodiaco: Cáncer, agua cardinal","Amazonita|Ámbar":"sol, dios: Huitzilopochtli, dios solar azteca, expresión emocional","Apatita Azul|Cianita Azul":"zodiaco: Libra, aire cardinal","Apatita Azul|Cianita Azul|Iolita":"zodiaco: Libra, aire cardinal","Apatita Azul|Cianita Azul|Zoisita":"zodiaco: Libra, aire cardinal","Apatita Azul|Cuarzo Transparente":"orisha: Yemayá, madre de los orishas y protectora del océano","Apatita Azul|Hematita":"voz forjada, verdad encarnada","Apatita Azul|Iolita":"zodiaco: Libra, aire cardinal","Apatita Azul|Iolita|Zoisita":"zodiaco: Libra, aire cardinal","Apatita Azul|Jaspe Oceánico":"sol: Tamanuiterā, sol maorí, ritmo y desaceleración","Apatita Azul|Jaspe Oceánico|Ámbar":"sol: Tamanuiterā, sol maorí, ritmo y desaceleración","Apatita Azul|Lapislázuli":"expresión alineada (azules)","Apatita Azul|Lapislázuli|Larimar":"verbo y visión (azules)","Apatita Azul|Lapislázuli|Ojo de Halcón":"expresión alineada (azules)","Apatita Azul|Lapislázuli|Perla Negra":"verbo y visión (azules)","Apatita Azul|Lapislázuli|Piedra Luna":"verbo y visión (azules)","Apatita Azul|Larimar":"verbo y visión (azules)","Apatita Azul|Larimar|Perla Negra":"verbo y visión (azules)","Apatita Azul|Larimar|Piedra Luna":"verbo y visión (azules)","Apatita Azul|Ojo de Halcón":"expresión alineada (azules)","Apatita Azul|Perla Negra":"verbo y visión (azules)","Apatita Azul|Perla Negra|Piedra Luna":"verbo y visión (azules)","Apatita Azul|Piedra Luna":"verbo y visión (azules)","Apatita Azul|Shoushan":"palabra que funda, comunicación con peso","Apatita Azul|Turmalina Negra":"verdad cimentada, visión vertical","Apatita Azul|Zoisita":"zodiaco: Libra, aire cardinal","Apatita Azul|Ámbar":"sol: Tamanuiterā, sol maorí, ritmo y desaceleración","Berilos|Esmeralda en Matriz de Biotita":"alineación sentir-decir-hacer, los tres berilos","Berilos|Esmeralda en Matriz de Biotita|Turmalina Negra":"visión trifocal anclada","Berilos|Turmalina Negra":"visión trifocal anclada","Charoita|Perla Negra":"visión y ternura (violeta)","Charoita|Perla Negra|Turmalina Rosa":"visión y ternura (violeta)","Charoita|Turmalina Rosa":"visión y ternura (violeta)","Cianita Azul|Iolita":"zodiaco: Libra, aire cardinal","Cianita Azul|Iolita|Zoisita":"zodiaco: Libra, aire cardinal","Cianita Azul|Piedra Luna":"comunicación intuitiva y alineación cíclica","Cianita Azul|Zoisita":"zodiaco: Libra, aire cardinal","Citrino|Granate Grosularia":"zodiaco: Aries, fuego cardinal","Citrino|Granate Grosularia|Piedra Volcánica":"zodiaco: Aries, fuego cardinal","Citrino|Granate Grosularia|Semillas de Rudraksha":"zodiaco: Aries, fuego cardinal","Citrino|Piedra Sol Roja":"sol, deidad: Sol Invictus, sol invicto romano, entusiasmo sin permiso","Citrino|Piedra Sol Roja|Ámbar":"sol, deidad: Sol Invictus, sol invicto romano, entusiasmo sin permiso","Citrino|Piedra Volcánica":"zodiaco: Aries, fuego cardinal","Citrino|Piedra Volcánica|Semillas de Rudraksha":"zodiaco: Aries, fuego cardinal","Citrino|Semillas de Rudraksha":"zodiaco: Aries, fuego cardinal","Citrino|Turmalina Negra":"voluntad enraizada, abundancia sostenida","Citrino|Ámbar":"sol, deidad: Sol Invictus, sol invicto romano, entusiasmo sin permiso","Cornalina|Feldespato Sódico":"zodiaco: Sagitario, fuego mutable","Cornalina|Feldespato Sódico|Obsidiana Caoba":"zodiaco: Sagitario, fuego mutable","Cornalina|Feldespato Sódico|Rodonita Encaje Negro":"zodiaco: Sagitario, fuego mutable","Cornalina|Obsidiana Caoba":"zodiaco: Sagitario, fuego mutable","Cornalina|Obsidiana Caoba|Rodonita Encaje Negro":"zodiaco: Sagitario, fuego mutable","Cornalina|Rodonita Encaje Negro":"zodiaco: Sagitario, fuego mutable","Crisocola|Kunzita":"zodiaco: Piscis, agua mutable","Crisocola|Kunzita|Lapislázuli":"zodiaco: Piscis, agua mutable","Crisocola|Kunzita|Lepidolita Violeta":"zodiaco: Piscis, agua mutable","Crisocola|Lapislázuli":"Piscis, agua mutable","Crisocola|Lapislázuli|Lepidolita Violeta":"zodiaco: Piscis, agua mutable","Crisocola|Lepidolita Violeta":"zodiaco: Piscis, agua mutable","Crisoprasa|Piedra Luna":"zodiaco: Cáncer, agua cardinal","Cuarzo Ahumado|Granate Estrella":"zodiaco: Virgo, tierra mutable","Cuarzo Ahumado|Granate Estrella|Madera de Ébano":"zodiaco: Virgo, tierra mutable","Cuarzo Ahumado|Granate Estrella|Obsidiana Plateada":"zodiaco: Virgo, tierra mutable","Cuarzo Ahumado|Granate Estrella|Turmalina Negra":"zodiaco: Virgo, tierra mutable","Cuarzo Ahumado|Granate Rojo":"orisha: Oyá, vientos, tormentas y transformación","Cuarzo Ahumado|Madera de Ébano":"zodiaco: Virgo, tierra mutable","Cuarzo Ahumado|Madera de Ébano|Obsidiana Plateada":"zodiaco: Virgo, tierra mutable","Cuarzo Ahumado|Madera de Ébano|Turmalina Negra":"zodiaco: Virgo, tierra mutable","Cuarzo Ahumado|Obsidiana Plateada":"zodiaco: Virgo, tierra mutable","Cuarzo Ahumado|Obsidiana Plateada|Turmalina Negra":"zodiaco: Virgo, tierra mutable","Cuarzo Ahumado|Turmalina Negra":"anclaje doble, presencia blindada","Cuarzo Rosa|Labradorita":"geometría del alma, amor y visión","Cuarzo Rosa|Labradorita|Obsidiana Dorada":"geometría del alma, amor y visión","Cuarzo Rosa|Labradorita|Pietersita Amarilla y Roja":"geometría del alma, amor y visión","Cuarzo Rosa|Labradorita|Pirita":"geometría del alma, amor y visión","Cuarzo Rosa|Obsidiana Dorada":"geometría del alma, amor y visión","Cuarzo Rosa|Obsidiana Dorada|Pietersita Amarilla y Roja":"geometría del alma, amor y visión","Cuarzo Rosa|Obsidiana Dorada|Pirita":"geometría del alma, amor y visión","Cuarzo Rosa|Pietersita Amarilla y Roja":"geometría del alma, amor y visión","Cuarzo Rosa|Pietersita Amarilla y Roja|Pirita":"geometría del alma, amor y visión","Cuarzo Rosa|Pirita":"geometría del alma, amor y visión","Cuarzo Rosa|Rodonita Encaje Negro":"sol, diosa: Saule, diosa solar báltica, ternura y vulnerabilidad","Cuarzo Rosa|Rodonita Encaje Negro|Ámbar":"sol, diosa: Saule, diosa solar báltica, ternura y vulnerabilidad","Cuarzo Rosa|Rodonita Encaje Negro|Ópalo Rosa":"sol, diosa: Saule, diosa solar báltica, ternura y vulnerabilidad","Cuarzo Rosa|Turmalina Negra":"amor resguardado, corazón regenerado","Cuarzo Rosa|Ámbar":"sol, diosa: Saule, diosa solar báltica, ternura y vulnerabilidad","Cuarzo Rosa|Ámbar|Ópalo Rosa":"sol, diosa: Saule, diosa solar báltica, ternura y vulnerabilidad","Cuarzo Rosa|Ópalo Rosa":"sol, diosa: Saule, diosa solar báltica, ternura y vulnerabilidad","Cuarzo Rutilado|Jade Verde":"orisha: Orula, adivinación, destino y sabiduría ancestral","Cuarzo Rutilado|Pirita":"orisha: Oshún, amor, dulzura y ríos de agua dulce","Cuarzo Transparente|Howlita":"orisha: Obatalá, padre creador y paz","Cuarzo Transparente|Piedra Luna":"sol, diosa: Arinna, diosa solar hitita, confianza en el proceso","Cuarzo Transparente|Piedra Luna|Ámbar":"sol, diosa: Arinna, diosa solar hitita, confianza en el proceso","Cuarzo Transparente|Turmalina Negra":"amplificación centrada, canal protegido","Cuarzo Transparente|Ámbar":"sol, diosa: Arinna, diosa solar hitita, confianza en el proceso","Cuarzo Turmalinado|Obsidiana Copo de Nieve":"sol, dios: Horus, dios solar egipcio, protección reconstruida","Cuarzo Turmalinado|Obsidiana Copo de Nieve|Turmalina Negra":"sol, dios: Horus, dios solar egipcio, protección reconstruida","Cuarzo Turmalinado|Obsidiana Copo de Nieve|Ámbar":"sol, dios: Horus, dios solar egipcio, protección reconstruida","Cuarzo Turmalinado|Turmalina Negra":"transmutación blindada, escudo dinámico","Cuarzo Turmalinado|Turmalina Negra|Ámbar":"sol, dios: Horus, dios solar egipcio, protección reconstruida","Cuarzo Turmalinado|Ámbar":"sol, dios: Horus, dios solar egipcio, protección reconstruida","Esmeralda en Matriz de Biotita|Ojo de Tigre":"sol, dios: Freyr, dios nórdico del sol y la paz, firmeza sin rigidez","Esmeralda en Matriz de Biotita|Ojo de Tigre|Ámbar":"sol, dios: Freyr, dios nórdico del sol y la paz, firmeza sin rigidez","Esmeralda en Matriz de Biotita|Prehnita":"zodiaco: Escorpio, agua fija","Esmeralda en Matriz de Biotita|Turmalina Negra":"corazón abrigado, sanación íntima","Esmeralda en Matriz de Biotita|Ámbar":"sol, dios: Freyr, dios nórdico del sol y la paz, firmeza sin rigidez","Feldespato Sódico|Obsidiana Caoba":"zodiaco: Sagitario, fuego mutable","Feldespato Sódico|Obsidiana Caoba|Rodonita Encaje Negro":"zodiaco: Sagitario, fuego mutable","Feldespato Sódico|Rodonita Encaje Negro":"zodiaco: Sagitario, fuego mutable","Flogopita|Obsidiana Caoba":"sol, dios: Kinich Ahau, dios solar maya, fuego dirigido","Flogopita|Obsidiana Caoba|Ámbar":"sol, dios: Kinich Ahau, dios solar maya, fuego dirigido","Flogopita|Ámbar":"sol, dios: Kinich Ahau, dios solar maya, fuego dirigido","Fluorita|Prehnita":"sol, dios: Surya, dios solar hindú, claridad útil sin sobreanálisis","Fluorita|Prehnita|Ámbar":"sol, dios: Surya, dios solar hindú, claridad útil sin sobreanálisis","Fluorita|Ámbar":"sol, dios: Surya, dios solar hindú, claridad útil sin sobreanálisis","Granate Espesartina|Granate Rojo":"sol, dios: Inti, dios solar inca, vitalidad y deseo sin culpa","Granate Espesartina|Granate Rojo|Ámbar":"sol, dios: Inti, dios solar inca, vitalidad y deseo sin culpa","Granate Espesartina|Ámbar":"sol, dios: Inti, dios solar inca, vitalidad y deseo sin culpa","Granate Estrella|Granate Rojo":"crisis, eje de resistencia","Granate Estrella|Madera de Ébano":"zodiaco: Virgo, tierra mutable","Granate Estrella|Madera de Ébano|Obsidiana Plateada":"zodiaco: Virgo, tierra mutable","Granate Estrella|Madera de Ébano|Turmalina Negra":"zodiaco: Virgo, tierra mutable","Granate Estrella|Obsidiana Plateada":"zodiaco: Virgo, tierra mutable","Granate Estrella|Obsidiana Plateada|Turmalina Negra":"zodiaco: Virgo, tierra mutable","Granate Estrella|Turmalina Negra":"zodiaco: Virgo, tierra mutable","Granate Estrella|Ámbar":"resiliencia y luz navegante","Granate Grosularia|Jade Verde":"sol, dios: Usil, dios solar etrusco, equilibrio entre dar y recibir","Granate Grosularia|Jade Verde|Ámbar":"sol, dios: Usil, dios solar etrusco, equilibrio entre dar y recibir","Granate Grosularia|Piedra Volcánica":"zodiaco: Aries, fuego cardinal","Granate Grosularia|Piedra Volcánica|Semillas de Rudraksha":"zodiaco: Aries, fuego cardinal","Granate Grosularia|Pietersita Amarilla y Roja":"fuego, fuerza interna","Granate Grosularia|Pietersita Amarilla y Roja|Ámbar":"fuego, fuerza interna","Granate Grosularia|Semillas de Rudraksha":"zodiaco: Aries, fuego cardinal","Granate Grosularia|Ámbar":"sol, dios: Usil, dios solar etrusco, equilibrio entre dar y recibir","Granate Rojo|Jade Verde":"fuerza alegre, guerrero","Granate Rojo|Jade Verde|Jaspe Dálmata":"fuerza alegre, guerrero","Granate Rojo|Jaspe Dálmata":"fuerza alegre, guerrero","Granate Rojo|Ámbar":"sol, dios: Inti, dios solar inca, vitalidad y deseo sin culpa","Hematita|Labradorita":"visión y anclaje","Hematita|Labradorita|Larvikita":"visión y anclaje","Hematita|Larvikita":"visión y anclaje","Hematita|Ojo de Tigre":"acción decidida, mirada fijada","Hematita|Piedra Luna":"intuición aterrizada, ciclo con hierro","Hematita|Rodonita Rosa":"amor anidado, ternura con piso","Iolita|Zoisita":"zodiaco: Libra, aire cardinal","Jade Verde|Jaspe Dálmata":"fuerza alegre, guerrero","Jade Verde|Jaspe Rojo":"orisha: Orunmila, sabiduría, conocimiento y profecía","Jade Verde|Jaspe Selva Tropical":"zodiaco: Tauro, tierra fija","Jade Verde|Jaspe Selva Tropical|Ámbar":"zodiaco: Tauro, tierra fija","Jade Verde|Jaspe Unakita":"renacimiento, amanecer interior","Jade Verde|Turmalina Negra":"abundancia cimentada, suficiencia arraigada","Jade Verde|Ámbar":"sol, dios: Usil, dios solar etrusco, equilibrio entre dar y recibir","Jaspe Dálmata|Obsidiana Dorada":"protección lúdica, alegría","Jaspe Dálmata|Piedra Volcánica":"sol, dios: Malakbel, dios solar de Palmira, estructura con ligereza y juego","Jaspe Dálmata|Piedra Volcánica|Pirita":"sol, dios: Malakbel, dios solar de Palmira, estructura con ligereza y juego","Jaspe Dálmata|Piedra Volcánica|Ámbar":"sol, dios: Malakbel, dios solar de Palmira, estructura con ligereza y juego","Jaspe Dálmata|Pirita":"sol, dios: Malakbel, dios solar de Palmira, estructura con ligereza y juego","Jaspe Dálmata|Pirita|Ámbar":"sol, dios: Malakbel, dios solar de Palmira, estructura con ligereza y juego","Jaspe Dálmata|Ámbar":"sol, dios: Malakbel, dios solar de Palmira, estructura con ligereza y juego","Jaspe Kambaba|Jaspe Sangre de Dragón":"corazón y raíz (verdes)","Jaspe Kambaba|Jaspe Sangre de Dragón|Prehnita":"corazón y raíz (verdes)","Jaspe Kambaba|Jaspe Sangre de Dragón|Ágata Musgosa":"corazón y raíz (verdes)","Jaspe Kambaba|Prehnita":"corazón y raíz (verdes)","Jaspe Kambaba|Prehnita|Ágata Musgosa":"corazón y raíz (verdes)","Jaspe Kambaba|Ágata Musgosa":"corazón y raíz (verdes)","Jaspe Mapa|Lapislázuli":"visión encarnada, cielo y suelo","Jaspe Oceánico|Lapislázuli":"sol, dios: Utu, dios solar sumerio de la justicia, autenticidad y pertenencia","Jaspe Oceánico|Lapislázuli|Turquesa Africana":"sol, dios: Utu, dios solar sumerio de la justicia, autenticidad y pertenencia","Jaspe Oceánico|Lapislázuli|Ámbar":"sol, dios: Utu, dios solar sumerio de la justicia, autenticidad y pertenencia","Jaspe Oceánico|Turquesa Africana":"sol, dios: Utu, dios solar sumerio de la justicia, autenticidad y pertenencia","Jaspe Oceánico|Turquesa Africana|Ámbar":"sol, dios: Utu, dios solar sumerio de la justicia, autenticidad y pertenencia","Jaspe Oceánico|Ámbar":"sol: Tamanuiterā, sol maorí, ritmo y desaceleración","Jaspe Paisaje|Jaspe Piel de Elefante":"sol, dios: Tonatiuh, dios azteca del Quinto Sol, memoria y arraigo","Jaspe Paisaje|Jaspe Piel de Elefante|Ámbar":"sol, dios: Tonatiuh, dios azteca del Quinto Sol, memoria y arraigo","Jaspe Paisaje|Ojo de Tigre":"rescate enraizado y perspectiva resiliente","Jaspe Paisaje|Ojo de Tigre|Rodonita Encaje Negro":"rescate enraizado y perspectiva resiliente","Jaspe Paisaje|Rodonita Encaje Negro":"rescate enraizado y perspectiva resiliente","Jaspe Paisaje|Ámbar":"sol, dios: Tonatiuh, dios azteca del Quinto Sol, memoria y arraigo","Jaspe Piel de Elefante|Ámbar":"sol, dios: Tonatiuh, dios azteca del Quinto Sol, memoria y arraigo","Jaspe Sangre de Dragón|Prehnita":"corazón y raíz (verdes)","Jaspe Sangre de Dragón|Prehnita|Ágata Musgosa":"corazón y raíz (verdes)","Jaspe Sangre de Dragón|Ágata Musgosa":"corazón y raíz (verdes)","Jaspe Selva Tropical|Ámbar":"zodiaco: Tauro, tierra fija","Jaspe Unakita|Rodonita Rosa":"sol, dios: Dazbog, dios solar eslavo, límites al cuidado que se da","Jaspe Unakita|Rodonita Rosa|Ámbar":"sol, dios: Dazbog, dios solar eslavo, límites al cuidado que se da","Jaspe Unakita|Ámbar":"sol, dios: Dazbog, dios solar eslavo, límites al cuidado que se da","Kunzita|Lapislázuli":"zodiaco: Piscis, agua mutable","Kunzita|Lapislázuli|Lepidolita Violeta":"zodiaco: Piscis, agua mutable","Kunzita|Lepidolita Violeta":"zodiaco: Piscis, agua mutable","Labradorita|Lapislázuli":"aurora que despunta, visión con verdad","Labradorita|Larvikita":"visión y anclaje","Labradorita|Obsidiana Dorada":"geometría del alma, amor y visión","Labradorita|Obsidiana Dorada|Pietersita Amarilla y Roja":"geometría del alma, amor y visión","Labradorita|Obsidiana Dorada|Pirita":"geometría del alma, amor y visión","Labradorita|Ojo de Halcón":"visión, percepción multidimensional","Labradorita|Pietersita Amarilla y Roja":"geometría del alma, amor y visión","Labradorita|Pietersita Amarilla y Roja|Pirita":"geometría del alma, amor y visión","Labradorita|Pirita":"geometría del alma, amor y visión","Labradorita|Selenita":"portal, umbral perceptivo","Labradorita|Selenita|Ágata Gris":"portal, umbral perceptivo","Labradorita|Super 7":"alma integrada, multi-chakra","Labradorita|Super 7|Turmalina Rosa":"alma integrada, multi-chakra","Labradorita|Turmalina Negra":"intuición anclada, visión con piso","Labradorita|Turmalina Rosa":"alma integrada, multi-chakra","Labradorita|Turquesa Africana":"percepción sin exigencia, pertenencia","Labradorita|Turquesa Africana|Ámbar":"percepción sin exigencia, pertenencia","Labradorita|Ágata Gris":"portal, umbral perceptivo","Labradorita|Ámbar":"sol, dios: Mithra, dios persa de la luz y los pactos, intuición anclada","Lapislázuli|Larimar":"verbo y visión (azules)","Lapislázuli|Larimar|Perla Negra":"verbo y visión (azules)","Lapislázuli|Larimar|Piedra Luna":"verbo y visión (azules)","Lapislázuli|Lepidolita Violeta":"zodiaco: Piscis, agua mutable","Lapislázuli|Ojo de Halcón":"expresión alineada (azules)","Lapislázuli|Perla Negra":"orisha: Olokun, misterios oceánicos y sabiduría abisal","Lapislázuli|Perla Negra|Piedra Luna":"verbo y visión (azules)","Lapislázuli|Piedra Luna":"verbo y visión (azules)","Lapislázuli|Turmalina Negra":"verdad con peso, soberanía anclada","Lapislázuli|Turquesa Africana":"sol, dios: Utu, dios solar sumerio de la justicia, autenticidad y pertenencia","Lapislázuli|Turquesa Africana|Ámbar":"sol, dios: Utu, dios solar sumerio de la justicia, autenticidad y pertenencia","Lapislázuli|Ámbar":"sol, dios: Utu, dios solar sumerio de la justicia, autenticidad y pertenencia","Larimar|Perla Negra":"verbo y visión (azules)","Larimar|Perla Negra|Piedra Luna":"verbo y visión (azules)","Larimar|Piedra Luna":"verbo y visión (azules)","Larvikita|Obsidiana Copo de Nieve":"sol, diosa: Yhi, diosa solar aborigen australiana, transformación silenciosa","Larvikita|Obsidiana Copo de Nieve|Ámbar":"sol, diosa: Yhi, diosa solar aborigen australiana, transformación silenciosa","Larvikita|Ámbar":"sol, diosa: Yhi, diosa solar aborigen australiana, transformación silenciosa","Madera de Sándalo|Ámbar":"sol, dios: Ra, dios solar egipcio supremo, sostén y hogar","Madera de Ébano|Obsidiana Plateada":"zodiaco: Virgo, tierra mutable","Madera de Ébano|Obsidiana Plateada|Turmalina Negra":"zodiaco: Virgo, tierra mutable","Madera de Ébano|Turmalina Negra":"zodiaco: Virgo, tierra mutable","Madera de Ébano|Turquesa Africana":"renacimiento ardiente, fénix","Madera de Ébano|Turquesa Africana|Ámbar":"renacimiento ardiente, fénix","Madera de Ébano|Ámbar":"fuego ancestral, renacimiento de la pasión","Obsidiana Caoba|Rodonita Encaje Negro":"zodiaco: Sagitario, fuego mutable","Obsidiana Caoba|Ámbar":"sol, dios: Kinich Ahau, dios solar maya, fuego dirigido","Obsidiana Copo de Nieve|Turmalina Negra":"sol, dios: Horus, dios solar egipcio, protección reconstruida","Obsidiana Copo de Nieve|Turmalina Negra|Ámbar":"sol, dios: Horus, dios solar egipcio, protección reconstruida","Obsidiana Copo de Nieve|Ámbar":"sol, diosa: Yhi, diosa solar aborigen australiana, transformación silenciosa","Obsidiana Dorada|Pietersita Amarilla y Roja":"geometría del alma, amor y visión","Obsidiana Dorada|Pietersita Amarilla y Roja|Pirita":"geometría del alma, amor y visión","Obsidiana Dorada|Pirita":"geometría del alma, amor y visión","Obsidiana Dorada|Turmalina Negra":"poder anclado, sombra dorada","Obsidiana Plateada|Selenita":"sol, diosa: Amaterasu, diosa solar japonesa, pausa y retiro","Obsidiana Plateada|Selenita|Ámbar":"sol, diosa: Amaterasu, diosa solar japonesa, pausa y retiro","Obsidiana Plateada|Turmalina Negra":"zodiaco: Virgo, tierra mutable","Obsidiana Plateada|Ámbar":"sol, diosa: Amaterasu, diosa solar japonesa, pausa y retiro","Ojo de Tigre|Piedra Sol Naranja":"zodiaco: Leo, fuego fijo","Ojo de Tigre|Piedra Sol Naranja|Piedra Sol Roja":"zodiaco: Leo, fuego fijo","Ojo de Tigre|Piedra Sol Roja":"zodiaco: Leo, fuego fijo","Ojo de Tigre|Rodonita Encaje Negro":"rescate enraizado y perspectiva resiliente","Ojo de Tigre|Sodalita":"orisha: Ochosi, cazador divino, justicia y precisión","Ojo de Tigre|Ágata Crazy Lace (Mexicana)":"alegría y enfoque vigilante","Ojo de Tigre|Ámbar":"sol, dios: Freyr, dios nórdico del sol y la paz, firmeza sin rigidez","Perla Negra|Piedra Luna":"verbo y visión (azules)","Perla Negra|Turmalina Rosa":"visión y ternura (violeta)","Piedra Luna|Selenita":"ciclos internos, sabiduría propia","Piedra Luna|Ámbar":"sol, diosa: Arinna, diosa solar hitita, confianza en el proceso","Piedra Sangre|Pirita":"zodiaco: Capricornio, tierra cardinal","Piedra Sol Naranja|Piedra Sol Roja":"zodiaco: Leo, fuego fijo","Piedra Sol Roja|Ámbar":"sol, deidad: Sol Invictus, sol invicto romano, entusiasmo sin permiso","Piedra Volcánica|Pirita":"sol, dios: Malakbel, dios solar de Palmira, estructura con ligereza y juego","Piedra Volcánica|Pirita|Ámbar":"sol, dios: Malakbel, dios solar de Palmira, estructura con ligereza y juego","Piedra Volcánica|Semillas de Rudraksha":"zodiaco: Aries, fuego cardinal","Piedra Volcánica|Ámbar":"sol, dios: Malakbel, dios solar de Palmira, estructura con ligereza y juego","Pietersita Amarilla y Roja|Pirita":"geometría del alma, amor y visión","Pietersita Amarilla y Roja|Ámbar":"fuego, fuerza interna","Pirita|Turquesa Africana":"guerrero solar, abundancia avizorada","Pirita|Turquesa Africana|Ámbar":"guerrero solar, abundancia avizorada","Pirita|Ámbar":"abundancia encarnada, voluntad ejecutiva","Prehnita|Turquesa Africana":"transformación leal, cambio","Prehnita|Ágata Musgosa":"corazón y raíz (verdes)","Prehnita|Ámbar":"sol, dios: Surya, dios solar hindú, claridad útil sin sobreanálisis","Rodonita Encaje Negro|Turmalina Negra":"integración de la sombra, protección emocional","Rodonita Encaje Negro|Ámbar":"sol, diosa: Saule, diosa solar báltica, ternura y vulnerabilidad","Rodonita Encaje Negro|Ámbar|Ópalo Rosa":"sol, diosa: Saule, diosa solar báltica, ternura y vulnerabilidad","Rodonita Encaje Negro|Ópalo Rosa":"sol, diosa: Saule, diosa solar báltica, ternura y vulnerabilidad","Rodonita Rosa|Ámbar":"sol, dios: Dazbog, dios solar eslavo, límites al cuidado que se da","Rodonita Rosa|Ópalo Rosa":"ternura anclada","Selenita|Ágata Gris":"portal, umbral perceptivo","Selenita|Ámbar":"sol, diosa: Amaterasu, diosa solar japonesa, pausa y retiro","Shungita|Turmalina Negra":"protección triple, escudo integral","Super 7|Turmalina Rosa":"alma integrada, multi-chakra","Turmalina Negra|Turmalina Rosa":"arquitectura emocional","Turmalina Negra|Zoisita":"duelo transmutado, fuego con raíz","Turmalina Negra|Ámbar":"sol, dios: Horus, dios solar egipcio, protección reconstruida","Turquesa Africana|Ámbar":"guerrero solar, abundancia avizorada","Ámbar|Ópalo Rosa":"sol, diosa: Saule, diosa solar báltica, ternura y vulnerabilidad"};
const COT_WORKER = "https://mamapachita-oraculo.morelos1900.workers.dev";
const COT_LECT_KEY = "mp-cotizador-lecturas-v1";
let cotLecturaEnVuelo = false;
function cotLow(s){ return String(s).toLowerCase(); }
function cotListar(arr){
  if(!arr.length) return "";
  if(arr.length === 1) return arr[0];
  const ult = arr[arr.length - 1];
  const conj = /^h?i/i.test(ult) ? " e " : " y ";
  return arr.slice(0, -1).join(", ") + conj + ult;
}
function cotSujeto(n, todasLa){
  const art = todasLa ? "Las" : "Los";
  const num = n === 2 ? "dos" : n === 3 ? "tres" : n === 4 ? "cuatro" : n === 5 ? "cinco" : ("" + n);
  return art + " " + num;
}
// la lectura de la mezcla: verbatim si la union ya vive en la casa; si no, composicion desde las intenciones canonicas
function cotLeeMezcla(mids){
  if(!mids || mids.length < 2) return "";
  const ms = mids.map(function(id){ return DATOS.minerales[id]; });
  const nombres = ms.map(function(m){ return m.n; });
  const frases = [];
  const clave = nombres.slice().sort().join("|");
  if(COT_COMBOS[clave]){
    frases.push('Esta unión ya camina en la casa: <span class="mp23-ene-casa">' + escHtml(COT_COMBOS[clave]) + '</span>.');
  } else {
    let par = null;
    for(let i = 0; i < ms.length && !par; i++){
      for(let j = i + 1; j < ms.length && !par; j++){
        const k2 = [ms[i].n, ms[j].n].sort().join("|");
        if(COT_COMBOS[k2]) par = { a: ms[i], b: ms[j], tema: COT_COMBOS[k2] };
      }
    }
    if(par){
      const juntas = (par.a.art === "la" || par.a.art === "las") && (par.b.art === "la" || par.b.art === "las") ? "juntas" : "juntos";
      frases.push(cap(escHtml(nombreArt(par.a, false))) + " y " + escHtml(nombreArt(par.b, false)) + " ya caminan " + juntas + ' en la casa: <span class="mp23-ene-casa">' + escHtml(par.tema) + '</span>.');
    }
  }
  const base = ms[0].intenciones || [];
  const comunes = base.filter(function(x){
    return ms.every(function(m){ return m.intenciones && m.intenciones.indexOf(x) >= 0; });
  });
  const todasLa = ms.every(function(m){ return m.art === "la" || m.art === "las"; });
  if(comunes.length){
    frases.push(cotSujeto(ms.length, todasLa) + " caminan hacia lo mismo: " + cotListar(comunes.map(cotLow)) + ".");
  }
  if(frases.length < 2){
    const partes = [];
    ms.forEach(function(m){
      const unicas = (m.intenciones || []).filter(function(x){
        return ms.every(function(o){ return o === m || !o.intenciones || o.intenciones.indexOf(x) < 0; });
      });
      if(unicas.length) partes.push(escHtml(nombreArt(m, false)) + " trae " + cotListar(unicas.slice(0, 2).map(cotLow)));
    });
    if(partes.length) frases.push((comunes.length ? "Y cada piedra suma lo suyo: " : "Cada piedra cuida su propio frente: ") + partes.join("; ") + ".");
  }
  return frases.slice(0, 2).join(" ");
}
// el sello de coincidencias: intenciones que 2+ minerales distintos de la mezcla comparten
function cotMezclaCoincide(){
  const mids = mp23MineralesCuerpo();
  if(mids.length < 2) return [];
  const cnt = {};
  mids.forEach(function(id){
    const m = DATOS.minerales[id];
    if(!m.intenciones) return;
    m.intenciones.forEach(function(x){ cnt[x] = (cnt[x] || 0) + 1; });
  });
  const shared = Object.keys(cnt).filter(function(x){ return cnt[x] >= 2; });
  shared.sort(function(a, b){ return cnt[b] - cnt[a] || a.localeCompare(b, "es"); });
  return shared;
}
function cotSelloVozHTML(){
  const shared = cotMezclaCoincide();
  if(!shared.length) return "";
  return '<span class="mp15-voz-sep cot-coincide">Tu mezcla coincide en ' + escHtml(cotListar(shared.map(cotLow))) + '.</span>';
}
// T4 · la lectura del Oraculo a peticion (una llamada por mezcla; cache por composicion en localStorage, auto-guardado silencioso que persiste entre visitas; MP_QA antes del fetch)
function cotClaveLectura(mids){ return mids.map(function(id){ return DATOS.minerales[id].n; }).slice().sort().join("|"); }
function cotLecturasCache(){
  try { return JSON.parse(localStorage.getItem(COT_LECT_KEY) || "{}"); } catch(e){ return {}; }
}
function cotGuardaLectura(clave, lectura){
  try {
    const c = cotLecturasCache(); c[clave] = lectura;
    const ks = Object.keys(c); while(ks.length > 60){ delete c[ks.shift()]; }
    localStorage.setItem(COT_LECT_KEY, JSON.stringify(c));
  } catch(e){}
}
function cotRepintaEnergia(){
  const box = $("mp23-ene-scroll"); if(box) box.innerHTML = mp23EnergiaContenidoHTML();
}
function cotPideLectura(btn){
  if(cotLecturaEnVuelo) return;
  const mids = mp23MineralesCuerpo();
  if(mids.length < 2 || mids.length > 6) return;
  const clave = cotClaveLectura(mids);
  if(cotLecturasCache()[clave]){ cotRepintaEnergia(); return; }
  cotLecturaEnVuelo = true;
  if(btn){ btn.disabled = true; btn.textContent = btn.getAttribute("data-espera") || btn.textContent; }
  const nombres = mids.map(function(id){ return DATOS.minerales[id].n; });
  function aterriza(lectura){
    cotLecturaEnVuelo = false;
    if(lectura) cotGuardaLectura(clave, lectura);
    cotRepintaEnergia();
  }
  if(window.MP_QA === true){ aterriza(""); return; }
  const ctrl = ("AbortController" in window) ? new AbortController() : null;
  const reloj = ctrl ? setTimeout(function(){ try{ ctrl.abort(); }catch(e){} }, 15000) : null;
  fetch(COT_WORKER + "/mezcla", {
    method: "POST", headers: { "content-type": "application/json" },
    body: JSON.stringify({ minerales: nombres }),
    signal: ctrl ? ctrl.signal : undefined
  }).then(function(r){ return r.json(); })
    .then(function(data){ if(reloj) clearTimeout(reloj); aterriza(data && data.lectura ? String(data.lectura) : ""); })
    .catch(function(){ if(reloj) clearTimeout(reloj); aterriza(""); });
}

/* --- F2 · la mesa expandida: un panel con TODOS los pinceles a la vista --- */
function mp23SlotHTML(s){
  const m = DATOS.minerales[s.mid], f = fillMin(s.mid), cnt = conteoMineral(s.mid);
  const lbl = "Pincel " + nombreArt(m, false) + (cnt > 0 ? (", " + cnt + " en la pieza") : "") + (s.fija ? ", fijado" : "");
  let h = '<button class="slot" aria-pressed="' + (brush === s.mid) + '" data-slot-mid="' + s.mid + '" aria-label="' + lbl + '">';
  h += '<span class="slot-r fill ' + f.cls + '" style="' + f.style + '"></span>';
  if(cnt > 0) h += '<span class="slot-badge">' + cnt + '</span>';
  if(s.fija) h += '<span class="slot-pin" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M12 3l0 8M8 11h8l-2 4h-4l-2-4zM12 15l0 6"/></svg></span>';
  h += '<span class="slot-n">' + m.n + '</span></button>';
  return h;
}
function mp23RenderMesaPanel(){
  const el = $("mp23-mesa-panel"); if(!el) return;
  let h = '<div class="mp23-mp-tit">Tus pinceles a la mano</div><div class="mp23-mp-grid">';
  mesa.forEach(function(s){ h += mp23SlotHTML(s); });
  h += '</div>';
  const conSep = pieza === "cod" && DATOS.patrones[patronIdx] && DATOS.patrones[patronIdx].sep > 0;
  if(conSep){
    h += '<div class="mp23-mp-lbl">Separadores de 4 mm</div><div class="mp23-mp-grid">';
    sepMesaChips().forEach(function(si){
      const s = DATOS.separadores[si], f = fillSep(s), on = (sepBrush === si);
      const lbl = "Pincel de separador " + nombreArt(s, false) + ", " + money(s.por_sep) + " cada uno" + (on ? ", activo" : "");
      h += '<button class="slot sepslot" aria-pressed="' + on + '" data-sep-pincel="' + si + '" aria-label="' + lbl + '">'
        + '<span class="slot-r fill ' + f.cls + '" style="' + f.style + '"></span><span class="slot-n">' + s.n + '</span></button>';
    });
    h += '</div>';
  }
  h += '<div class="mp23-mp-act">';
  h += '<button class="mp23-mp-btn" data-mp23-mesa-act="mas"><svg viewBox="0 0 24 24"><path d="M12 5v14M5 12h14"/></svg>Explorar minerales</button>';
  const T = beads.filter(function(x){ return x != null; }).length;
  if(brush >= 0 || T > 0) h += '<button class="mp23-mp-btn" data-mp23-mesa-act="varita"><svg viewBox="0 0 24 24"><path d="M5 19l9-9M14 7l3-3M17 7l-3-3M19 12l2-1M19 12l1 2"/></svg>Llenar o vaciar</button>';
  if(conSep) h += '<button class="mp23-mp-btn" data-mp23-mesa-act="sepmas"><svg viewBox="0 0 24 24"><circle cx="7.5" cy="9" r="2.2"/><circle cx="16.5" cy="9" r="2.2"/><circle cx="12" cy="15" r="2.2"/></svg>Otro separador</button>';
  h += '</div>';
  el.innerHTML = h;
}
function mp23AbreMesaPanel(){
  mp23RenderMesaPanel();
  const sc = $("mp23-mesa-scrim"), pa = $("mp23-mesa-panel");
  sc.hidden = false; pa.hidden = false;
  requestAnimationFrame(function(){ pa.classList.add("on"); });
  mp23MesaAbierta = true;
}
function mp23CierraMesaPanel(){
  const sc = $("mp23-mesa-scrim"), pa = $("mp23-mesa-panel"); if(!pa) return;
  pa.classList.remove("on");
  const fin = function(){ pa.hidden = true; sc.hidden = true; };
  if(reduce) fin(); else setTimeout(fin, 200);
  mp23MesaAbierta = false;
}
function mp23ToggleMesaPanel(){ if(mp23MesaAbierta) mp23CierraMesaPanel(); else mp23AbreMesaPanel(); }

/* --- F4 · la ficha de inspeccion dentro del explorador --- */
function mp23FichaCtaLabel(){
  if(huecoObjetivo >= 0) return "Pintar esta cuenta";
  if(reemplazo != null) return "Cambiar por esta";
  return "Usar como pincel";
}
function mp23AbreFicha(i){
  const m = DATOS.minerales[i]; if(!m) return;
  mp23FichaMid = i;
  const f = fillMin(i);
  let h = '<div class="mp23-fic-top"><span class="mp23-fic-esfera fill ' + f.cls + '" style="' + f.style + '"></span>';
  h += '<div class="mp23-fic-nombre">' + escHtml(nombreArt(m, true)) + '</div>';
  if(m.intenciones && m.intenciones.length){
    h += '<div class="mp23-fic-chips">' + m.intenciones.slice(0, 3).map(function(x){ return '<span class="int-chip">' + escHtml(x) + '</span>'; }).join("") + '</div>';
  }
  h += '</div>';
  if(m.hook) h += '<p class="mp23-fic-esencia">' + escHtml(m.hook) + '</p>';
  h += '<div class="mp23-fic-precio"><b>' + money(m.cuenta8) + '</b> la cuenta de 8 mm';
  if(esEstimado(m) && !precioDirecto(m)) h += '<span class="aviso">precio estimado, se confirma en el chat</span>';   // R23: el Rubi (directo del fundador) no lleva "aprox."
  h += '</div>';
  h += '<button class="mp23-fic-cta" id="mp23-fic-cta">' + mp23FichaCtaLabel() + '</button>';
  $("mp23-fic-in").innerHTML = h;
  const fic = $("mp23-fic");
  const scEl = fic.querySelector(".mp23-fic-scroll"); if(scEl) scEl.scrollTop = 0;
  fic.classList.add("on"); fic.setAttribute("aria-hidden", "false");
  mp23FichaAbierta = true;
}
function mp23CierraFicha(){
  const fic = $("mp23-fic"); if(!fic) return;
  fic.classList.remove("on"); fic.setAttribute("aria-hidden", "true");
  mp23FichaAbierta = false; mp23FichaMid = -1;
}
function mp23FichaElegir(){
  const i = mp23FichaMid;
  mp23CierraFicha();
  if(i >= 0) elegirDesdeExplorador(i);   // el flujo viejo EXACTO (pinta el hueco / cambia / queda de pincel) y cierra el explorador si toca
}

/* ======================= RONDA 20 · EL PASEO DE LOS DISEÑOS =======================
   La pastilla unica "Los diseños" (siempre en la barra, protagonica con la pieza vacia)
   abre EL PASEO: una capa propia sobre el OBSERVATORIO REAL (la gota grande al centro).
   3 carriles (Lo que buscas · Las familias de luz · Las piezas de la casa) reusan las
   siembras existentes; deslizar/flechas/teclado recorren los diseños y los aplican EN VIVO.
   "Hacerla mía" conserva (empuja UN deshacer con la foto de entrada); "Volver a como
   estaba" restaura la foto sin tocar el stack. Navegar NO empuja al stack (flag mp20Aplicando).
   Canon: JAMAS abre solo; solo por el toque a "Los diseños". */
let mp20Activo = false;        // el Paseo esta abierto
let mp20Aplicando = false;     // aplicando un diseño via siembra (las siembras saltan pushUndo/cerrarSheet/toast)
let mp20EntryFoto = null;      // snapshot completo tomado al ENTRAR (foto de "como estaba")
let mp20CuartoPrevio = null;   // cuarto al entrar (para regresar al salir)
let mp20EncuadrePrevio = null; // R23: zoom/paneo reales al entrar (se restauran EXACTOS al salir)
let mp20Carril = "intencion";  // intencion | familia | semilla
let mp20Lista = [];            // items del carril vigente
let mp20Idx = 0;               // posicion en la lista

function mp20DisenosChipHTML(){
  const vacia = beads.every(function(x){ return x == null; });
  return '<button class="chip mp20-disenos' + (vacia ? " mp20-prot" : "") + '" id="mp20-disenos-btn" aria-label="Los diseños: pasea las propuestas de la casa y hazla tuya">'
    + '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="8" cy="8" r="3.4"/><circle cx="16.4" cy="10.4" r="2.6"/><circle cx="9.6" cy="16.4" r="2.6"/></svg>Los diseños</button>';
}

// las tres listas de diseños (solo los que producen una pieza valida)
function mp20Construye(k){
  if(k === "familia") return MP13_FAMILIAS.filter(function(f){ return mp17SeleccionFamilia(f.k).length >= 2; }).map(function(f){ return { tipo:"familia", key:f.k, n:f.n }; });
  if(k === "semilla") return mp13Semillas().map(function(i){ return { tipo:"semilla", mid:i }; });
  return INTENCIONES.filter(function(x){ return mp12CandidatosIntencion(x) != null; }).map(function(x){ return { tipo:"intencion", key:x }; });
}

// aplica el diseño EN VIVO reusando las siembras existentes (sin pushUndo, sin toast, sin cerrar hoja)
function mp20Aplica(item){
  mp20Aplicando = true;
  try{
    if(item.tipo === "intencion") mp12SiembraIntencion(item.key);
    else if(item.tipo === "familia") mp17SiembraFamilia(item.key);
    else if(item.tipo === "semilla") mp13SiembraSemilla(item.mid);
  } finally { mp20Aplicando = false; }
}
function mp20AplicaActual(){
  const item = mp20Lista[mp20Idx];
  const esc = $("escena");
  if(item) mp20Aplica(item);
  mp20ActualizaChrome();
  if(!reduce && esc && item){   // crossfade suave (reduced-motion = corte limpio)
    esc.style.transition = "none"; esc.style.opacity = "0.16";
    requestAnimationFrame(function(){
      esc.style.transition = "opacity .24s ease";
      requestAnimationFrame(function(){ esc.style.opacity = "1"; });
    });
  }
}
function mp20Ir(delta){
  if(!mp20Lista.length) return;
  mp20Idx = (mp20Idx + delta + mp20Lista.length) % mp20Lista.length;   // recorrido circular
  mp20AplicaActual();
}
function mp20SetCarril(k){
  mp20Carril = k;
  mp20Lista = mp20Construye(k);
  mp20Idx = 0;
  mp20RenderCarriles();
  if(mp20Lista.length) mp20AplicaActual();
  else mp20ActualizaChrome();
}
function mp20RenderCarriles(){
  const cont = $("mp20-carriles"); if(!cont) return;
  const carriles = [
    { k:"intencion", n:"Lo que buscas" },
    { k:"familia",   n:"Las familias de luz" },
    { k:"semilla",   n:"Las piezas de la casa" }
  ];
  let h = "";
  carriles.forEach(function(c){
    h += '<button class="mp20-carril" data-mp20-carril="' + c.k + '" aria-pressed="' + (mp20Carril === c.k ? "true" : "false") + '">' + c.n + '</button>';
  });
  cont.innerHTML = h;
}
function mp20ActualizaChrome(){
  const item = mp20Lista[mp20Idx];
  const nom = $("mp20-nombre"), vz = $("mp20-voz"), pr = $("mp20-precio"), sub = $("mp20-sub"), pos = $("mp20-pos");
  if(!nom) return;
  if(!item){
    nom.textContent = "Esta familia pide el explorador";
    vz.textContent = ""; pr.textContent = ""; sub.textContent = ""; pos.textContent = "";
    mp20PosicionaInfo(); return;
  }
  let nombre = "";
  if(item.tipo === "intencion") nombre = "Para " + item.key.toLowerCase();
  else if(item.tipo === "familia") nombre = item.n;
  else { const m = DATOS.minerales[item.mid], cabeza = pieza === "cod" ? "Codificador" : "Japa Mala"; nombre = cabeza + " " + deMin(m); }
  nom.textContent = nombre;
  const voz = mp12VozDe(beads, 2);
  vz.textContent = voz || "";
  pr.textContent = ($("pc-precio").textContent || "").trim();   // el precio vivo (misma formula, sin duplicar)
  sub.textContent = ($("pc-sub").textContent || "").trim();     // la nota de la casa ("ya vive en la tienda" / "se cotiza...")
  pos.textContent = (mp20Idx + 1) + " de " + mp20Lista.length; mp20PosicionaInfo();
}

// R22 · ancla la info del Paseo al hueco interior del lazo (centrada en el centroide de la gota, medida por el #lienzo real; jamas toca las cuentas)
function mp20PosicionaInfo(){
  const info = $("mp20-info"); if(!info) return;
  const lz = $("lienzo");
  if(lz && LAYOUT && LAYOUT.cx != null && LAYOUT.apexY != null && LAYOUT.botY != null){
    const r = lz.getBoundingClientRect(), path = lz.querySelector("svg.hilos path");
    const loopW = path ? path.getBoundingClientRect().width : 2 * (LAYOUT.amp || 150);
    const w = Math.max(150, Math.min(Math.round(window.innerWidth * 0.86), Math.round(loopW * 0.62)));   // ancho contenido dentro del anillo real (medido), para no tocar las cuentas
    info.style.left = (r.left + LAYOUT.cx).toFixed(1) + "px";
    info.style.top = (r.top + (LAYOUT.apexY + LAYOUT.botY) / 2).toFixed(1) + "px";                          // el centroide del lazo (el hueco)
    info.style.bottom = "auto"; info.style.width = w + "px"; info.style.transform = "translate(-50%,-50%)";
  } else {
    info.style.left = ""; info.style.top = ""; info.style.bottom = ""; info.style.width = ""; info.style.transform = "";   // fallback: la posicion del CSS (abajo)
  }
}

function mp20Abre(){
  if(mp20Activo) return;
  precargaFamilias(DATOS.minerales.map(function(_, i){ return i; }));   // calienta FAM para un carril de familias fiel
  mp20EntryFoto = snapshot();                                            // la foto de "como estaba"
  mp20CuartoPrevio = cuarto;
  mp20EncuadrePrevio = { z:zoom, x:panX, y:panY };                       // R23: el encuadre real de entrada, para la restauracion perfecta
  mp20Activo = true;
  if(cuarto !== "observatorio"){                                        // el Paseo usa el observatorio real de escenario
    cuarto = "observatorio"; $("app").dataset.cuarto = "observatorio"; actualizaTabs();
    renderContexto(); renderCuarto(); updateCotizacion();
  } else { renderCuarto(); }                                            // R23: re-encuadra con los pads del Paseo (centrada y a lo ancho)
  $("app").setAttribute("data-mp20", "1"); resetZoom(false);   // R22: resetea el zoom heredado de La pieza (mata el borroso por transform scale)
  const ov = $("mp20-paseo"); ov.setAttribute("aria-hidden", "false"); ov.classList.add("on");
  mp20SetCarril("intencion");                                           // carril por defecto: aplica el diseño 0
  mp21Susurro("paseo", "Desliza o toca los lados para pasear; tu pieza queda a salvo.", true);   // R21: susurro DENTRO del Paseo
}
function mp20CierraOverlay(){
  mp20Activo = false;
  const ov = $("mp20-paseo"); ov.classList.remove("on"); ov.setAttribute("aria-hidden", "true");
  $("app").removeAttribute("data-mp20");
  const esc = $("escena"); if(esc){ esc.style.transition = ""; esc.style.opacity = ""; }
  if(mp20CuartoPrevio && mp20CuartoPrevio !== cuarto){                  // regresa al cuarto en el que estaba
    cuarto = mp20CuartoPrevio; $("app").dataset.cuarto = cuarto; actualizaTabs();
  }
  mp20EntryFoto = null; mp20CuartoPrevio = null;
  renderContexto(); renderCuarto(); renderMesa(); updateCotizacion();
  // R23: la ley del Paseo es restauracion perfecta; el encuadre (zoom y paneo) vuelve EXACTO a como estaba
  if(mp20EncuadrePrevio){
    zoom = mp20EncuadrePrevio.z; panX = mp20EncuadrePrevio.x; panY = mp20EncuadrePrevio.y;
    mp20EncuadrePrevio = null;
    suaveZoom(false); clampPan(); applyZoom();
  }
}
function mp20HacerlaMia(){
  if(!mp20Activo) return;
  const foto = mp20EntryFoto;                                           // conserva el diseño aplicado
  if(foto) foto.cuarto = mp20CuartoPrevio;   // R23 · UN deshacer regresa EXACTO, incluido el cuarto en el que estabas al entrar
  mp20CuartoPrevio = "observatorio";   // R23 · ya es tuya: aterriza en La pieza (donde vive y reaparece la estampa), no en la charola
  mp20CierraOverlay();
  if(foto){ historial.push(foto); if(historial.length > 20) historial.shift(); actualizaUndo(); }   // UN deshacer regresa a lo previo
}
function mp20Volver(){
  if(!mp20Activo) return;
  const foto = mp20EntryFoto;
  if(foto) aplicaSnapshot(foto);                                        // restaura la foto de entrada, sin tocar el stack
  mp20CierraOverlay();
}

/* ===== R5 · patrones de mezcla ===== */
// secuencia de una hebra (longitud = half) con los minerales elegidos en orden
/* ===== Ronda 7 · ACOMODOS: todos son PERMUTACIONES PURAS del cuerpo actual =====
   Invariante (Trabajo 1): el multiconjunto {mineral: cantidad} antes y despues es IDENTICO.
   Ningun acomodo cambia el mineral de una cuenta, ni agrega, ni quita, ni toca el centro.
   Todo pasa por reordenar(): lee el orden serpentina, lo permuta, y lo escribe de vuelta.
   Decision de huecos: los acomodos "lineales" compactan lo colocado al frente del orden y
   dejan los vacios al final; los simetricos (espejo/luz-en-espejo) centran lo colocado y dejan
   los vacios en los extremos; invertir y girar mueven el orden completo (vacios incluidos). */

// orden de lectura (serpentina) del cuerpo: indices de cuenta, saltando el centro
function readingOrder(){
  const half = CFG[pieza].half, N = CFG[pieza].N, out = [];
  for(let L = 0; L <= N; L++){ if(L === half) continue; out.push(linToBead(L)); }
  return out;
}
// valores (mid o null) en orden de lectura
function seqActual(){ return readingOrder().map(function(i){ return beads[i]; }); }
// escribe una secuencia (en orden de lectura) de vuelta al arreglo beads, sin tocar el centro
function escribeSeq(newSeq){
  const ro = readingOrder(), nb = beads.slice();
  for(let k = 0; k < ro.length; k++){ nb[ro[k]] = (k < newSeq.length ? newSeq[k] : null); }
  return nb;
}
// LA funcion unica por la que pasan todos los acomodos (permutacion pura + 1 paso de deshacer)
function reordenar(newBeads){
  pushUndo();
  beads = newBeads.slice();
  tocada = true; justPainted = [];
  tras();
}

/* --- utilidades de conteo y claridad --- */
function countsSorted(placed){
  const cnt = {};
  placed.forEach(function(m){ cnt[m] = (cnt[m] || 0) + 1; });
  return Object.keys(cnt).map(function(k){ return { mid:+k, n:cnt[k] }; })
    .sort(function(a, b){ return b.n - a.n || DATOS.minerales[a.mid].n.localeCompare(DATOS.minerales[b.mid].n, "es"); });
}
function lumDeColor(hex){
  const h = String(hex || "#808080").replace("#", "");
  const r = parseInt(h.substr(0, 2), 16), g = parseInt(h.substr(2, 2), 16), b = parseInt(h.substr(4, 2), 16);
  return 0.2126 * (r || 128) + 0.7152 * (g || 128) + 0.0722 * (b || 128);
}
// claridad media 0..255 del mineral; cache en LUMEN; respaldo inmediato desde el color
function luminanciaMineral(mid){
  const name = DATOS.minerales[mid].n;
  if(LUMEN[name] != null) return LUMEN[name];
  return lumDeColor(COL[mid] && COL[mid].c);
}
function cmpLumAsc(a, b){ return luminanciaMineral(a) - luminanciaMineral(b); }
// perezoso: al abrir la hoja de Acomodos pinta cada retrato en un canvas y saca su luminancia media
function precargaLuminancia(mids){
  mids.forEach(function(mid){
    const name = DATOS.minerales[mid].n;
    if(LUMEN[name] != null) return;
    const r = RETRATOS[name];
    if(!r || !r.uri){ LUMEN[name] = lumDeColor(COL[mid] && COL[mid].c); return; }
    const img = new Image();
    img.onload = function(){
      let val;
      try{
        const s = 24, cv = document.createElement("canvas"); cv.width = s; cv.height = s;
        const g = cv.getContext("2d"); g.drawImage(img, 0, 0, s, s);
        const d = g.getImageData(0, 0, s, s).data; let sum = 0, n = 0;
        for(let i = 0; i < d.length; i += 4){ if(d[i + 3] < 8) continue; sum += 0.2126 * d[i] + 0.7152 * d[i + 1] + 0.0722 * d[i + 2]; n++; }
        val = n ? sum / n : lumDeColor(COL[mid] && COL[mid].c);
      }catch(_){ val = lumDeColor(COL[mid] && COL[mid].c); }
      LUMEN[name] = val;
      if(sheetTipo === "acomodos") refrescaAcomodos();   // refina las previews de degradado cuando llega el dato
    };
    img.onerror = function(){ LUMEN[name] = lumDeColor(COL[mid] && COL[mid].c); };
    img.src = r.uri;
  });
}

/* ============================================================================
   RONDA 13 · LOS TRES MOMENTOS
   ========================================================================== */

/* ===== 4 · LAS FAMILIAS DE LUZ (entrada por color al explorador) =====
   7 familias por el color REAL de las cuentas. Se calcula UNA vez del retrato:
   color medio (canvas 24x24, los mismos pixeles opacos que LUMEN) -> HSL ->
   familia por umbrales deterministas de tono/claridad. Cada mineral vive en UNA
   sola familia. Cache perezoso en FAM (por nombre); respaldo sincrono desde el
   color de la cuenta (COL) mientras llega el canvas. */
const FAM = {};                              // nombre -> clave de familia
const FAMCOL = {};                           // nombre -> {r,g,b} color medio (depurar / verificar)
const MP13_FAMILIAS = [
  { k:"noche",  n:"Las de la noche",  pt:"#2a2622" },
  { k:"fuego",  n:"Las del fuego",    pt:"#c0492e" },
  { k:"tierra", n:"Las de la tierra", pt:"#a9793f" },
  { k:"bosque", n:"Las del bosque",   pt:"#3f7d4e" },
  { k:"cielo",  n:"Las del cielo",    pt:"#3f6f9e" },
  { k:"aurora", n:"Las de la aurora", pt:"#9a5fa0" },
  { k:"luz",    n:"Las de la luz",    pt:"#e8e3da" }
];
// UMBRALES (deterministas). lum = luminancia 0..255; s = saturacion HSL 0..1; h = tono 0..360.
//  noche  : lum < 60                                   (oscuras)
//  luz    : lum > 198 y s < 0.22                       (blancas y claras)
//  gris   : s < 0.10 -> por claridad (lum>172 luz / lum<105 noche / si no tierra)
//  clara con velo calido: h 16..45, s < 0.24, lum >= 138 = luz
//    (los retratos de piedras blancas/transparentes salen con un velo calido de la foto:
//     el Cuarzo Transparente, la Piedra Luna; poca saturacion + claridad = luz)
//  rosa/violeta h 330..350    : suave (s<0.5, lum>=65) = aurora, si no fuego
//  rojos/rosas  h>=350 o h<16 : claro o palido ((lum>150,s<0.5) o (lum>105,s<0.35)) = aurora, si no fuego
//  naranja/cafe h 16..45      : naranja vivo (s>0.55,lum>120) = fuego, si no tierra (cafe/dorado)
//  dorado       h 45..70      = tierra
//  verde        h 70..170     = bosque
//  azul/cyan    h 170..255    = cielo
//  morado/magenta h 255..360  = aurora
function mp13FamDeRGB(r, g, b){
  const mx = Math.max(r, g, b), mn = Math.min(r, g, b), d = mx - mn;
  const lum = 0.2126 * r + 0.7152 * g + 0.0722 * b;
  const l = (mx + mn) / 2;
  const s = d === 0 ? 0 : d / (255 - Math.abs(2 * l - 255));
  let h = 0;
  if(d !== 0){
    if(mx === r) h = ((g - b) / d) % 6;
    else if(mx === g) h = (b - r) / d + 2;
    else h = (r - g) / d + 4;
    h *= 60; if(h < 0) h += 360;
  }
  if(lum < 60) return "noche";
  if(lum > 198 && s < 0.22) return "luz";
  if(s < 0.10) return lum > 172 ? "luz" : (lum < 105 ? "noche" : "tierra");
  if(h >= 16 && h < 45 && s < 0.24 && lum >= 138) return "luz";
  if(h >= 330 && h < 350) return (s < 0.5 && lum >= 65) ? "aurora" : "fuego";
  if(h < 16 || h >= 350) return ((lum > 150 && s < 0.5) || (lum > 105 && s < 0.35)) ? "aurora" : "fuego";
  if(h < 45) return (s > 0.55 && lum > 120) ? "fuego" : "tierra";
  if(h < 70) return "tierra";
  if(h < 170) return "bosque";
  if(h < 255) return "cielo";
  return "aurora";
}
function mp13FamDeColor(mid){
  const h = String((COL[mid] && COL[mid].c) || "#808080").replace("#", "");
  return mp13FamDeRGB(parseInt(h.substr(0,2),16)||128, parseInt(h.substr(2,2),16)||128, parseInt(h.substr(4,2),16)||128);
}
function familiaMineral(mid){
  const name = DATOS.minerales[mid].n;
  if(FAM[name] != null) return FAM[name];
  return mp13FamDeColor(mid);                // respaldo sincrono hasta que llegue el canvas
}
// perezoso: pinta cada retrato en canvas, saca el color MEDIO (pixeles opacos) y su familia
function precargaFamilias(mids){
  let quedan = 0, refresco = false;
  function acaso(){ if(refresco && quedan === 0 && expAbierto && sheetTipo == null){ refresco = false; renderExpGrid(); } }
  mids.forEach(function(mid){
    const name = DATOS.minerales[mid].n;
    if(FAM[name] != null) return;
    const r = RETRATOS[name];
    if(!r || !r.uri){ FAM[name] = mp13FamDeColor(mid); return; }
    quedan++; refresco = true;
    const img = new Image();
    img.onload = function(){
      try{
        const sN = 24, cv = document.createElement("canvas"); cv.width = sN; cv.height = sN;
        const g = cv.getContext("2d"); g.drawImage(img, 0, 0, sN, sN);
        const dt = g.getImageData(0, 0, sN, sN).data; let sr = 0, sg = 0, sb = 0, nn = 0;
        for(let i = 0; i < dt.length; i += 4){ if(dt[i + 3] < 8) continue; sr += dt[i]; sg += dt[i + 1]; sb += dt[i + 2]; nn++; }
        if(nn){ const mr = sr / nn, mg = sg / nn, mb = sb / nn; FAMCOL[name] = { r:mr, g:mg, b:mb }; FAM[name] = mp13FamDeRGB(mr, mg, mb); }
        else FAM[name] = mp13FamDeColor(mid);
      }catch(_){ FAM[name] = mp13FamDeColor(mid); }
      quedan--; acaso();
    };
    img.onerror = function(){ FAM[name] = mp13FamDeColor(mid); quedan--; acaso(); };
    img.src = r.uri;
  });
}
function renderExpFamilias(){
  const cont = $("mp13-familias"); if(!cont) return;
  let h = "";
  MP13_FAMILIAS.forEach(function(f){
    h += '<button class="mp13-fam" aria-pressed="' + (expFam === f.k ? "true" : "false") + '" data-fam="' + f.k + '">'
      + '<span class="fam-pt" style="background:' + f.pt + '"></span>' + f.n + '</button>';
  });
  cont.innerHTML = h;
}

/* ===== R17 · F2 · SEMILLAS DE LAS FAMILIAS DE LUZ =====
   La tercera puerta de la pieza vacia: 7 chips (las mismas 7 familias del explorador). Tocar una
   siembra su diseno canonico DETERMINISTICO: 5 minerales cotizables de la familia por rango de
   luminancia (indices 0, n/4, n/2, 3n/4, n-1; dedupe; <=5 miembros = todos), conteos escalados por
   pieza (cod 9/9/9/9/8 · japa 22/22/22/22/20, el menor al mas CLARO; con <5 se reparte parejo y el
   sobrante va al mas oscuro) y el acomodo "Degradado en espejo" pre-aplicado. Es una SIEMBRA
   editable: 1 paso de deshacer la revierte entera; el precio es el de una pieza personalizada. */
function mp17MiembrosFamilia(k){
  // cotizables de la familia: con precio de cuenta (cuenta8) y con retrato real
  const out = [];
  DATOS.minerales.forEach(function(m, i){
    if(m.cuenta8 == null) return;
    const r = RETRATOS[m.n];
    if(!r || !r.uri) return;
    if(familiaMineral(i) !== k) return;
    out.push(i);
  });
  return out;
}
function mp17SeleccionFamilia(k){
  const mem = mp17MiembrosFamilia(k);
  mem.sort(function(a, b){ return luminanciaMineral(a) - luminanciaMineral(b) || DATOS.minerales[a].n.localeCompare(DATOS.minerales[b].n, "es"); });
  const n = mem.length;
  if(n <= 5) return mem.slice();               // <=5 miembros: usa todos (2..5)
  const raw = [0, Math.round(n / 4), Math.round(n / 2), Math.round(3 * n / 4), n - 1];
  const pick = [], seen = {};
  raw.forEach(function(ix){ if(ix < 0) ix = 0; if(ix > n - 1) ix = n - 1; if(!seen[ix]){ seen[ix] = 1; pick.push(mem[ix]); } });
  return pick;                                  // ya en orden ascendente de luminancia (indices crecientes)
}
// conteos por pieza, alineados a los minerales en orden ascendente de luminancia (oscuro -> claro)
// COD: todos los conteos PARES para que el espejo quede PERFECTO en las 44 posiciones (sin
// sueltas al fondo); el resto va a los mas oscuros, que anclan la pieza (5 -> 10/10/8/8/8).
function mp17Conteos(m){
  const N = CFG[pieza].N;                        // 44 (cod) o 108 (japa)
  if(pieza === "cod"){
    const pares = N / 2;                         // 22 pares a repartir
    const base = Math.floor(pares / m), rem = pares - base * m, c = [];
    for(let i = 0; i < m; i++){ c.push(2 * (base + (i < rem ? 1 : 0))); }   // pares; el ajuste al mas oscuro
    return c;
  }
  if(m >= 5) return [22, 22, 22, 22, 20];        // japa: el menor al mas claro (ultimo)
  const base = Math.floor(N / m), rem = N - base * m, c = [];
  for(let i = 0; i < m; i++){ c.push(base + (i < rem ? 1 : 0)); }   // el sobrante a los mas oscuros (primeros)
  return c;
}
/* R20 · F6: mp17FamiliasChipHTML / mp17AbreFamilias retiradas: las 7 familias viven en el carril "Las familias de luz" del Paseo. */
function mp17SiembraFamilia(k){
  const sel = mp17SeleccionFamilia(k);
  if(!mp20Aplicando) cerrarSheet();   // R20: el Paseo aplica en vivo, sin cerrar hoja
  if(!sel || sel.length < 2){ mp9Toast("Esa familia pide más minerales; ábrela en el explorador.", 4200); return; }
  if(!mp20Aplicando) pushUndo();      // R20: navegar en el Paseo NO empuja al stack de deshacer
  if(pieza === "cod") centroForma = "icosaedro";
  centroManual = { icosaedro:null, c10:null, c12:null, flanqueada:null, guru:null };   // el centro/guru queda automatico
  sepPinta = [];   // R18 · F2: una familia es una declaracion fresca de diseno -> base uniforme; el pushUndo de arriba ya guardo los overrides previos, y deshacer los restaura
  const conteos = mp17Conteos(sel.length), flat = [];
  sel.forEach(function(mid, i){ for(let t = 0; t < conteos[i]; t++) flat.push(mid); });   // multiconjunto exacto
  const seqNew = acomodoEspejo(flat);           // "Degradado en espejo": simetrico, preserva conteos
  beads = escribeSeq(seqNew);
  // los minerales entran a la mesa como pinceles (sin cambiar el pincel activo)
  sel.slice().reverse().forEach(function(mid){ if(!mesa.some(function(s){ return s.mid === mid; })) mesa.unshift({ mid:mid, fija:false }); });
  ordenaMesa();
  while(mesa.length > 5){ let q = false; for(let i = mesa.length - 1; i >= 0; i--){ if(!mesa[i].fija){ mesa.splice(i, 1); q = true; break; } } if(!q) break; }
  tocada = true; brush = -1;
  mp13SyncFill(); syncComplete();               // ya quedo llena: baseline de hitos sin disparar acorde/voz
  actualizaPiezaChip(); renderContexto(); renderMesa(); renderCuarto(); updateCotizacion(); marcaCambio();
  const fam = MP13_FAMILIAS.filter(function(f){ return f.k === k; })[0];
  if(!mp20Aplicando) mp9Toast((fam ? fam.n : "Una familia de luz") + ". Es tuya: cámbiala cuenta por cuenta.", 5200);
}

/* ===== 2 · LA HERMANA ACCESIBLE (agencia pura, jamas presion) =====
   Regla determinista: la hermana comparte la intencion DOMINANTE del mineral
   (su intenciones[0]) y su cuenta cuesta <= 60% de la actual; se elige la mas
   barata que cumpla (desempate por nombre). Si no existe, no se muestra nada. */
function mp13Hermana(mid){
  const cur = DATOS.minerales[mid];
  if(!cur || cur.cuenta8 == null || !cur.intenciones || !cur.intenciones.length) return null;
  const domInt = cur.intenciones[0];
  const techo = cur.cuenta8 * 0.60;
  let best = -1;
  DATOS.minerales.forEach(function(m, i){
    if(i === mid || m.cuenta8 == null) return;
    if(!m.intenciones || m.intenciones.indexOf(domInt) < 0) return;
    if(m.cuenta8 > techo) return;
    if(best < 0 || m.cuenta8 < DATOS.minerales[best].cuenta8
       || (m.cuenta8 === DATOS.minerales[best].cuenta8 && m.n.localeCompare(DATOS.minerales[best].n, "es") < 0)) best = i;
  });
  return best < 0 ? null : { mid:best, intp:domInt };
}
function mp13ConoceHermana(mid){
  cerrarSheet();
  expFam = ""; expInt = {};
  expFiltro = DATOS.minerales[mid].n;
  const inp = $("exp-buscar"); if(inp) inp.value = expFiltro;
  huecoObjetivo = -1;
  abrirExplorador();
}

/* ===== 1 · LAS SEMILLAS DE LA CASA (piezas publicadas de un solo mineral) =====
   Ancla de pieza publicada por tipo: ancla_cod (Codificador) / ancla_japa (Japa).
   Sembrar una repone la pieza COMPLETA de ese mineral (cuerpo + centro del mismo
   mineral, talla sin separadores en cod) y el precio sale EXACTO al de la tienda
   por la ruta "ya vive en la tienda" de calcular(). Editar recalcula a personalizada. */
function mp13AnclaPub(mid){ const m = DATOS.minerales[mid]; return pieza === "cod" ? m.ancla_cod : m.ancla_japa; }
function mp13Semillas(){
  return DATOS.minerales.map(function(_, i){ return i; })
    .filter(function(i){ var r = RETRATOS[DATOS.minerales[i].n]; return mp13AnclaPub(i) != null && !!(r && r.uri); })   // R22: solo piezas con retrato real (fuera Jaspe Piel de Leopardo y Rubi hasta que lo tengan)
    .sort(function(a, b){ return DATOS.minerales[a].n.localeCompare(DATOS.minerales[b].n, "es"); });
}
/* R20 · F6: mp13SemillaChipHTML / mp13AbreSemillas retiradas: las piezas de la casa viven en el carril "Las piezas de la casa" del Paseo. */
function mp13SiembraSemilla(mid){
  if(!mp20Aplicando) cerrarSheet();   // R20: el Paseo aplica en vivo, sin cerrar hoja
  if(mp13AnclaPub(mid) == null) return;
  if(!mp20Aplicando) pushUndo();      // R20: navegar en el Paseo NO empuja al stack de deshacer
  if(pieza === "cod"){ centroForma = "icosaedro"; patronIdx = 0; }   // talla 33 cm, sin separadores
  centroManual = { icosaedro:null, c10:null, c12:null, flanqueada:null, guru:null };
  centroManual[pieza === "cod" ? "icosaedro" : "guru"] = mid;
  for(let i = 0; i < beads.length; i++){ beads[i] = mid; }
  justPainted = [];
  if(!mesa.some(function(s){ return s.mid === mid; })) mesa.unshift({ mid:mid, fija:false });
  ordenaMesa();
  while(mesa.length > 5){ let q = false; for(let i = mesa.length - 1; i >= 0; i--){ if(!mesa[i].fija){ mesa.splice(i, 1); q = true; break; } } if(!q) break; }
  brush = -1; tocada = true;
  mp13SyncFill(); syncComplete();
  actualizaPiezaChip(); renderContexto(); renderMesa(); renderCuarto(); updateCotizacion(); marcaCambio();
  const m = DATOS.minerales[mid];
  const cabeza = pieza === "cod" ? "El Codificador" : "La Japa Mala";
  if(!mp20Aplicando) mp9Toast(cabeza + " " + deMin(m) + " tal como vive en la tienda. Es tuya: cámbiala cuenta por cuenta.", 5200);
}

/* ===== 3 · EL ACUSE DEL TALLER (sin promesa de tiempo) =====
   Nota transitoria que respira sobre el grupo del precio cuando la pieza SE SELLA
   (junto a la voz del sellado y cerca del CTA de cotizar), ~9 s y se va sola.
   La linea permanente vive en el desglose; el mensaje del chat conserva la suya. */
let mp13AcuseSellado = false;   // estado anterior (detecta el momento de sellar)
let mp13AcuseTimer = 0;
function mp13SyncAcuse(sellada){
  if(sellada && !mp13AcuseSellado) mp13MuestraAcuse();
  if(!sellada && mp13AcuseSellado) mp13OcultaAcuse();
  mp13AcuseSellado = sellada;
}
function mp13MuestraAcuse(){
  const el = $("mp13-acuse"); if(!el) return;
  if(mp14Ceremonia){ mp14PendAcuse = true; return; }   // Ronda 14 · T2: durante la cristalizacion el acuse llega con el latido
  mp13OcultaHito();                          // comparten el mismo lugar: al sellar, el acuse toma el turno
  el.hidden = false;
  mp13PosicionaNota(el);
  requestAnimationFrame(function(){ el.classList.add("on"); });
  clearTimeout(mp13AcuseTimer);
  mp13AcuseTimer = setTimeout(mp13OcultaAcuse, 9000);
}
function mp13OcultaAcuse(){
  const el = $("mp13-acuse"); if(!el || el.hidden) return;
  el.classList.remove("on"); clearTimeout(mp13AcuseTimer);
  if(reduce){ el.hidden = true; return; }
  mp13AcuseTimer = setTimeout(function(){ el.hidden = true; }, 520);
}

/* ===== 5 · LOS HITOS DEL LLENADO (solo japa, zen, una vez por cruce ascendente) ===== */
const MP13_HITOS = [
  { t:27, txt:"27 cuentas · el primer tramo del camino." },
  { t:54, txt:"54 · la mitad del camino." },
  { t:81, txt:"81 · el último tramo." }
];
let mp13LastFill = { cod:0, japa:0 };
let mp13HitoTimer = 0;
function mp13FilledCount(){ return beads.filter(function(x){ return x != null; }).length; }
function mp13SyncFill(){ mp13LastFill[pieza] = mp13FilledCount(); }
function mp13ChecaHitos(){
  const cur = mp13FilledCount(), prev = mp13LastFill[pieza];
  mp13LastFill[pieza] = cur;
  if(pieza !== "japa") return;               // en codificador: nada
  if(cur <= prev) return;                     // solo cruce ascendente
  if(cur >= CFG[pieza].N) return;             // al completar manda la ceremonia del sellado (acorde + voz), no el hito
  let hit = null;
  MP13_HITOS.forEach(function(hh){ if(prev < hh.t && cur >= hh.t) hit = hh; });   // el mayor cruzado
  if(hit) mp13MuestraHito(hit.txt);
}
function mp13MuestraHito(txt){
  const el = $("mp13-hito"); if(!el) return;
  el.textContent = txt; el.hidden = false;
  ["charola", "lienzo"].forEach(function(id){
    const n = $(id); if(!n) return;
    n.classList.remove("mp13-pulso"); void n.offsetWidth; n.classList.add("mp13-pulso");
    setTimeout(function(){ n.classList.remove("mp13-pulso"); }, 1600);
  });
  mp13PosicionaNota(el);
  requestAnimationFrame(function(){ el.classList.add("on"); });
  clearTimeout(mp13HitoTimer);
  mp13HitoTimer = setTimeout(mp13OcultaHito, 4000);
}
// posiciona una nota (hito / acuse) SOBRE el grupo del precio y la banda de pastillas
function mp13PosicionaNota(el){
  const w = $("precio-wrap"), c = $("contexto");
  if(!el || !w) return;
  const h = Math.ceil(w.getBoundingClientRect().height);
  const ch = c ? Math.ceil(c.getBoundingClientRect().height) : 0;
  el.style.bottom = "calc(env(safe-area-inset-bottom) + " + (h + ch + 30) + "px)";
}
function mp13OcultaHito(){
  const el = $("mp13-hito"); if(!el || el.hidden) return;
  el.classList.remove("on"); clearTimeout(mp13HitoTimer);
  if(reduce){ el.hidden = true; return; }
  mp13HitoTimer = setTimeout(function(){ el.hidden = true; }, 520);
}

/* ==================================================================== */
/* ===================== RONDA 14 · LOS 4 TRABAJOS ==================== */
/* ==================================================================== */

/* --- estado compartido de la cristalizacion (Trabajo 2) --- */
let mp14Ceremonia = false;     // true durante el tras() que sella: difiere el acuse al latido
let mp14PendAcuse = false;     // el acuse quedo pendiente de la cristalizacion
let mp14SelloTimer = 0;
let mp14CristalTimer = 0;
function mp14Completa(){ return beads.filter(function(x){ return x != null; }).length === CFG[pieza].N; }

/* ===== TRABAJO 2 · EL SELLADO COMO CRISTALIZACION ===== */
// la oracion, VERBATIM del manifiesto-cristalizacion-v2.txt (linea 35, sin recombinar)
function mp14FraseManifiesto(){
  return "Cada uno encuentra su lugar en un orden que los integra sin borrarlos.";
}
// (a) la onda que asienta las cuentas, recorriendo la serpentina en su orden
function mp14Onda(){
  if(reduce) return;
  const host = cuarto === "charola" ? $("charola") : $("lienzo");
  if(!host) return;
  const nodes = host.querySelectorAll(cuarto === "charola" ? ".hueco" : ".cuenta");
  const n = nodes.length; if(!n) return;
  const DUR = 340, TOTAL = 600;
  const stag = n > 1 ? Math.max(1, (TOTAL - DUR) / (n - 1)) : 0;
  nodes.forEach(function(el, k){
    const d = Math.round(k * stag);
    el.style.animationDelay = d + "ms";
    el.classList.remove("mp14-onda"); void el.offsetWidth; el.classList.add("mp14-onda");
    setTimeout(function(){ el.classList.remove("mp14-onda"); el.style.animationDelay = ""; }, d + DUR + 80);
  });
}
// (b) la frase del manifiesto, en el lugar de la voz del sellado
function mp14MuestraCristal(txt){
  const el = $("mp14-cristal"); if(!el || !txt) return;
  clearTimeout(mp14CristalTimer);
  el.textContent = txt; el.hidden = false;
  requestAnimationFrame(function(){ el.classList.add("on"); });
}
function mp14OcultaCristal(inmediato){
  const el = $("mp14-cristal"); if(!el || el.hidden) return;
  el.classList.remove("on"); clearTimeout(mp14CristalTimer);
  if(reduce || inmediato){ el.hidden = true; return; }   // inmediato: al cambiar de pieza la frase no se arrastra
  mp14CristalTimer = setTimeout(function(){ el.hidden = true; }, 260);
}
// la coreografia del instante de sellar (llamada desde maybeChord al completar)
function mp14Cristaliza(){
  const linea = mp14FraseManifiesto();
  const pz = pieza;                                    // Ronda 14fix: la ceremonia pertenece a ESTA pieza
  mp13OcultaHito();                                    // Ronda 14fix: el hito se retira en el instante de completar, sin esperar el relevo de voz/acuse
  if(reduce){
    // sin onda, sin latido: la frase se apila sobre la voz y todo aparece junto (el acuse ya lo mostro updateCotizacion)
    acorde(); vibra([12, 60, 12]); mostrarVozSellado(linea);
    return;
  }
  mp14Onda();                                          // (a) las cuentas se asientan
  mp14MuestraCristal(linea);                           // (b) la frase, ANTES que la voz, en su mismo lugar
  clearTimeout(mp14SelloTimer);
  mp14SelloTimer = setTimeout(function(){              // (c) un latido despues: el precio se sella con el acorde
    if(pieza !== pz || !mp14Completa()){ mp14OcultaCristal(); mp14PendAcuse = false; return; }   // la pieza cambio dentro del latido: aborta
    acorde(); vibra([12, 60, 12]);
    mp14OcultaCristal();                                // la frase se retira (260ms)
    setTimeout(function(){                              // la voz entra cuando la frase ya se fue (turno, sin traslape)
      if(pieza !== pz || !mp14Completa()) return;
      mostrarVozSellado(null);
      if(mp14PendAcuse){ mp14PendAcuse = false; mp13MuestraAcuse(); }
    }, 300);
  }, 900);
}

/* ===== TRABAJO 1 · LA ANTESALA DE CONFIANZA ===== */
function mp14ResumenHTML(r){
  let h = "";
  h += '<div class="mp14-rr cab">' + (pieza === "cod" ? "Codificador 45" : "Japa Mala 108") + '</div>';
  r.grupos.forEach(function(g){
    const m = DATOS.minerales[g.mid];
    h += '<div class="mp14-rr"><span class="mp14-dot" style="background:' + COL[g.mid].c + '"></span>' + g.n + (g.n === 1 ? ' cuenta ' : ' cuentas ') + escHtml(deMin(m)) + '</div>';
  });
  if(pieza === "cod" && r.sepCount > 0){
    if(!r.sepMixto){ h += '<div class="mp14-rr">' + r.sepCount + ' separadores de 4 mm ' + escHtml(deMin(r.sepMin)) + '</div>'; }
    else { h += '<div class="mp14-rr">' + r.sepCount + ' separadores de 4 mm: ' + escHtml(r.sepGrupos.map(function(g){ return g.n + ' ' + deMin(DATOS.separadores[g.si]); }).join(', ')) + '</div>'; }
  }
  if(r.centroMid >= 0){
    h += '<div class="mp14-rr">' + (pieza === "cod" ? "Centro" : "Gurú") + ': ' + escHtml(nombreArt(DATOS.minerales[r.centroMid], false)) + '</div>';
  }
  if(degTono && mp15bAplica()){   // Ronda 15b: refleja la misma linea que viaja en el encargo
    h += '<div class="mp14-rr">Degradado de tono: se afina a mano en el taller, de tono a tono.</div>';
  }
  if(pieza === "cod"){
    const p = DATOS.patrones[patronIdx];
    h += '<div class="mp14-rr suave">Talla ' + p.cm + ' cm · ' + escHtml(p.sep === 0 ? "sin separadores" : p.desc) + '</div>';
  } else {
    h += '<div class="mp14-rr suave">108 cuentas · anudado en nailon · borla de seda natural</div>';
  }
  return h;
}
function mp14AbreAntesala(){
  const r = calcular();
  if(r.vacia || r.incompleta) return;                  // solo con pieza completa
  const href = "https://wa.me/" + DATOS.wa + "?text=" + encodeURIComponent(mensajeWA(r));   // el mismo mensaje de siempre, intacto
  let h = "";
  h += '<div class="mp14-ant-head"><h2>Esto es lo que vas a enviar</h2></div>';
  h += '<div class="mp14-ant-pieza"><canvas id="mp14-ant-canvas" width="360" height="440" aria-label="Tu pieza en su forma"></canvas></div>';
  h += '<div class="mp14-ant-total">' + money(r.final) + '</div>';
  h += '<div class="mp14-ant-resumen" id="mp14-ant-resumen">' + mp14ResumenHTML(r) + '</div>';
  h += '<ul class="mp14-ant-hechos">';
  h += '<li>Hecha a mano en México, cuenta por cuenta.</li>';
  h += '<li>Minerales reales, siempre.</li>';
  h += '<li>Envío gratis a todo México.</li>';
  h += '</ul>';
  h += '<div class="mp14-ant-acc">';
  h += '<a class="mp14-ant-enviar" id="mp14-ant-enviar" href="' + escHtml(href) + '" target="_blank" rel="noopener">Enviar por WhatsApp</a>';
  h += '<button class="mp14-ant-volver" id="mp14-ant-volver">Volver a mi pieza</button>';
  h += '</div>';
  $("mp14-ant-in").innerHTML = h;
  const ov = $("mp14-antesala");
  ov.classList.add("on"); ov.setAttribute("aria-hidden", "false");
  mp14DibujaMini();
  mpMontaFocoVelo(ov);   // cura C2: foco al velo + trampa de Tab (patron del contador)
}
function mp14CierraAntesala(){ const ov = $("mp14-antesala"); ov.classList.remove("on"); ov.setAttribute("aria-hidden", "true"); mpRegresaFocoVelo(); }
// la pieza en su forma de gota, en miniatura (reusa el renderer de la estampa)
function mp14DibujaMini(){
  const cv = $("mp14-ant-canvas"); if(!cv) return;
  const W = cv.width, H = cv.height, ctx = cv.getContext("2d");
  ctx.setTransform(1, 0, 0, 1, 0, 0); ctx.clearRect(0, 0, W, H);
  const names = mp12NombresDe(mp12DisenoActual());
  mp12Preload(names, function(imgs){
    const L = layoutGota(1000, 1000, { top:30, bottom:30, left:30, right:30 });
    const bb = mp12Bbox(L), pad = 14;
    const bw = (bb.maxX - bb.minX) || 1, bh = (bb.maxY - bb.minY) || 1;
    const k = Math.min((W - 2 * pad) / bw, (H - 2 * pad) / bh);
    const cw = bw * k, ch = bh * k;
    const tx = (W - cw) / 2 - bb.minX * k, ty = (H - ch) / 2 - bb.minY * k;
    mp12DibujaPieza(ctx, L, imgs, tx, ty, k);
  });
}

/* ===== TRABAJO 3 · LA HOJA DE ARMADO ===== */
function mp14FormaCentroTxt(){
  return ({ icosaedro:"icosaedro clásico", c10:"cuenta de 10 mm", c12:"cuenta de 12 mm", flanqueada:"flanqueada por 2 separadores" })[formaActual()] || "icosaedro clásico";
}
// la pieza en el orden REAL de la serpentina, con el centro en su posicion y los separadores del patron
function mp14OrdenEnsartado(){
  const half = CFG[pieza].half, N = CFG[pieza].N, items = [];
  let pos = 0;
  for(let L = 0; L <= N; L++){
    pos++;
    if(L === half){ items.push({ pos:pos, tipo:"centro", mid:centroMinActual() }); }
    else { items.push({ pos:pos, tipo:"cuenta", mid:beads[linToBead(L)] }); }
  }
  return items;
}
function mp14ArmadoLista(){
  // NO calcula cadencia propia: consume sepCadencia() (la misma fuente que dibuja el
  // observatorio) y traduce cada separador a su posicion del orden de ensartado.
  // R18 · F1: cada posicion de separador nombra el mineral de SU slot (override o base).
  const items = mp14OrdenEnsartado();
  const cad = sepCadencia();
  const half = CFG[pieza].half;
  const tieneSep = (pieza === "cod" && DATOS.patrones[patronIdx].sep > 0);
  if(tieneSep) sepPintaSane();
  function slotNom(slot){ return tieneSep ? sepDeSlot(slot).n : null; }
  const nb = 2 * cad.bs.length;
  const after = {};                                  // pos del ensartado -> indice de slot del separador
  cad.bs.forEach(function(b, i){
    after[half - b - 1] = 2 * i;                     // izquierda: entre las cuentas b+1 y b -> slot 2i
    after[b + half + 2] = 2 * i + 1;                 // espejo derecho -> slot 2i+1
  });
  const guruSep = sepGuruVisible(cad);               // Ronda 16 · pegado al guru
  if(guruSep) after[half] = nb;                      // hebra izquierda: entre la 1a cuenta y el centro -> slot nb
  const rows = [];
  let run = null;
  function cierraRun(){ if(run){ rows.push({ kind:"run", desde:run.desde, hasta:run.hasta, mid:run.mid, n:run.n }); run = null; } }
  items.forEach(function(it){
    if(it.tipo === "centro"){ cierraRun(); rows.push({ kind:"centro", pos:it.pos, mid:it.mid });
      if(guruSep) rows.push({ kind:"sep", pos:it.pos, mid:slotNom(nb + 1) });   // pegado al guru, hebra derecha -> slot nb+1
      return; }
    if(run && run.mid === it.mid){ run.hasta = it.pos; run.n++; }
    else { cierraRun(); run = { desde:it.pos, hasta:it.pos, mid:it.mid, n:1 }; }
    if(after[it.pos] != null){ cierraRun(); rows.push({ kind:"sep", pos:it.pos, mid:slotNom(after[it.pos]) }); }
  });
  cierraRun();
  if(cad.cierre){ rows.push({ kind:"sepcierre", mid:slotNom(nb + (guruSep ? 2 : 0)) }); }   // Ronda 16 · el cierre del fondo
  return rows;
}
function mp14ArmadoHTML(){
  const r = calcular();
  const rows = mp14ArmadoLista();
  const piezaTxt = pieza === "cod" ? "Codificador 45" : "Japa Mala 108";
  const tallaTxt = pieza === "cod"
    ? ("talla " + DATOS.patrones[patronIdx].cm + " cm · " + (DATOS.patrones[patronIdx].sep === 0 ? "sin separadores" : DATOS.patrones[patronIdx].desc))
    : "108 cuentas · anudado en nailon · borla de seda natural";
  let h = "";
  h += '<div class="mp14-arm-head"><h2>Vista de armado</h2><p>Para la mesa del taller: el orden real del ensartado.</p></div>';
  h += '<div class="mp14-arm-meta"><div>' + piezaTxt + '</div><div class="suave">' + escHtml(tallaTxt) + '</div><div class="mp14-arm-total">' + (r.vacia ? "" : money(r.final)) + '</div></div>';
  h += '<div class="mp14-arm-scroll"><ol class="mp14-arm-lista">';
  rows.forEach(function(row){
    if(row.kind === "run"){
      const nombre = row.mid == null ? "por nombrar" : nombreArt(DATOS.minerales[row.mid], false);
      const rango = row.desde === row.hasta ? ("cuenta " + row.desde) : ("cuentas " + row.desde + " a " + row.hasta);
      const dot = row.mid == null ? "" : '<span class="mp14-dot" style="background:' + COL[row.mid].c + '"></span>';
      h += '<li class="mp14-arm-run">' + dot + '<span>' + rango + ' · ' + escHtml(nombre) + ' (' + row.n + ')</span></li>';
    } else if(row.kind === "centro"){
      const forma = pieza === "cod" ? mp14FormaCentroTxt() : "gurú";
      const cola = row.mid < 0 ? "por nombrar" : deMin(DATOS.minerales[row.mid]);
      h += '<li class="mp14-arm-centro">posición ' + row.pos + ' · CENTRO · ' + escHtml(forma) + ' ' + escHtml(cola) + '</li>';
    } else if(row.kind === "sep"){
      h += '<li class="mp14-arm-sep">posición ' + row.pos + '.5 · separador de 4 mm' + (row.mid ? ' de ' + escHtml(row.mid) : '') + '</li>';
    } else if(row.kind === "sepcierre"){
      h += '<li class="mp14-arm-sep">el cierre del fondo · separador de 4 mm' + (row.mid ? ' de ' + escHtml(row.mid) : '') + '</li>';
    }
  });
  h += '</ol></div>';
  if(degTono && mp15bAplica()){ h += '<div class="mp15b-arm">Degradado de tono: afinar a mano, de tono a tono.</div>'; }   // Ronda 15b
  h += '<div class="mp14-arm-cod">' + escHtml(codificaDiseno()) + '</div>';
  h += '<div class="mp14-arm-acc"><button class="mp14-arm-copiar" id="mp14-arm-copiar">Copiar la lista</button><button class="mp14-arm-cerrar" id="mp14-arm-cerrar">Cerrar</button></div>';
  return h;
}
function mp14ArmadoTexto(){
  const r = calcular();
  const rows = mp14ArmadoLista();
  const L = [];
  L.push((pieza === "cod" ? "Codificador 45" : "Japa Mala 108") + " · vista de armado");
  L.push(pieza === "cod"
    ? ("Talla " + DATOS.patrones[patronIdx].cm + " cm · " + (DATOS.patrones[patronIdx].sep === 0 ? "sin separadores" : DATOS.patrones[patronIdx].desc))
    : "108 cuentas · anudado en nailon · borla de seda natural");
  if(!r.vacia) L.push("Total estimado: " + money(r.final));
  L.push("");
  rows.forEach(function(row){
    if(row.kind === "run"){
      const nombre = row.mid == null ? "por nombrar" : nombreArt(DATOS.minerales[row.mid], false);
      const rango = row.desde === row.hasta ? ("Cuenta " + row.desde) : ("Cuentas " + row.desde + " a " + row.hasta);
      L.push(rango + " · " + nombre + " (" + row.n + ")");
    } else if(row.kind === "centro"){
      const forma = pieza === "cod" ? mp14FormaCentroTxt() : "gurú";
      const cola = row.mid < 0 ? "por nombrar" : deMin(DATOS.minerales[row.mid]);
      L.push("Posición " + row.pos + " · CENTRO · " + forma + " " + cola);
    } else if(row.kind === "sep"){
      L.push("Posición " + row.pos + ".5 · separador de 4 mm" + (row.mid ? " de " + row.mid : ""));
    } else if(row.kind === "sepcierre"){
      L.push("El cierre del fondo · separador de 4 mm" + (row.mid ? " de " + row.mid : ""));
    }
  });
  if(degTono && mp15bAplica()){ L.push(""); L.push("Degradado de tono: afinar a mano, de tono a tono."); }   // Ronda 15b
  L.push("");
  L.push("Código del diseño: " + codificaDiseno());
  return L.join("\n");
}
function mp14AbreArmado(){
  $("mp14-arm-in").innerHTML = mp14ArmadoHTML();
  const ov = $("mp14-armado"); ov.classList.add("on"); ov.setAttribute("aria-hidden", "false");
}
function mp14CierraArmado(){ const ov = $("mp14-armado"); ov.classList.remove("on"); ov.setAttribute("aria-hidden", "true"); }

/* ===== TRABAJO 4 · EL EMBUDO LOCAL (4 eventos, solo localStorage) ===== */
const LS_EMBUDO = "mp_cotizador_embudo_v1";
const MP14_EVENTOS = ["abrio", "primera_cuenta", "precio_sellado", "cotizar_tocado"];
const MP14_EMB_ETQ = { abrio:"Abrió el cotizador", primera_cuenta:"Nombró su primera cuenta", precio_sellado:"Selló el precio de una pieza", cotizar_tocado:"Tocó enviar por WhatsApp" };
let mp14EmbudoSesion = {};      // una vez por sesion de pagina
function mp14EmbudoVacio(){ const o = {}; MP14_EVENTOS.forEach(function(k){ o[k] = { n:0, last:null }; }); return o; }
function mp14LeeEmbudo(){
  let o = {};
  try{ o = JSON.parse(localStorage.getItem(LS_EMBUDO)) || {}; }catch(_){ o = {}; }
  MP14_EVENTOS.forEach(function(k){
    if(!o[k] || typeof o[k] !== "object"){ o[k] = { n:0, last:null }; }
    if(typeof o[k].n !== "number") o[k].n = 0;
    if(typeof o[k].last === "undefined") o[k].last = null;
  });
  return o;
}
function mp14GuardaEmbudo(o){ try{ localStorage.setItem(LS_EMBUDO, JSON.stringify(o)); }catch(_){} }
function mp14Embudo(evt){
  if(MP14_EVENTOS.indexOf(evt) < 0) return;
  if(mp14EmbudoSesion[evt]) return;                    // una sola vez por sesion de pagina
  mp14EmbudoSesion[evt] = true;
  const o = mp14LeeEmbudo();
  o[evt].n += 1;
  o[evt].last = new Date().toISOString();
  mp14GuardaEmbudo(o);
  mp14RefrescaPanel();
}
function mp14VaciaEmbudo(){
  mp14GuardaEmbudo(mp14EmbudoVacio());
  mp14EmbudoSesion = {};                                // reabre la ventana de observacion en esta sesion
  mp14RefrescaPanel();
}
function mp14FechaCorta(iso){
  try{
    const d = new Date(iso); if(isNaN(d.getTime())) return "";
    const meses = ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"];
    const hh = String(d.getHours()).padStart(2, "0"), mi = String(d.getMinutes()).padStart(2, "0");
    return d.getDate() + " " + meses[d.getMonth()] + " " + hh + ":" + mi;
  }catch(_){ return ""; }
}
function mp14EmbudoHTML(){
  const o = mp14LeeEmbudo();
  function pct(a, b){ return b ? (Math.round(a / b * 100) + "%") : "·"; }
  let h = '<div class="mp14-embudo" id="mp14-embudo-panel">';
  h += '<div class="ck-lbl">El embudo</div>';
  h += '<div class="ck-sub">Uso interno, de esta computadora. Cuatro pasos, una vez por sesión. Sin red: vive solo en este navegador.</div>';
  for(let i = 0; i < MP14_EVENTOS.length; i++){
    const k = MP14_EVENTOS[i], row = o[k];
    const paso = i > 0 ? '<span class="mp14-emb-pct">' + pct(row.n, o[MP14_EVENTOS[i - 1]].n) + '</span>' : "";
    const fecha = row.last ? mp14FechaCorta(row.last) : "";
    h += '<div class="mp14-emb-row"><span class="mp14-emb-k">' + MP14_EMB_ETQ[k] + (fecha ? '<small>último: ' + fecha + '</small>' : '') + '</span>'
      + '<span class="mp14-emb-v">' + row.n + paso + '</span></div>';
  }
  h += '<div class="mp14-emb-acc"><button class="mp14-emb-vaciar" id="mp14-emb-vaciar">Vaciar el embudo</button></div>';
  h += '<div class="mp14-emb-confirma" id="mp14-emb-confirma" hidden><p>Esto borra los conteos de esta computadora. La práctica de la clienta no se toca.</p>'
    + '<div class="mp14-emb-confirma-row"><button class="mp14-emb-si" id="mp14-emb-si">Sí, vaciar</button><button class="mp14-emb-no" id="mp14-emb-no">Mejor no</button></div></div>';
  h += '</div>';
  return h;
}
function mp14RefrescaPanel(){ const p = $("mp14-embudo-panel"); if(p) p.outerHTML = mp14EmbudoHTML(); }

/* --- los acomodos (Ronda 16 · LEY DEL ESPEJO del fundador): TODOS simetricos y bellos,
   en espejo desde la cuenta principal (guru) hacia afuera. Lo asimetrico se pinta a mano.
   Cada acomodo es una PERMUTACION PURA (mismo multiconjunto) y UN paso de deshacer.
   El eje de simetria es el guru: en orden de lectura (seq) el guru vive entre seq[half-1]
   y seq[half], asi que seq[j] == seq[N-1-j] (twin) = pieza simetrica. Un mineral de conteo
   IMPAR deja una cuenta sobrante: va al FONDO (lo mas lejano del guru), agrupada; ahi, y solo
   ahi, el espejo se rompe (es la unica excepcion prevista). --- */

// Construye una seq simetrica a partir de un "brazo" (guru -> fondo). El armBuilder ordena
// los PARES (floor(cnt/2) por mineral) en el brazo; simetriza los refleja a ambas hebras y
// coloca los sobrantes impares en los anillos del fondo, con los vacios en los extremos.
function simetriza(seq, armBuilder, leftoverOrder){
  const N = seq.length, half = N >> 1;
  const placed = seq.filter(function(x){ return x != null; });
  if(!placed.length) return new Array(N).fill(null);
  const cnt = {};
  placed.forEach(function(m){ cnt[m] = (cnt[m] || 0) + 1; });
  const mids = Object.keys(cnt).map(Number);
  const pairFlat = [], leftovers = [];
  mids.forEach(function(m){
    const p = Math.floor(cnt[m] / 2);
    for(let i = 0; i < p; i++) pairFlat.push(m);
    if(cnt[m] % 2) leftovers.push(m);
  });
  const arm = (pairFlat.length ? armBuilder(pairFlat, cnt) : []);   // guru -> fondo, longitud = pares
  const AP = arm.length;
  const res = new Array(N).fill(null);
  for(let t = 0; t < AP && t < half; t++){ res[half - 1 - t] = arm[t]; res[half + t] = arm[t]; }   // espejo
  // sobrantes impares: en los anillos siguientes hacia el fondo (agrupados); si alguno queda
  // sin pareja, su gemelo es un vacio (solo posible con pieza incompleta)
  const lo = leftoverOrder ? leftoverOrder(leftovers, cnt) : leftovers.slice();
  let t = AP;
  for(let i = 0; i < lo.length && t < half; i += 2){
    res[half - 1 - t] = lo[i];
    res[half + t] = (i + 1 < lo.length) ? lo[i + 1] : null;
    t++;
  }
  return res;
}
// ronda (una de cada mineral) sobre una lista de pares
function rondaDe(pf){
  const work = countsSorted(pf), out = []; let rem = pf.length;
  while(rem > 0){ for(let i = 0; i < work.length; i++){ if(work[i].n > 0){ out.push(work[i].mid); work[i].n--; rem--; } } }
  return out;
}

// 1 · Alternado en espejo: una de cada mineral, en ronda, igual a cada lado del centro
function acomodoAlternado(seq){ return simetriza(seq, function(pf){ return rondaDe(pf); }); }
// 2 · Bloques en espejo: bandas gemelas de N del mismo mineral desde el centro
function acomodoBloques(seq, k){
  k = Math.max(2, Math.min(11, k | 0));
  return simetriza(seq, function(pf){
    const work = countsSorted(pf), out = [], total = pf.length;
    while(out.length < total){
      let adv = false;
      for(let i = 0; i < work.length; i++){ if(work[i].n > 0){ const take = Math.min(k, work[i].n); for(let t = 0; t < take; t++){ out.push(work[i].mid); work[i].n--; } adv = true; } }
      if(!adv) break;
    }
    return out;
  });
}
// 3 · Coronas del centro: el mineral mas escaso abraza el centro; el mas abundante, el fondo
function acomodoCoronas(seq){
  return simetriza(seq, function(pf, cnt){
    const ms = Object.keys(cnt).map(Number).sort(function(a, b){ return cnt[a] - cnt[b] || DATOS.minerales[a].n.localeCompare(DATOS.minerales[b].n, "es"); });
    const out = [];
    ms.forEach(function(m){ const p = Math.floor(cnt[m] / 2); for(let i = 0; i < p; i++) out.push(m); });
    return out;
  });
}
// 4 · Degradado en espejo: cada brazo va de oscuro (guru) a claro (medio) y de vuelta a oscuro
//     (fondo); reflejado, la pieza lee oscuro-claro-oscuro-claro-oscuro alrededor del centro.
function acomodoEspejo(seq){
  return simetriza(seq, function(pf){
    const sorted = pf.slice().sort(cmpLumAsc);   // oscuro -> claro
    const AP = sorted.length, out = new Array(AP), c = (AP - 1) / 2, pos = [];
    for(let j = 0; j < AP; j++) pos.push(j);
    pos.sort(function(a, b){ return Math.abs(a - c) - Math.abs(b - c) || a - b; });   // del medio del brazo hacia afuera
    for(let k = 0; k < AP; k++){ out[pos[k]] = sorted[AP - 1 - k]; }   // el mas claro al medio del brazo
    return out;
  });
}
// 5 · La luz del centro: la mas clara junto al centro; la mas oscura en el fondo (monotono)
function acomodoLuz(seq){
  return simetriza(seq, function(pf){
    return pf.slice().sort(function(a, b){ return luminanciaMineral(b) - luminanciaMineral(a); });   // claro -> oscuro
  });
}
// 6 · Por intencion en espejo: bandas gemelas por intencion dominante; la mas chica al centro
function acomodoPorIntencion(seq){
  return simetriza(seq, function(pf){
    const c = {}; pf.forEach(function(m){ c[m] = (c[m] || 0) + 1; });
    function fam(mid){ const it = DATOS.minerales[mid].intenciones; return (it && it.length) ? it[0] : "·otras"; }
    const groups = {};
    Object.keys(c).forEach(function(k){ const mid = +k, f = fam(mid); (groups[f] = groups[f] || []).push(mid); });
    function famTotal(f){ return groups[f].reduce(function(s, mid){ return s + c[mid]; }, 0); }
    function famRank(f){ const i = INTENCIONES.indexOf(f); return i < 0 ? 999 : i; }
    const keys = Object.keys(groups).sort(function(a, b){ return famTotal(a) - famTotal(b) || famRank(a) - famRank(b) || a.localeCompare(b, "es"); });   // chica al centro
    const out = [];
    keys.forEach(function(f){
      const ms = groups[f].slice().sort(function(a, b){ return c[b] - c[a] || DATOS.minerales[a].n.localeCompare(DATOS.minerales[b].n, "es"); });
      ms.forEach(function(mid){ for(let t = 0; t < c[mid]; t++) out.push(mid); });
    });
    return out;
  });
}
// 7 · Ritmo parejo: el mas abundante es la base; los demas (acentos) a intervalos regulares
function acomodoRitmo(seq){
  return simetriza(seq, function(pf){
    const work = countsSorted(pf);
    if(work.length <= 1) return pf.slice();
    const base = work[0].mid, AP = pf.length;
    const accents = [];
    for(let i = 1; i < work.length; i++){ for(let t = 0; t < work[i].n; t++) accents.push(work[i].mid); }
    const accRound = rondaDe(accents);            // intercala los distintos acentos en ronda
    const A = accRound.length, out = new Array(AP).fill(null);
    for(let i = 0; i < A; i++){
      let p = Math.floor((i + 0.5) * AP / A);
      while(p < AP && out[p] != null) p++;
      if(p >= AP){ p = AP - 1; while(p >= 0 && out[p] != null) p--; }
      if(p >= 0 && p < AP) out[p] = accRound[i];
    }
    for(let p = 0; p < AP; p++){ if(out[p] == null) out[p] = base; }
    return out;
  });
}
// giro: la mano del cliente; puede romper el espejo a proposito (su agencia)
function acomodoGirar(seq, dir){
  const N = seq.length; if(!N) return seq.slice();
  const d = (((dir % N) + N) % N), out = new Array(N);
  for(let j = 0; j < N; j++){ out[(j + d) % N] = seq[j]; }
  return out;
}
// 8 · Aleatorio en espejo: baraja una hebra al azar; la otra la refleja
function acomodoAleatorio(seq){
  return simetriza(seq, function(pf){
    const a = pf.slice();
    for(let i = a.length - 1; i > 0; i--){ const j = Math.floor(Math.random() * (i + 1)); const t = a[i]; a[i] = a[j]; a[j] = t; }
    return a;
  });
}
function construyeAcomodo(id, seq){
  switch(id){
    case "alternado": return acomodoAlternado(seq);
    case "bloques":   return acomodoBloques(seq, acomodoBloqueN);
    case "coronas":   return acomodoCoronas(seq);
    case "espejo":    return acomodoEspejo(seq);
    case "luz":       return acomodoLuz(seq);
    case "intencion": return acomodoPorIntencion(seq);
    case "ritmo":     return acomodoRitmo(seq);
    case "aleatorio": return acomodoAleatorio(seq);
    default:          return seq.slice();
  }
}

const ACOMODOS = [
  { id:"alternado", t:"Alternado en espejo",     m:"una de cada mineral, igual a cada lado del centro" },
  { id:"bloques",   t:"Bloques en espejo",       m:"bandas gemelas del mismo mineral, desde el centro", ctrl:"bloque" },
  { id:"coronas",   t:"Coronas del centro",      m:"el que menos tienes abraza el centro; el que más, el fondo" },
  { id:"espejo",    t:"Degradado en espejo",     m:"de oscuro a claro y de vuelta, desde el centro" },
  { id:"luz",       t:"La luz del centro",       m:"la más clara junto al centro; la más oscura en el fondo" },
  { id:"intencion", t:"Por intención en espejo", m:"bandas gemelas por la intención que comparten" },
  { id:"ritmo",     t:"Ritmo parejo",            m:"los minerales acento, repartidos parejo entre el resto" },
  { id:"aleatorio", t:"Aleatorio en espejo",     m:"una hebra al azar; la otra la refleja", ctrl:"aleatorio" },
  { id:"girar",     t:"Girar el orden",          m:"corre todas una posición", ctrl:"girar" }
];

// Ronda 16 · la tira nace del CENTRO: el guru (rombo dorado) va al medio y el patron real
// crece hacia ambos lados desde el, reflejando el acomodo sobre la composicion actual. Si no
// caben todas las cuentas, se submuestrea SIMETRICO (mismo numero a cada lado del guru).
function acomodoPreviewDots(res){
  const N = res.length, half = N >> 1, MAX = 12;
  const side = Math.min(half, MAX);
  function sidx(t){ return side === half ? t : Math.round(t * (half - 1) / (side - 1)); }   // 0..half-1
  function dot(mid){ return mid == null ? '<span class="ac-dot vacia"></span>' : '<span class="ac-dot" style="background:' + COL[mid].c + '"></span>'; }
  // en orden de lectura: res[0..half-1] = hebra izquierda del fondo al guru; res[half..N-1] = del guru al fondo.
  // La derecha se muestrea como ESPEJO exacto de la izquierda (posicion j <-> N-1-j): mismo numero a cada lado.
  let h = "";
  for(let t = 0; t < side; t++){ h += dot(res[sidx(t)]); }                        // fondo-izq -> guru-izq
  h += '<span class="ac-dot mp16-guru" aria-hidden="true"></span>';               // el guru, al centro de la tira
  for(let t = side - 1; t >= 0; t--){ h += dot(res[N - 1 - sidx(t)]); }           // guru-der -> fondo-der (espejos exactos)
  return h;
}
function acomodoCardHTML(a, seq, vacia){
  const res = vacia ? [] : (a.id === "girar" ? acomodoGirar(seq, 1) : construyeAcomodo(a.id, seq));   // girar: el orden actual corrido una posicion
  const prev = vacia ? "" : acomodoPreviewDots(res);
  const dis = vacia ? " disabled" : "";
  let h = "";
  if(a.ctrl === "girar"){
    h += '<div class="ac-card"' + dis + '>';
    h += '<div class="ac-body"><span class="ac-t">' + a.t + '</span><span class="ac-m">' + a.m + '</span>'
      + '<div class="ac-prev" id="ac-prev-' + a.id + '">' + prev + '</div></div>';
    h += '<span class="ac-ctrl" role="group" aria-label="Girar el orden">'
      + '<button data-ac-girar="-1" aria-label="girar hacia atrás"' + dis + '><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 6l-6 6 6 6"/></svg></button>'
      + '<button data-ac-girar="1" aria-label="girar hacia adelante"' + dis + '><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 6l6 6-6 6"/></svg></button></span>';
    h += '</div>';
    return h;
  }
  if(a.ctrl === "bloque"){
    h += '<div class="ac-card"' + dis + '>';
    h += '<button class="ac-body" data-ac-apply="bloques"' + dis + ' aria-label="Aplicar bloques de ' + acomodoBloqueN + '"><span class="ac-t">' + a.t + '</span><span class="ac-m">' + a.m + '</span>'
      + '<div class="ac-prev" id="ac-prev-' + a.id + '">' + prev + '</div></button>';
    h += '<span class="ac-ctrl" role="group" aria-label="Cuentas por bloque">'
      + '<button data-ac-blk="-1" aria-label="menos"' + (acomodoBloqueN <= 2 ? " disabled" : "") + '>&minus;</button>'
      + '<b id="ac-blk-n">' + acomodoBloqueN + '</b>'
      + '<button data-ac-blk="1" aria-label="más"' + (acomodoBloqueN >= 11 ? " disabled" : "") + '>+</button></span>';
    h += '</div>';
    return h;
  }
  // tarjeta simple: toda la tarjeta aplica el acomodo
  h += '<button class="ac-card" data-ac-apply="' + a.id + '"' + dis + ' aria-label="Aplicar: ' + a.t + '">';
  h += '<div class="ac-body"><span class="ac-t">' + a.t + '</span><span class="ac-m">' + a.m + '</span>'
    + '<div class="ac-prev" id="ac-prev-' + a.id + '">' + prev + '</div></div>';
  h += '<span class="ac-go" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M5 12h14M13 6l6 6-6 6"/></svg></span>';
  h += '</button>';
  return h;
}
// Ronda 15 (conservado en R16): los acomodos se adaptan a la composicion de las cuentas LLENAS.
// < 2 minerales distintos: ninguna tarjeta (la pieza ya esta en su orden).
// luz y espejo (los dos leen luminancia): exigen >= 2 valores de luminancia distintos;
// intencion: >= 2 intenciones dominantes distintas.
function mp15AcomodosDe(seq){
  const set = {};
  seq.forEach(function(x){ if(x != null) set[x] = 1; });
  const mids = Object.keys(set).map(Number);
  if(mids.length < 2) return [];
  return ACOMODOS.filter(function(a){
    if(a.id === "luz" || a.id === "espejo"){
      const vals = {}; mids.forEach(function(m){ vals[String(luminanciaMineral(m))] = 1; });
      return Object.keys(vals).length >= 2;
    }
    if(a.id === "intencion"){
      const doms = {}; mids.forEach(function(m){ const it = DATOS.minerales[m].intenciones; doms[(it && it.length) ? it[0] : "·otras"] = 1; });
      return Object.keys(doms).length >= 2;
    }
    return true;
  });
}
function abrirAcomodos(){
  const seq = seqActual();
  const placed = seq.filter(function(x){ return x != null; });
  const vacia = placed.length === 0;
  if(!vacia) precargaLuminancia(placed.map(function(m){ return m; }));
  const lista = vacia ? [] : mp15AcomodosDe(seq);
  let h = '<div class="grabber"></div>';
  h += '<div class="sheet-head"><div><div class="sheet-nombre">Acomodos</div>'
    + '<div class="sheet-lugar">solo cambian el orden de tus cuentas; nunca su mineral</div></div></div>';
  if(vacia){
    h += '<p class="ac-nota">Llena algunas cuentas en la charola y vuelve aquí para acomodarlas.</p>';
  } else if(!lista.length){
    h += '<p class="ac-nota">Con un solo mineral, la pieza ya está en su orden.</p>';
    h += mp15bCardHTML();   // Ronda 15b: si ese mineral es multicolor, el apagador del degradado de tono
  } else {
    h += '<div class="ac-galeria" id="ac-galeria">';
    lista.forEach(function(a){ h += acomodoCardHTML(a, seq, false); });
    h += '</div>';
    h += '<p class="ac-nota">Cada acomodo es un paso de deshacer. El precio no cambia con el orden.</p>';
  }
  h += '<div class="sheet-acciones"><button class="prim" data-act="cerrar">Listo</button></div>';
  $("sheet-in").innerHTML = h;
  abrirSheet("acomodos", "Acomodos");
}
// refresca SOLO las previews (no reconstruye los botones, para no romper el mantener-presionado de girar)
// Ronda 15: respeta el gating (solo toca las tarjetas que existen en la hoja)
function refrescaAcomodos(){
  const seq = seqActual();
  if(seq.filter(function(x){ return x != null; }).length === 0){ return; }
  mp15AcomodosDe(seq).forEach(function(a){
    const el = $("ac-prev-" + a.id); if(!el) return;
    const res = (a.id === "girar") ? acomodoGirar(seq, 1) : construyeAcomodo(a.id, seq);
    el.innerHTML = acomodoPreviewDots(res);
  });
  const bn = $("ac-blk-n"); if(bn) bn.textContent = acomodoBloqueN;
}
function pulsoReacomodo(){
  const host = (cuarto === "observatorio") ? $("escena") : $("charola");
  if(!host || reduce) return;
  host.classList.remove("reacomodo"); void host.offsetWidth; host.classList.add("reacomodo");
}
/* Ronda 10 · el reacomodo se VE (peticion del fundador): la hoja se aparta y cada cuenta
   viaja de su lugar viejo al nuevo, con la misma alma de la transicion viva entre cuartos.
   La k-esima cuenta de cada mineral en el orden viejo viaja a su k-esima casa nueva. */
function mp8ViajeReacomodo(seqOld, seqNew){
  if(reduce){ pulsoReacomodo(); return; }
  const rects = mp8Rects(cuarto);
  const ro = readingOrder();
  const nuevasPor = {};
  for(let k = 0; k < seqNew.length; k++){ const m = seqNew[k]; if(m == null) continue; (nuevasPor[m] = nuevasPor[m] || []).push(k); }
  const usadas = {};
  const viajes = []; let seMueven = 0;
  for(let k = 0; k < seqOld.length; k++){
    const m = seqOld[k]; if(m == null) continue;
    const lista = nuevasPor[m] || [];
    const idx = (usadas[m] || 0); usadas[m] = idx + 1;
    const kNew = lista[idx]; if(kNew == null) continue;
    const a = rects.beads[ro[k]], b = rects.beads[ro[kNew]];
    if(!a || !b) continue;
    if(kNew !== k) seMueven++;
    viajes.push({ s:a, d:b, color: COL[m].c });
  }
  if(!seMueven){ pulsoReacomodo(); return; }
  const capa = document.createElement("div"); capa.className = "mp8-trans-capa";
  const block = document.createElement("div"); block.className = "mp8-trans-block";
  room.appendChild(block); room.appendChild(capa);
  $("app").setAttribute("data-mp8trans", "1");
  const DUR = 620, STAG = 140, total = viajes.length;
  const clones = [];
  viajes.forEach(function(v){
    const el = document.createElement("div");
    el.className = "mp8-trans-clon";
    el.style.left = (v.s.x - v.s.d / 2).toFixed(1) + "px";
    el.style.top = (v.s.y - v.s.d / 2).toFixed(1) + "px";
    el.style.width = v.s.d.toFixed(1) + "px";
    el.style.height = v.s.d.toFixed(1) + "px";
    el.style.background = v.color;
    capa.appendChild(el);
    clones.push({ el:el, dx:(v.d.x - v.s.x), dy:(v.d.y - v.s.y), sc:(v.d.d / v.s.d) });
  });
  const cm = centroMinActual();
  if(cm >= 0 && rects.centro){
    const c = rects.centro, el = document.createElement("div");
    el.className = "mp8-trans-clon mp8-clon-centro";
    el.style.left = (c.x - c.d / 2).toFixed(1) + "px";
    el.style.top = (c.y - c.d / 2).toFixed(1) + "px";
    el.style.width = c.d.toFixed(1) + "px";
    el.style.height = c.d.toFixed(1) + "px";
    el.style.background = COL[cm].c;
    capa.appendChild(el);
  }
  requestAnimationFrame(function(){
    requestAnimationFrame(function(){
      clones.forEach(function(c, k){
        const delay = total > 1 ? Math.round(k / (total - 1) * STAG) : 0;
        c.el.style.transition = "transform " + DUR + "ms cubic-bezier(.4,0,.2,1) " + delay + "ms";
        c.el.style.transform = "translate(" + c.dx.toFixed(1) + "px," + c.dy.toFixed(1) + "px) scale(" + c.sc.toFixed(3) + ")";
      });
    });
  });
  setTimeout(function(){
    $("app").removeAttribute("data-mp8trans");
    if(capa.parentNode) capa.parentNode.removeChild(capa);
    if(block.parentNode) block.parentNode.removeChild(block);
  }, DUR + STAG + 80);
}
function aplicaAcomodo(id){
  const seqOld = seqActual();
  if(seqOld.filter(function(x){ return x != null; }).length === 0) return;
  const seqNew = construyeAcomodo(id, seqOld);
  cerrarSheet();                                    // la hoja se aparta para VER el reacomodo
  reordenar(escribeSeq(seqNew));
  setTimeout(function(){ mp8ViajeReacomodo(seqOld, seqNew); }, 240);
}

/* ===== R5 · compartir / pegar un diseno (codigo compacto, sin red) ===== */
function b64urlEncode(str){
  const b = btoa(unescape(encodeURIComponent(str)));
  return b.replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}
function b64urlDecode(s){
  let t = s.replace(/-/g, "+").replace(/_/g, "/");
  while(t.length % 4) t += "=";
  return decodeURIComponent(escape(atob(t)));
}
function rleEncode(arr){
  const out = [];
  for(let i = 0; i < arr.length;){
    let j = i; while(j < arr.length && arr[j] === arr[i]) j++;
    out.push([arr[i] == null ? null : arr[i], j - i]);
    i = j;
  }
  return out;
}
function rleDecode(rle, N){
  const out = [];
  for(let i = 0; i < rle.length; i++){
    const pair = rle[i];
    if(!Array.isArray(pair) || pair.length !== 2) return null;
    const v = pair[0], c = pair[1];
    if(!Number.isInteger(c) || c < 0) return null;
    for(let k = 0; k < c; k++) out.push(v == null ? null : v);
  }
  return out.length === N ? out : null;
}
/* ===== Ronda 9 · IDENTIDAD PERPETUA (los minerales viajan por NOMBRE) =====
   El catalogo va a cambiar de tamano y orden; un codigo por indices se corromperia en silencio.
   Formato MP1 sch 2: dic:[nombres] + b = RLE de indices AL DICCIONARIO (compacto e inmune a
   reordenamientos); el centro c.m y el separador s por NOMBRE; el patron t por su valor
   estructural (el cm de la talla). dg = huella diagnostica informativa (no bloqueante).
   Se sigue leyendo el formato viejo v1 (por indices) como compatibilidad transitoria: los
   indices de HOY aun coinciden con el catalogo actual. */
let _NAME2IDX = null;
function mineralIdxPorNombre(){
  // se reconstruye siempre por si el catalogo cambia en memoria (test de reordenamiento)
  const map = {}; DATOS.minerales.forEach(function(m, i){ map[m.n] = i; });
  _NAME2IDX = map; return map;
}
function nameToMid(nm){ if(nm == null) return null; const i = mineralIdxPorNombre()[nm]; return (i == null) ? null : i; }
function midToName(mid){ return (mid == null || mid < 0 || mid >= DATOS.minerales.length) ? null : DATOS.minerales[mid].n; }

// R18 · F1: reconstruye sepPinta (overrides por slot) desde el bloque sq/sdic de un codigo sch3.
// Por NOMBRE (prueba de la corona): un separador que ya no vive queda como base. Null si no aplica.
function sqAPinta(obj, patIdx, sepIdx){
  if(!obj || obj.sch !== 3 || !Array.isArray(obj.sq) || !Array.isArray(obj.sdic)) return null;
  const nslots = sepSlotCountFor(patIdx);
  const ref = rleDecode(obj.sq, nslots);
  if(!ref) return null;
  const map = obj.sdic.map(function(nm){ return (typeof nm === "string") ? DATOS.separadores.findIndex(function(s){ return s.n === nm; }) : -1; });
  const pinta = new Array(nslots).fill(null);
  for(let k = 0; k < nslots; k++){
    const ri = ref[k];
    if(ri == null || !Number.isInteger(ri) || ri < 0 || ri >= map.length) continue;
    const j = map[ri];
    if(j >= 0 && j !== sepIdx) pinta[k] = j;   // igual al base = sin override
  }
  return pinta;
}
function codificaDiseno(){
  const dic = [], dicIdx = {};
  function refName(name){
    if(name == null) return null;
    if(dicIdx[name] == null){ dicIdx[name] = dic.length; dic.push(name); }
    return dicIdx[name];
  }
  const beadsRef = beads.map(function(mid){ return (mid == null) ? null : refName(DATOS.minerales[mid].n); });
  const cm = centroMinActual();
  const obj = {
    sch: 2,
    p: pieza,
    v: "gota",   // mp11: la pieza vive solo en gota; el campo se conserva por compat del esquema
    t: DATOS.patrones[patronIdx] ? DATOS.patrones[patronIdx].cm : null,   // valor estructural (cm), no indice
    s: (sepMineralIdx >= 0 && DATOS.separadores[sepMineralIdx]) ? DATOS.separadores[sepMineralIdx].n : null,
    c: { m: (cm >= 0 ? DATOS.minerales[cm].n : null), f: formaActual() },
    dic: dic,
    b: rleEncode(beadsRef),
    dg: DATOS.generado
  };
  // R18 · F1 · MP1 sch3: si hay separadores personalizados, el esquema se EXTIENDE con la secuencia de
  // separadores por NOMBRE (sdic + sq = RLE al diccionario, mismo mecanismo que las cuentas). Sin
  // overrides -> sch2 BYTE-IDENTICO (compatibilidad total hacia atras). Con overrides -> sch:3.
  if(pieza === "cod" && !sepPintaTodoNull()){
    const sdic = [], sdicIdx = {};
    const nslots = sepSlotCount();
    const seqRef = [];
    for(let k = 0; k < nslots; k++){
      const nm = sepDeSlot(k).n;
      if(sdicIdx[nm] == null){ sdicIdx[nm] = sdic.length; sdic.push(nm); }
      seqRef.push(sdicIdx[nm]);
    }
    obj.sch = 3;                 // (misma posicion; setear una clave existente no la reordena)
    obj.sdic = sdic;             // sdic y sq se anexan al final, tras dg
    obj.sq = rleEncode(seqRef);
  }
  return "MP1." + b64urlEncode(JSON.stringify(obj));
}
// re-codifica un codigo viejo v1 (por indices, validos HOY) a sch 2 (por nombre), sin tocar el estado
function recodificaAsch2(code){
  const s = String(code || "").replace(/\s+/g, "");
  if(s.indexOf("MP1.") !== 0) return code;
  let obj; try{ obj = JSON.parse(b64urlDecode(s.slice(4))); }catch(_){ return code; }
  if(!obj || typeof obj !== "object") return code;
  if(obj.sch === 2 || obj.sch === 3) return code;      // ya viaja por nombre (sch2/sch3)
  if(obj.p !== "cod" && obj.p !== "japa") return code;
  const N = CFG[obj.p].N;
  const body = rleDecode(obj.b, N);
  if(!body) return code;
  const dic = [], dicIdx = {};
  function refIdx(mid){
    if(mid == null || mid < 0 || mid >= DATOS.minerales.length) return null;
    const nm = DATOS.minerales[mid].n;
    if(dicIdx[nm] == null){ dicIdx[nm] = dic.length; dic.push(nm); }
    return dicIdx[nm];
  }
  const beadsRef = body.map(refIdx);
  const c = (obj.c && typeof obj.c === "object") ? obj.c : {};
  const out = {
    sch: 2, p: obj.p, v: "gota",   // mp11: se reescribe siempre a gota (la enrollada murio)
    t: (Number.isInteger(obj.t) && DATOS.patrones[obj.t]) ? DATOS.patrones[obj.t].cm : null,
    s: (Number.isInteger(obj.s) && DATOS.separadores[obj.s]) ? DATOS.separadores[obj.s].n : null,
    c: { m: (Number.isInteger(c.m) && DATOS.minerales[c.m]) ? DATOS.minerales[c.m].n : null, f: c.f },
    dic: dic, b: rleEncode(beadsRef), dg: DATOS.generado
  };
  return "MP1." + b64urlEncode(JSON.stringify(out));
}
function aplicaDisenoCodigo(raw){
  const s = String(raw || "").replace(/\s+/g, "");
  if(s.indexOf("MP1.") !== 0) return false;
  let obj;
  try{ obj = JSON.parse(b64urlDecode(s.slice(4))); }catch(_){ return false; }
  if(!obj || typeof obj !== "object") return false;
  return (obj.sch === 2 || obj.sch === 3) ? aplicaSch2(obj) : aplicaV1(obj);   // R18 · F1: sch3 abre por la misma puerta que sch2
}
// sch 2 / sch 3: resuelve nombres contra el catalogo ACTUAL; un nombre desconocido deja ese espacio vacio
function aplicaSch2(obj){
  if(obj.p !== "cod" && obj.p !== "japa") return false;
  if(obj.v !== "gota" && obj.v !== "enrollada") return false;
  if(!Array.isArray(obj.dic) || !Array.isArray(obj.b)) return false;
  const N = CFG[obj.p].N;
  const refBody = rleDecode(obj.b, N);
  if(!refBody) return false;
  const dicMid = obj.dic.map(function(nm){ return (typeof nm === "string") ? nameToMid(nm) : null; });
  let huboFantasma = false;
  const body = new Array(N).fill(null);
  for(let i = 0; i < N; i++){
    const ref = refBody[i];
    if(ref == null) continue;
    if(!Number.isInteger(ref) || ref < 0 || ref >= dicMid.length) return false;   // codigo mal formado
    const mid = dicMid[ref];
    if(mid == null){ huboFantasma = true; }                                        // cuenta que ya no vive en el catalogo
    else body[i] = mid;
  }
  // patron por su valor estructural (el cm de la talla)
  let patIdx = patronIdx;
  if(obj.t != null){ const j = DATOS.patrones.findIndex(function(p){ return String(p.cm) === String(obj.t); }); if(j >= 0) patIdx = j; else patIdx = 0; }
  // separador por nombre
  let sepIdx = sepMineralIdx;
  if(obj.s != null){ const j = DATOS.separadores.findIndex(function(x){ return x.n === obj.s; }); if(j >= 0) sepIdx = j; }
  // centro por nombre
  const c = (obj.c && typeof obj.c === "object") ? obj.c : {};
  const formasCod = ["icosaedro", "c10", "c12", "flanqueada"];
  const forma = obj.p === "japa" ? "guru" : (formasCod.indexOf(c.f) >= 0 ? c.f : "icosaedro");
  const cm = (c.m != null) ? nameToMid(c.m) : null;
  // R18 · F1 · sch3: la secuencia de separadores por slot (por nombre); sch2 la deja en null (uniforme)
  const pinta = (obj.p === "cod") ? sqAPinta(obj, patIdx, sepIdx) : null;
  aplicaEstadoDiseno(obj.p, obj.v, patIdx, sepIdx, body, forma, (cm != null && cm >= 0) ? cm : -1, pinta);
  if(huboFantasma) mp9AvisoFantasma();
  return true;
}
// v1: compatibilidad transitoria (indices posicionales; validos mientras el catalogo no cambie)
function aplicaV1(obj){
  if(obj.p !== "cod" && obj.p !== "japa") return false;
  if(obj.v !== "gota" && obj.v !== "enrollada") return false;
  const N = CFG[obj.p].N;
  if(!Number.isInteger(obj.t) || obj.t < 0 || obj.t >= DATOS.patrones.length) return false;
  if(!Number.isInteger(obj.s) || obj.s < 0 || obj.s >= DATOS.separadores.length) return false;
  if(!Array.isArray(obj.b)) return false;
  const body = rleDecode(obj.b, N);
  if(!body) return false;
  for(let i = 0; i < body.length; i++){
    const v = body[i];
    if(v !== null && (!Number.isInteger(v) || v < 0 || v >= DATOS.minerales.length)) return false;
  }
  const c = (obj.c && typeof obj.c === "object") ? obj.c : {};
  const formasCod = ["icosaedro", "c10", "c12", "flanqueada"];
  const forma = obj.p === "japa" ? "guru" : (formasCod.indexOf(c.f) >= 0 ? c.f : "icosaedro");
  const cm = (Number.isInteger(c.m) && c.m >= 0 && c.m < DATOS.minerales.length) ? c.m : -1;
  aplicaEstadoDiseno(obj.p, obj.v, obj.t, obj.s, body, forma, cm);
  return true;
}
// arma la pieza exacta como UN paso de deshacer (compartido por sch 2, sch 3 y v1)
function aplicaEstadoDiseno(p, v, patIdx, sepIdx, body, forma, cm, pinta){
  pushUndo();
  pieza = p;
  vista = "gota";   // mp11: el codigo puede traer v:"gota"|"enrollada"; se ignora y todo abre en gota
  patronIdx = patIdx;
  sepMineralIdx = sepIdx;
  sepPinta = (p === "cod" && Array.isArray(pinta)) ? pinta.slice() : [];   // R18 · F1
  sepBrush = -1;                                                            // R18 · F1: un codigo nunca trae pincel de sep activo
  beads = body.slice();
  centroForma = (p === "japa") ? "icosaedro" : forma;
  centroManual = { icosaedro:null, c10:null, c12:null, flanqueada:null, guru:null };
  if(cm >= 0) centroManual[forma] = cm;
  tocada = body.some(function(x){ return x != null; });
  degTono = false;   // Ronda 15b: un codigo/diseno compartido nunca trae el degradado (MP1 sch2 intacto)
  brush = -1;
  zoom = 1; panX = 0; panY = 0;
  mp13SyncFill(); syncComplete();
  actualizaPiezaChip();
  renderContexto(); renderMesa(); renderCuarto(); updateCotizacion();
  marcaCambio();
}
function compartirDiseno(){
  const code = codificaDiseno();
  const out = $("share-out"), msg = $("share-msg");
  if(out){ out.hidden = false; out.value = code; try{ out.focus(); out.select(); }catch(_){} }
  const ok = "Tu diseño quedó copiado. Compártelo o guárdalo: pegarlo aquí lo vuelve a armar.";
  function marca(){ if(msg){ msg.hidden = false; msg.className = "comp-msg ok"; msg.textContent = ok; } }
  if(navigator.share){
    navigator.share({ text: code }).then(marca).catch(function(){ copiaPortapapeles(code, marca); });
  } else {
    copiaPortapapeles(code, marca);
  }
}
function copiaPortapapeles(code, done){
  if(navigator.clipboard && navigator.clipboard.writeText){
    navigator.clipboard.writeText(code).then(done).catch(function(){ done(); });
  } else {
    // respaldo: el codigo ya vive seleccionable en #share-out
    try{ document.execCommand("copy"); }catch(_){}
    done();
  }
}
function pegarDiseno(){
  const inp = $("paste-in"), msg = $("paste-msg");
  const val = inp ? inp.value : "";
  if(aplicaDisenoCodigo(val)){
    if(msg){ msg.hidden = false; msg.className = "comp-msg ok"; msg.textContent = "Diseño armado. Aquí lo tienes tal cual."; }
    if(inp) inp.value = "";
  } else {
    if(msg){ msg.hidden = false; msg.className = "comp-msg err"; msg.textContent = "Ese código no se reconoce; revisa que esté completo."; }
  }
}

/* Ronda 10: el calibrador de tamano real con tarjeta se retiro por decision del fundador. */

/* =====================================================================
   RONDA 12 · las 3 piezas de experiencia
   1) La estampa   2) La puerta de la intencion   3) La pieza a tamano real
   ===================================================================== */

/* ---- iconos ---- */
const MP12_ICO = {
  estampa: '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="3" y="4" width="18" height="15" rx="2"/><circle cx="8.5" cy="9" r="1.6"/><path d="M4 17l4.5-4.5 3 3L16 10l4 5"/></svg>',
  real: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 8V4h4M17 4h4v4M21 16v4h-4M7 20H3v-4"/><path d="M8 12h8"/><path d="M8 10v4M16 10v4"/></svg>',
  intencion: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3l2.2 5.6L20 9.3l-4.4 3.7L17 19l-5-3.2L7 19l1.4-6L4 9.3l5.8-.7z"/></svg>'
};

/* ---- estado px/mm (calibracion con la tarjeta) ---- */
const LS_PXMM = "mp_cotizador_pxmm_v1";
const MP12_CARD_MM = 53.98;        // ancho de una tarjeta de pie (lado corto)
const MP12_CARD_LARGO_MM = 85.60;  // largo de la tarjeta (lado largo)
const MP12_PXMM_DEFAULT = 3.7795;  // 1 mm = 96/25.4 px CSS
function mp12LeePxmm(){
  try{ const v = parseFloat(localStorage.getItem(LS_PXMM)); return (isFinite(v) && v > 0.5) ? v : null; }catch(_){ return null; }
}
function mp12GuardaPxmm(v){ try{ localStorage.setItem(LS_PXMM, String(v)); }catch(_){} }

/* ---- fuentes en canvas ---- */
let _mp12Fraunces = false, _mp12Hanken = false;
function mp12ChecaFuentes(){
  try{
    _mp12Fraunces = document.fonts.check('500 40px "Fraunces"');
    _mp12Hanken = document.fonts.check('400 30px "Hanken Grotesk"');
  }catch(_){ _mp12Fraunces = false; _mp12Hanken = false; }
}
function mp12FontD(px, ital){ const f = _mp12Fraunces ? '"Fraunces"' : 'Georgia'; return (ital ? "italic " : "") + "500 " + px + 'px ' + f + ", Georgia, serif"; }
function mp12FontT(px, w){ const f = _mp12Hanken ? '"Hanken Grotesk"' : 'sans-serif'; return (w || "400") + " " + px + "px " + f + ", -apple-system, sans-serif"; }

/* ---- precarga de retratos a <img> (cache propia) ---- */
const _mp12Img = {};
function mp12Preload(names, done){
  const uniq = []; const seen = {};
  names.forEach(function(n){ if(n && !seen[n]){ seen[n] = 1; uniq.push(n); } });
  let pend = uniq.length; const out = {};
  if(!pend){ done(out); return; }
  uniq.forEach(function(nm){
    if(_mp12Img[nm]){ out[nm] = _mp12Img[nm]; if(--pend === 0) done(out); return; }
    const r = RETRATOS[nm];
    if(!r || !r.uri){ if(--pend === 0) done(out); return; }
    const img = new Image();
    img.onload = function(){ _mp12Img[nm] = img; out[nm] = img; if(--pend === 0) done(out); };
    img.onerror = function(){ if(--pend === 0) done(out); };
    img.src = r.uri;
  });
}

/* ---- lee un diseno (codigo MP1 o el estado actual) a un objeto plano, sin tocar el estado ---- */
function mp12DisenoActual(){
  return { pieza:pieza, beads:beads.slice(), patronIdx:patronIdx, sepMineralIdx:sepMineralIdx,
    sepPinta:(Array.isArray(sepPinta) ? sepPinta.slice() : []),   // R18 · F1
    forma:formaActual(), centroMid:centroMinActual() };
}
function mp12LeeDiseno(code){
  const s = String(code || "").replace(/\s+/g, "");
  if(s.indexOf("MP1.") !== 0) return null;
  let obj; try{ obj = JSON.parse(b64urlDecode(s.slice(4))); }catch(_){ return null; }
  if(!obj || typeof obj !== "object") return null;
  const p = (obj.p === "japa") ? "japa" : (obj.p === "cod" ? "cod" : null);
  if(!p) return null;
  const N = CFG[p].N;
  let body, patIdx = 0, sepIdx = sepMineralIdx, forma, centroMid = -1, pinta = null;
  if(obj.sch === 2 || obj.sch === 3){
    const refBody = rleDecode(obj.b, N); if(!refBody) return null;
    const dicMid = (obj.dic || []).map(function(nm){ return (typeof nm === "string") ? nameToMid(nm) : null; });
    body = new Array(N).fill(null);
    for(let i = 0; i < N; i++){ const ref = refBody[i]; if(ref == null) continue; if(Number.isInteger(ref) && ref >= 0 && ref < dicMid.length && dicMid[ref] != null) body[i] = dicMid[ref]; }
    if(obj.t != null){ const j = DATOS.patrones.findIndex(function(x){ return String(x.cm) === String(obj.t); }); patIdx = j >= 0 ? j : 0; }
    if(obj.s != null){ const j = DATOS.separadores.findIndex(function(x){ return x.n === obj.s; }); if(j >= 0) sepIdx = j; }
    const c = (obj.c && typeof obj.c === "object") ? obj.c : {};
    const formasCod = ["icosaedro", "c10", "c12", "flanqueada"];
    forma = p === "japa" ? "guru" : (formasCod.indexOf(c.f) >= 0 ? c.f : "icosaedro");
    if(c.m != null){ const m = nameToMid(c.m); if(m != null) centroMid = m; }
    if(p === "cod") pinta = sqAPinta(obj, patIdx, sepIdx);   // R18 · F1: overrides de separador (sch3)
  } else {
    body = rleDecode(obj.b, N); if(!body) return null;
    body = body.map(function(v){ return (Number.isInteger(v) && v >= 0 && v < DATOS.minerales.length) ? v : null; });
    if(Number.isInteger(obj.t) && DATOS.patrones[obj.t]) patIdx = obj.t;
    if(Number.isInteger(obj.s) && DATOS.separadores[obj.s]) sepIdx = obj.s;
    const c = (obj.c && typeof obj.c === "object") ? obj.c : {};
    const formasCod = ["icosaedro", "c10", "c12", "flanqueada"];
    forma = p === "japa" ? "guru" : (formasCod.indexOf(c.f) >= 0 ? c.f : "icosaedro");
    if(Number.isInteger(c.m) && c.m >= 0 && c.m < DATOS.minerales.length) centroMid = c.m;
  }
  return { pieza:p, beads:body, patronIdx:patIdx, sepMineralIdx:sepIdx, sepPinta:pinta, forma:forma, centroMid:centroMid };
}
function mp12NombresDe(d){
  const out = [];
  d.beads.forEach(function(mid){ if(mid != null) out.push(DATOS.minerales[mid].n); });
  const sm = DATOS.separadores[d.sepMineralIdx]; if(sm) out.push(sm.n);
  if(Array.isArray(d.sepPinta)){ d.sepPinta.forEach(function(si){ if(si != null && DATOS.separadores[si]) out.push(DATOS.separadores[si].n); }); }   // R18 · F1: retratos de los separadores override
  if(d.centroMid != null && d.centroMid >= 0) out.push(DATOS.minerales[d.centroMid].n);
  return out;
}
// corre fn() con el estado global temporalmente puesto en el diseno d (sincrono; restaura siempre)
function mp12ConDiseno(d, fn){
  const save = { pieza:pieza, patronIdx:patronIdx, sepMineralIdx:sepMineralIdx, sepPinta:sepPinta, centroForma:centroForma, centroManual:centroManual, beads:beads, vista:vista };
  pieza = d.pieza; patronIdx = d.patronIdx; sepMineralIdx = d.sepMineralIdx; vista = "gota";
  sepPinta = Array.isArray(d.sepPinta) ? d.sepPinta.slice() : [];   // R18 · F1: los overrides de separador del diseno
  centroForma = (d.pieza === "cod" && !mpFormaSinLista(d.forma)) ? d.forma : "icosaedro";   // parche gen (cotizador-c12-fuera): la estampa de un guardado en 12 mm, con el icosaedro
  centroManual = { icosaedro:null, c10:null, c12:null, flanqueada:null, guru:null };
  if(d.centroMid != null && d.centroMid >= 0) centroManual[d.forma] = d.centroMid;
  beads = d.beads.slice();
  let out;
  try{ out = fn(); }
  finally{
    pieza = save.pieza; patronIdx = save.patronIdx; sepMineralIdx = save.sepMineralIdx; sepPinta = save.sepPinta;
    centroForma = save.centroForma; centroManual = save.centroManual; beads = save.beads; vista = save.vista;
  }
  return out;
}

/* ---- voz de un cuerpo cualquiera (sin tocar el estado): "Habla de X y Y." ---- */
function mp12VozDe(beadsArr, max, d){
  const w = {};
  beadsArr.forEach(function(mid){ if(mid == null) return; const m = DATOS.minerales[mid]; if(!m.intenciones) return; m.intenciones.forEach(function(x){ w[x] = (w[x] || 0) + 1; }); });
  if(!Object.keys(w).length) return null;
  // Ronda 15: los separadores tambien suman (peso 0.125 por separador, la razon real de volumen)
  const p = (d && d.pieza) ? d.pieza : pieza;
  if(p === "cod"){
    pesoSeparadores(w,
      (d && d.patronIdx != null) ? d.patronIdx : patronIdx,
      (d && d.sepMineralIdx != null) ? d.sepMineralIdx : sepMineralIdx,
      (d && d.forma) ? d.forma : formaActual(),
      (d && Array.isArray(d.sepPinta)) ? d.sepPinta : sepPinta);
  }
  const keys = Object.keys(w); if(!keys.length) return null;
  keys.sort(function(a, b){ return w[b] - w[a] || a.localeCompare(b, "es"); });
  const top = keys.slice(0, max || 2).map(function(x){ return x.toLowerCase(); });
  let frase;
  if(top.length === 1) frase = top[0];
  else if(top.length === 2) frase = top[0] + " y " + top[1];
  else frase = top[0] + ", " + top[1] + " y " + top[2];
  return "Habla de " + frase + ".";
}

/* ---- geometria: caja que abarca la pieza en el layout (para escalar y centrar) ---- */
function mp12Bbox(L){
  const N = CFG[pieza].N, r = L.D / 2;
  let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
  for(let i = 0; i < N; i++){
    const n = L.nodes[i];
    if(n.x - r < minX) minX = n.x - r; if(n.x + r > maxX) maxX = n.x + r;
    if(n.y - r < minY) minY = n.y - r; if(n.y + r > maxY) maxY = n.y + r;
  }
  const pr = L.principalD / 2;
  if(L.cx - pr < minX) minX = L.cx - pr; if(L.cx + pr > maxX) maxX = L.cx + pr;
  const halo = L.principalD * 0.14;
  if(L.principalY - pr - halo < minY) minY = L.principalY - pr - halo;
  if(L.principalY + pr > maxY) maxY = L.principalY + pr;
  const sr = Math.max(6, L.D * 0.5) / 2;   // Ronda 15: el separador mide 0.5 del diametro de cuenta
  (L.seps || []).forEach(function(p){ if(p.x - sr < minX) minX = p.x - sr; if(p.x + sr > maxX) maxX = p.x + sr; if(p.y - sr < minY) minY = p.y - sr; if(p.y + sr > maxY) maxY = p.y + sr; });
  if(pieza === "japa"){ const bottom = L.principalY + L.principalD * (0.42 + 0.9); if(bottom > maxY) maxY = bottom; }
  return { minX:minX, minY:minY, maxX:maxX, maxY:maxY };
}

/* ---- dibujo de una cuenta con su retrato real (o gradiente de respaldo) ---- */
function mp12Bead(ctx, x, y, D, mid, imgs, k){
  const r = D / 2;
  ctx.save();
  ctx.beginPath(); ctx.arc(x, y, r, 0, Math.PI * 2); ctx.closePath(); ctx.clip();
  const nm = DATOS.minerales[mid].n, img = imgs[nm];
  if(img && img.width){ ctx.drawImage(img, x - r, y - r, D, D); }
  else {
    const col = COL[mid] || { c:"#6b6258", hi:"#928a80", sh:"#4a423a" };
    const g = ctx.createRadialGradient(x - r * 0.34, y - r * 0.4, r * 0.1, x, y, r);
    g.addColorStop(0, col.hi || col.c); g.addColorStop(0.58, col.c); g.addColorStop(1, col.sh || col.c);
    ctx.fillStyle = g; ctx.fillRect(x - r, y - r, D, D);
  }
  ctx.restore();
  ctx.save();
  ctx.beginPath(); ctx.arc(x, y, r, 0, Math.PI * 2);
  const sg = ctx.createRadialGradient(x - r * 0.34, y - r * 0.42, r * 0.05, x, y, r);
  sg.addColorStop(0, "rgba(255,255,255,.30)"); sg.addColorStop(0.34, "rgba(255,255,255,0)");
  sg.addColorStop(0.8, "rgba(0,0,0,0)"); sg.addColorStop(1, "rgba(0,0,0,.36)");
  ctx.fillStyle = sg; ctx.fill();
  ctx.lineWidth = Math.max(0.5 / k, D * 0.028); ctx.strokeStyle = "rgba(0,0,0,.42)"; ctx.stroke();
  ctx.restore();
}
/* Ronda 15: el separador es una ESFERA con el retrato real (misma luz/sombra que las cuentas) */
function mp15SepBead(ctx, x, y, D, name, imgs, k){
  const r = D / 2;
  ctx.save();
  ctx.beginPath(); ctx.arc(x, y, r, 0, Math.PI * 2); ctx.closePath(); ctx.clip();
  const img = imgs && imgs[name];
  if(img && img.width){ ctx.drawImage(img, x - r, y - r, D, D); }
  else {
    const s = RETRATOS[name] || { c:"#8a8078", hi:"#b3aaa1", sh:"#5e564e" };
    const g = ctx.createRadialGradient(x - r * 0.34, y - r * 0.4, r * 0.1, x, y, r);
    g.addColorStop(0, s.hi || s.c); g.addColorStop(0.58, s.c); g.addColorStop(1, s.sh || s.c);
    ctx.fillStyle = g; ctx.fillRect(x - r, y - r, D, D);
  }
  ctx.restore();
  ctx.save();
  ctx.beginPath(); ctx.arc(x, y, r, 0, Math.PI * 2);
  const sg = ctx.createRadialGradient(x - r * 0.34, y - r * 0.42, r * 0.05, x, y, r);
  sg.addColorStop(0, "rgba(255,255,255,.30)"); sg.addColorStop(0.34, "rgba(255,255,255,0)");
  sg.addColorStop(0.8, "rgba(0,0,0,0)"); sg.addColorStop(1, "rgba(0,0,0,.36)");
  ctx.fillStyle = sg; ctx.fill();
  ctx.lineWidth = Math.max(0.4 / k, D * 0.03); ctx.strokeStyle = "rgba(0,0,0,.42)"; ctx.stroke();
  ctx.restore();
}
/* ---- dibujo del centro (icosaedro / c10 / c12 / gurus / flanqueada) ---- */
function mp12Principal(ctx, L, imgs, k){
  const cm = centroMinActual();
  if(cm < 0) return;
  const esCod = pieza === "cod";
  const forma = formaActual();
  const x = L.cx, y = L.principalY, D = L.principalD, r = D / 2;
  const nm = DATOS.minerales[cm].n, img = imgs[nm], col = COL[cm] || { c:"#6b6258", hi:"#928a80", sh:"#4a423a" };
  function bola(cx, cy, dd){
    const rr = dd / 2;
    ctx.save(); ctx.beginPath(); ctx.arc(cx, cy, rr, 0, Math.PI * 2); ctx.clip();
    if(img && img.width) ctx.drawImage(img, cx - rr, cy - rr, dd, dd);
    else { const g = ctx.createRadialGradient(cx - rr * 0.34, cy - rr * 0.4, rr * 0.1, cx, cy, rr); g.addColorStop(0, col.hi || col.c); g.addColorStop(0.58, col.c); g.addColorStop(1, col.sh || col.c); ctx.fillStyle = g; ctx.fillRect(cx - rr, cy - rr, dd, dd); }
    ctx.restore();
    ctx.save(); ctx.beginPath(); ctx.arc(cx, cy, rr, 0, Math.PI * 2);
    const sg = ctx.createRadialGradient(cx - rr * 0.34, cy - rr * 0.42, rr * 0.05, cx, cy, rr);
    sg.addColorStop(0, "rgba(255,255,255,.30)"); sg.addColorStop(0.34, "rgba(255,255,255,0)"); sg.addColorStop(0.82, "rgba(0,0,0,0)"); sg.addColorStop(1, "rgba(0,0,0,.34)");
    ctx.fillStyle = sg; ctx.fill(); ctx.lineWidth = Math.max(0.6 / k, dd * 0.02); ctx.strokeStyle = "rgba(0,0,0,.4)"; ctx.stroke(); ctx.restore();
  }
  // borla del japa (bajo la gurus)
  if(!esCod){
    const bw = D * 0.5, bh = D * 0.9, topB = y + D * 0.42;
    ctx.save(); ctx.strokeStyle = "rgba(201,169,97,.85)"; ctx.lineCap = "round";
    ctx.lineWidth = Math.max(0.8 / k, bw * 0.09);
    const hs = [bh * 0.78, bh, bh * 0.88, bh * 0.7];
    hs.forEach(function(hh, i){ const hx = x - bw / 2 + (i + 0.5) * (bw / hs.length); ctx.beginPath(); ctx.moveTo(hx, topB); ctx.lineTo(hx, topB + hh); ctx.stroke(); });
    ctx.restore();
  }
  if(esCod && forma === "icosaedro"){
    // aro dorado + gema angular con retrato
    ctx.save(); ctx.beginPath(); ctx.arc(x, y, r + D * 0.14, 0, Math.PI * 2); ctx.strokeStyle = "rgba(201,169,97,.5)"; ctx.lineWidth = Math.max(0.7 / k, D * 0.02); ctx.stroke(); ctx.restore();
    const gw = D * 0.92, rad = gw * 0.14, gx = x - gw / 2, gy = y - gw / 2;
    ctx.save();
    ctx.beginPath();
    ctx.moveTo(gx + rad, gy); ctx.arcTo(gx + gw, gy, gx + gw, gy + gw, rad); ctx.arcTo(gx + gw, gy + gw, gx, gy + gw, rad); ctx.arcTo(gx, gy + gw, gx, gy, rad); ctx.arcTo(gx, gy, gx + gw, gy, rad); ctx.closePath();
    ctx.clip();
    if(img && img.width) ctx.drawImage(img, gx, gy, gw, gw);
    else { const g = ctx.createRadialGradient(x - gw * 0.18, y - gw * 0.2, gw * 0.08, x, y, gw * 0.6); g.addColorStop(0, col.hi || col.c); g.addColorStop(0.58, col.c); g.addColorStop(1, col.sh || col.c); ctx.fillStyle = g; ctx.fillRect(gx, gy, gw, gw); }
    // facetas
    ctx.fillStyle = "rgba(255,255,255,.14)"; ctx.beginPath(); ctx.moveTo(x, gy); ctx.lineTo(x, gy + gw); ctx.lineTo(gx + gw * 0.07, gy + gw * 0.75); ctx.lineTo(gx + gw * 0.07, gy + gw * 0.25); ctx.closePath(); ctx.fill();
    ctx.fillStyle = "rgba(0,0,0,.16)"; ctx.beginPath(); ctx.moveTo(x, gy); ctx.lineTo(gx + gw * 0.93, gy + gw * 0.25); ctx.lineTo(gx + gw * 0.93, gy + gw * 0.75); ctx.lineTo(x, gy + gw); ctx.closePath(); ctx.fill();
    ctx.restore();
  } else if(esCod && forma === "flanqueada"){
    // Ronda 15: geometria real. La central es una cuenta de 8 mm (= diametro del cuerpo) y los
    // separadores de 4 mm (mitad) van tangentes a cada lado sobre la linea del hilo, completos
    // y visibles: distancia entre centros = Dc/2 + Ds/2. Orden de pintado: separadores primero,
    // la cuenta central al final (el cuerpo ya quedo pintado antes en mp12DibujaPieza).
    const Dc = L.D, Ds = L.D * 0.5, off = (Dc + Ds) / 2, sm = DATOS.separadores[sepMineralIdx];
    if(sm){ mp15SepBead(ctx, x - off, y, Ds, sm.n, imgs, k); mp15SepBead(ctx, x + off, y, Ds, sm.n, imgs, k); }
    bola(x, y, Dc);
  } else {
    // c10 / c12 (cod) o gurus (japa): bola con retrato; Ronda 15: en cod, a su diametro real
    if(!esCod){ ctx.save(); ctx.beginPath(); ctx.arc(x, y, r + D * 0.1, 0, Math.PI * 2); ctx.strokeStyle = "rgba(201,169,97,.45)"; ctx.lineWidth = Math.max(0.7 / k, D * 0.02); ctx.stroke(); ctx.restore(); }
    const dd = esCod ? (forma === "c10" ? L.D * 1.25 : L.D * 1.5) : D;
    bola(x, y, dd);
  }
}

/* ---- dibuja la pieza completa (hilo + separadores + cuentas + centro) en el ctx ---- */
/* debe llamarse con el estado global ya puesto (mp12ConDiseno) ---- */
function mp12DibujaPieza(ctx, L, imgs, tx, ty, k){
  const N = CFG[pieza].N;
  ctx.save();
  // Ronda 15: transform COMPUESTA (respeta el scale de devicePixelRatio del canvas fisico)
  ctx.transform(k, 0, 0, k, tx, ty);
  ctx.lineJoin = "round"; ctx.lineCap = "round";
  // hilo
  try{ const path = new Path2D(L.paths[0]); ctx.lineWidth = 1.3 / k; ctx.strokeStyle = "rgba(201,169,97,.36)"; ctx.stroke(path); }catch(_){}
  // cuentas del cuerpo
  for(let i = 0; i < N; i++){ if(beads[i] != null) mp12Bead(ctx, L.nodes[i].x, L.nodes[i].y, L.D, beads[i], imgs, k); }
  // Ronda 15: separadores DESPUES de las cuentas (esferas de 4 mm reales = 0.5 del diametro de cuenta)
  // R18 · F1: cada slot con su propio mineral (override o base)
  if(pieza === "cod"){ sepPintaSane(); const sd = Math.max(6, L.D * 0.5); (L.seps || []).forEach(function(p, si){ mp15SepBead(ctx, p.x, p.y, sd, sepDeSlot(si).n, imgs, k); }); }
  // centro (al final, encima)
  mp12Principal(ctx, L, imgs, k);
  ctx.restore();
}

/* =========================== 1 · LA ESTAMPA =========================== */
let _mp12Est = { nombre:"Tu pieza", voz:null, code:"" };
function mp12EstMsg(txt){ const el = $("mp12-est-msg"); if(!el) return; if(!txt){ el.hidden = true; el.textContent = ""; return; } el.hidden = false; el.textContent = txt; }
function mp12EstTexto(){
  const L = [];
  L.push((_mp12Est.nombre || "Tu pieza") + " · mi pieza en Mamapachita.");
  if(_mp12Est.voz) L.push(_mp12Est.voz);
  L.push("Ábrelo en el cotizador con este código: " + _mp12Est.code);
  L.push("Diseña la tuya en el Taller: https://mamapachita.com/pages/taller");
  return L.join("\n");
}
function mp12FondoCasa(ctx, W, H){
  const g = ctx.createRadialGradient(W / 2, H * 0.02, 80, W / 2, H * 0.52, H * 0.92);
  g.addColorStop(0, "#241F1B"); g.addColorStop(0.62, "#1A1714"); g.addColorStop(1, "#141110");
  ctx.fillStyle = g; ctx.fillRect(0, 0, W, H);
  // textura sutil (puntos tenues deterministas)
  let s = 987654321;
  function rnd(){ s = (s * 1664525 + 1013904223) & 0x7fffffff; return s / 0x7fffffff; }
  for(let i = 0; i < 1500; i++){ const x = rnd() * W, y = rnd() * H, a = rnd() * 0.02; ctx.fillStyle = "rgba(201,169,97," + a.toFixed(3) + ")"; ctx.fillRect(x, y, 1.6, 1.6); }
  // marco tenue
  ctx.strokeStyle = "rgba(201,169,97,.18)"; ctx.lineWidth = 2;
  const m = 24, rr = 26, x0 = m, y0 = m, x1 = W - m, y1 = H - m;
  ctx.beginPath(); ctx.moveTo(x0 + rr, y0); ctx.arcTo(x1, y0, x1, y1, rr); ctx.arcTo(x1, y1, x0, y1, rr); ctx.arcTo(x0, y1, x0, y0, rr); ctx.arcTo(x0, y0, x1, y0, rr); ctx.closePath(); ctx.stroke();
}
function mp12WrapText(ctx, text, cx, y, maxW, lh){
  const words = String(text || "").split(" "); let line = "", yy = y;
  for(let n = 0; n < words.length; n++){
    const test = line ? line + " " + words[n] : words[n];
    if(ctx.measureText(test).width > maxW && line){ ctx.fillText(line, cx, yy); line = words[n]; yy += lh; }
    else line = test;
  }
  if(line) ctx.fillText(line, cx, yy);
  return yy;
}
function mp12EstDibuja(d, nombre, voz, precioTxt){
  const cv = $("mp12-est-canvas"), W = 1080, H = 1350;
  cv.width = W; cv.height = H;
  const ctx = cv.getContext("2d");
  ctx.setTransform(1, 0, 0, 1, 0, 0);
  mp12FondoCasa(ctx, W, H);
  const names = mp12NombresDe(d);
  mp12Preload(names, function(imgs){
    mp12ConDiseno(d, function(){
      const L = layoutGota(1000, 1000, { top:30, bottom:30, left:30, right:30 });
      const bb = mp12Bbox(L);
      const areaX = 118, areaY = 150, areaW = W - 236, areaH = 720;
      const bw = (bb.maxX - bb.minX) || 1, bh = (bb.maxY - bb.minY) || 1;
      const k = Math.min(areaW / bw, areaH / bh);
      const cw = bw * k, ch = bh * k;
      const tx = areaX + (areaW - cw) / 2 - bb.minX * k;
      const ty = areaY + (areaH - ch) / 2 - bb.minY * k;
      mp12DibujaPieza(ctx, L, imgs, tx, ty, k);
    });
    // textos (identidad de la casa)
    ctx.setTransform(1, 0, 0, 1, 0, 0);
    ctx.textAlign = "center"; ctx.textBaseline = "alphabetic";
    ctx.fillStyle = "#F3EFE9"; ctx.font = mp12FontD(56, true);
    ctx.fillText(nombre || "Tu pieza", W / 2, 972);
    let yy = 972;
    if(voz){ ctx.fillStyle = "rgba(243,239,233,.72)"; ctx.font = mp12FontT(30, "400"); yy = mp12WrapText(ctx, voz, W / 2, 1024, W - 240, 40); }
    // Ronda 15: la linea del separador, chica bajo la voz
    const sepVoz = mp15SepVoz(d.patronIdx, d.sepMineralIdx, d.pieza, d.sepPinta);
    if(sepVoz){ ctx.fillStyle = "rgba(243,239,233,.55)"; ctx.font = mp12FontT(24, "400"); yy += 36; ctx.fillText(sepVoz, W / 2, yy); }
    if(precioTxt){ ctx.fillStyle = "#C9A961"; ctx.font = mp12FontD(34, true); ctx.fillText(precioTxt, W / 2, Math.max(1092, yy + 54)); }
    ctx.fillStyle = "#DCC188"; ctx.font = mp12FontD(42, false); ctx.fillText("Mamapachita", W / 2, 1220);
    ctx.fillStyle = "rgba(243,239,233,.58)"; ctx.font = mp12FontT(24, "400");
    ctx.fillText("Si un mineral te llama, escucha a tu corazón", W / 2, 1262);
    // R23 O3 · F3 · la firma legible de la casa (el QR quedo dormido 9-jul por decision del fundador)
    ctx.fillStyle = "rgba(220,193,136,.72)"; ctx.font = mp12FontD(25, true);
    ctx.fillText("Diseñada en el Taller de Mamapachita · mamapachita.com", W / 2, 1300);
    // texto de compartir para QA y para el share
    try{ $("mp12-est").dataset.shareText = mp12EstTexto(); }catch(_){}
  });
}
function mp12AbreEstampa(d, nombre, voz, code, precioTxt){
  _mp12Est = { nombre:nombre || "Tu pieza", voz:voz || null, code:code || "" };
  mp12EstMsg("");
  const sub = $("mp12-est-sub"); if(sub) sub.textContent = "Una imagen de tu pieza, para guardar o compartir.";
  const ov = $("mp12-est");
  ov.dataset.shareText = "";
  const run = function(){ mp12ChecaFuentes(); mp12EstDibuja(d, nombre, voz, precioTxt); };
  if(document.fonts && document.fonts.ready && document.fonts.ready.then) document.fonts.ready.then(run).catch(run);
  else run();
  ov.classList.add("on"); ov.setAttribute("aria-hidden", "false");
  mpMontaFocoVelo(ov);   // cura C2: foco al velo + trampa de Tab (patron del contador)
}
function mp12CierraEstampa(){ const ov = $("mp12-est"); ov.classList.remove("on"); ov.setAttribute("aria-hidden", "true"); mpRegresaFocoVelo(); }
function mp12EstampaActual(){
  const r = calcular();
  const d = mp12DisenoActual();
  mp12AbreEstampa(d, "Tu pieza", mp12VozDe(beads, 3, d), codificaDiseno(), r.vacia ? null : money(r.final));
}
function mp12EstampaGuardado(i){
  const g = GUARDADOS[i]; if(!g) return;
  const d = mp12LeeDiseno(g.codigo); if(!d) return;
  cerrarSheet();
  const voz = mp12VozDe(d.beads, 3, d);
  mp12AbreEstampa(d, g.nombre, voz, g.codigo, g.precioTxt || null);
}
function mp12EstDescargaYcopia(blob, text){
  try{
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a"); a.href = url; a.download = "mi-pieza-mamapachita.png";
    document.body.appendChild(a); a.click(); document.body.removeChild(a);
    setTimeout(function(){ URL.revokeObjectURL(url); }, 4000);
  }catch(_){}
  mp8Copia(text, function(){});
  mp12EstMsg("Guardamos tu estampa y copiamos el texto con tu código. Pégalo donde quieras compartirla.");
}
function mp12EstCompartir(){
  const cv = $("mp12-est-canvas"), text = mp12EstTexto();
  if(!cv.toBlob){ mp12EstMsg("Tu navegador no puede generar la imagen; copia el texto con tu código."); mp8Copia(text, function(){}); return; }
  cv.toBlob(function(blob){
    if(!blob){ mp12EstMsg("No se pudo generar la imagen; copiamos el texto con tu código."); mp8Copia(text, function(){}); return; }
    let file = null;
    try{ file = new File([blob], "mi-pieza-mamapachita.png", { type:"image/png" }); }catch(_){ file = null; }
    if(file && navigator.share && navigator.canShare && navigator.canShare({ files:[file] })){
      navigator.share({ files:[file], text:text, title:"Mi pieza en Mamapachita" })
        .then(function(){ mp12EstMsg("Listo. Gracias por compartir tu pieza."); })
        .catch(function(){ mp12EstDescargaYcopia(blob, text); });
    } else {
      mp12EstDescargaYcopia(blob, text);
    }
  }, "image/png");
}
function mp12EstGuardar(){
  const cv = $("mp12-est-canvas");
  if(!cv.toBlob){ mp12EstMsg("Tu navegador no puede generar la imagen."); return; }
  cv.toBlob(function(blob){
    if(!blob){ mp12EstMsg("No se pudo generar la imagen."); return; }
    try{
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a"); a.href = url; a.download = "mi-pieza-mamapachita.png";
      document.body.appendChild(a); a.click(); document.body.removeChild(a);
      setTimeout(function(){ URL.revokeObjectURL(url); }, 4000);
      mp12EstMsg("Guardamos la imagen de tu pieza.");
    }catch(_){ mp12EstMsg("No se pudo guardar la imagen en este navegador."); }
  }, "image/png");
}
function mp12EstCopiar(){ mp8Copia(mp12EstTexto(), function(){}); mp12EstMsg("Copiamos el texto con tu código. Pégalo donde quieras compartir tu pieza."); }

/* ==================== 2 · LA PUERTA DE LA INTENCION ==================== */
function mp12ColorDist(h1, h2){
  function rgb(h){ h = String(h || "#808080").replace("#", ""); return [parseInt(h.substr(0,2),16)||128, parseInt(h.substr(2,2),16)||128, parseInt(h.substr(4,2),16)||128]; }
  const a = rgb(h1), b = rgb(h2);
  return Math.sqrt((a[0]-b[0])*(a[0]-b[0]) + (a[1]-b[1])*(a[1]-b[1]) + (a[2]-b[2])*(a[2]-b[2]));
}
// 2-3 minerales de la intencion: colores distintos entre si + al menos uno accesible de precio
function mp12CandidatosIntencion(intp){
  let cands = DATOS.minerales.map(function(_, i){ return i; }).filter(function(i){
    const m = DATOS.minerales[i]; return m.intenciones && m.intenciones.indexOf(intp) >= 0 && m.cuenta8 != null;
  });
  if(cands.length < 2) return null;
  cands.sort(function(a, b){ return DATOS.minerales[a].cuenta8 - DATOS.minerales[b].cuenta8; });
  const barato = cands[0];                     // accesible de precio
  const chosen = [barato];
  const byLum = cands.slice().sort(function(a, b){ return luminanciaMineral(a) - luminanciaMineral(b); });
  for(let pass = 0; pass < 2 && chosen.length < 3; pass++){
    const lumUmbral = pass === 0 ? 34 : 20, colUmbral = pass === 0 ? 62 : 38;
    byLum.forEach(function(c){
      if(chosen.length >= 3 || chosen.indexOf(c) >= 0) return;
      const ok = chosen.every(function(k){ return Math.abs(luminanciaMineral(k) - luminanciaMineral(c)) >= lumUmbral && mp12ColorDist(COL[k].c, COL[c].c) >= colUmbral; });
      if(ok) chosen.push(c);
    });
  }
  if(chosen.length < 2){ for(let i = 0; i < byLum.length && chosen.length < 2; i++){ if(chosen.indexOf(byLum[i]) < 0) chosen.push(byLum[i]); } }
  return chosen;
}
function mp12CentroIntencion(intp, forma){
  const list = LISTS[forma] || [];
  for(let i = 0; i < list.length; i++){ const m = DATOS.minerales[list[i]]; if(m.intenciones && m.intenciones.indexOf(intp) >= 0) return list[i]; }
  return null;
}
// degradado en espejo: extremos oscuros, centro claro; simetrico (respeta el espejo)
function mp12DegradadoEspejo(mids, N){
  const s = mids.slice().sort(function(a, b){ return luminanciaMineral(a) - luminanciaMineral(b); });
  const out = new Array(N), medio = (N - 1) / 2;
  for(let k = 0; k < N; k++){
    const t = 1 - Math.abs(k - medio) / medio;       // 0 en extremos, 1 en el centro
    let idx = Math.round(t * (s.length - 1));
    if(idx < 0) idx = 0; if(idx > s.length - 1) idx = s.length - 1;
    out[k] = s[idx];
  }
  return out;
}
function mp12SiembraIntencion(intp){
  const forma = pieza === "cod" ? "icosaedro" : "guru";
  const chosen = mp12CandidatosIntencion(intp);
  if(!mp20Aplicando) cerrarSheet();   // R20: el Paseo aplica en vivo, sin cerrar hoja
  if(!chosen){ mp9Toast("Esa intención pide más minerales; ábrela en el explorador.", 4200); return; }
  if(!mp20Aplicando) pushUndo();      // R20: navegar en el Paseo NO empuja al stack de deshacer
  if(pieza === "cod") centroForma = "icosaedro";
  centroManual = { icosaedro:null, c10:null, c12:null, flanqueada:null, guru:null };
  const cen = mp12CentroIntencion(intp, forma);
  if(cen != null) centroManual[forma] = cen;
  const order = readingOrder();
  const seq = mp12DegradadoEspejo(chosen, order.length);
  order.forEach(function(b, kk){ beads[b] = seq[kk]; });
  // los minerales de la propuesta entran a la mesa como pinceles (sin cambiar el pincel activo)
  chosen.slice().reverse().forEach(function(m){ if(!mesa.some(function(s){ return s.mid === m; })) mesa.unshift({ mid:m, fija:false }); });
  ordenaMesa();
  while(mesa.length > 5){ let q = false; for(let i = mesa.length - 1; i >= 0; i--){ if(!mesa[i].fija){ mesa.splice(i, 1); q = true; break; } } if(!q) break; }
  tocada = true; brush = -1;
  mp13SyncFill(); syncComplete();              // ya quedo llena: nada de acorde/voz sorpresa (Ronda 13: baseline de hitos sin disparar)
  actualizaPiezaChip(); renderContexto(); renderMesa(); renderCuarto(); updateCotizacion(); marcaCambio();
  if(!mp20Aplicando) mp9Toast("Una propuesta de " + intp.toLowerCase() + ". Es tuya: cámbiala cuenta por cuenta.", 5200);
}
/* R20 · F6: mp12AbreIntenciones retirada: la hoja de la intencion la reemplaza el carril "Lo que buscas" del Paseo. */

/* ======================= 3 · LA PIEZA A TAMANO REAL ======================= */
let _mp12CalibContinua = false;
let _mp12RealPan = { x:0, y:0, min:{ x:0, y:0 }, max:{ x:0, y:0 } };
function mp12CalibReposiciona(){
  const body = $("mp12-calib-body"); if(!body) return;
  const pxmm = parseFloat($("mp12-pxmm").value) || MP12_PXMM_DEFAULT;
  const gap = MP12_CARD_MM * pxmm, largo = MP12_CARD_LARGO_MM * pxmm;
  const w = body.clientWidth, h = body.clientHeight, cx = w / 2, cy = h / 2;
  $("mp12-line-a").style.left = (cx - gap / 2) + "px";
  $("mp12-line-b").style.left = (cx + gap / 2) + "px";
  const card = $("mp12-calib-card");
  card.style.left = cx + "px"; card.style.top = cy + "px";
  card.style.width = gap + "px";
  card.style.height = Math.min(largo, h * 0.8) + "px";
  $("mp12-pxmm-val").textContent = pxmm.toFixed(2) + " px/mm";
}
function mp12AbreCalibracion(continua){
  _mp12CalibContinua = !!continua;
  const pxmm = mp12LeePxmm() || MP12_PXMM_DEFAULT;
  $("mp12-pxmm").value = String(pxmm);
  const ov = $("mp12-calib"); ov.classList.add("on"); ov.setAttribute("aria-hidden", "false");
  requestAnimationFrame(mp12CalibReposiciona);
}
function mp12CierraCalibracion(){ const ov = $("mp12-calib"); ov.classList.remove("on"); ov.setAttribute("aria-hidden", "true"); }
function mp12GuardaCalibracion(){
  const pxmm = parseFloat($("mp12-pxmm").value) || MP12_PXMM_DEFAULT;
  mp12GuardaPxmm(pxmm);
  mp12CierraCalibracion();
  if(_mp12CalibContinua){ _mp12CalibContinua = false; mp23AplicaZoomFisico(); }   // R23: el destino tras calibrar es La pieza con el zoom fisico
}
// R23 · EL TAMANO REAL VIVE EN LA PIEZA: una cuenta de 8 mm = 8 x pxmm px (la misma fisica
// del R12), aplicada con el zoom real del lienzo. Se navega con las manos de siempre
// (pellizco y paneo) y la pastilla 1x regresa al encuadre normal. El overlay #mp12-real
// (cuentas deformadas, navegacion torpe) MURIO como destino; su codigo queda inerte abajo.
function mp23ZoomFisicoValor(pxmm){ return Math.max(1, (8 * pxmm) / (LAYOUT && LAYOUT.D > 0 ? LAYOUT.D : 24)); }
function mp23AplicaZoomFisico(){
  const pxmm = mp12LeePxmm(); if(pxmm == null) return;
  if(cuarto !== "observatorio"){   // la vista de diseño de La pieza, sin morph (el zoom llega enseguida)
    ocultaVoz();
    cuarto = "observatorio"; $("app").dataset.cuarto = "observatorio";
    actualizaTabs(); renderContexto(); renderCuarto(); updateCotizacion();
  }
  const z = mp23ZoomFisicoValor(pxmm);
  const lz = $("lienzo"), r = lz.getBoundingClientRect();
  const cx = r.left + r.width / 2, cy = r.top + r.height / 2;
  const lx = (cx - r.left - panX) / zoom, ly = (cy - r.top - panY) / zoom;
  zoom = z;                        // sin el tope del pellizco: la fisica manda (el pellizco conserva el suyo)
  panX = (cx - r.left) - lx * zoom;
  panY = (cy - r.top) - ly * zoom;
  clampPan(); suaveZoom(true); applyZoom();
  mp9Toast("Así de real es su tamaño. Vuelve a tocar Tamaño real si quieres calibrar de nuevo.", 5200);
}
function mp12IniciaTamanoReal(){
  if(beads.every(function(x){ return x == null; })) return;   // sin pieza no hay nada que medir
  const pxmm = mp12LeePxmm();
  if(pxmm == null){ mp12AbreCalibracion(true); return; }
  // R23: si ya estas viendo el tamano real, tocar de nuevo la pastilla abre la calibracion (por si algo no encaja)
  if(cuarto === "observatorio" && LAYOUT && LAYOUT.D > 0 && Math.abs(zoom - mp23ZoomFisicoValor(pxmm)) < 0.01){ mp12AbreCalibracion(true); return; }
  mp23AplicaZoomFisico();
}
// dibuja la pieza a ESCALA FISICA: una cuenta de 8 mm = 8 x pxmm px.
// la forma de la gota se calcula sobre el propio tamano de la ventana (como el observatorio,
// que ya muestra la cuenta cerca de su tamano real en un telefono tipico); al fijar la cuenta a
// 8 x pxmm, el codificador cabe entero en calibraciones normales y el japa se recorre paneando.
function mp12DibujaFisica(d, pxmm, vw, vh, cb){
  const names = mp12NombresDe(d);
  mp12Preload(names, function(imgs){
    const res = mp12ConDiseno(d, function(){
      const L = layoutGota(Math.max(180, vw), Math.max(300, vh), { top:24, bottom:24, left:20, right:20 });
      const bb = mp12Bbox(L);
      const k = (8 * pxmm) / L.D;                 // una cuenta de 8 mm = 8 x pxmm px
      const PAD = Math.round(3 * pxmm);
      const w = Math.ceil((bb.maxX - bb.minX) * k) + PAD * 2;
      const h = Math.ceil((bb.maxY - bb.minY) * k) + PAD * 2;
      // Ronda 15: nitidez a devicePixelRatio (tope 3). La escala fisica k queda en px CSS:
      // el bitmap crece por dpr y el tamano CSS se fija a w x h (la fisica no cambia).
      const dpr = Math.min(3, window.devicePixelRatio || 1);
      const cv = $("mp12-real-canvas");
      cv.width = Math.round(w * dpr); cv.height = Math.round(h * dpr);
      cv.style.width = w + "px"; cv.style.height = h + "px";
      const ctx = cv.getContext("2d");
      ctx.setTransform(1, 0, 0, 1, 0, 0);
      ctx.clearRect(0, 0, cv.width, cv.height);
      ctx.scale(dpr, dpr);
      const tx = PAD - bb.minX * k, ty = PAD - bb.minY * k;
      mp12DibujaPieza(ctx, L, imgs, tx, ty, k);
      ctx.setTransform(1, 0, 0, 1, 0, 0);
      return { w:w, h:h, beadPx:L.D * k };
    });
    cb(res);
  });
}
function mp12AplicaPanReal(){
  const cv = $("mp12-real-canvas");
  cv.style.transform = "translate(" + _mp12RealPan.x.toFixed(1) + "px," + _mp12RealPan.y.toFixed(1) + "px)";
  const ov = $("mp12-real");
  ov.dataset.panx = _mp12RealPan.x.toFixed(1); ov.dataset.pany = _mp12RealPan.y.toFixed(1);
}
// R23 · MUERTO COMO DESTINO: ya nadie llama a mp12AbreTamanoReal (la ronda 23 del fundador:
// cuentas deformadas y mala navegacion). El overlay #mp12-real, mp12DibujaFisica, su paneo y
// sus listeners (mp12-real-exit / mp12-real-recal) quedan inertes, sin excision (motor sellado).
function mp12AbreTamanoReal(){
  const ov = $("mp12-real");
  ov.classList.add("on"); ov.setAttribute("aria-hidden", "false");
  requestAnimationFrame(function(){
    const pxmm = mp12LeePxmm() || MP12_PXMM_DEFAULT;
    const d = mp12DisenoActual();
    const body = $("mp12-real-body"), cv = $("mp12-real-canvas");
    const vw = body.clientWidth || 360, vh = body.clientHeight || 640;
    mp12DibujaFisica(d, pxmm, vw, vh, function(res){
      // centrado; si no cabe, se recorre paneando
      const baseX = Math.round((vw - res.w) / 2), baseY = Math.round((vh - res.h) / 2);
      cv.style.left = baseX + "px"; cv.style.top = baseY + "px";
      const fitsX = res.w <= vw, fitsY = res.h <= vh, fits = fitsX && fitsY;
      _mp12RealPan = { x:0, y:0,
        min:{ x: fitsX ? 0 : (vw - res.w - baseX), y: fitsY ? 0 : (vh - res.h - baseY) },
        max:{ x: fitsX ? 0 : (0 - baseX), y: fitsY ? 0 : (0 - baseY) } };
      mp12AplicaPanReal();
      ov.dataset.beadPx = res.beadPx.toFixed(3); ov.dataset.pxmm = String(pxmm);
      ov.dataset.canvasW = String(res.w); ov.dataset.canvasH = String(res.h);
      ov.dataset.viewW = String(vw); ov.dataset.viewH = String(vh);
      ov.dataset.fits = fits ? "1" : "0";
      const hint = $("mp12-real-hint");
      hint.innerHTML = (fits ? "Así de real es su tamaño en tu mesa." : "Arrástrala para recorrerla; así de real es su tamaño.")
        + '<a class="mp12-recal" id="mp12-real-recal" role="button" tabindex="0">Calibrar de nuevo</a>';
    });
  });
}
function mp12CierraTamanoReal(){ const ov = $("mp12-real"); ov.classList.remove("on"); ov.setAttribute("aria-hidden", "true"); }

/* ---- pastillas nuevas del contexto ---- */
function mp12EstampaChipHTML(){
  const off = beads.some(function(x){ return x == null; });   // atenuada hasta completar
  return '<button class="chip mp12-estampa' + (off ? " mp12-off" : "") + '" id="mp12-est-btn"'
    + (off ? ' aria-disabled="true" title="al completar tu pieza"' : "")
    + ' aria-label="La estampa: una imagen de tu pieza para guardar o compartir">' + MP12_ICO.estampa + 'La estampa</button>';
}
function mp12RealChipHTML(){
  return '<button class="chip mp12-real-chip" id="mp12-real-btn" aria-label="Verla a tamaño real, con tu pantalla calibrada">' + MP12_ICO.real + 'Tamaño real</button>';
}
/* R20 · F6: mp12IntencionChipHTML retirada: la puerta de la intencion vive ahora en el carril "Lo que buscas" del Paseo. */


/* ===== cambiar de pieza (Trabajo 6: guarda la actual, restaura la otra) ===== */
function setPieza(p){
  if(p === pieza) return;
  ocultaVoz();
  mp13OcultaHito(); mp13OcultaAcuse();    // Ronda 13fix: al cambiar de pieza no queda ninguna nota flotando (hito/acuse de la pieza anterior)
  clearTimeout(mp14SelloTimer); mp14PendAcuse = false; mp14OcultaCristal(true);   // Ronda 14fix: cancela la ceremonia en vuelo (nada suena ni se arrastra la frase de la pieza que se deja)
  marcaCambio();                          // guarda el estado de la pieza actual
  pieza = p;
  cargaPieza(p);                          // restaura la otra pieza tal cual estaba (o limpia si es nueva)
  brush = -1; cancelarReemplazoSilencio();
  historial = []; actualizaUndo();        // el deshacer se limpia al cambiar de pieza (documentado)
  zoom = 1; panX = 0; panY = 0;
  syncComplete();
  actualizaPiezaChip();
  renderContexto(); renderMesa(); renderCuarto(); updateCotizacion();
}
function cancelarReemplazoSilencio(){ reemplazo = null; $("reemplazo").classList.remove("on"); }

/* ===== Ronda 7 · autoguardado por pieza + persistencia en localStorage ===== */
function snapPieza(){
  return {
    beads: beads.slice(),
    centroForma: centroForma,
    centroManual: Object.assign({}, centroManual),
    patronIdx: patronIdx,
    sepMineralIdx: sepMineralIdx,
    sepPinta: (Array.isArray(sepPinta) ? sepPinta.slice() : []),   // R18 · F1
    tocada: tocada,
    degTono: degTono
  };
}
function marcaCambio(){ PZ[pieza] = snapPieza(); persistePZ(); }
// Ronda 9: se guarda por NOMBRE (inmune a cambios de tamano/orden del catalogo).
// PZ vive en memoria por INDICES (los render usan indices); la serializacion traduce a nombres.
function pzAstore(){
  const out = {};
  ["cod", "japa"].forEach(function(p){
    const st = PZ[p]; if(!st) return;
    const cmNombres = {};
    Object.keys(st.centroManual || {}).forEach(function(f){ const mid = st.centroManual[f]; cmNombres[f] = (mid != null) ? midToName(mid) : null; });
    out[p] = {
      beads: (st.beads || []).map(midToName),
      centroForma: st.centroForma,
      centroManual: cmNombres,
      patronCm: DATOS.patrones[st.patronIdx] ? DATOS.patrones[st.patronIdx].cm : null,
      sepNombre: (st.sepMineralIdx >= 0 && DATOS.separadores[st.sepMineralIdx]) ? DATOS.separadores[st.sepMineralIdx].n : null,
      sepPinta: (Array.isArray(st.sepPinta) ? st.sepPinta.map(function(si){ return (si != null && DATOS.separadores[si]) ? DATOS.separadores[si].n : null; }) : []),   // R18 · F1: por NOMBRE
      tocada: st.tocada,
      degTono: !!st.degTono
    };
  });
  // la mesa de pinceles tambien se recuerda (por nombre): la casa no olvida tus recientes al recargar
  out.mesa = mesa.map(function(s){ return { n: midToName(s.mid), fija: !!s.fija }; });
  return out;
}
function pzDesdeStore(o){
  ["cod", "japa"].forEach(function(p){
    const s = o[p]; if(!s || typeof s !== "object") return;
    const beads = (Array.isArray(s.beads) ? s.beads : []).map(function(nm){ return (nm != null) ? nameToMid(nm) : null; });
    const cm = { icosaedro:null, c10:null, c12:null, flanqueada:null, guru:null };
    if(s.centroManual && typeof s.centroManual === "object"){
      Object.keys(cm).forEach(function(f){ const nm = s.centroManual[f]; const mid = (nm != null) ? nameToMid(nm) : null; cm[f] = (mid != null && mid >= 0) ? mid : null; });
    }
    let patIdx = 0;
    if(s.patronCm != null){ const j = DATOS.patrones.findIndex(function(x){ return String(x.cm) === String(s.patronCm); }); if(j >= 0) patIdx = j; }
    let sepIdx = sepMineralIdx;
    if(s.sepNombre != null){ const j = DATOS.separadores.findIndex(function(x){ return x.n === s.sepNombre; }); if(j >= 0) sepIdx = j; }
    // R18 · F1: overrides de separador por NOMBRE (estados viejos sin la llave = [] = todo base)
    const pinta = Array.isArray(s.sepPinta) ? s.sepPinta.map(function(nm){ if(nm == null) return null; const j = DATOS.separadores.findIndex(function(x){ return x.n === nm; }); return (j >= 0 && j !== sepIdx) ? j : null; }) : [];
    PZ[p] = { beads: beads, centroForma: s.centroForma, centroManual: cm, patronIdx: patIdx, sepMineralIdx: sepIdx, sepPinta: pinta, tocada: !!s.tocada, degTono: !!s.degTono };
  });
  // restaura la mesa de pinceles guardada (nombres desconocidos se descartan; tope 5, como en el uso)
  if(Array.isArray(o.mesa)){
    const vistos = {};
    const rest = [];
    o.mesa.forEach(function(s){
      if(!s || typeof s !== "object") return;
      const mid = nameToMid(s.n);
      if(mid == null || vistos[mid]) return;
      vistos[mid] = 1;
      rest.push({ mid: mid, fija: !!s.fija });
    });
    if(rest.length) mesa = rest.slice(0, 5);
  }
}
function persistePZ(){ try{ localStorage.setItem(LS_ESTADO, JSON.stringify(pzAstore())); }catch(_){} }
function limpiaBeadsValidos(arr, N){
  const out = new Array(N).fill(null);
  if(!Array.isArray(arr)) return out;
  for(let i = 0; i < N; i++){
    const v = arr[i];
    if(Number.isInteger(v) && v >= 0 && v < DATOS.minerales.length) out[i] = v;
  }
  return out;
}
function cargaPieza(p){
  const N = CFG[p].N;
  const st = PZ[p];
  if(st){
    beads = limpiaBeadsValidos(st.beads, N);
    centroForma = (["icosaedro", "c10", "c12", "flanqueada"].indexOf(st.centroForma) >= 0) ? st.centroForma : "icosaedro";
    centroManual = Object.assign({ icosaedro:null, c10:null, c12:null, flanqueada:null, guru:null }, st.centroManual || {});
    patronIdx = (Number.isInteger(st.patronIdx) && st.patronIdx >= 0 && st.patronIdx < DATOS.patrones.length) ? st.patronIdx : 0;
    sepMineralIdx = (Number.isInteger(st.sepMineralIdx) && st.sepMineralIdx >= 0 && st.sepMineralIdx < DATOS.separadores.length) ? st.sepMineralIdx : sepMineralIdx;
    sepPinta = (Array.isArray(st.sepPinta)) ? st.sepPinta.slice() : [];   // R18 · F1: aditiva (estados viejos = [] = todo base)
    tocada = !!st.tocada;
    degTono = !!st.degTono;                   // Ronda 15b: aditiva (estados viejos sin la llave = false)
  } else {
    beads = new Array(N).fill(null);
    centroForma = "icosaedro";
    centroManual = { icosaedro:null, c10:null, c12:null, flanqueada:null, guru:null };
    sepPinta = [];
    tocada = false;
    degTono = false;
    // patronIdx / sepMineralIdx conservan sus valores por defecto de la sesion
  }
  sepBrush = -1;                               // R18 · F1: el pincel de sep no sobrevive el cambio de pieza
  if(pieza === "cod") sepPintaSane();          // ajusta la longitud a la cadencia vigente
  wasComplete = false;
  mp13LastFill[p] = beads.filter(function(x){ return x != null; }).length;   // Ronda 13: baseline de hitos al cargar/restaurar (no dispara)
  mp15bReevalua();                            // Ronda 15b: nunca cargar un degradado que ya no cumple
}
function cargaPZinicial(){
  // v2 (por nombre): la fuente vigente
  try{
    const raw = localStorage.getItem(LS_ESTADO);
    if(raw){ const o = JSON.parse(raw); if(o && typeof o === "object"){ pzDesdeStore(o); return; } }
  }catch(_){}
  // migracion unica desde v1 (por indices; hoy siguen siendo correctos). Deja v1 intacta como reliquia.
  try{
    const raw = localStorage.getItem(LS_ESTADO_V1);
    if(raw){
      const o = JSON.parse(raw);
      if(o && typeof o === "object"){
        if(o.cod) PZ.cod = o.cod;
        if(o.japa) PZ.japa = o.japa;
        persistePZ();                      // reescribe por nombre en v2
      }
    }
  }catch(_){}
}

/* ===== Ronda 8 · T3 · Mis diseños (guarda hasta 5 versiones; llave propia, separada del autoguardado) ===== */
const LS_DISENOS = "mp_cotizador_disenos_v2";
let GUARDADOS = [];
let mp8ConfirmAbrir = -1;
function escHtml(s){ return String(s).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;"); }
function persisteGuardados(){ try{ localStorage.setItem(LS_DISENOS, JSON.stringify(GUARDADOS)); }catch(_){} }
function cargaGuardadosDe(key){
  try{
    const raw = localStorage.getItem(key); if(!raw) return false;
    const arr = JSON.parse(raw); if(!Array.isArray(arr)) return false;
    GUARDADOS = arr.filter(function(g){ return g && typeof g === "object" && typeof g.codigo === "string" && g.codigo.indexOf("MP1.") === 0; })
      .slice(0, 5).map(function(g){
        return {
          nombre: String(g.nombre || "Diseño").slice(0, 24),
          pieza: (g.pieza === "japa" ? "japa" : "cod"),
          codigo: g.codigo,
          precioTxt: String(g.precioTxt || ""),
          sello: String(g.sello || ""),
          colores: Array.isArray(g.colores) ? g.colores.slice(0, 24).map(function(c){ return (typeof c === "string") ? c : null; }) : []
        };
      });
    return true;
  }catch(_){ return false; }
}
function cargaGuardados(){
  // v2 (codigos sch 2, por nombre): la fuente vigente
  if(cargaGuardadosDe(LS_DISENOS)) return;
  // migracion unica desde v1: re-codifica cada diseño a sch 2 (por nombre) y deja v1 intacta como reliquia
  if(cargaGuardadosDe(LS_DISENOS_V1)){
    GUARDADOS = GUARDADOS.map(function(g){ return Object.assign({}, g, { codigo: recodificaAsch2(g.codigo) }); });
    persisteGuardados();                    // escribe v2
  }
}
// franja de puntitos (muestra del cuerpo en orden de lectura)
function muestraColores(){
  const seq = seqActual(), N = seq.length, MAX = 24, idxs = [], out = [];
  if(N <= MAX){ for(let j = 0; j < N; j++) idxs.push(j); }
  else { for(let d = 0; d < MAX; d++) idxs.push(Math.round(d * (N - 1) / (MAX - 1))); }
  idxs.forEach(function(j){ const mid = seq[j]; out.push(mid == null ? null : COL[mid].c); });
  return out;
}
function mp8Copia(txt, done){
  if(navigator.clipboard && navigator.clipboard.writeText){
    navigator.clipboard.writeText(txt).then(done).catch(function(){ mp8CopiaFallback(txt); done(); });
  } else { mp8CopiaFallback(txt); done(); }
}
function mp8CopiaFallback(txt){
  try{
    const ta = document.createElement("textarea");
    ta.value = txt; ta.style.position = "fixed"; ta.style.opacity = "0";
    document.body.appendChild(ta); ta.focus(); ta.select();
    document.execCommand("copy"); document.body.removeChild(ta);
  }catch(_){}
}
function mp8Mensaje(txt, cls){ const el = $("mp8-msg"); if(!el) return; el.hidden = false; el.className = "mp8-msg " + (cls || ""); el.textContent = txt; }
function tarjetaGuardado(g, i){
  const piezaTxt = g.pieza === "cod" ? "Codificador 45" : "Japa Mala 108";
  let dots = "";
  (g.colores || []).forEach(function(c){ dots += c ? ('<span class="mp8-dot" style="background:' + c + '"></span>') : '<span class="mp8-dot vacia"></span>'; });
  let h = '<div class="mp8-card">';
  h += '<div class="mp8-card-top"><span class="mp8-card-n">' + escHtml(g.nombre) + '</span><span class="mp8-card-p">' + escHtml(g.precioTxt || "") + '</span></div>';
  h += '<div class="mp8-card-sub">' + piezaTxt + (g.sello ? (' · ' + escHtml(g.sello)) : "") + '</div>';
  h += '<div class="mp8-strip">' + dots + '</div>';
  h += '<div class="mp8-card-acc">'
    + '<button class="mp8-abtn" data-mp8-abrir="' + i + '">Abrir</button>'
    + '<button class="mp8-abtn" data-mp12-estampa-card="' + i + '">La estampa</button>'
    + '<button class="mp8-abtn" data-mp8-copiar="' + i + '">Copiar código</button>'
    + '<button class="mp8-abtn quitar" data-mp8-quitar="' + i + '">Quitar</button>'
    + '</div></div>';
  return h;
}
function renderGuardados(){
  let h = '<div class="grabber"></div>';
  h += '<div class="sheet-head"><div><div class="sheet-nombre">Mis diseños</div>'
    + '<div class="sheet-lugar">guarda hasta 5 versiones de tu pieza</div></div></div>';
  if(mp8ConfirmAbrir >= 0 && GUARDADOS[mp8ConfirmAbrir]){
    const g = GUARDADOS[mp8ConfirmAbrir];
    h += '<div class="mp8-confirma"><p>Cargar "' + escHtml(g.nombre) + '" reemplaza lo que tienes ahora en tu pieza.</p>'
      + '<div class="mp8-confirma-row"><button class="mp8-cbtn prim" data-mp8-confirmar="' + mp8ConfirmAbrir + '">Cargar</button>'
      + '<button class="mp8-cbtn" data-mp8-cancelar="1">Cancelar</button></div></div>';
  }
  const rNow = calcular();
  const puede = !rNow.vacia;
  h += '<div class="sheet-label">Guardar el de ahora</div>';
  if(GUARDADOS.length >= 5){
    h += '<p class="mp8-nota">Tienes tus 5 diseños. Quita uno para guardar otro.</p>';
  } else {
    h += '<div class="mp8-save-row"><input class="mp8-nombre-in" id="mp8-nombre" maxlength="24" placeholder="Nombra tu diseño" aria-label="Nombre del diseño" autocomplete="off">'
      + '<button class="mp8-cbtn prim" data-mp8-guardar="1"' + (puede ? "" : " disabled") + '>Guardar</button></div>';
    if(!puede) h += '<p class="mp8-nota">Nombra al menos una cuenta para guardar tu diseño.</p>';
  }
  h += '<div class="sheet-label">Tus diseños</div>';
  if(!GUARDADOS.length){
    h += '<p class="mp8-vacio">Guarda hasta 5 versiones de tu pieza y compáralas.</p>';
  } else {
    h += '<div class="mp8-lista">';
    GUARDADOS.forEach(function(g, i){ h += tarjetaGuardado(g, i); });
    h += '</div>';
  }
  h += '<p class="mp8-msg" id="mp8-msg" hidden></p>';
  h += '<div class="sheet-acciones"><button class="prim" data-act="cerrar">Listo</button></div>';
  $("sheet-in").innerHTML = h;
}
function abrirGuardados(){ mp8ConfirmAbrir = -1; renderGuardados(); abrirSheet("guardados", "Mis diseños"); }
function guardarDiseno(){
  const r = calcular(); if(r.vacia) return;
  if(GUARDADOS.length >= 5) return;
  const inp = $("mp8-nombre");
  let nombre = (inp ? inp.value : "").trim().slice(0, 24);
  if(!nombre) nombre = (pieza === "cod" ? "Codificador" : "Japa") + " " + (GUARDADOS.length + 1);
  let precioTxt, sello;
  if(r.incompleta){ precioTxt = money(r.final); sello = "parcial · van " + r.T + " de " + r.N; }
  else { precioTxt = money(r.final); sello = r.exacta ? "sellado · ya vive en la tienda" : "sellado"; }
  GUARDADOS.push({ nombre:nombre, pieza:pieza, codigo:codificaDiseno(), precioTxt:precioTxt, sello:sello, colores:muestraColores() });
  if(GUARDADOS.length > 5) GUARDADOS = GUARDADOS.slice(-5);
  persisteGuardados();
  renderGuardados();
  mp8Mensaje('Guardaste "' + nombre + '".', "ok");
}
function pideAbrirGuardado(i){
  if(!GUARDADOS[i]) return;
  const hayTrabajo = beads.some(function(x){ return x != null; });
  if(hayTrabajo){ mp8ConfirmAbrir = i; renderGuardados(); return; }
  ejecutaAbrirGuardado(i);
}
function ejecutaAbrirGuardado(i){
  const g = GUARDADOS[i]; if(!g) return;
  mp8ConfirmAbrir = -1;
  cerrarSheet();
  aplicaDisenoCodigo(g.codigo);
}
function copiarGuardado(i){ const g = GUARDADOS[i]; if(!g) return; mp8Copia(g.codigo, function(){ mp8Mensaje('Copiaste el código de "' + g.nombre + '".', "ok"); }); }
function quitarGuardado(i){
  if(i < 0 || i >= GUARDADOS.length) return;
  const nombre = GUARDADOS[i].nombre;
  GUARDADOS.splice(i, 1);
  if(mp8ConfirmAbrir === i) mp8ConfirmAbrir = -1; else if(mp8ConfirmAbrir > i) mp8ConfirmAbrir--;
  persisteGuardados();
  renderGuardados();
  mp8Mensaje('Quitaste "' + nombre + '".', "");
}

/* ===== eventos ===== */
function initEventos(){
  const lz = $("lienzo");

  /* ===== gestos del lienzo: 1 dedo pinta / barre · 2 dedos acercan y panean · doble toque acerca ===== */
  const pointers = new Map();
  let tap = null;              // candidato a toque / barrido de un dedo
  let pinch = null;            // {dist, zoom, lx, ly} para pellizco + paneo
  let panMouse = null;         // paneo de escritorio (boton medio o barra espaciadora)
  let ignoreLeftover = false;  // tras multitouch, ignora el dedo que queda
  let paintSnapped = false;    // ya se guardo el paso de deshacer de este barrido
  let spaceHeld = false;
  let tapTimer = 0;
  const lastTap = { t:0, x:0, y:0 };

  function finalizaToque(t){
    const now = Date.now();
    // R18 · F1: con el pincel de separadores activo, un toque sobre un separador lo pinta (nada mas)
    if(sepBrush >= 0){
      if(tapTimer){ clearTimeout(tapTimer); tapTimer = 0; }
      lastTap.t = now; lastTap.x = t.x; lastTap.y = t.y;
      if(t.downSep >= 0) sepPaintTap(t.downSep);
      return;
    }
    // con pincel activo el doble toque NO hace zoom (se pinta directo); el zoom con pincel queda en pellizco
    const dbl = brush < 0 && (now - lastTap.t) < 280 && Math.hypot(t.x - lastTap.x, t.y - lastTap.y) < 28;
    if(dbl){
      if(tapTimer){ clearTimeout(tapTimer); tapTimer = 0; }
      lastTap.t = 0;
      if(zoom > 1.01) resetZoom(true); else zoomAPunto(t.x, t.y, 2, true);
      return;
    }
    lastTap.t = now; lastTap.x = t.x; lastTap.y = t.y;
    const hit = t.downHit;
    if(brush >= 0){
      if(tapTimer){ clearTimeout(tapTimer); tapTimer = 0; }
      if(hit >= 0) onBeadTap(hit);
    } else {
      if(tapTimer) clearTimeout(tapTimer);
      tapTimer = setTimeout(function(){ tapTimer = 0; if(hit >= 0) onBeadTap(hit); }, 250);
    }
  }

  lz.addEventListener("pointerdown", function(e){
    if(e.target.closest("[data-principal]")) return;   // la principal usa su click nativo
    ensureAudio();                                     // calienta el audio dentro del gesto (si el sonido esta encendido)
    if(e.pointerType === "mouse" && (e.button === 1 || (spaceHeld && e.button === 0))){
      panMouse = { x:e.clientX, y:e.clientY, panX:panX, panY:panY, pid:e.pointerId };
      try{ lz.setPointerCapture(e.pointerId); }catch(_){}
      e.preventDefault(); return;
    }
    if(e.button && e.button !== 0) return;
    try{ lz.setPointerCapture(e.pointerId); }catch(_){}
    pointers.set(e.pointerId, { x:e.clientX, y:e.clientY });
    if(pointers.size === 1){
      ignoreLeftover = false; paintSnapped = false;
      const lp = screenToLayout(e.clientX, e.clientY);
      const sepEl = e.target.closest("[data-sepslot]");   // R18 · F1: separador tocado (con el pincel de sep activo)
      tap = { x:e.clientX, y:e.clientY, downHit:nearestBead(lp.x, lp.y), downSep:(sepEl ? +sepEl.getAttribute("data-sepslot") : -1), pid:e.pointerId, moved:false };
    } else if(pointers.size === 2){
      tap = null;
      const pts = Array.from(pointers.values());
      const dist = Math.hypot(pts[0].x - pts[1].x, pts[0].y - pts[1].y) || 1;
      const mx = (pts[0].x + pts[1].x) / 2, my = (pts[0].y + pts[1].y) / 2;
      const r = lz.getBoundingClientRect();
      pinch = { dist:dist, zoom:zoom, lx:(mx - r.left - panX) / zoom, ly:(my - r.top - panY) / zoom };
      suaveZoom(false);
    }
  });

  lz.addEventListener("pointermove", function(e){
    if(panMouse && e.pointerId === panMouse.pid){
      panX = panMouse.panX + (e.clientX - panMouse.x);
      panY = panMouse.panY + (e.clientY - panMouse.y);
      clampPan(); applyZoom(); return;
    }
    if(!pointers.has(e.pointerId)) return;
    pointers.set(e.pointerId, { x:e.clientX, y:e.clientY });
    if(pointers.size >= 2 && pinch){
      const pts = Array.from(pointers.values());
      const dist = Math.hypot(pts[0].x - pts[1].x, pts[0].y - pts[1].y) || 1;
      const mx = (pts[0].x + pts[1].x) / 2, my = (pts[0].y + pts[1].y) / 2;
      const r = lz.getBoundingClientRect();
      zoom = clampZoom(pinch.zoom * dist / pinch.dist);
      panX = (mx - r.left) - pinch.lx * zoom;
      panY = (my - r.top) - pinch.ly * zoom;
      clampPan(); applyZoom();
      return;
    }
    if(pointers.size === 1 && tap && e.pointerId === tap.pid){
      const dx = e.clientX - tap.x, dy = e.clientY - tap.y;
      if(!tap.moved && (dx * dx + dy * dy) > 36) tap.moved = true;
      if(ignoreLeftover) return;
      if(brush < 0 || reemplazo != null || !tap.moved) return;
      const lp = screenToLayout(e.clientX, e.clientY);
      const hit = nearestBead(lp.x, lp.y);
      if(hit >= 0 && beads[hit] !== brush){
        if(!paintSnapped){ pushUndo(); paintSnapped = true; }
        pintar(hit, brush); tocada = true; tras();
      }
    }
  });

  function finPointer(e){
    if(panMouse && e.pointerId === panMouse.pid){ panMouse = null; try{ lz.releasePointerCapture(e.pointerId); }catch(_){} return; }
    if(!pointers.has(e.pointerId)) return;
    pointers.delete(e.pointerId);
    try{ lz.releasePointerCapture(e.pointerId); }catch(_){}
    if(pinch && pointers.size < 2){ pinch = null; ignoreLeftover = pointers.size > 0; }
    if(pointers.size === 0){
      if(tap && !tap.moved && !ignoreLeftover) finalizaToque(tap);
      tap = null; ignoreLeftover = false; paintSnapped = false;
    }
  }
  lz.addEventListener("pointerup", finPointer);
  lz.addEventListener("pointercancel", function(e){
    if(panMouse && e.pointerId === panMouse.pid) panMouse = null;
    pointers.delete(e.pointerId);
    if(pinch && pointers.size < 2) pinch = null;
    if(pointers.size === 0){ tap = null; ignoreLeftover = false; paintSnapped = false; }
  });

  // click nativo: la principal abre el centro; el teclado en las cuentas llega aqui
  lz.addEventListener("click", function(e){
    if(sepBrush >= 0) return;   // R18 · F1: con el pincel de separadores el pintado va por el flujo de punteros
    const p = e.target.closest("[data-principal]");
    if(p){ abrirCentro(); return; }
    const t = e.target.closest("[data-i]");
    if(t){ onBeadTap(+t.getAttribute("data-i")); }
  });

  // escritorio: rueda con Ctrl (o pellizco de trackpad) acerca en el cursor
  lz.addEventListener("wheel", function(e){
    if(!e.ctrlKey) return;
    e.preventDefault();
    zoomAPunto(e.clientX, e.clientY, clampZoom(zoom * Math.exp(-e.deltaY * 0.0022)), false);
  }, { passive:false });
  document.addEventListener("keydown", function(e){ if(e.code === "Space") spaceHeld = true; });
  document.addEventListener("keyup", function(e){ if(e.code === "Space") spaceHeld = false; });

  // pills flotantes
  $("zoom-pill").addEventListener("click", function(){ resetZoom(true); });
  $("undo-pill").addEventListener("click", deshacer);

  // pastilla de la pieza: alterna Codificador / Japa Mala
  $("pieza-chip").addEventListener("click", function(){ setPieza(pieza === "cod" ? "japa" : "cod"); });

  // los dos cuartos: las pestanas y el paso adelante desde la charola
  $("tab-charola").addEventListener("click", function(){ setCuarto("charola"); });
  $("tab-observatorio").addEventListener("click", function(){ setCuarto("observatorio"); });
  $("ver-cta").addEventListener("click", function(){ setCuarto("observatorio"); });

  // CUARTO 1 · LA CHAROLA: toque = pintar / mirilla · centro = elegir su mineral ·
  //   presion larga sobre una cuenta puesta = levantarla y arrastrarla para intercambiar
  (function(){
    const ch = $("charola");
    let tap = null, timer = 0, longFired = false, drag = null, ghost = null;
    function huecoEn(x, y){ const el = document.elementFromPoint(x, y); return el ? el.closest("[data-i]") : null; }
    function limpiaDrag(){
      if(ghost){ ghost.remove(); ghost = null; }
      ch.querySelectorAll(".alzada,.destino").forEach(function(el){ el.classList.remove("alzada"); el.classList.remove("destino"); });
    }
    function iniciaArrastre(i, el, x, y){
      drag = { i:i };
      el.classList.add("alzada");
      const D = el.offsetWidth || CHAROLA.D;
      const f = fillMin(beads[i]);
      const g = document.createElement("div");
      g.className = "drag-fantasma fill " + f.cls;
      g.style.cssText = f.style + "width:" + D + "px;height:" + D + "px;";
      ch.appendChild(g); ghost = g;
      mueveArrastre(x, y);
      vibra(10);
    }
    function mueveArrastre(x, y){
      if(!ghost) return;
      const r = ch.getBoundingClientRect();
      ghost.style.left = (x - r.left) + "px";
      ghost.style.top = (y - r.top) + "px";
      ch.querySelectorAll(".hueco.destino").forEach(function(el){ el.classList.remove("destino"); });
      const dest = huecoEn(x, y);
      if(dest && dest.getAttribute("data-i") !== String(drag.i)) dest.classList.add("destino");
    }
    function intercambia(i, j){
      pushUndo();
      const a = beads[i]; beads[i] = beads[j]; beads[j] = a;
      if(espejo && twin(i) !== j){ const ti = twin(i), tj = twin(j), b = beads[ti]; beads[ti] = beads[tj]; beads[tj] = b; }
      tocada = true; justPainted = [];
    }
    ch.addEventListener("pointerdown", function(e){
      if(e.button && e.button !== 0) return;
      // R18 · F1: con el pincel de separadores activo, tocar un separador de la charola lo pinta
      const spEl = e.target.closest("[data-sepslot]");
      if(spEl && sepBrush >= 0){
        ensureAudio(); longFired = false;
        tap = { sepSlot:+spEl.getAttribute("data-sepslot"), x:e.clientX, y:e.clientY, moved:false, pid:e.pointerId };
        try{ ch.setPointerCapture(e.pointerId); }catch(_){}
        return;
      }
      if(e.target.closest("[data-centro-slot]")){ tap = null; return; }   // el centro usa su click nativo
      const b = e.target.closest("[data-i]");
      if(!b) return;
      ensureAudio();
      const i = +b.getAttribute("data-i");
      longFired = false;
      tap = { i:i, x:e.clientX, y:e.clientY, moved:false, pid:e.pointerId };
      try{ ch.setPointerCapture(e.pointerId); }catch(_){}
      if(beads[i] != null && reemplazo == null && sepBrush < 0){   // el pincel de sep no arrastra cuentas
        timer = setTimeout(function(){ timer = 0; longFired = true; iniciaArrastre(i, b, e.clientX, e.clientY); }, 300);
      }
    });
    ch.addEventListener("pointermove", function(e){
      if(drag){ mueveArrastre(e.clientX, e.clientY); return; }
      if(tap && e.pointerId === tap.pid && !tap.moved && Math.hypot(e.clientX - tap.x, e.clientY - tap.y) > 8){
        tap.moved = true; if(timer){ clearTimeout(timer); timer = 0; }
      }
      // Ronda 10: barrido de pintado con pincel activo (mismo gesto que el observatorio);
      // la presion larga (intercambio) sigue viva: solo dispara si el dedo NO se movio.
      if(tap && e.pointerId === tap.pid && tap.moved && brush >= 0 && reemplazo == null){
        const b = huecoEn(e.clientX, e.clientY);
        if(b){
          const j = +b.getAttribute("data-i");
          if(beads[j] !== brush){
            if(!tap.sweepSnap){ pushUndo(); tap.sweepSnap = true; }
            pintar(j, brush); tocada = true; tras();
          }
        }
      }
    });
    ch.addEventListener("pointerup", function(e){
      if(timer){ clearTimeout(timer); timer = 0; }
      try{ ch.releasePointerCapture(e.pointerId); }catch(_){}
      if(drag){
        const dest = huecoEn(e.clientX, e.clientY);
        if(dest){ const j = +dest.getAttribute("data-i"); if(j !== drag.i){ intercambia(drag.i, j); mp21Susurro("drag", "Cambiaste dos cuentas de lugar. El orden no cambia el precio."); } }
        limpiaDrag(); drag = null; tap = null; tras(); return;
      }
      if(tap && tap.sepSlot != null && !tap.moved){ sepPaintTap(tap.sepSlot); tap = null; longFired = false; return; }   // R18 · F1
      if(sepBrush >= 0){ tap = null; longFired = false; return; }   // con el pincel de sep, las cuentas no responden al toque
      if(tap && !tap.moved && !longFired && tap.i != null) onBeadTap(tap.i);
      tap = null; longFired = false;
    });
    ch.addEventListener("pointercancel", function(){ if(timer){ clearTimeout(timer); timer = 0; } if(drag){ limpiaDrag(); drag = null; } tap = null; longFired = false; });
    ch.addEventListener("click", function(e){
      if(e.target.closest("[data-centro-slot]")){ abrirCentro(); return; }
      if(sepBrush >= 0) return;   // R18 · F1: con el pincel de sep, el pintado va por el flujo de punteros
      if(e.detail === 0){ const b = e.target.closest("[data-i]"); if(b) onBeadTap(+b.getAttribute("data-i")); }   // teclado
    });
  })();

  // LA MESA: toque = activar pincel · presion larga (o click derecho) = fijar · varita · mas
  (function(){
    const mz = $("mesa");
    let press = null, timer = 0, longFired = false;
    mz.addEventListener("pointerdown", function(e){
      const s = e.target.closest("[data-slot-mid]");
      if(!s) return;
      longFired = false;
      const mid = +s.getAttribute("data-slot-mid");
      press = { mid:mid, x:e.clientX, y:e.clientY };
      timer = setTimeout(function(){ longFired = true; press = null; mesaFijar(mid); }, 450);
    });
    mz.addEventListener("pointermove", function(e){
      if(press && Math.hypot(e.clientX - press.x, e.clientY - press.y) > 10){ clearTimeout(timer); press = null; }
    });
    mz.addEventListener("pointerup", function(){ if(timer){ clearTimeout(timer); timer = 0; } });
    mz.addEventListener("pointercancel", function(){ if(timer){ clearTimeout(timer); timer = 0; } press = null; });
    mz.addEventListener("contextmenu", function(e){
      const s = e.target.closest("[data-slot-mid]");
      if(s){ e.preventDefault(); if(timer){ clearTimeout(timer); timer = 0; } longFired = true; press = null; mesaFijar(+s.getAttribute("data-slot-mid")); }
    });
    mz.addEventListener("click", function(e){
      if(e.target.closest("#mp23-mesa-exp")){ mp23ToggleMesaPanel(); return; }   // R23 O3 · F2: expandir la mesa
      if(e.target.closest("#mesa-mas")){ abrirExplorador(); return; }
      if(e.target.closest("#mesa-varita")){ abrirAcciones(); return; }
      if(e.target.closest("#mesa-sep-mas")){ abrirSepSelector(); return; }   // R18 · F1
      const sp = e.target.closest("[data-sep-pincel]");                       // R18 · F1: chip de pincel de separador
      if(sp){ toggleSepBrush(+sp.getAttribute("data-sep-pincel")); return; }
      const s = e.target.closest("[data-slot-mid]");
      if(s){
        if(longFired){ longFired = false; return; }   // fue presion larga (fijar), no activar
        toggleBrush(+s.getAttribute("data-slot-mid"));
      }
    });
  })();

  $("reemplazo-cancelar").addEventListener("click", cancelarReemplazo);

  // ajustes / contexto (delegacion)
  (function(){
    const cx = $("contexto");
    cx.addEventListener("click", function(e){
      const abre = e.target.closest("[data-abre]");
      if(abre){ if(abre.getAttribute("data-abre") === "patron") abrirPatron(); return; }
      const ac = e.target.closest("[data-abre-acomodos]");
      if(ac){ abrirAcomodos(); return; }
      const est = e.target.closest("#mp12-est-btn");
      if(est){ if(est.getAttribute("aria-disabled") === "true") return; mp12EstampaActual(); return; }
      const real = e.target.closest("#mp12-real-btn");
      if(real){ mp12IniciaTamanoReal(); return; }
      const dis = e.target.closest("#mp20-disenos-btn");   // R20 · F1: la pastilla unica abre el Paseo
      if(dis){ mp20Abre(); return; }
      const ene = e.target.closest("#mp18-energia-btn");   // R18 · F2 · R23 O3 · F1: abre la ventana centrada (sin autocierre)
      if(ene){ mp23AbreEnergia(); return; }
      const como = e.target.closest("#mp21-como-btn");   // R21 · F2
      if(como){ mp21AbreComo(); return; }
      const esp = e.target.closest("#chip-espejo");
      if(esp){ espejo = !espejo; renderContexto(); mostrarEspejoToast(); return; }
      const son = e.target.closest("#chip-sonido");
      if(son){ sonidoOn = !sonidoOn; if(sonidoOn) ensureAudio(); renderContexto(); return; }
    });
  })();

  // Ronda 20 · EL PASEO: carriles, flechas, deslizar sobre la gota, teclado y las dos salidas
  (function(){
    const carr = $("mp20-carriles");
    if(carr) carr.addEventListener("click", function(e){
      const c = e.target.closest("[data-mp20-carril]"); if(!c) return;
      mp20SetCarril(c.getAttribute("data-mp20-carril"));
    });
    const prev = $("mp20-prev"), next = $("mp20-next");
    if(prev) prev.addEventListener("click", function(){ mp20Ir(-1); });
    if(next) next.addEventListener("click", function(){ mp20Ir(1); });
    const mia = $("mp20-mia"), volver = $("mp20-volver"), scrim = $("mp20-scrim");
    if(mia) mia.addEventListener("click", mp20HacerlaMia);
    if(volver) volver.addEventListener("click", mp20Volver);
    if(scrim) scrim.addEventListener("click", mp20Volver);   // tocar fuera = volver a como estaba (pasear jamas destruye: la foto se restaura)
    // deslizar horizontal sobre la gota (touch + mouse via pointer events)
    const zona = $("mp20-swipe");
    if(zona){
      let sx = 0, sy = 0, act = false;
      zona.addEventListener("pointerdown", function(e){ act = true; sx = e.clientX; sy = e.clientY; try{ zona.setPointerCapture(e.pointerId); }catch(_){ } });
      zona.addEventListener("pointerup", function(e){
        if(!act) return; act = false;
        const dx = e.clientX - sx, dy = e.clientY - sy;
        if(Math.abs(dx) >= 40 && Math.abs(dx) > Math.abs(dy)){ mp20Ir(dx < 0 ? 1 : -1); return; }   // izquierda = siguiente, derecha = anterior
        if(Math.abs(dx) < 40 && Math.abs(dy) < 40){                                                  // toque simple (no swipe, mismo umbral): la mitad tocada navega
          const r = zona.getBoundingClientRect();
          mp20Ir((e.clientX - r.left) >= r.width / 2 ? 1 : -1);   // mitad derecha = siguiente, izquierda = anterior
        }
      });
      zona.addEventListener("pointercancel", function(){ act = false; });
    }
    // teclado (desktop): flechas recorren, Escape = volver a como estaba
    document.addEventListener("keydown", function(e){
      if(!mp20Activo) return;
      if(e.key === "ArrowRight"){ e.preventDefault(); mp20Ir(1); }
      else if(e.key === "ArrowLeft"){ e.preventDefault(); mp20Ir(-1); }
      else if(e.key === "Escape"){ e.preventDefault(); mp20Volver(); }
    });
  })();

  // Ronda 10: girar = un paso VISIBLE por toque (la hoja se aparta y el giro se ve en la pieza)
  (function(){
    const sh = $("sheet");
    sh.addEventListener("pointerdown", function(e){
      const g = e.target.closest("[data-ac-girar]"); if(!g || g.disabled) return;
      const dir = +g.getAttribute("data-ac-girar");
      const seqOld = seqActual();
      if(seqOld.filter(function(x){ return x != null; }).length === 0) return;
      const seqNew = acomodoGirar(seqOld, dir);
      cerrarSheet();
      reordenar(escribeSeq(seqNew));
      setTimeout(function(){ mp8ViajeReacomodo(seqOld, seqNew); }, 240);
    });
  })();


  // Ronda 8 · Mis diseños
  $("mp8-guardados-btn").addEventListener("click", abrirGuardados);

  // Ronda 12 · La estampa (capa propia)
  $("mp12-est-share").addEventListener("click", mp12EstCompartir);
  $("mp12-est-save").addEventListener("click", mp12EstGuardar);
  $("mp12-est-copy").addEventListener("click", mp12EstCopiar);
  $("mp12-est-close").addEventListener("click", mp12CierraEstampa);

  // Ronda 12 · Calibrar con la tarjeta
  $("mp12-pxmm").addEventListener("input", mp12CalibReposiciona);
  $("mp12-calib-save").addEventListener("click", mp12GuardaCalibracion);
  $("mp12-calib-close").addEventListener("click", mp12CierraCalibracion);

  // Ronda 12 · Tamaño real: salir, recalibrar y paneo con un dedo
  $("mp12-real-exit").addEventListener("click", mp12CierraTamanoReal);
  $("mp12-real").addEventListener("click", function(e){
    if(e.target.closest("#mp12-real-recal")){ mp12CierraTamanoReal(); mp12AbreCalibracion(true); }
  });
  (function(){
    const body = $("mp12-real-body");
    let drag = null;
    body.addEventListener("pointerdown", function(e){
      if(e.target.closest("#mp12-real-recal")) return;
      drag = { x:e.clientX, y:e.clientY, px:_mp12RealPan.x, py:_mp12RealPan.y };
      try{ body.setPointerCapture(e.pointerId); }catch(_){}
    });
    body.addEventListener("pointermove", function(e){
      if(!drag) return;
      let nx = drag.px + (e.clientX - drag.x), ny = drag.py + (e.clientY - drag.y);
      nx = Math.min(_mp12RealPan.max.x, Math.max(_mp12RealPan.min.x, nx));
      ny = Math.min(_mp12RealPan.max.y, Math.max(_mp12RealPan.min.y, ny));
      _mp12RealPan.x = nx; _mp12RealPan.y = ny; mp12AplicaPanReal();
    });
    function fin(e){ drag = null; try{ body.releasePointerCapture(e.pointerId); }catch(_){} }
    body.addEventListener("pointerup", fin);
    body.addEventListener("pointercancel", fin);
  })();

  // explorador a pantalla completa
  $("exp-volver").addEventListener("click", cerrarExplorador);
  $("exp-buscar").addEventListener("input", function(){ expFiltro = this.value; renderExpGrid(); });
  $("exp-intenciones").addEventListener("click", function(e){
    const b = e.target.closest("[data-int]"); if(!b) return;
    const x = b.getAttribute("data-int");
    expInt[x] = !expInt[x];
    b.setAttribute("aria-pressed", expInt[x] ? "true" : "false");
    renderExpGrid();
  });
  // Ronda 13 · familias de luz (una sola a la vez; toca de nuevo para soltar; se compone con lo demas)
  $("mp13-familias").addEventListener("click", function(e){
    const b = e.target.closest("[data-fam]"); if(!b) return;
    const k = b.getAttribute("data-fam");
    expFam = (expFam === k) ? "" : k;
    renderExpFamilias();
    renderExpGrid();
  });
  $("exp-orden").addEventListener("click", function(e){
    const b = e.target.closest("[data-orden]"); if(!b) return;
    expOrden = b.getAttribute("data-orden");
    const bs = this.children;
    for(let i = 0; i < bs.length; i++){ bs[i].setAttribute("aria-pressed", bs[i] === b ? "true" : "false"); }
    renderExpGrid();
  });
  $("exp-grid").addEventListener("click", function(e){
    const b = e.target.closest("[data-exp-brush]"); if(!b) return;
    mp23AbreFicha(+b.getAttribute("data-exp-brush"));   // R23 O3 · F4: inspecciona antes de elegir; el boton contextual hace lo que hacia el tap viejo
  });
  // R23 O3 · monta el CSS y el HTML de la Oleada 3 (inyectado tras DATOS; jamas mueve las lineas sagradas)
  mp23Monta();
  // R23 O3 · F4 · la ficha: elegir (flujo viejo exacto) o cerrar sin elegir
  $("mp23-fic").addEventListener("click", function(e){
    if(e.target.closest("#mp23-fic-cta")){ mp23FichaElegir(); return; }
    if(e.target.closest("#mp23-fic-x")){ mp23CierraFicha(); return; }
    if(e.target.closest("#mp23-fic-scrim")){ mp23CierraFicha(); return; }
  });
  // R23 O3 · F1 · la ventana de la energia: cerrar por la tachita o el scrim
  $("mp23-ene-x").addEventListener("click", mp23CierraEnergia);
  $("mp23-ene-scrim").addEventListener("click", mp23CierraEnergia);
  $("mp23-ene-ov").addEventListener("click", function(e){ const b = e.target.closest("[data-cot-lectura]"); if(b) cotPideLectura(b); });   // MUDANZA · T4: pedir la lectura del Oraculo
  // R23 O3 · F2 · el panel expandido de la mesa: gestos propios (tocar = pincel, presion larga = fijar)
  (function(){
    const pa = $("mp23-mesa-panel"), sc = $("mp23-mesa-scrim");
    let press = null, timer = 0, longFired = false;
    pa.addEventListener("pointerdown", function(e){
      const s = e.target.closest("[data-slot-mid]"); if(!s) return;
      longFired = false;
      const mid = +s.getAttribute("data-slot-mid");
      press = { mid:mid, x:e.clientX, y:e.clientY };
      timer = setTimeout(function(){ longFired = true; press = null; mesaFijar(mid); }, 450);   // renderMesa re-pinta el panel
    });
    pa.addEventListener("pointermove", function(e){ if(press && Math.hypot(e.clientX - press.x, e.clientY - press.y) > 10){ clearTimeout(timer); press = null; } });
    pa.addEventListener("pointerup", function(){ if(timer){ clearTimeout(timer); timer = 0; } });
    pa.addEventListener("pointercancel", function(){ if(timer){ clearTimeout(timer); timer = 0; } press = null; });
    pa.addEventListener("contextmenu", function(e){ const s = e.target.closest("[data-slot-mid]"); if(s){ e.preventDefault(); if(timer){ clearTimeout(timer); timer = 0; } longFired = true; press = null; mesaFijar(+s.getAttribute("data-slot-mid")); } });
    pa.addEventListener("click", function(e){
      const act = e.target.closest("[data-mp23-mesa-act]");
      if(act){ const a = act.getAttribute("data-mp23-mesa-act"); mp23CierraMesaPanel();
        if(a === "mas") abrirExplorador(); else if(a === "sepmas") abrirSepSelector(); else if(a === "varita") abrirAcciones(); return; }
      const sp = e.target.closest("[data-sep-pincel]");
      if(sp){ toggleSepBrush(+sp.getAttribute("data-sep-pincel")); mp23CierraMesaPanel(); return; }
      const s = e.target.closest("[data-slot-mid]");
      if(s){ if(longFired){ longFired = false; return; } toggleBrush(+s.getAttribute("data-slot-mid")); mp23CierraMesaPanel(); return; }
    });
    if(sc) sc.addEventListener("click", mp23CierraMesaPanel);
  })();

  // desglose (lo abre el chip de precio)
  $("precio-chip").addEventListener("click", abrirDesglose);
  $("cot-cta").addEventListener("click", function(e){
    e.preventDefault();                                   // Ronda 14 · T1: ya no salta directo; abre la antesala de confianza
    if(this.getAttribute("aria-disabled") === "true") return;
    mp14AbreAntesala();
  });
  // Ronda 14 · T1 · la antesala: enviar (con el wa.me intacto) o volver a la pieza
  $("mp14-antesala").addEventListener("click", function(e){
    if(e.target.closest("#mp14-ant-volver")){ mp14CierraAntesala(); return; }
    if(e.target.closest("#mp14-ant-enviar")){ mp14Embudo("cotizar_tocado"); return; }   // el tap real; deja navegar el enlace
  });
  // Ronda 14 · T3 · la hoja de armado: copiar la lista o cerrar
  $("mp14-armado").addEventListener("click", function(e){
    if(e.target.closest("#mp14-arm-cerrar")){ mp14CierraArmado(); return; }
    if(e.target.closest("#mp14-arm-copiar")){
      mp8Copia(mp14ArmadoTexto(), function(){});
      const b = $("mp14-arm-copiar"); if(b){ b.textContent = "Copiada"; setTimeout(function(){ b.textContent = "Copiar la lista"; }, 1600); }
      return;
    }
  });

  // sheet (delegacion)
  $("sheet").addEventListener("click", function(e){
    const act = e.target.closest("[data-act]");
    if(act){
      if(act.disabled) return;
      const a = act.getAttribute("data-act");
      if(a === "cerrar"){ cerrarSheet(); }
      else if(a === "cambiar" && sheetTipo === "mirilla"){ const i = +$("sheet").dataset.beadIndex; cerrarSheet(); armarReemplazo(i); }
      else if(a === "quitar" && sheetTipo === "mirilla"){ const i = +$("sheet").dataset.beadIndex; pushUndo(); beads[i] = null; if(espejo) beads[twin(i)] = null; cerrarSheet(); tras(); }
      else if(a === "llenar-vacias"){ llenarVacias(); cerrarSheet(); }
      else if(a === "llenar-todo"){ llenarTodo(); cerrarSheet(); }
      else if(a === "vaciar"){ vaciarTodo(); cerrarSheet(); }
      else if(a === "acomodos"){ abrirAcomodos(); }
      return;
    }
    if(e.target.closest("#btn-compartir")){ compartirDiseno(); return; }
    if(e.target.closest("#btn-pegar")){ pegarDiseno(); return; }
    // Ronda 14 · T3: abrir la vista de armado desde la hoja de compartir/pegar
    if(e.target.closest("#mp14-armado-abrir")){ mp14AbreArmado(); return; }
    // Ronda 14 · T4: el embudo (vaciar con confirmacion amable)
    if(e.target.closest("#mp14-emb-vaciar")){ const c = $("mp14-emb-confirma"); if(c) c.hidden = false; return; }
    if(e.target.closest("#mp14-emb-no")){ const c = $("mp14-emb-confirma"); if(c) c.hidden = true; return; }
    if(e.target.closest("#mp14-emb-si")){ mp14VaciaEmbudo(); return; }
    // Ronda 8 · Mis diseños (guardar / abrir / confirmar / cancelar / copiar / quitar)
    const g1 = e.target.closest("[data-mp8-guardar]"); if(g1){ if(g1.disabled) return; guardarDiseno(); return; }
    const g2 = e.target.closest("[data-mp8-abrir]"); if(g2){ pideAbrirGuardado(+g2.getAttribute("data-mp8-abrir")); return; }
    const g3 = e.target.closest("[data-mp8-confirmar]"); if(g3){ ejecutaAbrirGuardado(+g3.getAttribute("data-mp8-confirmar")); return; }
    const g4 = e.target.closest("[data-mp8-cancelar]"); if(g4){ mp8ConfirmAbrir = -1; renderGuardados(); return; }
    const g5 = e.target.closest("[data-mp8-copiar]"); if(g5){ copiarGuardado(+g5.getAttribute("data-mp8-copiar")); return; }
    const g6 = e.target.closest("[data-mp8-quitar]"); if(g6){ quitarGuardado(+g6.getAttribute("data-mp8-quitar")); return; }
    // Ronda 12 · la estampa desde una tarjeta guardada
    const ge = e.target.closest("[data-mp12-estampa-card]"); if(ge){ mp12EstampaGuardado(+ge.getAttribute("data-mp12-estampa-card")); return; }
    // Ronda 13 · conocer a la hermana accesible (desde el explorador) · R20: las 3 puertas de siembra migraron al Paseo
    const gh = e.target.closest("[data-mp13-hermana]"); if(gh){ mp13ConoceHermana(+gh.getAttribute("data-mp13-hermana")); return; }
    // Ronda 15b: el apagador del degradado de tono (peticion de taller)
    if(e.target.closest("#mp15b-tog")){
      if(mp15bAplica()){ degTono = !degTono; marcaCambio(); updateCotizacion(); }   // refresca el wa.me (y el desglose si esta abierto)
      const t = $("mp15b-tog");
      if(t){ t.setAttribute("aria-checked", degTono ? "true" : "false"); t.setAttribute("aria-label", "Degradado de tono " + (degTono ? "encendido" : "apagado")); }
      return;
    }
    // Acomodos (galeria): aplicar por tarjeta, o el stepper de bloques (girar va por pointer, mas abajo)
    const acA = e.target.closest("[data-ac-apply]");
    if(acA){ if(acA.disabled) return; aplicaAcomodo(acA.getAttribute("data-ac-apply")); return; }
    const acB = e.target.closest("[data-ac-blk]");
    if(acB){ if(acB.disabled) return; acomodoBloqueN = Math.max(2, Math.min(11, acomodoBloqueN + (+acB.getAttribute("data-ac-blk")))); refrescaAcomodos(); return; }
    const cen = e.target.closest("[data-centro]");
    if(cen){ const mid = +cen.getAttribute("data-centro"); centroManual[formaActual()] = mid; renderCuarto(); updateCotizacion(); marcaCambio(); abrirCentro(); return; }
    const fo = e.target.closest("[data-forma]");
    if(fo){ centroForma = fo.getAttribute("data-forma"); renderCuarto(); updateCotizacion(); marcaCambio(); abrirCentro(); return; }
    const pt = e.target.closest("[data-pat]");
    if(pt){
      // R18 · F1 · F8: al cambiar de talla, conserva los overrides por rol (i-esimo interno, guru, cierre)
      const oldCad = sepCadencia(), oldPinta = Array.isArray(sepPinta) ? sepPinta.slice() : [];
      patronIdx = +pt.getAttribute("data-pat");
      sepPinta = sepPintaRemap(oldCad, oldPinta, sepCadencia());
      renderMesa(); renderContexto(); renderCuarto(); updateCotizacion(); marcaCambio(); abrirPatron(); return;
    }
    const sp = e.target.closest("[data-sepbyname]");
    if(sp){
      // R18 · F1 · F4 · LA BROCHA GORDA: elegir el mineral del separador pinta TODOS y borra los overrides (1 deshacer)
      const mid = +sp.getAttribute("data-sepbyname");
      const j = DATOS.separadores.findIndex(function(s){ return s.n === DATOS.minerales[mid].n; });
      if(j >= 0){ pushUndo(); sepMineralIdx = j; sepPinta = []; sepPintaSane(); renderMesa(); renderContexto(); renderCuarto(); updateCotizacion(); marcaCambio(); abrirPatron(); }
      return;
    }
    // R18 · F1: elegir el mineral del PINCEL de separadores desde el selector; queda activo y la hoja se cierra
    const spp = e.target.closest("[data-sep-pincel-pick]");
    if(spp){ const si = +spp.getAttribute("data-sep-pincel-pick"); if(DATOS.separadores[si]){ sepBrush = si; brush = -1; cancelarReemplazoSilencio(); renderMesa(); renderCuarto(); mp21Susurro("sep-pincel", "Pincel de separadores: toca cualquier separador de la pieza y se pinta."); } cerrarSheet(); return; }
    const aa = e.target.closest("#ancla-a"); if(aa){ calibAncla = "A"; aa.setAttribute("aria-pressed", true); $("ancla-b").setAttribute("aria-pressed", false); updateCotizacion(); return; }
    const ab = e.target.closest("#ancla-b"); if(ab){ calibAncla = "B"; ab.setAttribute("aria-pressed", true); $("ancla-a").setAttribute("aria-pressed", false); updateCotizacion(); return; }
  });
  $("sheet").addEventListener("input", function(e){
    if(e.target.id === "colchon"){ colchon = +e.target.value; $("colchon-val").textContent = colchon + "%"; updateCotizacion(); }
    else if(e.target.id === "recargo"){ recargoPct = +e.target.value; $("recargo-val").textContent = recargoPct + "%"; updateCotizacion(); }
  });
  $("backdrop").addEventListener("click", cerrarSheet);
  document.addEventListener("keydown", function(e){
    if(e.key !== "Escape") return;
    if(mp23EneAbierta){ mp23CierraEnergia(); return; }        // R23 O3 · F1
    if(mp23MesaAbierta){ mp23CierraMesaPanel(); return; }     // R23 O3 · F2
    if(mp23FichaAbierta){ mp23CierraFicha(); return; }        // R23 O3 · F4 (antes que el explorador)
    if($("mp14-antesala").classList.contains("on")){ mp14CierraAntesala(); return; }   // Ronda 14 · T1
    if($("mp14-armado").classList.contains("on")){ mp14CierraArmado(); return; }        // Ronda 14 · T3
    if($("mp12-est").classList.contains("on")){ mp12CierraEstampa(); return; }
    if($("mp12-real").classList.contains("on")){ mp12CierraTamanoReal(); return; }
    if($("mp12-calib").classList.contains("on")){ mp12CierraCalibracion(); return; }
    if(expAbierto){ cerrarExplorador(); return; }
    if(!$("sheet").hidden) cerrarSheet();
  });

  // relayout del cuarto activo cuando cambia la caja de la app.
  // Ronda 8: solo repinta si el tamano cambio de verdad (evita el re-render espurio inicial
  // del observer, que pisaba la respiracion de entrada; y ahorra trabajo).
  function relayoutSiCambia(){
    rafLayout = 0;
    const a = $("app"), w = a.clientWidth, h = a.clientHeight;
    if(w === lastAppW && h === lastAppH) return;
    lastAppW = w; lastAppH = h;
    anclaContexto();                         // Ronda 10: re-ancla las pastillas al alto real del recuadro
    renderCuarto(); if(mp20Activo) mp20PosicionaInfo();   // R22: reancla la info del Paseo al hueco tras el relayout
  }
  if("ResizeObserver" in window){
    const ro = new ResizeObserver(function(){
      if(rafLayout) cancelAnimationFrame(rafLayout);
      rafLayout = requestAnimationFrame(relayoutSiCambia);
    });
    ro.observe($("app"));
  }
  window.addEventListener("resize", function(){
    if(rafLayout) cancelAnimationFrame(rafLayout);
    rafLayout = requestAnimationFrame(relayoutSiCambia);
  });
  // R23 · iOS: la barra del navegador y los menus del sistema mueven el viewport VISUAL
  // sin cambiar el tamano de #app (position:fixed:inset:0), asi que ni "resize" ni el
  // ResizeObserver disparan. Los posicionadores que miden con getBoundingClientRect
  // (mp20PosicionaInfo, anclaContexto) quedaban descuadrados dentro del anillo hasta recargar.
  // Aqui los re-anclamos cuando el viewport visual se ajusta o se mueve, sin el candado de
  // dimension de relayoutSiCambia (esa dimension aqui no cambia).
  if(window.visualViewport){
    let rafVV = 0;
    function reanclaVisual(){
      rafVV = 0;
      anclaContexto();
      if(mp20Activo) mp20PosicionaInfo();
    }
    function pideReanclaVisual(){
      if(rafVV) cancelAnimationFrame(rafVV);
      rafVV = requestAnimationFrame(reanclaVisual);
    }
    window.visualViewport.addEventListener("resize", pideReanclaVisual);
    window.visualViewport.addEventListener("scroll", pideReanclaVisual);
  }
  // R23 · el pellizco (y el doble toque) sobre el cromo de la app escalaba TODA la pagina en
  // iOS Safari y sacaba de vista los botones de arriba, sin regreso. El zoom de la PIEZA vive
  // en el lienzo/charola por punteros (touch-action:none) y NO se toca; fuera de ese lienzo,
  // bloqueamos el gesto de pagina. Se ata al documento de la maqueta (su unico contenido es la
  // app y sus hojas); jamas al viewport estatico, para no matar el zoom del resto de una pagina.
  ["gesturestart", "gesturechange", "gestureend"].forEach(function(ev){
    document.addEventListener(ev, function(e){
      if(e.target && e.target.closest && e.target.closest(".lienzo, .charola")) return;   // el pellizco de la pieza sigue vivo
      e.preventDefault();
    }, { passive:false });
  });

  // Ronda 19 · en desktop (pointer fino), la rueda vertical del mouse desplaza los
  // rieles horizontales que desbordan (contexto, filas del explorador, tiras de las hojas).
  // Solo se ENGANCHA en desktop; en movil el listener no existe -> comportamiento intacto.
  const MP19_DESK = window.matchMedia("(min-width:1024px) and (pointer:fine)");
  const MP19_RIEL = ".contexto,.mp13fix-riel,.mini-fila,.patrones,.mz-fichas,.mz-prev,.exp-chips,.exp-orden,.mp13-fam-row,.mp17-fam-chips,.mp12-int-chips";
  function mp19WheelRiel(e){
    if(!MP19_DESK.matches) return;
    const riel = e.target.closest && e.target.closest(MP19_RIEL);
    if(!riel) return;
    if(riel.scrollWidth - riel.clientWidth <= 2) return;         // no desborda: deja pasar
    if(Math.abs(e.deltaY) <= Math.abs(e.deltaX)) return;         // gesto horizontal: nativo
    riel.scrollLeft += e.deltaY;
    e.preventDefault();
  }
  function mp19Engancha(on){
    if(on) document.addEventListener("wheel", mp19WheelRiel, { passive:false });
    else document.removeEventListener("wheel", mp19WheelRiel, { passive:false });
  }
  if(MP19_DESK.matches) mp19Engancha(true);
  MP19_DESK.addEventListener("change", function(ev){ mp19Engancha(ev.matches); });
}

/* ===== inyeccion de retratos ===== */
function inyectaRetratos(){
  let css = "";
  Object.keys(RETRATOS).forEach(function(name){
    const r = RETRATOS[name];
    if(r && r.uri && RTID[name] != null){ css += ".rt" + RTID[name] + '{background-image:url("' + r.uri + '");background-size:cover;background-position:center;background-repeat:no-repeat}'; }
  });
  const st = document.createElement("style");
  st.textContent = css;
  document.head.appendChild(st);
}

/* ===== arranque ===== */
function init(){
  inyectaRetratos();
  // separador default = el mas barato
  let best = 0, bp = Infinity;
  DATOS.separadores.forEach(function(s, i){ if(s.por_sep < bp){ bp = s.por_sep; best = i; } });
  sepMineralIdx = best;

  // Ronda 7: recupera el estado guardado de cada pieza (sobrevive recargas)
  cargaPZinicial();
  cargaGuardados();                          // Ronda 8 · recupera los diseños guardados (llave propia)
  mp21CargaVistos();                          // Ronda 21 · carga el registro de susurros ya vistos (jamas muestra ninguno)
  cargaPieza(pieza);                         // restaura la pieza actual tal cual quedo (o limpia si no hay)
  mesaSembrar();                             // Ronda 9: 4 pinceles curados si la mesa esta vacia (primer minuto guiado)
  $("app").dataset.cuarto = cuarto;
  actualizaTabs();
  actualizaPiezaChip();
  renderContexto();
  renderMesa();
  renderCuarto();
  actualizaUndo();
  updateCotizacion();
  const _a = $("app"); lastAppW = _a.clientWidth; lastAppH = _a.clientHeight;   // Ronda 8: fija la caja base
  mp14Embudo("abrio");                        // Ronda 14 · T4: el primer paso del embudo, al cargar
  initEventos();
}
init();

  /* >>> parche gen (cotizador-p6-siembra) >>> */
  // P6 · la siembra del Oraculo: si la URL trae ?m=<Nombre[,Nombre|Nombre]> (uno o varios nombres canonicos
  // separados por coma o barra), cada uno se siembra en la mesa; se recorre en REVERSA para que el PRIMERO de
  // la URL quede como pincel activo (mesaUsar hace unshift y activa). La mesa respeta su tope de 5. Silencioso, sin susurro.
  try {
    var _mSiembra = new URLSearchParams(location.search).get('m');
    if (_mSiembra) {
      var _lista = _mSiembra.split(/[|,]/);
      for (var _i = _lista.length - 1; _i >= 0; _i--) {
        var _mid = nameToMid(_lista[_i].trim());
        if (_mid != null) { mesaUsar(_mid); }
      }
    }
  } catch (_e) { /* la siembra jamas rompe el arranque */ }
  /* <<< parche gen (cotizador-p6-siembra) <<< */

  } catch (e) {
    try { document.documentElement.classList.remove('mp-app'); } catch (_e) {}
    try { var r2 = document.querySelector('[data-mp-cotizador] [data-room]'); if (r2) { r2.hidden = true; } } catch (_e2) {}
    if (window.MP_QA === true) { throw e; }
  }
})();
